// generated with @7nohe/openapi-react-query-codegen@1.6.1

import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
} from "@tanstack/react-query";
import {
  AdminUserControllerService,
  AffiliateGroupControllerService,
  AgentDealControllerService,
  AgentFirmControllerService,
  AgentPayoutService,
  AgreementControllerService,
  AllergyControllerService,
  AncillaryServiceChargesControllerService,
  AnnotableImageControllerService,
  AnnotableImagePinControllerService,
  AnnotableImageTemplateControllerService,
  AppointmentControllerService,
  AppointmentTypeControllerService,
  AuditHistoryControllerService,
  AvailabilityControllerService,
  AwsControllerService,
  BookmarkControllerService,
  BreakGlassControllerService,
  BrokerControllerService,
  CallLogsControllerService,
  CancellationControllerService,
  CarePlanControllerService,
  CartControllerService,
  ChargeCategoryControllerService,
  ChargeItemControllerService,
  CommentControllerService,
  ContactDirectoryControllerService,
  CouponControllerService,
  CoveragePlanControllerService,
  CoverageRuleControllerService,
  CptCodeControllerService,
  CreditControllerService,
  CrmCampaignControllerService,
  CrmNewsletterControllerService,
  CrmTaskControllerService,
  CrmTemplateControllerService,
  CsvControllerService,
  DashboardControllerService,
  DiagnosisControllerService,
  DocumentControllerService,
  DocumentTypeControllerService,
  DrugIntoleranceControllerService,
  DynamicMappingControllerService,
  EducationalMaterialControllerService,
  EmailControllerService,
  EmailHistoryControllerService,
  EmployeeUploadControllerService,
  EmployerAdministratorControllerService,
  EmployerControllerService,
  EmployerDivisionControllerService,
  EmployerManagementNotificationSettingControllerService,
  EmployerNotificationSettingControllerService,
  EmployerPageControllerService,
  FaceSheetLayoutControllerService,
  FamilyHistoryControllerService,
  FaxControllerService,
  FdbMedicationsControllerService,
  FeatureManagementControllerService,
  FormTemplateControllerService,
  FutureBillingControllerService,
  GlobalHolidayControllerService,
  GoogleMapsControllerService,
  GrowthChartControllerService,
  HAndPNoteControllerService,
  HabitsControllerService,
  Hl7ControllerService,
  IcdCodeControllerService,
  ImagingOrderControllerService,
  ImagingResultControllerService,
  InsuranceControllerService,
  InventoryOrderControllerService,
  InvoiceControllerService,
  InvoiceSettingControllerService,
  LabOrderControllerService,
  LabOrderSetControllerService,
  LabResultControllerService,
  LabTestControllerService,
  LeadControllerService,
  LocationAvailabilityControllerService,
  LocationControllerService,
  LocationGroupControllerService,
  LocationShareableSettingControllerService,
  MacroControllerService,
  MedicationControllerService,
  MessageControllerService,
  MobileAuthControllerService,
  NoteControllerService,
  NotificationControllerService,
  NotificationPreferenceControllerService,
  NotificationSettingControllerService,
  NurseStaffProviderControllerService,
  OrderStudyControllerService,
  PastMedicalHistoryControllerService,
  PastSurgicalHistoryControllerService,
  PatientControllerService,
  PatientFlagControllerService,
  PatientFormControllerService,
  PatientInformationControllerService,
  PatientLinkPharmacyControllerService,
  PatientModuleAccessControllerService,
  PatientModuleControllerService,
  PatientVaccinationControllerService,
  PaymentTransactionControllerService,
  PdfControllerService,
  PharmacyControllerService,
  PhysicalExamControllerService,
  PhysicalExamTemplateControllerService,
  PhysicianAccountTypeControllerService,
  PlaceholderControllerService,
  PlanControllerService,
  PocLabResultControllerService,
  PocLabTestControllerService,
  PointsOfCareLabControllerService,
  ProcedureCodeControllerService,
  ProviderControllerService,
  ProviderCoverageControllerService,
  ProviderDirectoryControllerService,
  PushNotificationControllerService,
  QuestControllerService,
  QuestResultPushControllerService,
  QuestionnaireControllerService,
  RealtimeControllerService,
  ReferralControllerService,
  ReviewOfSystemControllerService,
  ReviewOfSystemTemplateControllerService,
  RoleTypeFeatureManagementControllerService,
  RoleTypeManagementControllerService,
  RolesAndPermissionControllerService,
  SalesTaxJurisdictionControllerService,
  SalesTaxProfileControllerService,
  SavedBankControllerService,
  SavedCardControllerService,
  ScreenHistoryControllerService,
  ScriptSureControllerService,
  ShareBankControllerService,
  ShareCardControllerService,
  SnsWebHookControllerService,
  SoapNoteControllerService,
  SoapNoteTemplateControllerService,
  SocialHistoryControllerService,
  SpecialityControllerService,
  StatusConfigurationControllerService,
  StripControllerService,
  StripeControllerService,
  SupervisingProviderRequestControllerService,
  TaskCategoryControllerService,
  TaskControllerService,
  TaskLogControllerService,
  ThreadControllerService,
  TicketAttachmentControllerService,
  TicketControllerService,
  TicketConversationControllerService,
  TicketLinkedControllerService,
  TicketMergeControllerService,
  TicketNotesControllerService,
  TicketTaskControllerService,
  TribleLabControllerService,
  TwilioControllerService,
  TwilioVoiceControllerService,
  TwilioVoiceWebhookControllerService,
  UserControllerService,
  VaccineControllerService,
  VideoCallControllerService,
  VideoControllerService,
  VitalControllerService,
  WorkNoteControllerService,
} from "../requests/services.gen";
import {
  AddInventoryRequest,
  AddMemberShipDto,
  AddMetadataRequest,
  AddPayoutBankAccountRequest,
  AdminUserRequest,
  AffiliateAgreementNotificationDto,
  AffiliateGroupDto,
  AgentDealDto,
  AgentFirmDto,
  AllergyDto,
  AncillaryServiceChargesRequest,
  AnnotableImageDto,
  AnnotableImagePinDto,
  AnnotableImageTemplateDto,
  AppointmentBlockTimeDto,
  AppointmentDto,
  AppointmentInfo,
  AppointmentTypeDto,
  ApprovePatientRequest,
  AssignedProviderDto,
  AvailabilityDto,
  BreakGlassRequest,
  BrokerDto,
  BulkUserCredentialDto,
  CallInvitationDto,
  CallLogsDto,
  CancelPlanChangeDto,
  CancellationRequest,
  CardUpdateRequest,
  CarePlanRequest,
  ChangeInvoiceStatusRequest,
  ChargeCategoryRequest,
  ChargeItemRequest,
  ChargePaidNotificationRequest,
  CheckChargeCoverageRequest,
  CommentRequestDto,
  CompleteSubscriptionRequest,
  ConfirmEnrollmentRequest,
  ContactDirectoryRequest,
  CouponRequestDto,
  CoveragePlanDto,
  CoverageRequestDto,
  CoverageRuleDto,
  CptCodeDto,
  CreateChargeItemAndInvoiceRequest,
  CreateCouponDto,
  CreateProductPriceRequest,
  CreateProductRequest,
  CreditDto,
  CrmCampaignDto,
  CrmNewsletterDto,
  CrmTaskDto,
  CrmTemplateDto,
  DeleteAppointmentRequestDto,
  DependentRelationDto,
  DiagnosisDto,
  DocumentRequest,
  DocumentTypeRequest,
  DrugIntoleranceDto,
  EducationalMaterialDto,
  EmployerAccountDto,
  EmployerAdministratorDto,
  EmployerAutopayNotificationRequest,
  EmployerDivisionDto,
  EmployerDto,
  EmployerInvoiceNotificationRequest,
  EmployerInvoiceSettingRequest,
  EmployerOnlineSignUpDto,
  EmployerPageDto,
  EmployerPlanChangeDto,
  EmployerPricingDto,
  ExternalLabResultDto,
  FaceSheetLayoutRequestDto,
  FamilyHistoryDto,
  FaxDocumentsRequest,
  FaxStatusRequest,
  FdbMedicationsDto,
  FeatureRequest,
  FlexiblePaymentRequest,
  ForgotPasswordRequest,
  FormTemplateRequest,
  GenericSMSRequest,
  GlobalHolidayDto,
  HAndPNoteRequestDto,
  HabitsDto,
  IcdCodeDto,
  ImagingFaxDto,
  ImagingOrderRequest,
  ImagingResultRequest,
  InsuranceDetailsDto,
  InvoiceRequest,
  InvoiceSettingDto,
  InvoiceStatementRequest,
  LabOrderDto,
  LabOrderFaxDto,
  LabOrderPdfDto,
  LabOrderSetDto,
  LabResultDto,
  LabResultFaxDto,
  LabResultPdfDto,
  LabTestDto,
  LeadResponseDto,
  LocationAvailabilityDto,
  LocationGroupRequest,
  LocationInventoryTransferRequest,
  LocationRequestDto,
  LogoutRequest,
  MacroDto,
  MakePaymentRequest,
  MakePayoutRequest,
  MedicationRequest,
  MessageDto,
  MessageReminderDto,
  MiscellaneousServiceChargeRequest,
  MobileLoginRequest,
  MultipleFormsEmailDto,
  NoteRequest,
  NotificationDto,
  NotificationPreferenceDto,
  NotificationPreferenceUpdateRequest,
  NotificationSettingEnableRequest,
  NurseStaffProviderRequestDto,
  OpenThreadRequest,
  Pageable,
  PastMedicalHistoryDto,
  PastSurgicalHistoryDto,
  PatientBasicPaymentDetailsDto,
  PatientChartItemsDto,
  PatientDetailsRequestDto,
  PatientFlagDto,
  PatientInformationRequest,
  PatientInvoiceEmailRequest,
  PatientLinkedPharmacyDto,
  PatientModuleAccessRequest,
  PatientModuleRequest,
  PatientPaymentInfoRequest,
  PatientRequestDto,
  PatientVaccinationDto,
  PaymentReceivedDto,
  PaymentTransactionRequestDto,
  PharmacyDto,
  PhysicalExamDto,
  PhysicalExamTemplateDto,
  PlaceCallRequest,
  PlanDetailsDto,
  PlanDto,
  PocLabResultRequestDto,
  PocLabTestRequestDto,
  PointOfCareLabDto,
  PromotionalCodeDto,
  PromotionalCodeDto1,
  ProviderDirectoryRequest,
  ProviderReassignmentEmailDto,
  ProviderRequestDto,
  QuestionnaireFaxDto,
  QueueFaxRequest,
  RealtimeEventDto,
  ReferralEmailDto,
  ReferralFaxDto,
  ReferralRequest,
  RefreshTokenRequest,
  RefundDto,
  RegisterUserRequest,
  ReviewOfSystemDto,
  ReviewOfSystemTemplateDto,
  RoleRequest,
  RoleTypeFeatureRequest,
  RoleTypeRequest,
  SalesTaxJurisdictionRequest,
  SalesTaxProfileRequest,
  SaveCardRequest,
  ScheduledPaymentRequest,
  ScreenHistoryDto,
  ScriptSureAllergyDto,
  ScriptSureMedicationPrescriptionDto,
  ScriptSurePatientDto,
  ScriptSurePharmacyDto,
  SendEmailDto,
  SendSMSRequest,
  ShareBankRequest,
  ShareCardNotificationDto,
  ShareCardRequest,
  SoapNoteRequestDto,
  SoapNoteTemplateDto,
  SocialHistoryDto,
  SpecimenLabelDto,
  StatusConfigurationDto,
  StripeCustomerRequest,
  StripePaymentRequest,
  StripeProductPaymentRequest,
  StripeRefundRequest,
  StripeSubscriptionRequest,
  SupervisingRequestCreateDto,
  TaskLogsDto,
  TaskRequestDto,
  TestNamesDto,
  ThreadDto,
  TicketAttachmentDto,
  TicketConversationDto,
  TicketDto,
  TicketLinkedDto,
  TicketMergeDto,
  TicketNotesDto,
  TicketTaskDto,
  UnEnrollDto,
  UpdateAncillaryServiceChargesRequest,
  UpdateCarePlanRequest,
  UpdateDocumentTypeRequest,
  UpdateGoogleMapsShareLinkRequest,
  UpdateLocationInventoryRequest,
  UpdateSavedBankRequest,
  UploadFormPdfRequest,
  UrgentMessageAlertDto,
  User,
  UserInvitationDto,
  VaccineDto,
  VerifyOtpRequest,
  VerifyPayoutBankAccountRequest,
  VideoCallStartRequest,
  VitalDto,
  WorkNoteRequestDto,
} from "../requests/types.gen";
import * as Common from "./common";
/**
 * User Profile
 * Get Logged-in User Profile
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceGetProfile = <
  TData = Common.UserControllerServiceGetProfileDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseUserControllerServiceGetProfileKeyFn(queryKey),
    queryFn: () => UserControllerService.getProfile() as TData,
    ...options,
  });
/**
 * List Staff Users
 * List staff users using Filter with Pagination and Sorting with filter options on status, archive and role and search functionality on firstName, lastName and email,
 * @param data The data for the request.
 * @param data.page
 * @param data.size
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.status
 * @param data.archive
 * @param data.role
 * @param data.roleType
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceGetAllUsers = <
  TData = Common.UserControllerServiceGetAllUsersDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    archive,
    page,
    role,
    roleType,
    searchString,
    size,
    sortBy,
    sortDirection,
    status,
  }: {
    archive?: boolean;
    page?: number;
    role?: string;
    roleType?:
      | "ADMIN"
      | "USER"
      | "EHR"
      | "EMPLOYER"
      | "PATIENT"
      | "AGENT"
      | "AFFILIATE"
      | "BROKER"
      | "CLINIC_USER";
    searchString?: string;
    size?: number;
    sortBy?: string;
    sortDirection?: string;
    status?: boolean;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseUserControllerServiceGetAllUsersKeyFn(
      {
        archive,
        page,
        role,
        roleType,
        searchString,
        size,
        sortBy,
        sortDirection,
        status,
      },
      queryKey,
    ),
    queryFn: () =>
      UserControllerService.getAllUsers({
        archive,
        page,
        role,
        roleType,
        searchString,
        size,
        sortBy,
        sortDirection,
        status,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceGetAllProviderAndStaffUser = <
  TData = Common.UserControllerServiceGetAllProviderAndStaffUserDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseUserControllerServiceGetAllProviderAndStaffUserKeyFn(
      { page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      UserControllerService.getAllProviderAndStaffUser({
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.locationUuids
 * @param data.roleTypes
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceGetClinicalStaff = <
  TData = Common.UserControllerServiceGetClinicalStaffDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationUuids,
    page,
    pageSize,
    roleTypes,
    searchString,
    sortBy,
    sortDirection,
  }: {
    locationUuids?: string[];
    page?: number;
    pageSize?: number;
    roleTypes?: (
      | "ADMIN"
      | "USER"
      | "EHR"
      | "EMPLOYER"
      | "PATIENT"
      | "AGENT"
      | "AFFILIATE"
      | "BROKER"
      | "CLINIC_USER"
    )[];
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseUserControllerServiceGetClinicalStaffKeyFn(
      {
        locationUuids,
        page,
        pageSize,
        roleTypes,
        searchString,
        sortBy,
        sortDirection,
      },
      queryKey,
    ),
    queryFn: () =>
      UserControllerService.getClinicalStaff({
        locationUuids,
        page,
        pageSize,
        roleTypes,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.roleType
 * @param data.employerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceGetUsersByRoleType = <
  TData = Common.UserControllerServiceGetUsersByRoleTypeDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
    page,
    pageSize,
    roleType,
    searchString,
    sortBy,
    sortDirection,
  }: {
    employerUuid?: string;
    page?: number;
    pageSize?: number;
    roleType?:
      | "ADMIN"
      | "USER"
      | "EHR"
      | "EMPLOYER"
      | "PATIENT"
      | "AGENT"
      | "AFFILIATE"
      | "BROKER"
      | "CLINIC_USER";
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseUserControllerServiceGetUsersByRoleTypeKeyFn(
      {
        employerUuid,
        page,
        pageSize,
        roleType,
        searchString,
        sortBy,
        sortDirection,
      },
      queryKey,
    ),
    queryFn: () =>
      UserControllerService.getUsersByRoleType({
        employerUuid,
        page,
        pageSize,
        roleType,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * Staff User
 * Get Staff User by userUuid
 * @param data The data for the request.
 * @param data.userId
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceGetUser = <
  TData = Common.UserControllerServiceGetUserDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    userId,
  }: {
    userId: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseUserControllerServiceGetUserKeyFn({ userId }, queryKey),
    queryFn: () => UserControllerService.getUser({ userId }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.iamid
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceGetUserFromIamid = <
  TData = Common.UserControllerServiceGetUserFromIamidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    iamid,
  }: {
    iamid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseUserControllerServiceGetUserFromIamidKeyFn(
      { iamid },
      queryKey,
    ),
    queryFn: () => UserControllerService.getUserFromIamid({ iamid }) as TData,
    ...options,
  });
/**
 * @returns string OK
 * @throws ApiError
 */
export const useUserControllerServiceCheck = <
  TData = Common.UserControllerServiceCheckDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseUserControllerServiceCheckKeyFn(queryKey),
    queryFn: () => UserControllerService.check() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.registrationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceCheckUserRegistration = <
  TData = Common.UserControllerServiceCheckUserRegistrationDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    registrationUuid,
  }: {
    registrationUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseUserControllerServiceCheckUserRegistrationKeyFn(
      { registrationUuid },
      queryKey,
    ),
    queryFn: () =>
      UserControllerService.checkUserRegistration({
        registrationUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.isAffiliate
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceGetAssignedLocations = <
  TData = Common.UserControllerServiceGetAssignedLocationsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    isAffiliate,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    isAffiliate?: boolean;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseUserControllerServiceGetAssignedLocationsKeyFn(
      { isAffiliate, page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      UserControllerService.getAssignedLocations({
        isAffiliate,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.flag
 * @param data.affiliate
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceGetUsers = <
  TData = Common.UserControllerServiceGetUsersDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    affiliate,
    flag,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    affiliate?: boolean;
    flag?: boolean;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseUserControllerServiceGetUsersKeyFn(
      { affiliate, flag, page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      UserControllerService.getUsers({
        affiliate,
        flag,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uploadUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.status
 * @param data.searchString
 * @param data.mute
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployeeUploadControllerServiceGetUploadDetailsByUploadUuid = <
  TData =
    Common.EmployeeUploadControllerServiceGetUploadDetailsByUploadUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    mute,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
    status,
    uploadUuid,
  }: {
    mute?: boolean;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: "SUCCESS" | "WARNING" | "ERROR";
    uploadUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseEmployeeUploadControllerServiceGetUploadDetailsByUploadUuidKeyFn(
        {
          mute,
          page,
          pageSize,
          searchString,
          sortBy,
          sortDirection,
          status,
          uploadUuid,
        },
        queryKey,
      ),
    queryFn: () =>
      EmployeeUploadControllerService.getUploadDetailsByUploadUuid({
        mute,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
        status,
        uploadUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uploadUuid
 * @param data.rowNumber
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployeeUploadControllerServiceGetRowFromCsv = <
  TData = Common.EmployeeUploadControllerServiceGetRowFromCsvDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    rowNumber,
    uploadUuid,
  }: {
    rowNumber: number;
    uploadUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEmployeeUploadControllerServiceGetRowFromCsvKeyFn(
      { rowNumber, uploadUuid },
      queryKey,
    ),
    queryFn: () =>
      EmployeeUploadControllerService.getRowFromCsv({
        rowNumber,
        uploadUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uploadUuid
 * @param data.status
 * @returns unknown OK
 * @throws ApiError
 */
export const useEmployeeUploadControllerServiceExportRows = <
  TData = Common.EmployeeUploadControllerServiceExportRowsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    status,
    uploadUuid,
  }: {
    status: "SUCCESS" | "WARNING" | "ERROR";
    uploadUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEmployeeUploadControllerServiceExportRowsKeyFn(
      { status, uploadUuid },
      queryKey,
    ),
    queryFn: () =>
      EmployeeUploadControllerService.exportRows({
        status,
        uploadUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uploadUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployeeUploadControllerServiceDownloadFile = <
  TData = Common.EmployeeUploadControllerServiceDownloadFileDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uploadUuid,
  }: {
    uploadUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEmployeeUploadControllerServiceDownloadFileKeyFn(
      { uploadUuid },
      queryKey,
    ),
    queryFn: () =>
      EmployeeUploadControllerService.downloadFile({ uploadUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.fileName
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployeeUploadControllerServiceGetAllUploads = <
  TData = Common.EmployeeUploadControllerServiceGetAllUploadsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
    fileName,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    employerUuid: string;
    fileName?: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEmployeeUploadControllerServiceGetAllUploadsKeyFn(
      { employerUuid, fileName, page, pageSize, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      EmployeeUploadControllerService.getAllUploads({
        employerUuid,
        fileName,
        page,
        pageSize,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uploadUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.status
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployeeUploadControllerServiceGetAllUploadDetailsByUploadUuid =
  <
    TData =
      Common.EmployeeUploadControllerServiceGetAllUploadDetailsByUploadUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      page,
      pageSize,
      sortBy,
      sortDirection,
      status,
      uploadUuid,
    }: {
      page?: number;
      pageSize?: number;
      sortBy?: string;
      sortDirection?: string;
      status?: "SUCCESS" | "WARNING" | "ERROR";
      uploadUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseEmployeeUploadControllerServiceGetAllUploadDetailsByUploadUuidKeyFn(
          { page, pageSize, sortBy, sortDirection, status, uploadUuid },
          queryKey,
        ),
      queryFn: () =>
        EmployeeUploadControllerService.getAllUploadDetailsByUploadUuid({
          page,
          pageSize,
          sortBy,
          sortDirection,
          status,
          uploadUuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.subscriptionId
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceGetSubscription = <
  TData = Common.StripeControllerServiceGetSubscriptionDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    subscriptionId,
  }: {
    subscriptionId: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseStripeControllerServiceGetSubscriptionKeyFn(
      { subscriptionId },
      queryKey,
    ),
    queryFn: () =>
      StripeControllerService.getSubscription({ subscriptionId }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceGetPhpUser = <
  TData = Common.StripeControllerServiceGetPhpUserDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseStripeControllerServiceGetPhpUserKeyFn(queryKey),
    queryFn: () => StripeControllerService.getPhpUser() as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceGetStripeConfig = <
  TData = Common.StripeControllerServiceGetStripeConfigDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseStripeControllerServiceGetStripeConfigKeyFn(queryKey),
    queryFn: () => StripeControllerService.getStripeConfig() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.userTypes
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceCheckServicesOfUser = <
  TData = Common.StripeControllerServiceCheckServicesOfUserDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    userTypes,
    uuid,
  }: {
    userTypes:
      | "EMPLOYER"
      | "PATIENT"
      | "BROKER"
      | "ADMIN_USER"
      | "PROVIDER"
      | "EMPLOYER_ADMINISTRATION"
      | "EMPLOYEE"
      | "PHP_USER"
      | "AFFILIATE_FIRM"
      | "BROKER_FIRM"
      | "NURSE_USER";
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseStripeControllerServiceCheckServicesOfUserKeyFn(
      { userTypes, uuid },
      queryKey,
    ),
    queryFn: () =>
      StripeControllerService.checkServicesOfUser({ userTypes, uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceGetPrescriptionIframe = <
  TData =
    Common.ScriptSureControllerServiceGetPrescriptionIframeDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseScriptSureControllerServiceGetPrescriptionIframeKeyFn(
      { patientUuid },
      queryKey,
    ),
    queryFn: () =>
      ScriptSureControllerService.getPrescriptionIframe({
        patientUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.doctorId
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceGetMessageCount = <
  TData = Common.ScriptSureControllerServiceGetMessageCountDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    doctorId,
  }: {
    doctorId: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseScriptSureControllerServiceGetMessageCountKeyFn(
      { doctorId },
      queryKey,
    ),
    queryFn: () =>
      ScriptSureControllerService.getMessageCount({ doctorId }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceGetMedCartIframe = <
  TData = Common.ScriptSureControllerServiceGetMedCartIframeDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseScriptSureControllerServiceGetMedCartIframeKeyFn(
      { patientUuid },
      queryKey,
    ),
    queryFn: () =>
      ScriptSureControllerService.getMedCartIframe({ patientUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.query
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceSearchDrugs = <
  TData = Common.ScriptSureControllerServiceSearchDrugsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    query,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    query: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseScriptSureControllerServiceSearchDrugsKeyFn(
      { page, pageSize, query, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      ScriptSureControllerService.searchDrugs({
        page,
        pageSize,
        query,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.drugId
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceGetDrugDoses = <
  TData = Common.ScriptSureControllerServiceGetDrugDosesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    drugId,
  }: {
    drugId: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseScriptSureControllerServiceGetDrugDosesKeyFn(
      { drugId },
      queryKey,
    ),
    queryFn: () =>
      ScriptSureControllerService.getDrugDoses({ drugId }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceGetDrugHistoryIframe = <
  TData = Common.ScriptSureControllerServiceGetDrugHistoryIframeDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseScriptSureControllerServiceGetDrugHistoryIframeKeyFn(
      { patientUuid },
      queryKey,
    ),
    queryFn: () =>
      ScriptSureControllerService.getDrugHistoryIframe({
        patientUuid,
      }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceGetCpoeIframe = <
  TData = Common.ScriptSureControllerServiceGetCpoeIframeDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseScriptSureControllerServiceGetCpoeIframeKeyFn(queryKey),
    queryFn: () => ScriptSureControllerService.getCpoeIframe() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.query
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceSearchAllergies = <
  TData = Common.ScriptSureControllerServiceSearchAllergiesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
    query,
  }: {
    patientUuid: string;
    query: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseScriptSureControllerServiceSearchAllergiesKeyFn(
      { patientUuid, query },
      queryKey,
    ),
    queryFn: () =>
      ScriptSureControllerService.searchAllergies({
        patientUuid,
        query,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceGetAllergyIframe = <
  TData = Common.ScriptSureControllerServiceGetAllergyIframeDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseScriptSureControllerServiceGetAllergyIframeKeyFn(
      { patientUuid },
      queryKey,
    ),
    queryFn: () =>
      ScriptSureControllerService.getAllergyIframe({ patientUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.userTypes
 * @param data.active
 * @param data.isDefault
 * @param data.brand
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useSavedCardControllerServiceGetAllSavedCards = <
  TData = Common.SavedCardControllerServiceGetAllSavedCardsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    active,
    brand,
    isDefault,
    page,
    size,
    sort,
    userTypes,
    uuid,
  }: {
    active?: boolean;
    brand?: string;
    isDefault?: boolean;
    page?: number;
    size?: number;
    sort?: string[];
    userTypes?:
      | "EMPLOYER"
      | "PATIENT"
      | "BROKER"
      | "ADMIN_USER"
      | "PROVIDER"
      | "EMPLOYER_ADMINISTRATION"
      | "EMPLOYEE"
      | "PHP_USER"
      | "AFFILIATE_FIRM"
      | "BROKER_FIRM"
      | "NURSE_USER";
    uuid?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseSavedCardControllerServiceGetAllSavedCardsKeyFn(
      { active, brand, isDefault, page, size, sort, userTypes, uuid },
      queryKey,
    ),
    queryFn: () =>
      SavedCardControllerService.getAllSavedCards({
        active,
        brand,
        isDefault,
        page,
        size,
        sort,
        userTypes,
        uuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @param data.active
 * @param data.isDefault
 * @param data.brand
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response1 OK
 * @throws ApiError
 */
export const useSavedCardControllerServiceGetAllSavedCards1 = <
  TData = Common.SavedCardControllerServiceGetAllSavedCards1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    active,
    brand,
    isDefault,
    page,
    size,
    sort,
    userUuid,
  }: {
    active?: boolean;
    brand?: string;
    isDefault?: boolean;
    page?: number;
    size?: number;
    sort?: string[];
    userUuid?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseSavedCardControllerServiceGetAllSavedCards1KeyFn(
      { active, brand, isDefault, page, size, sort, userUuid },
      queryKey,
    ),
    queryFn: () =>
      SavedCardControllerService.getAllSavedCards1({
        active,
        brand,
        isDefault,
        page,
        size,
        sort,
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.userTypes
 * @param data.bankName
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useSavedBankControllerServiceGetAllSavedBanks = <
  TData = Common.SavedBankControllerServiceGetAllSavedBanksDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    bankName,
    page,
    size,
    sort,
    userTypes,
    uuid,
  }: {
    bankName?: string;
    page?: number;
    size?: number;
    sort?: string[];
    userTypes?:
      | "EMPLOYER"
      | "PATIENT"
      | "BROKER"
      | "ADMIN_USER"
      | "PROVIDER"
      | "EMPLOYER_ADMINISTRATION"
      | "EMPLOYEE"
      | "PHP_USER"
      | "AFFILIATE_FIRM"
      | "BROKER_FIRM"
      | "NURSE_USER";
    uuid?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseSavedBankControllerServiceGetAllSavedBanksKeyFn(
      { bankName, page, size, sort, userTypes, uuid },
      queryKey,
    ),
    queryFn: () =>
      SavedBankControllerService.getAllSavedBanks({
        bankName,
        page,
        size,
        sort,
        userTypes,
        uuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @param data.bankName
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response1 OK
 * @throws ApiError
 */
export const useSavedBankControllerServiceGetAllSavedBanks1 = <
  TData = Common.SavedBankControllerServiceGetAllSavedBanks1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    bankName,
    page,
    size,
    sort,
    userUuid,
  }: {
    bankName?: string;
    page?: number;
    size?: number;
    sort?: string[];
    userUuid?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseSavedBankControllerServiceGetAllSavedBanks1KeyFn(
      { bankName, page, size, sort, userUuid },
      queryKey,
    ),
    queryFn: () =>
      SavedBankControllerService.getAllSavedBanks1({
        bankName,
        page,
        size,
        sort,
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.salesTaxProfileUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useSalesTaxProfileControllerServiceGetSalesTaxProfileByUuid = <
  TData =
    Common.SalesTaxProfileControllerServiceGetSalesTaxProfileByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    salesTaxProfileUuid,
  }: {
    salesTaxProfileUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseSalesTaxProfileControllerServiceGetSalesTaxProfileByUuidKeyFn(
        { salesTaxProfileUuid },
        queryKey,
      ),
    queryFn: () =>
      SalesTaxProfileControllerService.getSalesTaxProfileByUuid({
        salesTaxProfileUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useSalesTaxProfileControllerServiceGetAllSalesTaxProfiles = <
  TData =
    Common.SalesTaxProfileControllerServiceGetAllSalesTaxProfilesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    size,
    sort,
  }: {
    page?: number;
    size?: number;
    sort?: string[];
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseSalesTaxProfileControllerServiceGetAllSalesTaxProfilesKeyFn(
        { page, size, sort },
        queryKey,
      ),
    queryFn: () =>
      SalesTaxProfileControllerService.getAllSalesTaxProfiles({
        page,
        size,
        sort,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.salesTaxJurisdictionUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useSalesTaxJurisdictionControllerServiceGetSalesTaxJurisdictionByUuid =
  <
    TData =
      Common.SalesTaxJurisdictionControllerServiceGetSalesTaxJurisdictionByUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      salesTaxJurisdictionUuid,
    }: {
      salesTaxJurisdictionUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseSalesTaxJurisdictionControllerServiceGetSalesTaxJurisdictionByUuidKeyFn(
          { salesTaxJurisdictionUuid },
          queryKey,
        ),
      queryFn: () =>
        SalesTaxJurisdictionControllerService.getSalesTaxJurisdictionByUuid({
          salesTaxJurisdictionUuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useSalesTaxJurisdictionControllerServiceGetAllSalesTaxJurisdictions =
  <
    TData =
      Common.SalesTaxJurisdictionControllerServiceGetAllSalesTaxJurisdictionsDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      page,
      size,
      sort,
    }: {
      page?: number;
      size?: number;
      sort?: string[];
    } = {},
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseSalesTaxJurisdictionControllerServiceGetAllSalesTaxJurisdictionsKeyFn(
          { page, size, sort },
          queryKey,
        ),
      queryFn: () =>
        SalesTaxJurisdictionControllerService.getAllSalesTaxJurisdictions({
          page,
          size,
          sort,
        }) as TData,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useRolesAndPermissionControllerServiceGetRoleTypes = <
  TData = Common.RolesAndPermissionControllerServiceGetRoleTypesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseRolesAndPermissionControllerServiceGetRoleTypesKeyFn(queryKey),
    queryFn: () => RolesAndPermissionControllerService.getRoleTypes() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.roleType
 * @returns Response OK
 * @throws ApiError
 */
export const useRolesAndPermissionControllerServiceGetRolesByRoleType = <
  TData =
    Common.RolesAndPermissionControllerServiceGetRolesByRoleTypeDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    roleType,
  }: {
    roleType: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseRolesAndPermissionControllerServiceGetRolesByRoleTypeKeyFn(
        { roleType },
        queryKey,
      ),
    queryFn: () =>
      RolesAndPermissionControllerService.getRolesByRoleType({
        roleType,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.roleId
 * @returns Response OK
 * @throws ApiError
 */
export const useRolesAndPermissionControllerServiceGetFeaturesByRoleAndRoleType =
  <
    TData =
      Common.RolesAndPermissionControllerServiceGetFeaturesByRoleAndRoleTypeDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      roleId,
    }: {
      roleId: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseRolesAndPermissionControllerServiceGetFeaturesByRoleAndRoleTypeKeyFn(
          { roleId },
          queryKey,
        ),
      queryFn: () =>
        RolesAndPermissionControllerService.getFeaturesByRoleAndRoleType({
          roleId,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useRoleTypeManagementControllerServiceGetRoleTypeByUuid = <
  TData =
    Common.RoleTypeManagementControllerServiceGetRoleTypeByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseRoleTypeManagementControllerServiceGetRoleTypeByUuidKeyFn(
        { uuid },
        queryKey,
      ),
    queryFn: () =>
      RoleTypeManagementControllerService.getRoleTypeByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useRoleTypeManagementControllerServiceGetAllRoleTypes = <
  TData =
    Common.RoleTypeManagementControllerServiceGetAllRoleTypesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseRoleTypeManagementControllerServiceGetAllRoleTypesKeyFn(
        queryKey,
      ),
    queryFn: () =>
      RoleTypeManagementControllerService.getAllRoleTypes() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useRoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByUuid =
  <
    TData =
      Common.RoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      uuid,
    }: {
      uuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseRoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByUuidKeyFn(
          { uuid },
          queryKey,
        ),
      queryFn: () =>
        RoleTypeFeatureManagementControllerService.getRoleTypeFeatureByUuid({
          uuid,
        }) as TData,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useRoleTypeFeatureManagementControllerServiceGetAllRoleTypeFeatures =
  <
    TData =
      Common.RoleTypeFeatureManagementControllerServiceGetAllRoleTypeFeaturesDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseRoleTypeFeatureManagementControllerServiceGetAllRoleTypeFeaturesKeyFn(
          queryKey,
        ),
      queryFn: () =>
        RoleTypeFeatureManagementControllerService.getAllRoleTypeFeatures() as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.roleTypeUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useRoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByRoleType =
  <
    TData =
      Common.RoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByRoleTypeDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      roleTypeUuid,
    }: {
      roleTypeUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseRoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByRoleTypeKeyFn(
          { roleTypeUuid },
          queryKey,
        ),
      queryFn: () =>
        RoleTypeFeatureManagementControllerService.getRoleTypeFeaturesByRoleType(
          {
            roleTypeUuid,
          },
        ) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.roleTypeUuid
 * @param data.featureUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useRoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByRoleTypeAndFeature =
  <
    TData =
      Common.RoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByRoleTypeAndFeatureDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      featureUuid,
      roleTypeUuid,
    }: {
      featureUuid: string;
      roleTypeUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseRoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByRoleTypeAndFeatureKeyFn(
          { featureUuid, roleTypeUuid },
          queryKey,
        ),
      queryFn: () =>
        RoleTypeFeatureManagementControllerService.getRoleTypeFeatureByRoleTypeAndFeature(
          {
            featureUuid,
            roleTypeUuid,
          },
        ) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.featureUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useRoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByFeature =
  <
    TData =
      Common.RoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByFeatureDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      featureUuid,
    }: {
      featureUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseRoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByFeatureKeyFn(
          { featureUuid },
          queryKey,
        ),
      queryFn: () =>
        RoleTypeFeatureManagementControllerService.getRoleTypeFeaturesByFeature(
          {
            featureUuid,
          },
        ) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.providerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderControllerServiceGetProviderByUuid = <
  TData = Common.ProviderControllerServiceGetProviderByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    providerUuid,
  }: {
    providerUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseProviderControllerServiceGetProviderByUuidKeyFn(
      { providerUuid },
      queryKey,
    ),
    queryFn: () =>
      ProviderControllerService.getProviderByUuid({ providerUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userIamId
 * @returns boolean OK
 * @throws ApiError
 */
export const useProviderControllerServiceIsProviderWithUrgentMessageAlerts = <
  TData =
    Common.ProviderControllerServiceIsProviderWithUrgentMessageAlertsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    userIamId,
  }: {
    userIamId: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseProviderControllerServiceIsProviderWithUrgentMessageAlertsKeyFn(
        { userIamId },
        queryKey,
      ),
    queryFn: () =>
      ProviderControllerService.isProviderWithUrgentMessageAlerts({
        userIamId,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userIamId
 * @returns string OK
 * @throws ApiError
 */
export const useProviderControllerServiceGetCoveringProvidersForUrgentAlerts = <
  TData =
    Common.ProviderControllerServiceGetCoveringProvidersForUrgentAlertsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    userIamId,
  }: {
    userIamId: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseProviderControllerServiceGetCoveringProvidersForUrgentAlertsKeyFn(
        { userIamId },
        queryKey,
      ),
    queryFn: () =>
      ProviderControllerService.getCoveringProvidersForUrgentAlerts({
        userIamId,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.xLocationId
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderControllerServiceGetProviderProfile = <
  TData = Common.ProviderControllerServiceGetProviderProfileDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    xLocationId,
  }: {
    xLocationId?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseProviderControllerServiceGetProviderProfileKeyFn(
      { xLocationId },
      queryKey,
    ),
    queryFn: () =>
      ProviderControllerService.getProviderProfile({ xLocationId }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.longitude
 * @param data.latitude
 * @param data.leadUuid
 * @param data.filterBy
 * @param data.filterValue
 * @param data.searchString
 * @param data.zipcode
 * @param data.status
 * @param data.employer
 * @param data.locationUuids
 * @param data.employerPageUuid
 * @param data.specialityNames
 * @param data.stateNames
 * @param data.locationNames
 * @param data.roleUuid
 * @param data.isAffiliate
 * @param data.isPatientEnrollment
 * @param data.couponCode
 * @param data.couponLocationUuid
 * @param data.careTeamUserUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderControllerServiceGetAllProviders = <
  TData = Common.ProviderControllerServiceGetAllProvidersDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    careTeamUserUuid,
    couponCode,
    couponLocationUuid,
    employer,
    employerPageUuid,
    filterBy,
    filterValue,
    isAffiliate,
    isPatientEnrollment,
    latitude,
    leadUuid,
    locationNames,
    locationUuids,
    longitude,
    page,
    pageSize,
    roleUuid,
    searchString,
    sortBy,
    sortDirection,
    specialityNames,
    stateNames,
    status,
    zipcode,
  }: {
    careTeamUserUuid?: string;
    couponCode?: string;
    couponLocationUuid?: string[];
    employer?: boolean;
    employerPageUuid?: string;
    filterBy?: string;
    filterValue?: string[];
    isAffiliate?: boolean;
    isPatientEnrollment?: boolean;
    latitude?: string;
    leadUuid?: string;
    locationNames?: string[];
    locationUuids?: string[];
    longitude?: string;
    page?: number;
    pageSize?: number;
    roleUuid?: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    specialityNames?: string[];
    stateNames?: string[];
    status?: boolean;
    zipcode?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseProviderControllerServiceGetAllProvidersKeyFn(
      {
        careTeamUserUuid,
        couponCode,
        couponLocationUuid,
        employer,
        employerPageUuid,
        filterBy,
        filterValue,
        isAffiliate,
        isPatientEnrollment,
        latitude,
        leadUuid,
        locationNames,
        locationUuids,
        longitude,
        page,
        pageSize,
        roleUuid,
        searchString,
        sortBy,
        sortDirection,
        specialityNames,
        stateNames,
        status,
        zipcode,
      },
      queryKey,
    ),
    queryFn: () =>
      ProviderControllerService.getAllProviders({
        careTeamUserUuid,
        couponCode,
        couponLocationUuid,
        employer,
        employerPageUuid,
        filterBy,
        filterValue,
        isAffiliate,
        isPatientEnrollment,
        latitude,
        leadUuid,
        locationNames,
        locationUuids,
        longitude,
        page,
        pageSize,
        roleUuid,
        searchString,
        sortBy,
        sortDirection,
        specialityNames,
        stateNames,
        status,
        zipcode,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.longitude
 * @param data.latitude
 * @param data.patientUuid
 * @param data.filterBy
 * @param data.filterValue
 * @param data.searchString
 * @param data.zipcode
 * @param data.status
 * @param data.employer
 * @param data.locationUuid
 * @param data.employerPageUuid
 * @param data.specialityNames
 * @param data.stateNames
 * @param data.locationNames
 * @param data.affiliateGroupUuids
 * @param data.isAffiliate
 * @param data.isPatientEnrollment
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderControllerServiceGetAllProvidersByIsAffiliate = <
  TData =
    Common.ProviderControllerServiceGetAllProvidersByIsAffiliateDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    affiliateGroupUuids,
    employer,
    employerPageUuid,
    filterBy,
    filterValue,
    isAffiliate,
    isPatientEnrollment,
    latitude,
    locationNames,
    locationUuid,
    longitude,
    page,
    pageSize,
    patientUuid,
    searchString,
    sortBy,
    sortDirection,
    specialityNames,
    stateNames,
    status,
    zipcode,
  }: {
    affiliateGroupUuids?: string[];
    employer?: boolean;
    employerPageUuid?: string;
    filterBy?: string;
    filterValue?: string[];
    isAffiliate?: boolean;
    isPatientEnrollment?: boolean;
    latitude?: string;
    locationNames?: string[];
    locationUuid?: string;
    longitude?: string;
    page?: number;
    pageSize?: number;
    patientUuid?: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    specialityNames?: string[];
    stateNames?: string[];
    status?: boolean;
    zipcode?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseProviderControllerServiceGetAllProvidersByIsAffiliateKeyFn(
        {
          affiliateGroupUuids,
          employer,
          employerPageUuid,
          filterBy,
          filterValue,
          isAffiliate,
          isPatientEnrollment,
          latitude,
          locationNames,
          locationUuid,
          longitude,
          page,
          pageSize,
          patientUuid,
          searchString,
          sortBy,
          sortDirection,
          specialityNames,
          stateNames,
          status,
          zipcode,
        },
        queryKey,
      ),
    queryFn: () =>
      ProviderControllerService.getAllProvidersByIsAffiliate({
        affiliateGroupUuids,
        employer,
        employerPageUuid,
        filterBy,
        filterValue,
        isAffiliate,
        isPatientEnrollment,
        latitude,
        locationNames,
        locationUuid,
        longitude,
        page,
        pageSize,
        patientUuid,
        searchString,
        sortBy,
        sortDirection,
        specialityNames,
        stateNames,
        status,
        zipcode,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.searchString
 * @param data.zipcode
 * @param data.status
 * @param data.employer
 * @param data.locationUuid
 * @param data.specialityNames
 * @param data.stateNames
 * @param data.locationNames
 * @param data.affiliateGroupUuids
 * @returns unknown OK
 * @throws ApiError
 */
export const useProviderControllerServiceExportAffiliateProvidersCsv = <
  TData =
    Common.ProviderControllerServiceExportAffiliateProvidersCsvDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    affiliateGroupUuids,
    employer,
    locationNames,
    locationUuid,
    searchString,
    specialityNames,
    stateNames,
    status,
    zipcode,
  }: {
    affiliateGroupUuids?: string[];
    employer?: boolean;
    locationNames?: string[];
    locationUuid?: string;
    searchString?: string;
    specialityNames?: string[];
    stateNames?: string[];
    status?: boolean;
    zipcode?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseProviderControllerServiceExportAffiliateProvidersCsvKeyFn(
        {
          affiliateGroupUuids,
          employer,
          locationNames,
          locationUuid,
          searchString,
          specialityNames,
          stateNames,
          status,
          zipcode,
        },
        queryKey,
      ),
    queryFn: () =>
      ProviderControllerService.exportAffiliateProvidersCsv({
        affiliateGroupUuids,
        employer,
        locationNames,
        locationUuid,
        searchString,
        specialityNames,
        stateNames,
        status,
        zipcode,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.primaryLeadUuid
 * @param data.employer
 * @param data.birthDate
 * @param data.planUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePlanControllerServiceGetPlanAmount = <
  TData = Common.PlanControllerServiceGetPlanAmountDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    birthDate,
    employer,
    planUuid,
    primaryLeadUuid,
  }: {
    birthDate?: string;
    employer?: boolean;
    planUuid?: string;
    primaryLeadUuid?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePlanControllerServiceGetPlanAmountKeyFn(
      { birthDate, employer, planUuid, primaryLeadUuid },
      queryKey,
    ),
    queryFn: () =>
      PlanControllerService.getPlanAmount({
        birthDate,
        employer,
        planUuid,
        primaryLeadUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.planUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePlanControllerServiceGetPlanByUuid = <
  TData = Common.PlanControllerServiceGetPlanByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    planUuid,
  }: {
    planUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePlanControllerServiceGetPlanByUuidKeyFn(
      { planUuid },
      queryKey,
    ),
    queryFn: () => PlanControllerService.getPlanByUuid({ planUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.planUuid
 * @param data.employerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePlanControllerServiceGetPlanDetailsByUuid = <
  TData = Common.PlanControllerServiceGetPlanDetailsByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
    planUuid,
  }: {
    employerUuid?: string;
    planUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePlanControllerServiceGetPlanDetailsByUuidKeyFn(
      { employerUuid, planUuid },
      queryKey,
    ),
    queryFn: () =>
      PlanControllerService.getPlanDetailsByUuid({
        employerUuid,
        planUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.planUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePlanControllerServiceGetPlanStatus = <
  TData = Common.PlanControllerServiceGetPlanStatusDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    planUuid,
  }: {
    planUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePlanControllerServiceGetPlanStatusKeyFn(
      { planUuid },
      queryKey,
    ),
    queryFn: () => PlanControllerService.getPlanStatus({ planUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.primaryLeadUuid
 * @param data.planUuid
 * @param data.defaultBillingPeriod
 * @param data.relationShip
 * @param data.dependentName
 * @param data.employer
 * @param data.providerUuids
 * @param data.dependentBirthDate
 * @returns Response OK
 * @throws ApiError
 */
export const usePlanControllerServiceCheckMyPlan = <
  TData = Common.PlanControllerServiceCheckMyPlanDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    defaultBillingPeriod,
    dependentBirthDate,
    dependentName,
    employer,
    planUuid,
    primaryLeadUuid,
    providerUuids,
    relationShip,
  }: {
    defaultBillingPeriod?: "ANNUAL" | "MONTH" | "QUARTERLY" | "SEMI_ANNUALLY";
    dependentBirthDate?: string;
    dependentName?: string;
    employer?: boolean;
    planUuid?: string;
    primaryLeadUuid?: string;
    providerUuids?: string[];
    relationShip?:
      | "NONE"
      | "ALL"
      | "SELF"
      | "SPOUSE"
      | "SIBLING"
      | "MOTHER"
      | "FATHER"
      | "GUARDIAN"
      | "PARENT"
      | "CHILDREN"
      | "GRANDPARENT"
      | "GRANDCHILDREN"
      | "FRIEND"
      | "PARTNER"
      | "OTHER";
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePlanControllerServiceCheckMyPlanKeyFn(
      {
        defaultBillingPeriod,
        dependentBirthDate,
        dependentName,
        employer,
        planUuid,
        primaryLeadUuid,
        providerUuids,
        relationShip,
      },
      queryKey,
    ),
    queryFn: () =>
      PlanControllerService.checkMyPlan({
        defaultBillingPeriod,
        dependentBirthDate,
        dependentName,
        employer,
        planUuid,
        primaryLeadUuid,
        providerUuids,
        relationShip,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.planType
 * @param data.archive
 * @param data.employer
 * @param data.defaultPlan
 * @param data.employerplan
 * @returns Response OK
 * @throws ApiError
 */
export const usePlanControllerServiceGetAllPlan = <
  TData = Common.PlanControllerServiceGetAllPlanDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    archive,
    defaultPlan,
    employer,
    employerplan,
    page,
    pageSize,
    planType,
    searchString,
    sortBy,
    sortDirection,
  }: {
    archive?: boolean;
    defaultPlan?: boolean;
    employer?: boolean;
    employerplan?: "ALL" | "CURRENT" | "PAST" | "FUTURE";
    page?: number;
    pageSize?: number;
    planType?: "EMPLOYER" | "RETAIL";
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePlanControllerServiceGetAllPlanKeyFn(
      {
        archive,
        defaultPlan,
        employer,
        employerplan,
        page,
        pageSize,
        planType,
        searchString,
        sortBy,
        sortDirection,
      },
      queryKey,
    ),
    queryFn: () =>
      PlanControllerService.getAllPlan({
        archive,
        defaultPlan,
        employer,
        employerplan,
        page,
        pageSize,
        planType,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.paymentTransactionUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePaymentTransactionControllerServiceGetPaymentTransactionByUuid =
  <
    TData =
      Common.PaymentTransactionControllerServiceGetPaymentTransactionByUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      paymentTransactionUuid,
    }: {
      paymentTransactionUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UsePaymentTransactionControllerServiceGetPaymentTransactionByUuidKeyFn(
          { paymentTransactionUuid },
          queryKey,
        ),
      queryFn: () =>
        PaymentTransactionControllerService.getPaymentTransactionByUuid({
          paymentTransactionUuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const usePaymentTransactionControllerServiceGetAllPaymentTransactions = <
  TData =
    Common.PaymentTransactionControllerServiceGetAllPaymentTransactionsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UsePaymentTransactionControllerServiceGetAllPaymentTransactionsKeyFn(
        { page, pageSize, searchString, sortBy, sortDirection },
        queryKey,
      ),
    queryFn: () =>
      PaymentTransactionControllerService.getAllPaymentTransactions({
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceGetPatientByUuid = <
  TData = Common.PatientControllerServiceGetPatientByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePatientControllerServiceGetPatientByUuidKeyFn(
      { patientUuid },
      queryKey,
    ),
    queryFn: () =>
      PatientControllerService.getPatientByUuid({ patientUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceGetPatientLocationWithSalesTax = <
  TData =
    Common.PatientControllerServiceGetPatientLocationWithSalesTaxDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UsePatientControllerServiceGetPatientLocationWithSalesTaxKeyFn(
        { patientUuid },
        queryKey,
      ),
    queryFn: () =>
      PatientControllerService.getPatientLocationWithSalesTax({
        patientUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceGetLabPayerDefaults = <
  TData = Common.PatientControllerServiceGetLabPayerDefaultsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePatientControllerServiceGetLabPayerDefaultsKeyFn(
      { patientUuid },
      queryKey,
    ),
    queryFn: () =>
      PatientControllerService.getLabPayerDefaults({ patientUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.providerUuid
 * @param data.locationUuids
 * @param data.limit
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceGetRecentlyViewedPatients = <
  TData =
    Common.PatientControllerServiceGetRecentlyViewedPatientsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    limit,
    locationUuids,
    providerUuid,
  }: {
    limit?: number;
    locationUuids?: string[];
    providerUuid?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePatientControllerServiceGetRecentlyViewedPatientsKeyFn(
      { limit, locationUuids, providerUuid },
      queryKey,
    ),
    queryFn: () =>
      PatientControllerService.getRecentlyViewedPatients({
        limit,
        locationUuids,
        providerUuid,
      }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceGetProfile1 = <
  TData = Common.PatientControllerServiceGetProfile1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePatientControllerServiceGetProfile1KeyFn(queryKey),
    queryFn: () => PatientControllerService.getProfile1() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceGetPatientPlanDetails = <
  TData = Common.PatientControllerServiceGetPatientPlanDetailsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePatientControllerServiceGetPatientPlanDetailsKeyFn(
      { patientUuid },
      queryKey,
    ),
    queryFn: () =>
      PatientControllerService.getPatientPlanDetails({ patientUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceGetPatientOverview = <
  TData = Common.PatientControllerServiceGetPatientOverviewDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePatientControllerServiceGetPatientOverviewKeyFn(
      { patientUuid },
      queryKey,
    ),
    queryFn: () =>
      PatientControllerService.getPatientOverview({ patientUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceGetPatientMemberShip = <
  TData = Common.PatientControllerServiceGetPatientMemberShipDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePatientControllerServiceGetPatientMemberShipKeyFn(
      { page, pageSize, patientUuid, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      PatientControllerService.getPatientMemberShip({
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.paymentTransactionUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceGetPatientEmployeeMembershipDetails = <
  TData =
    Common.PatientControllerServiceGetPatientEmployeeMembershipDetailsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
    paymentTransactionUuid,
  }: {
    patientUuid: string;
    paymentTransactionUuid?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UsePatientControllerServiceGetPatientEmployeeMembershipDetailsKeyFn(
        { patientUuid, paymentTransactionUuid },
        queryKey,
      ),
    queryFn: () =>
      PatientControllerService.getPatientEmployeeMembershipDetails({
        patientUuid,
        paymentTransactionUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.employers
 * @param data.affiliateGroupUuid
 * @param data.providerUuids
 * @param data.locationUuids
 * @param data.patientStatus
 * @param data.employerUuids
 * @param data.excludeExistingDependents
 * @param data.isAffiliate
 * @param data.birthDateStart
 * @param data.birthDateEnd
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceGetPatientDropDown = <
  TData = Common.PatientControllerServiceGetPatientDropDownDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    affiliateGroupUuid,
    birthDateEnd,
    birthDateStart,
    employers,
    employerUuids,
    excludeExistingDependents,
    isAffiliate,
    locationUuids,
    page,
    pageSize,
    patientStatus,
    providerUuids,
    searchString,
    sortBy,
    sortDirection,
  }: {
    affiliateGroupUuid?: string;
    birthDateEnd?: string;
    birthDateStart?: string;
    employers?: boolean;
    employerUuids?: string[];
    excludeExistingDependents?: boolean;
    isAffiliate?: boolean;
    locationUuids?: string[];
    page?: number;
    pageSize?: number;
    patientStatus?: "ACTIVE" | "PENDING" | "INACTIVE";
    providerUuids?: string[];
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePatientControllerServiceGetPatientDropDownKeyFn(
      {
        affiliateGroupUuid,
        birthDateEnd,
        birthDateStart,
        employers,
        employerUuids,
        excludeExistingDependents,
        isAffiliate,
        locationUuids,
        page,
        pageSize,
        patientStatus,
        providerUuids,
        searchString,
        sortBy,
        sortDirection,
      },
      queryKey,
    ),
    queryFn: () =>
      PatientControllerService.getPatientDropDown({
        affiliateGroupUuid,
        birthDateEnd,
        birthDateStart,
        employers,
        employerUuids,
        excludeExistingDependents,
        isAffiliate,
        locationUuids,
        page,
        pageSize,
        patientStatus,
        providerUuids,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceGetPatientWithDependents = <
  TData =
    Common.PatientControllerServiceGetPatientWithDependentsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePatientControllerServiceGetPatientWithDependentsKeyFn(
      { patientUuid },
      queryKey,
    ),
    queryFn: () =>
      PatientControllerService.getPatientWithDependents({
        patientUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.affiliateGroupUuid
 * @param data.providerUuid
 * @returns string OK
 * @throws ApiError
 */
export const usePatientControllerServiceExportPatientsByAffiliateGroup = <
  TData =
    Common.PatientControllerServiceExportPatientsByAffiliateGroupDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    affiliateGroupUuid,
    providerUuid,
  }: {
    affiliateGroupUuid: string;
    providerUuid?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UsePatientControllerServiceExportPatientsByAffiliateGroupKeyFn(
        { affiliateGroupUuid, providerUuid },
        queryKey,
      ),
    queryFn: () =>
      PatientControllerService.exportPatientsByAffiliateGroup({
        affiliateGroupUuid,
        providerUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.primaryPatient
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceGetDependents = <
  TData = Common.PatientControllerServiceGetDependentsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    primaryPatient,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    primaryPatient?: boolean;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePatientControllerServiceGetDependentsKeyFn(
      { page, pageSize, patientUuid, primaryPatient, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      PatientControllerService.getDependents({
        page,
        pageSize,
        patientUuid,
        primaryPatient,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.startDate
 * @param data.endDate
 * @param data.employerUuids
 * @param data.providerUuid
 * @param data.employers
 * @param data.paid
 * @param data.billing
 * @param data.patientStatus
 * @param data.affiliateGroupUuid
 * @param data.planUuids
 * @param data.joinedPracticeDate
 * @param data.joinedPracticeEndDate
 * @param data.breakGlassUuid
 * @param data.isProvider
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceGetAllPatient = <
  TData = Common.PatientControllerServiceGetAllPatientDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    affiliateGroupUuid,
    billing,
    breakGlassUuid,
    employers,
    employerUuids,
    endDate,
    isProvider,
    joinedPracticeDate,
    joinedPracticeEndDate,
    page,
    pageSize,
    paid,
    patientStatus,
    planUuids,
    providerUuid,
    searchString,
    sortBy,
    sortDirection,
    startDate,
  }: {
    affiliateGroupUuid?: string;
    billing?: boolean;
    breakGlassUuid?: string;
    employers?: boolean;
    employerUuids?: string[];
    endDate?: string;
    isProvider?: boolean;
    joinedPracticeDate?: string;
    joinedPracticeEndDate?: string;
    page?: number;
    pageSize?: number;
    paid?: boolean;
    patientStatus?: "ACTIVE" | "PENDING" | "INACTIVE";
    planUuids?: string[];
    providerUuid?: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    startDate?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePatientControllerServiceGetAllPatientKeyFn(
      {
        affiliateGroupUuid,
        billing,
        breakGlassUuid,
        employers,
        employerUuids,
        endDate,
        isProvider,
        joinedPracticeDate,
        joinedPracticeEndDate,
        page,
        pageSize,
        paid,
        patientStatus,
        planUuids,
        providerUuid,
        searchString,
        sortBy,
        sortDirection,
        startDate,
      },
      queryKey,
    ),
    queryFn: () =>
      PatientControllerService.getAllPatient({
        affiliateGroupUuid,
        billing,
        breakGlassUuid,
        employers,
        employerUuids,
        endDate,
        isProvider,
        joinedPracticeDate,
        joinedPracticeEndDate,
        page,
        pageSize,
        paid,
        patientStatus,
        planUuids,
        providerUuid,
        searchString,
        sortBy,
        sortDirection,
        startDate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientModuleUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientModuleControllerServiceGetByUuid1 = <
  TData = Common.PatientModuleControllerServiceGetByUuid1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientModuleUuid,
  }: {
    patientModuleUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePatientModuleControllerServiceGetByUuid1KeyFn(
      { patientModuleUuid },
      queryKey,
    ),
    queryFn: () =>
      PatientModuleControllerService.getByUuid1({ patientModuleUuid }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientModuleControllerServiceGetAll = <
  TData = Common.PatientModuleControllerServiceGetAllDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePatientModuleControllerServiceGetAllKeyFn(queryKey),
    queryFn: () => PatientModuleControllerService.getAll() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientModuleAccessUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientModuleAccessControllerServiceGetByUuid2 = <
  TData = Common.PatientModuleAccessControllerServiceGetByUuid2DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientModuleAccessUuid,
  }: {
    patientModuleAccessUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePatientModuleAccessControllerServiceGetByUuid2KeyFn(
      { patientModuleAccessUuid },
      queryKey,
    ),
    queryFn: () =>
      PatientModuleAccessControllerService.getByUuid2({
        patientModuleAccessUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.granteePatientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientModuleAccessControllerServiceGetAllByGrantee = <
  TData =
    Common.PatientModuleAccessControllerServiceGetAllByGranteeDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    granteePatientUuid,
  }: {
    granteePatientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UsePatientModuleAccessControllerServiceGetAllByGranteeKeyFn(
        { granteePatientUuid },
        queryKey,
      ),
    queryFn: () =>
      PatientModuleAccessControllerService.getAllByGrantee({
        granteePatientUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.ownerPatientUuid
 * @param data.granteePatientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientModuleAccessControllerServiceGetAllByOwnerAndGrantee = <
  TData =
    Common.PatientModuleAccessControllerServiceGetAllByOwnerAndGranteeDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    granteePatientUuid,
    ownerPatientUuid,
  }: {
    granteePatientUuid: string;
    ownerPatientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UsePatientModuleAccessControllerServiceGetAllByOwnerAndGranteeKeyFn(
        { granteePatientUuid, ownerPatientUuid },
        queryKey,
      ),
    queryFn: () =>
      PatientModuleAccessControllerService.getAllByOwnerAndGrantee({
        granteePatientUuid,
        ownerPatientUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientInformationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientInformationControllerServiceGetByUuid = <
  TData = Common.PatientInformationControllerServiceGetByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientInformationUuid,
  }: {
    patientInformationUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePatientInformationControllerServiceGetByUuidKeyFn(
      { patientInformationUuid },
      queryKey,
    ),
    queryFn: () =>
      PatientInformationControllerService.getByUuid({
        patientInformationUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientInformationControllerServiceGetAllByPatientUuid = <
  TData =
    Common.PatientInformationControllerServiceGetAllByPatientUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UsePatientInformationControllerServiceGetAllByPatientUuidKeyFn(
        { page, pageSize, patientUuid, sortBy, sortDirection },
        queryKey,
      ),
    queryFn: () =>
      PatientInformationControllerService.getAllByPatientUuid({
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNurseStaffProviderControllerServiceGetNurseStaffProviderByUuid =
  <
    TData =
      Common.NurseStaffProviderControllerServiceGetNurseStaffProviderByUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      uuid,
    }: {
      uuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseNurseStaffProviderControllerServiceGetNurseStaffProviderByUuidKeyFn(
          { uuid },
          queryKey,
        ),
      queryFn: () =>
        NurseStaffProviderControllerService.getNurseStaffProviderByUuid({
          uuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.status
 * @param data.roleUuids
 * @param data.providerUuid
 * @param data.locationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNurseStaffProviderControllerServiceGetAllNurseStaffProviders = <
  TData =
    Common.NurseStaffProviderControllerServiceGetAllNurseStaffProvidersDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationUuid,
    page,
    pageSize,
    providerUuid,
    roleUuids,
    searchString,
    sortBy,
    sortDirection,
    status,
  }: {
    locationUuid?: string;
    page?: number;
    pageSize?: number;
    providerUuid?: string;
    roleUuids?: string[];
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: boolean;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseNurseStaffProviderControllerServiceGetAllNurseStaffProvidersKeyFn(
        {
          locationUuid,
          page,
          pageSize,
          providerUuid,
          roleUuids,
          searchString,
          sortBy,
          sortDirection,
          status,
        },
        queryKey,
      ),
    queryFn: () =>
      NurseStaffProviderControllerService.getAllNurseStaffProviders({
        locationUuid,
        page,
        pageSize,
        providerUuid,
        roleUuids,
        searchString,
        sortBy,
        sortDirection,
        status,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.leadUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLeadControllerServiceGetLeadByUuid = <
  TData = Common.LeadControllerServiceGetLeadByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    leadUuid,
  }: {
    leadUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLeadControllerServiceGetLeadByUuidKeyFn(
      { leadUuid },
      queryKey,
    ),
    queryFn: () => LeadControllerService.getLeadByUuid({ leadUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.couponCode
 * @returns Response OK
 * @throws ApiError
 */
export const useLeadControllerServiceValidateCouponCode = <
  TData = Common.LeadControllerServiceValidateCouponCodeDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    couponCode,
  }: {
    couponCode: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLeadControllerServiceValidateCouponCodeKeyFn(
      { couponCode },
      queryKey,
    ),
    queryFn: () =>
      LeadControllerService.validateCouponCode({ couponCode }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.leadUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLeadControllerServiceGetLeadFullInfo = <
  TData = Common.LeadControllerServiceGetLeadFullInfoDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    leadUuid,
  }: {
    leadUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLeadControllerServiceGetLeadFullInfoKeyFn(
      { leadUuid },
      queryKey,
    ),
    queryFn: () => LeadControllerService.getLeadFullInfo({ leadUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.isContact
 * @returns Response OK
 * @throws ApiError
 */
export const useLeadControllerServiceGetAllLead = <
  TData = Common.LeadControllerServiceGetAllLeadDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    isContact,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    isContact?: boolean;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLeadControllerServiceGetAllLeadKeyFn(
      { isContact, page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      LeadControllerService.getAllLead({
        isContact,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useInvoiceSettingControllerServiceGetInvoiceSettingByUuid = <
  TData =
    Common.InvoiceSettingControllerServiceGetInvoiceSettingByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseInvoiceSettingControllerServiceGetInvoiceSettingByUuidKeyFn(
        { uuid },
        queryKey,
      ),
    queryFn: () =>
      InvoiceSettingControllerService.getInvoiceSettingByUuid({
        uuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useInvoiceSettingControllerServiceGetAllInvoiceSettings = <
  TData =
    Common.InvoiceSettingControllerServiceGetAllInvoiceSettingsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseInvoiceSettingControllerServiceGetAllInvoiceSettingsKeyFn(
        { page, pageSize, sortBy, sortDirection },
        queryKey,
      ),
    queryFn: () =>
      InvoiceSettingControllerService.getAllInvoiceSettings({
        page,
        pageSize,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useFeatureManagementControllerServiceGetFeatureByUuid = <
  TData =
    Common.FeatureManagementControllerServiceGetFeatureByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseFeatureManagementControllerServiceGetFeatureByUuidKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () =>
      FeatureManagementControllerService.getFeatureByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useFeatureManagementControllerServiceGetAllFeatures = <
  TData =
    Common.FeatureManagementControllerServiceGetAllFeaturesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseFeatureManagementControllerServiceGetAllFeaturesKeyFn(queryKey),
    queryFn: () => FeatureManagementControllerService.getAllFeatures() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.locationUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceFetchSentFaxesByLocation = <
  TData = Common.FaxControllerServiceFetchSentFaxesByLocationDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationUuid,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    locationUuid: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseFaxControllerServiceFetchSentFaxesByLocationKeyFn(
      { locationUuid, page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      FaxControllerService.fetchSentFaxesByLocation({
        locationUuid,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.direction
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceRetrieveFax = <
  TData = Common.FaxControllerServiceRetrieveFaxDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    direction,
    uuid,
  }: {
    direction: string;
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseFaxControllerServiceRetrieveFaxKeyFn(
      { direction, uuid },
      queryKey,
    ),
    queryFn: () =>
      FaxControllerService.retrieveFax({ direction, uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns string OK
 * @throws ApiError
 */
export const useFaxControllerServiceGetImagingResultPdf = <
  TData = Common.FaxControllerServiceGetImagingResultPdfDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseFaxControllerServiceGetImagingResultPdfKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () => FaxControllerService.getImagingResultPdf({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns string OK
 * @throws ApiError
 */
export const useFaxControllerServiceGetLabOrderPdf = <
  TData = Common.FaxControllerServiceGetLabOrderPdfDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseFaxControllerServiceGetLabOrderPdfKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () => FaxControllerService.getLabOrderPdf({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceFetchOutboxFaxes = <
  TData = Common.FaxControllerServiceFetchOutboxFaxesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
  }: {
    page?: number;
    pageSize?: number;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseFaxControllerServiceFetchOutboxFaxesKeyFn(
      { page, pageSize },
      queryKey,
    ),
    queryFn: () =>
      FaxControllerService.fetchOutboxFaxes({ page, pageSize }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.locationUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceFetchInboxFaxes = <
  TData = Common.FaxControllerServiceFetchInboxFaxesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationUuid,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    locationUuid: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseFaxControllerServiceFetchInboxFaxesKeyFn(
      { locationUuid, page, pageSize, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      FaxControllerService.fetchInboxFaxes({
        locationUuid,
        page,
        pageSize,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceFetchInboxWithSubUsers = <
  TData = Common.FaxControllerServiceFetchInboxWithSubUsersDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseFaxControllerServiceFetchInboxWithSubUsersKeyFn(queryKey),
    queryFn: () => FaxControllerService.fetchInboxWithSubUsers() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.locationUuid
 * @param data.paginationOffset
 * @param data.paginationLimit
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceFetchSentFaxesFromEfax = <
  TData = Common.FaxControllerServiceFetchSentFaxesFromEfaxDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationUuid,
    paginationLimit,
    paginationOffset,
  }: {
    locationUuid: string;
    paginationLimit?: number;
    paginationOffset?: number;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseFaxControllerServiceFetchSentFaxesFromEfaxKeyFn(
      { locationUuid, paginationLimit, paginationOffset },
      queryKey,
    ),
    queryFn: () =>
      FaxControllerService.fetchSentFaxesFromEfax({
        locationUuid,
        paginationLimit,
        paginationOffset,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.locationUuid
 * @param data.paginationOffset
 * @param data.paginationLimit
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceFetchReceivedFaxesFromEfax = <
  TData = Common.FaxControllerServiceFetchReceivedFaxesFromEfaxDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationUuid,
    paginationLimit,
    paginationOffset,
  }: {
    locationUuid: string;
    paginationLimit?: number;
    paginationOffset?: number;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseFaxControllerServiceFetchReceivedFaxesFromEfaxKeyFn(
      { locationUuid, paginationLimit, paginationOffset },
      queryKey,
    ),
    queryFn: () =>
      FaxControllerService.fetchReceivedFaxesFromEfax({
        locationUuid,
        paginationLimit,
        paginationOffset,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.faxId
 * @param data.locationUuid
 * @param data.startPage
 * @param data.numPages
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceFetchEfaxFaxPages = <
  TData = Common.FaxControllerServiceFetchEfaxFaxPagesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    faxId,
    locationUuid,
    numPages,
    startPage,
  }: {
    faxId: string;
    locationUuid: string;
    numPages?: number;
    startPage?: number;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseFaxControllerServiceFetchEfaxFaxPagesKeyFn(
      { faxId, locationUuid, numPages, startPage },
      queryKey,
    ),
    queryFn: () =>
      FaxControllerService.fetchEfaxFaxPages({
        faxId,
        locationUuid,
        numPages,
        startPage,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.faxId
 * @param data.locationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceFetchEfaxOutboundFaxMetadata = <
  TData =
    Common.FaxControllerServiceFetchEfaxOutboundFaxMetadataDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    faxId,
    locationUuid,
  }: {
    faxId: string;
    locationUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseFaxControllerServiceFetchEfaxOutboundFaxMetadataKeyFn(
      { faxId, locationUuid },
      queryKey,
    ),
    queryFn: () =>
      FaxControllerService.fetchEfaxOutboundFaxMetadata({
        faxId,
        locationUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.faxId
 * @param data.locationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceFetchEfaxFaxMetadata = <
  TData = Common.FaxControllerServiceFetchEfaxFaxMetadataDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    faxId,
    locationUuid,
  }: {
    faxId: string;
    locationUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseFaxControllerServiceFetchEfaxFaxMetadataKeyFn(
      { faxId, locationUuid },
      queryKey,
    ),
    queryFn: () =>
      FaxControllerService.fetchEfaxFaxMetadata({
        faxId,
        locationUuid,
      }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useFaceSheetLayoutControllerServiceGetLayout = <
  TData = Common.FaceSheetLayoutControllerServiceGetLayoutDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseFaceSheetLayoutControllerServiceGetLayoutKeyFn(queryKey),
    queryFn: () => FaceSheetLayoutControllerService.getLayout() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceGetPricingDetails = <
  TData = Common.EmployerControllerServiceGetPricingDetailsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
  }: {
    employerUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEmployerControllerServiceGetPricingDetailsKeyFn(
      { employerUuid },
      queryKey,
    ),
    queryFn: () =>
      EmployerControllerService.getPricingDetails({ employerUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceGetOnlineSignUp = <
  TData = Common.EmployerControllerServiceGetOnlineSignUpDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
  }: {
    employerUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEmployerControllerServiceGetOnlineSignUpKeyFn(
      { employerUuid },
      queryKey,
    ),
    queryFn: () =>
      EmployerControllerService.getOnlineSignUp({ employerUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceGetAccountDetails = <
  TData = Common.EmployerControllerServiceGetAccountDetailsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
  }: {
    employerUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEmployerControllerServiceGetAccountDetailsKeyFn(
      { employerUuid },
      queryKey,
    ),
    queryFn: () =>
      EmployerControllerService.getAccountDetails({ employerUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceGetInvoiceSetting = <
  TData = Common.EmployerControllerServiceGetInvoiceSettingDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
  }: {
    employerUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEmployerControllerServiceGetInvoiceSettingKeyFn(
      { employerUuid },
      queryKey,
    ),
    queryFn: () =>
      EmployerControllerService.getInvoiceSetting({ employerUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.isEmployeePatient
 * @param data.patientStatus
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceGetAllEmployerTotalCount = <
  TData =
    Common.EmployerControllerServiceGetAllEmployerTotalCountDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
    isEmployeePatient,
    patientStatus,
  }: {
    employerUuid?: string;
    isEmployeePatient?: boolean;
    patientStatus?: "ACTIVE" | "PENDING" | "INACTIVE";
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEmployerControllerServiceGetAllEmployerTotalCountKeyFn(
      { employerUuid, isEmployeePatient, patientStatus },
      queryKey,
    ),
    queryFn: () =>
      EmployerControllerService.getAllEmployerTotalCount({
        employerUuid,
        isEmployeePatient,
        patientStatus,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceGetEmployerMemberShip = <
  TData = Common.EmployerControllerServiceGetEmployerMemberShipDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    employerUuid: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEmployerControllerServiceGetEmployerMemberShipKeyFn(
      { employerUuid, page, pageSize, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      EmployerControllerService.getEmployerMemberShip({
        employerUuid,
        page,
        pageSize,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.planUuid
 * @param data.employerPlanHistoryUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceGetMembershipDetails = <
  TData = Common.EmployerControllerServiceGetMembershipDetailsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerPlanHistoryUuid,
    employerUuid,
    planUuid,
  }: {
    employerPlanHistoryUuid?: string;
    employerUuid: string;
    planUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEmployerControllerServiceGetMembershipDetailsKeyFn(
      { employerPlanHistoryUuid, employerUuid, planUuid },
      queryKey,
    ),
    queryFn: () =>
      EmployerControllerService.getMembershipDetails({
        employerPlanHistoryUuid,
        employerUuid,
        planUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceGetEmployerByUuid = <
  TData = Common.EmployerControllerServiceGetEmployerByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEmployerControllerServiceGetEmployerByUuidKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () =>
      EmployerControllerService.getEmployerByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceGetEmployerCustomLogoByUuid = <
  TData =
    Common.EmployerControllerServiceGetEmployerCustomLogoByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseEmployerControllerServiceGetEmployerCustomLogoByUuidKeyFn(
        { uuid },
        queryKey,
      ),
    queryFn: () =>
      EmployerControllerService.getEmployerCustomLogoByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceGetEmployerCoveragePlans = <
  TData =
    Common.EmployerControllerServiceGetEmployerCoveragePlansDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    employerUuid: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEmployerControllerServiceGetEmployerCoveragePlansKeyFn(
      { employerUuid, page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      EmployerControllerService.getEmployerCoveragePlans({
        employerUuid,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceGetBasicDetailsByPatientUuid = <
  TData =
    Common.EmployerControllerServiceGetBasicDetailsByPatientUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseEmployerControllerServiceGetBasicDetailsByPatientUuidKeyFn(
        { uuid },
        queryKey,
      ),
    queryFn: () =>
      EmployerControllerService.getBasicDetailsByPatientUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.planName
 * @param data.status
 * @param data.search
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceGetAllEmployers = <
  TData = Common.EmployerControllerServiceGetAllEmployersDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    planName,
    search,
    sortBy,
    sortDirection,
    status,
  }: {
    page?: number;
    pageSize?: number;
    planName?: string;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: boolean;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEmployerControllerServiceGetAllEmployersKeyFn(
      { page, pageSize, planName, search, sortBy, sortDirection, status },
      queryKey,
    ),
    queryFn: () =>
      EmployerControllerService.getAllEmployers({
        page,
        pageSize,
        planName,
        search,
        sortBy,
        sortDirection,
        status,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerPageUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerPageControllerServiceGetEmployerPageByUuid = <
  TData =
    Common.EmployerPageControllerServiceGetEmployerPageByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerPageUuid,
  }: {
    employerPageUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEmployerPageControllerServiceGetEmployerPageByUuidKeyFn(
      { employerPageUuid },
      queryKey,
    ),
    queryFn: () =>
      EmployerPageControllerService.getEmployerPageByUuid({
        employerPageUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerPageUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerPageControllerServiceIsLinkActive = <
  TData = Common.EmployerPageControllerServiceIsLinkActiveDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerPageUuid,
  }: {
    employerPageUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEmployerPageControllerServiceIsLinkActiveKeyFn(
      { employerPageUuid },
      queryKey,
    ),
    queryFn: () =>
      EmployerPageControllerService.isLinkActive({ employerPageUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.employerOnlineSignUpUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerPageControllerServiceGetAllEmployerPages = <
  TData =
    Common.EmployerPageControllerServiceGetAllEmployerPagesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerOnlineSignUpUuid,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    employerOnlineSignUpUuid?: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEmployerPageControllerServiceGetAllEmployerPagesKeyFn(
      { employerOnlineSignUpUuid, page, pageSize, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      EmployerPageControllerService.getAllEmployerPages({
        employerOnlineSignUpUuid,
        page,
        pageSize,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerDivisionUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerDivisionControllerServiceGetEmployerDivisionByUuid = <
  TData =
    Common.EmployerDivisionControllerServiceGetEmployerDivisionByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerDivisionUuid,
  }: {
    employerDivisionUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseEmployerDivisionControllerServiceGetEmployerDivisionByUuidKeyFn(
        { employerDivisionUuid },
        queryKey,
      ),
    queryFn: () =>
      EmployerDivisionControllerService.getEmployerDivisionByUuid({
        employerDivisionUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.employerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerDivisionControllerServiceGetAllEmployerDivisions = <
  TData =
    Common.EmployerDivisionControllerServiceGetAllEmployerDivisionsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    employerUuid?: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseEmployerDivisionControllerServiceGetAllEmployerDivisionsKeyFn(
        { employerUuid, page, pageSize, sortBy, sortDirection },
        queryKey,
      ),
    queryFn: () =>
      EmployerDivisionControllerService.getAllEmployerDivisions({
        employerUuid,
        page,
        pageSize,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerAdministratorUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerAdministratorControllerServiceGetEmployerAdministratorByUuid =
  <
    TData =
      Common.EmployerAdministratorControllerServiceGetEmployerAdministratorByUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      employerAdministratorUuid,
    }: {
      employerAdministratorUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseEmployerAdministratorControllerServiceGetEmployerAdministratorByUuidKeyFn(
          { employerAdministratorUuid },
          queryKey,
        ),
      queryFn: () =>
        EmployerAdministratorControllerService.getEmployerAdministratorByUuid({
          employerAdministratorUuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerAdministratorControllerServiceGetAllEmployerAdministrators =
  <
    TData =
      Common.EmployerAdministratorControllerServiceGetAllEmployerAdministratorsDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      employerUuid,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
    }: {
      employerUuid: string;
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseEmployerAdministratorControllerServiceGetAllEmployerAdministratorsKeyFn(
          { employerUuid, page, pageSize, searchString, sortBy, sortDirection },
          queryKey,
        ),
      queryFn: () =>
        EmployerAdministratorControllerService.getAllEmployerAdministrators({
          employerUuid,
          page,
          pageSize,
          searchString,
          sortBy,
          sortDirection,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCreditControllerServiceGetCreditByUuid = <
  TData = Common.CreditControllerServiceGetCreditByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCreditControllerServiceGetCreditByUuidKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () => CreditControllerService.getCreditByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCreditControllerServiceGetTotalCreditByUuid = <
  TData = Common.CreditControllerServiceGetTotalCreditByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCreditControllerServiceGetTotalCreditByUuidKeyFn(
      { patientUuid },
      queryKey,
    ),
    queryFn: () =>
      CreditControllerService.getTotalCreditByUuid({ patientUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.expired
 * @returns Response OK
 * @throws ApiError
 */
export const useCreditControllerServiceGetAllCredits = <
  TData = Common.CreditControllerServiceGetAllCreditsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    expired,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    expired?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCreditControllerServiceGetAllCreditsKeyFn(
      { expired, page, pageSize, patientUuid, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      CreditControllerService.getAllCredits({
        expired,
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.coverageRuleUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCoverageRuleControllerServiceGetCoverageRuleByUuid = <
  TData =
    Common.CoverageRuleControllerServiceGetCoverageRuleByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    coverageRuleUuid,
  }: {
    coverageRuleUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCoverageRuleControllerServiceGetCoverageRuleByUuidKeyFn(
      { coverageRuleUuid },
      queryKey,
    ),
    queryFn: () =>
      CoverageRuleControllerService.getCoverageRuleByUuid({
        coverageRuleUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useCoverageRuleControllerServiceGetAllCoverageRule = <
  TData = Common.CoverageRuleControllerServiceGetAllCoverageRuleDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCoverageRuleControllerServiceGetAllCoverageRuleKeyFn(
      { page, pageSize, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      CoverageRuleControllerService.getAllCoverageRule({
        page,
        pageSize,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.coveragePlanUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCoveragePlanControllerServiceGetCoveragePlanByUuid = <
  TData =
    Common.CoveragePlanControllerServiceGetCoveragePlanByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    coveragePlanUuid,
  }: {
    coveragePlanUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCoveragePlanControllerServiceGetCoveragePlanByUuidKeyFn(
      { coveragePlanUuid },
      queryKey,
    ),
    queryFn: () =>
      CoveragePlanControllerService.getCoveragePlanByUuid({
        coveragePlanUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useCoveragePlanControllerServiceGetAllCoveragePlan = <
  TData = Common.CoveragePlanControllerServiceGetAllCoveragePlanDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCoveragePlanControllerServiceGetAllCoveragePlanKeyFn(
      { page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      CoveragePlanControllerService.getAllCoveragePlan({
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.couponUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCouponControllerServiceGetCouponByUuid = <
  TData = Common.CouponControllerServiceGetCouponByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    couponUuid,
  }: {
    couponUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCouponControllerServiceGetCouponByUuidKeyFn(
      { couponUuid },
      queryKey,
    ),
    queryFn: () =>
      CouponControllerService.getCouponByUuid({ couponUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.activeExpired
 * @param data.providerUuids
 * @param data.redeemableNonRedeemable
 * @returns Response OK
 * @throws ApiError
 */
export const useCouponControllerServiceGetAllCoupons = <
  TData = Common.CouponControllerServiceGetAllCouponsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    activeExpired,
    page,
    pageSize,
    providerUuids,
    redeemableNonRedeemable,
    searchString,
    sortBy,
    sortDirection,
  }: {
    activeExpired?:
      | "CURRENT"
      | "REDEEMABLE"
      | "NON_REDEEMABLE"
      | "ARCHIVE"
      | "EXPIRED";
    page?: number;
    pageSize?: number;
    providerUuids?: string[];
    redeemableNonRedeemable?:
      | "CURRENT"
      | "REDEEMABLE"
      | "NON_REDEEMABLE"
      | "ARCHIVE"
      | "EXPIRED";
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCouponControllerServiceGetAllCouponsKeyFn(
      {
        activeExpired,
        page,
        pageSize,
        providerUuids,
        redeemableNonRedeemable,
        searchString,
        sortBy,
        sortDirection,
      },
      queryKey,
    ),
    queryFn: () =>
      CouponControllerService.getAllCoupons({
        activeExpired,
        page,
        pageSize,
        providerUuids,
        redeemableNonRedeemable,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.chargeItemUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useChargeItemControllerServiceGetChargeItemByUuid = <
  TData = Common.ChargeItemControllerServiceGetChargeItemByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    chargeItemUuid,
  }: {
    chargeItemUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseChargeItemControllerServiceGetChargeItemByUuidKeyFn(
      { chargeItemUuid },
      queryKey,
    ),
    queryFn: () =>
      ChargeItemControllerService.getChargeItemByUuid({
        chargeItemUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.chargeItemUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useChargeItemControllerServiceGetChargeItemTaxMapping = <
  TData =
    Common.ChargeItemControllerServiceGetChargeItemTaxMappingDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    chargeItemUuid,
    patientUuid,
  }: {
    chargeItemUuid: string;
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseChargeItemControllerServiceGetChargeItemTaxMappingKeyFn(
      { chargeItemUuid, patientUuid },
      queryKey,
    ),
    queryFn: () =>
      ChargeItemControllerService.getChargeItemTaxMapping({
        chargeItemUuid,
        patientUuid,
      }) as TData,
    ...options,
  });
/**
 * @returns binary OK
 * @throws ApiError
 */
export const useChargeItemControllerServiceDownloadPriceUpdateCsvTemplate = <
  TData =
    Common.ChargeItemControllerServiceDownloadPriceUpdateCsvTemplateDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseChargeItemControllerServiceDownloadPriceUpdateCsvTemplateKeyFn(
        queryKey,
      ),
    queryFn: () =>
      ChargeItemControllerService.downloadPriceUpdateCsvTemplate() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.search
 * @param data.categoryName
 * @param data.minPrice
 * @param data.maxPrice
 * @returns unknown OK
 * @throws ApiError
 */
export const useChargeItemControllerServiceExportCsv = <
  TData = Common.ChargeItemControllerServiceExportCsvDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    categoryName,
    maxPrice,
    minPrice,
    search,
  }: {
    categoryName?: string;
    maxPrice?: number;
    minPrice?: number;
    search?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseChargeItemControllerServiceExportCsvKeyFn(
      { categoryName, maxPrice, minPrice, search },
      queryKey,
    ),
    queryFn: () =>
      ChargeItemControllerService.exportCsv({
        categoryName,
        maxPrice,
        minPrice,
        search,
      }) as TData,
    ...options,
  });
/**
 * @returns binary OK
 * @throws ApiError
 */
export const useChargeItemControllerServiceDownloadCsvTemplate1 = <
  TData = Common.ChargeItemControllerServiceDownloadCsvTemplate1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseChargeItemControllerServiceDownloadCsvTemplate1KeyFn(queryKey),
    queryFn: () => ChargeItemControllerService.downloadCsvTemplate1() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.chargeCategoryUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useChargeItemControllerServiceGetChargeItemsByChargeCategoryUuid =
  <
    TData =
      Common.ChargeItemControllerServiceGetChargeItemsByChargeCategoryUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      chargeCategoryUuid,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
    }: {
      chargeCategoryUuid: string;
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseChargeItemControllerServiceGetChargeItemsByChargeCategoryUuidKeyFn(
          {
            chargeCategoryUuid,
            page,
            pageSize,
            searchString,
            sortBy,
            sortDirection,
          },
          queryKey,
        ),
      queryFn: () =>
        ChargeItemControllerService.getChargeItemsByChargeCategoryUuid({
          chargeCategoryUuid,
          page,
          pageSize,
          searchString,
          sortBy,
          sortDirection,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.search
 * @param data.categoryName
 * @param data.minPrice
 * @param data.maxPrice
 * @param data.status
 * @returns Response OK
 * @throws ApiError
 */
export const useChargeItemControllerServiceSearchAndFilterChargeItems = <
  TData =
    Common.ChargeItemControllerServiceSearchAndFilterChargeItemsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    categoryName,
    maxPrice,
    minPrice,
    page,
    pageSize,
    search,
    sortBy,
    sortDirection,
    status,
  }: {
    categoryName?: string;
    maxPrice?: number;
    minPrice?: number;
    page?: number;
    pageSize?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: "ACTIVE" | "PENDING" | "ENDED";
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseChargeItemControllerServiceSearchAndFilterChargeItemsKeyFn(
        {
          categoryName,
          maxPrice,
          minPrice,
          page,
          pageSize,
          search,
          sortBy,
          sortDirection,
          status,
        },
        queryKey,
      ),
    queryFn: () =>
      ChargeItemControllerService.searchAndFilterChargeItems({
        categoryName,
        maxPrice,
        minPrice,
        page,
        pageSize,
        search,
        sortBy,
        sortDirection,
        status,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.chargeCategoryUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useChargeCategoryControllerServiceGetChargeCategoryByUuid = <
  TData =
    Common.ChargeCategoryControllerServiceGetChargeCategoryByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    chargeCategoryUuid,
  }: {
    chargeCategoryUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseChargeCategoryControllerServiceGetChargeCategoryByUuidKeyFn(
        { chargeCategoryUuid },
        queryKey,
      ),
    queryFn: () =>
      ChargeCategoryControllerService.getChargeCategoryByUuid({
        chargeCategoryUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.coveragePlanUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useChargeCategoryControllerServiceGetChargeCategoryByCoveragePlanUuid =
  <
    TData =
      Common.ChargeCategoryControllerServiceGetChargeCategoryByCoveragePlanUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      coveragePlanUuid,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
    }: {
      coveragePlanUuid: string;
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseChargeCategoryControllerServiceGetChargeCategoryByCoveragePlanUuidKeyFn(
          {
            coveragePlanUuid,
            page,
            pageSize,
            searchString,
            sortBy,
            sortDirection,
          },
          queryKey,
        ),
      queryFn: () =>
        ChargeCategoryControllerService.getChargeCategoryByCoveragePlanUuid({
          coveragePlanUuid,
          page,
          pageSize,
          searchString,
          sortBy,
          sortDirection,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.searchString
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useChargeCategoryControllerServiceGetAllChargeCategories = <
  TData =
    Common.ChargeCategoryControllerServiceGetAllChargeCategoriesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseChargeCategoryControllerServiceGetAllChargeCategoriesKeyFn(
        { page, pageSize, searchString, sortBy, sortDirection },
        queryKey,
      ),
    queryFn: () =>
      ChargeCategoryControllerService.getAllChargeCategories({
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.cancellationsUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCancellationControllerServiceGetCancellationByUuid = <
  TData =
    Common.CancellationControllerServiceGetCancellationByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    cancellationsUuid,
  }: {
    cancellationsUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCancellationControllerServiceGetCancellationByUuidKeyFn(
      { cancellationsUuid },
      queryKey,
    ),
    queryFn: () =>
      CancellationControllerService.getCancellationByUuid({
        cancellationsUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.description
 * @param data.archive
 * @param data.isCustom
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useCancellationControllerServiceGetAllCancellations = <
  TData =
    Common.CancellationControllerServiceGetAllCancellationsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    archive,
    description,
    isCustom,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    archive?: boolean;
    description?: string;
    isCustom?: boolean;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCancellationControllerServiceGetAllCancellationsKeyFn(
      { archive, description, isCustom, page, pageSize, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      CancellationControllerService.getAllCancellations({
        archive,
        description,
        isCustom,
        page,
        pageSize,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.brokerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useBrokerControllerServiceGetBrokerByUuid = <
  TData = Common.BrokerControllerServiceGetBrokerByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    brokerUuid,
  }: {
    brokerUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseBrokerControllerServiceGetBrokerByUuidKeyFn(
      { brokerUuid },
      queryKey,
    ),
    queryFn: () =>
      BrokerControllerService.getBrokerByUuid({ brokerUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.employerUuids
 * @param data.agentFirmUuids
 * @param data.status
 * @param data.startDate
 * @param data.endDate
 * @returns Response OK
 * @throws ApiError
 */
export const useBrokerControllerServiceGetAllBrokers = <
  TData = Common.BrokerControllerServiceGetAllBrokersDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    agentFirmUuids,
    employerUuids,
    endDate,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
    startDate,
    status,
  }: {
    agentFirmUuids?: string[];
    employerUuids?: string[];
    endDate?: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    startDate?: string;
    status?: boolean;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseBrokerControllerServiceGetAllBrokersKeyFn(
      {
        agentFirmUuids,
        employerUuids,
        endDate,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
        startDate,
        status,
      },
      queryKey,
    ),
    queryFn: () =>
      BrokerControllerService.getAllBrokers({
        agentFirmUuids,
        employerUuids,
        endDate,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
        startDate,
        status,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.breakGlassUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useBreakGlassControllerServiceGetByUuid3 = <
  TData = Common.BreakGlassControllerServiceGetByUuid3DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    breakGlassUuid,
  }: {
    breakGlassUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseBreakGlassControllerServiceGetByUuid3KeyFn(
      { breakGlassUuid },
      queryKey,
    ),
    queryFn: () =>
      BreakGlassControllerService.getByUuid3({ breakGlassUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.providerUuid
 * @param data.nurseStaffProviderUuid
 * @param data.locationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useBreakGlassControllerServiceGetAllBreakGlass = <
  TData = Common.BreakGlassControllerServiceGetAllBreakGlassDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationUuid,
    nurseStaffProviderUuid,
    patientUuid,
    providerUuid,
  }: {
    locationUuid?: string;
    nurseStaffProviderUuid?: string;
    patientUuid?: string;
    providerUuid?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseBreakGlassControllerServiceGetAllBreakGlassKeyFn(
      { locationUuid, nurseStaffProviderUuid, patientUuid, providerUuid },
      queryKey,
    ),
    queryFn: () =>
      BreakGlassControllerService.getAllBreakGlass({
        locationUuid,
        nurseStaffProviderUuid,
        patientUuid,
        providerUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.miscellaneousServiceChargeUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceGetMiscellaneousServiceChargeByUuid =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceGetMiscellaneousServiceChargeByUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      miscellaneousServiceChargeUuid,
    }: {
      miscellaneousServiceChargeUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseAncillaryServiceChargesControllerServiceGetMiscellaneousServiceChargeByUuidKeyFn(
          { miscellaneousServiceChargeUuid },
          queryKey,
        ),
      queryFn: () =>
        AncillaryServiceChargesControllerService.getMiscellaneousServiceChargeByUuid(
          {
            miscellaneousServiceChargeUuid,
          },
        ) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.ancillaryServiceChargesUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceGetAncillaryServiceChargesUuid =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceGetAncillaryServiceChargesUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      ancillaryServiceChargesUuid,
    }: {
      ancillaryServiceChargesUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseAncillaryServiceChargesControllerServiceGetAncillaryServiceChargesUuidKeyFn(
          { ancillaryServiceChargesUuid },
          queryKey,
        ),
      queryFn: () =>
        AncillaryServiceChargesControllerService.getAncillaryServiceChargesUuid(
          {
            ancillaryServiceChargesUuid,
          },
        ) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @param data.userTypes
 * @param data.startDate
 * @param data.endDate
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceTransactionDetails = <
  TData =
    Common.AncillaryServiceChargesControllerServiceTransactionDetailsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    page,
    size,
    sort,
    startDate,
    userTypes,
    userUuid,
  }: {
    endDate?: string;
    page?: number;
    size?: number;
    sort?: string[];
    startDate?: string;
    userTypes:
      | "EMPLOYER"
      | "PATIENT"
      | "BROKER"
      | "ADMIN_USER"
      | "PROVIDER"
      | "EMPLOYER_ADMINISTRATION"
      | "EMPLOYEE"
      | "PHP_USER"
      | "AFFILIATE_FIRM"
      | "BROKER_FIRM"
      | "NURSE_USER";
    userUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAncillaryServiceChargesControllerServiceTransactionDetailsKeyFn(
        { endDate, page, size, sort, startDate, userTypes, userUuid },
        queryKey,
      ),
    queryFn: () =>
      AncillaryServiceChargesControllerService.transactionDetails({
        endDate,
        page,
        size,
        sort,
        startDate,
        userTypes,
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceInvoiceTransactionDetails =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceInvoiceTransactionDetailsDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      invoiceUuid,
      page,
      size,
      sort,
    }: {
      invoiceUuid: string;
      page?: number;
      size?: number;
      sort?: string[];
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseAncillaryServiceChargesControllerServiceInvoiceTransactionDetailsKeyFn(
          { invoiceUuid, page, size, sort },
          queryKey,
        ),
      queryFn: () =>
        AncillaryServiceChargesControllerService.invoiceTransactionDetails({
          invoiceUuid,
          page,
          size,
          sort,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @param data.userTypes
 * @param data.startDate
 * @param data.endDate
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceGetInvoiceStatement = <
  TData =
    Common.AncillaryServiceChargesControllerServiceGetInvoiceStatementDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    page,
    pageSize,
    sortBy,
    sortDirection,
    startDate,
    userTypes,
    userUuid,
  }: {
    endDate?: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
    startDate?: string;
    userTypes:
      | "EMPLOYER"
      | "PATIENT"
      | "BROKER"
      | "ADMIN_USER"
      | "PROVIDER"
      | "EMPLOYER_ADMINISTRATION"
      | "EMPLOYEE"
      | "PHP_USER"
      | "AFFILIATE_FIRM"
      | "BROKER_FIRM"
      | "NURSE_USER";
    userUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAncillaryServiceChargesControllerServiceGetInvoiceStatementKeyFn(
        {
          endDate,
          page,
          pageSize,
          sortBy,
          sortDirection,
          startDate,
          userTypes,
          userUuid,
        },
        queryKey,
      ),
    queryFn: () =>
      AncillaryServiceChargesControllerService.getInvoiceStatement({
        endDate,
        page,
        pageSize,
        sortBy,
        sortDirection,
        startDate,
        userTypes,
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceGetAllScheduledPayment =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceGetAllScheduledPaymentDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      invoiceUuid,
      page,
      size,
      sort,
    }: {
      invoiceUuid: string;
      page?: number;
      size?: number;
      sort?: string[];
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseAncillaryServiceChargesControllerServiceGetAllScheduledPaymentKeyFn(
          { invoiceUuid, page, size, sort },
          queryKey,
        ),
      queryFn: () =>
        AncillaryServiceChargesControllerService.getAllScheduledPayment({
          invoiceUuid,
          page,
          size,
          sort,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServicePaymentHistory = <
  TData =
    Common.AncillaryServiceChargesControllerServicePaymentHistoryDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    invoiceUuid,
  }: {
    invoiceUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAncillaryServiceChargesControllerServicePaymentHistoryKeyFn(
        { invoiceUuid },
        queryKey,
      ),
    queryFn: () =>
      AncillaryServiceChargesControllerService.paymentHistory({
        invoiceUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceGetAllMiscellaneousServiceCharges =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceGetAllMiscellaneousServiceChargesDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      invoiceUuid,
      page,
      pageSize,
      sortBy,
      sortDirection,
    }: {
      invoiceUuid: string;
      page?: number;
      pageSize?: number;
      sortBy?: string;
      sortDirection?: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseAncillaryServiceChargesControllerServiceGetAllMiscellaneousServiceChargesKeyFn(
          { invoiceUuid, page, pageSize, sortBy, sortDirection },
          queryKey,
        ),
      queryFn: () =>
        AncillaryServiceChargesControllerService.getAllMiscellaneousServiceCharges(
          {
            invoiceUuid,
            page,
            pageSize,
            sortBy,
            sortDirection,
          },
        ) as TData,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceGenerateRetailPatientInvoices =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceGenerateRetailPatientInvoicesDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseAncillaryServiceChargesControllerServiceGenerateRetailPatientInvoicesKeyFn(
          queryKey,
        ),
      queryFn: () =>
        AncillaryServiceChargesControllerService.generateRetailPatientInvoices() as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceGetInvoiceStatus = <
  TData =
    Common.AncillaryServiceChargesControllerServiceGetInvoiceStatusDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    invoiceUuid,
  }: {
    invoiceUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAncillaryServiceChargesControllerServiceGetInvoiceStatusKeyFn(
        { invoiceUuid },
        queryKey,
      ),
    queryFn: () =>
      AncillaryServiceChargesControllerService.getInvoiceStatus({
        invoiceUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceInvoiceDetails = <
  TData =
    Common.AncillaryServiceChargesControllerServiceInvoiceDetailsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    invoiceUuid,
  }: {
    invoiceUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAncillaryServiceChargesControllerServiceInvoiceDetailsKeyFn(
        { invoiceUuid },
        queryKey,
      ),
    queryFn: () =>
      AncillaryServiceChargesControllerService.invoiceDetails({
        invoiceUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.search
 * @param data.invoiceUuid
 * @param data.chargeType
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceEmployerEmployeesDetails =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceEmployerEmployeesDetailsDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      chargeType,
      employerUuid,
      invoiceUuid,
      page,
      search,
      size,
      sort,
    }: {
      chargeType?: string;
      employerUuid: string;
      invoiceUuid?: string;
      page?: number;
      search?: string;
      size?: number;
      sort?: string[];
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseAncillaryServiceChargesControllerServiceEmployerEmployeesDetailsKeyFn(
          { chargeType, employerUuid, invoiceUuid, page, search, size, sort },
          queryKey,
        ),
      queryFn: () =>
        AncillaryServiceChargesControllerService.employerEmployeesDetails({
          chargeType,
          employerUuid,
          invoiceUuid,
          page,
          search,
          size,
          sort,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceGetChargeItemNamesByInvoice =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceGetChargeItemNamesByInvoiceDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      invoiceUuid,
    }: {
      invoiceUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseAncillaryServiceChargesControllerServiceGetChargeItemNamesByInvoiceKeyFn(
          { invoiceUuid },
          queryKey,
        ),
      queryFn: () =>
        AncillaryServiceChargesControllerService.getChargeItemNamesByInvoice({
          invoiceUuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @param data.rate
 * @param data.patientUuid
 * @param data.applyCredit
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceAmountDetails = <
  TData =
    Common.AncillaryServiceChargesControllerServiceAmountDetailsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    applyCredit,
    invoiceUuid,
    patientUuid,
    rate,
  }: {
    applyCredit?: boolean;
    invoiceUuid: string;
    patientUuid?: string;
    rate?: number;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAncillaryServiceChargesControllerServiceAmountDetailsKeyFn(
        { applyCredit, invoiceUuid, patientUuid, rate },
        queryKey,
      ),
    queryFn: () =>
      AncillaryServiceChargesControllerService.amountDetails({
        applyCredit,
        invoiceUuid,
        patientUuid,
        rate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @param data.userUuid
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceGetAllAncillaryServiceCharges =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceGetAllAncillaryServiceChargesDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      invoiceUuid,
      page,
      size,
      sort,
      userUuid,
    }: {
      invoiceUuid?: string;
      page?: number;
      size?: number;
      sort?: string[];
      userUuid?: string;
    } = {},
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseAncillaryServiceChargesControllerServiceGetAllAncillaryServiceChargesKeyFn(
          { invoiceUuid, page, size, sort, userUuid },
          queryKey,
        ),
      queryFn: () =>
        AncillaryServiceChargesControllerService.getAllAncillaryServiceCharges({
          invoiceUuid,
          page,
          size,
          sort,
          userUuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.affiliateFirmUuid
 * @param data.invoiceUuid
 * @param data.search
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceAffiliateFirmEmployeesDetails =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceAffiliateFirmEmployeesDetailsDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      affiliateFirmUuid,
      invoiceUuid,
      page,
      search,
      size,
      sort,
    }: {
      affiliateFirmUuid: string;
      invoiceUuid: string;
      page?: number;
      search?: string;
      size?: number;
      sort?: string[];
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseAncillaryServiceChargesControllerServiceAffiliateFirmEmployeesDetailsKeyFn(
          { affiliateFirmUuid, invoiceUuid, page, search, size, sort },
          queryKey,
        ),
      queryFn: () =>
        AncillaryServiceChargesControllerService.affiliateFirmEmployeesDetails({
          affiliateFirmUuid,
          invoiceUuid,
          page,
          search,
          size,
          sort,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.year
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceEmployerDetailsMonthWise =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceEmployerDetailsMonthWiseDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      employerUuid,
      page,
      size,
      sort,
      year,
    }: {
      employerUuid: string;
      page?: number;
      size?: number;
      sort?: string[];
      year?: number;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseAncillaryServiceChargesControllerServiceEmployerDetailsMonthWiseKeyFn(
          { employerUuid, page, size, sort, year },
          queryKey,
        ),
      queryFn: () =>
        AncillaryServiceChargesControllerService.employerDetailsMonthWise({
          employerUuid,
          page,
          size,
          sort,
          year,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceGetAllAffiliateBrokerServiceCharges =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceGetAllAffiliateBrokerServiceChargesDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      invoiceUuid,
      page,
      size,
      sort,
    }: {
      invoiceUuid?: string;
      page?: number;
      size?: number;
      sort?: string[];
    } = {},
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseAncillaryServiceChargesControllerServiceGetAllAffiliateBrokerServiceChargesKeyFn(
          { invoiceUuid, page, size, sort },
          queryKey,
        ),
      queryFn: () =>
        AncillaryServiceChargesControllerService.getAllAffiliateBrokerServiceCharges(
          {
            invoiceUuid,
            page,
            size,
            sort,
          },
        ) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @param data.search
 * @param data.chargeType
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceAffiliateProviderEmployeeDetails =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceAffiliateProviderEmployeeDetailsDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      chargeType,
      invoiceUuid,
      page,
      search,
      size,
      sort,
    }: {
      chargeType?: string;
      invoiceUuid: string;
      page?: number;
      search?: string;
      size?: number;
      sort?: string[];
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseAncillaryServiceChargesControllerServiceAffiliateProviderEmployeeDetailsKeyFn(
          { chargeType, invoiceUuid, page, search, size, sort },
          queryKey,
        ),
      queryFn: () =>
        AncillaryServiceChargesControllerService.affiliateProviderEmployeeDetails(
          {
            chargeType,
            invoiceUuid,
            page,
            search,
            size,
            sort,
          },
        ) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.agentFirmUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAgentFirmControllerServiceGetAgentFirmByUuid = <
  TData = Common.AgentFirmControllerServiceGetAgentFirmByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    agentFirmUuid,
  }: {
    agentFirmUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAgentFirmControllerServiceGetAgentFirmByUuidKeyFn(
      { agentFirmUuid },
      queryKey,
    ),
    queryFn: () =>
      AgentFirmControllerService.getAgentFirmByUuid({ agentFirmUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.agentFirmUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.employerStatus
 * @param data.commissionStatus
 * @param data.brokerUuids
 * @returns Response OK
 * @throws ApiError
 */
export const useAgentFirmControllerServiceGetEmployersUnderAgentFirm = <
  TData =
    Common.AgentFirmControllerServiceGetEmployersUnderAgentFirmDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    agentFirmUuid,
    brokerUuids,
    commissionStatus,
    employerStatus,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    agentFirmUuid: string;
    brokerUuids?: string[];
    commissionStatus?: string;
    employerStatus?: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAgentFirmControllerServiceGetEmployersUnderAgentFirmKeyFn(
        {
          agentFirmUuid,
          brokerUuids,
          commissionStatus,
          employerStatus,
          page,
          pageSize,
          searchString,
          sortBy,
          sortDirection,
        },
        queryKey,
      ),
    queryFn: () =>
      AgentFirmControllerService.getEmployersUnderAgentFirm({
        agentFirmUuid,
        brokerUuids,
        commissionStatus,
        employerStatus,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.search
 * @param data.agentFirmType
 * @returns Response OK
 * @throws ApiError
 */
export const useAgentFirmControllerServiceGetAllAgentFirms = <
  TData = Common.AgentFirmControllerServiceGetAllAgentFirmsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    agentFirmType,
    page,
    pageSize,
    search,
    sortBy,
    sortDirection,
  }: {
    agentFirmType?: "INDEPENDENT" | "AFFILIATED";
    page?: number;
    pageSize?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAgentFirmControllerServiceGetAllAgentFirmsKeyFn(
      { agentFirmType, page, pageSize, search, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      AgentFirmControllerService.getAllAgentFirms({
        agentFirmType,
        page,
        pageSize,
        search,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.agentDealUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAgentDealControllerServiceGetAgentDealByUuid = <
  TData = Common.AgentDealControllerServiceGetAgentDealByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    agentDealUuid,
  }: {
    agentDealUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAgentDealControllerServiceGetAgentDealByUuidKeyFn(
      { agentDealUuid },
      queryKey,
    ),
    queryFn: () =>
      AgentDealControllerService.getAgentDealByUuid({ agentDealUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.brokerUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.employerStatus
 * @param data.commissionStatus
 * @returns Response OK
 * @throws ApiError
 */
export const useAgentDealControllerServiceGetEmployersUnderBroker = <
  TData =
    Common.AgentDealControllerServiceGetEmployersUnderBrokerDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    brokerUuid,
    commissionStatus,
    employerStatus,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    brokerUuid: string;
    commissionStatus?: string;
    employerStatus?: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAgentDealControllerServiceGetEmployersUnderBrokerKeyFn(
      {
        brokerUuid,
        commissionStatus,
        employerStatus,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      },
      queryKey,
    ),
    queryFn: () =>
      AgentDealControllerService.getEmployersUnderBroker({
        brokerUuid,
        commissionStatus,
        employerStatus,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.agentFirmUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.deals
 * @returns Response OK
 * @throws ApiError
 */
export const useAgentDealControllerServiceGetAgentDealsByAgentFirmUuid = <
  TData =
    Common.AgentDealControllerServiceGetAgentDealsByAgentFirmUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    agentFirmUuid,
    deals,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    agentFirmUuid: string;
    deals?: ("FUTURE" | "ENDED" | "ONGOING")[];
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAgentDealControllerServiceGetAgentDealsByAgentFirmUuidKeyFn(
        { agentFirmUuid, deals, page, pageSize, sortBy, sortDirection },
        queryKey,
      ),
    queryFn: () =>
      AgentDealControllerService.getAgentDealsByAgentFirmUuid({
        agentFirmUuid,
        deals,
        page,
        pageSize,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.employerUuid
 * @param data.deals
 * @returns Response OK
 * @throws ApiError
 */
export const useAgentDealControllerServiceGetAllAgentDeals = <
  TData = Common.AgentDealControllerServiceGetAllAgentDealsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    deals,
    employerUuid,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    deals?: ("FUTURE" | "ENDED" | "ONGOING")[];
    employerUuid?: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAgentDealControllerServiceGetAllAgentDealsKeyFn(
      { deals, employerUuid, page, pageSize, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      AgentDealControllerService.getAllAgentDeals({
        deals,
        employerUuid,
        page,
        pageSize,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.affiliateGroupUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAffiliateGroupControllerServiceGetAffiliateGropByUuid = <
  TData =
    Common.AffiliateGroupControllerServiceGetAffiliateGropByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    affiliateGroupUuid,
  }: {
    affiliateGroupUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAffiliateGroupControllerServiceGetAffiliateGropByUuidKeyFn(
        { affiliateGroupUuid },
        queryKey,
      ),
    queryFn: () =>
      AffiliateGroupControllerService.getAffiliateGropByUuid({
        affiliateGroupUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.affiliateGroupUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useAffiliateGroupControllerServiceGetAffiliateUsersByAffiliateGroupUuid =
  <
    TData =
      Common.AffiliateGroupControllerServiceGetAffiliateUsersByAffiliateGroupUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      affiliateGroupUuid,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
    }: {
      affiliateGroupUuid: string;
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseAffiliateGroupControllerServiceGetAffiliateUsersByAffiliateGroupUuidKeyFn(
          {
            affiliateGroupUuid,
            page,
            pageSize,
            searchString,
            sortBy,
            sortDirection,
          },
          queryKey,
        ),
      queryFn: () =>
        AffiliateGroupControllerService.getAffiliateUsersByAffiliateGroupUuid({
          affiliateGroupUuid,
          page,
          pageSize,
          searchString,
          sortBy,
          sortDirection,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.affiliateGroupUuid
 * @returns unknown OK
 * @throws ApiError
 */
export const useAffiliateGroupControllerServiceDownloadAffiliateDataExcel = <
  TData =
    Common.AffiliateGroupControllerServiceDownloadAffiliateDataExcelDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    affiliateGroupUuid,
  }: {
    affiliateGroupUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAffiliateGroupControllerServiceDownloadAffiliateDataExcelKeyFn(
        { affiliateGroupUuid },
        queryKey,
      ),
    queryFn: () =>
      AffiliateGroupControllerService.downloadAffiliateDataExcel({
        affiliateGroupUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAffiliateGroupControllerServiceGetAffiliateUserByUuid = <
  TData =
    Common.AffiliateGroupControllerServiceGetAffiliateUserByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    userUuid,
  }: {
    userUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAffiliateGroupControllerServiceGetAffiliateUserByUuidKeyFn(
        { userUuid },
        queryKey,
      ),
    queryFn: () =>
      AffiliateGroupControllerService.getAffiliateUserByUuid({
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.searchString
 * @returns unknown OK
 * @throws ApiError
 */
export const useAffiliateGroupControllerServiceExportCsvForAffiliate = <
  TData =
    Common.AffiliateGroupControllerServiceExportCsvForAffiliateDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    searchString,
  }: {
    searchString?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAffiliateGroupControllerServiceExportCsvForAffiliateKeyFn(
        { searchString },
        queryKey,
      ),
    queryFn: () =>
      AffiliateGroupControllerService.exportCsvForAffiliate({
        searchString,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useAffiliateGroupControllerServiceGetAllAffiliates = <
  TData = Common.AffiliateGroupControllerServiceGetAllAffiliatesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAffiliateGroupControllerServiceGetAllAffiliatesKeyFn(
      { page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      AffiliateGroupControllerService.getAllAffiliates({
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.adminUserUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAdminUserControllerServiceGetAdminUserByUuid = <
  TData = Common.AdminUserControllerServiceGetAdminUserByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    adminUserUuid,
  }: {
    adminUserUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAdminUserControllerServiceGetAdminUserByUuidKeyFn(
      { adminUserUuid },
      queryKey,
    ),
    queryFn: () =>
      AdminUserControllerService.getAdminUserByUuid({ adminUserUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.dashboardType
 * @returns Response OK
 * @throws ApiError
 */
export const useAdminUserControllerServiceGetSupersetDashBoardId = <
  TData =
    Common.AdminUserControllerServiceGetSupersetDashBoardIdDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    dashboardType,
  }: {
    dashboardType:
      | "BROKER"
      | "EMPLOYER_ENROLLMENTS"
      | "RETAIL_PATIENT_ENROLLMENTS"
      | "PAYMENT_OVERVIEW"
      | "PATIENT_BILLING"
      | "PATIENT_BILLING_EMPLOYER"
      | "INVOICE_STATUS"
      | "INVOICE_STATUS_EMPLOYER"
      | "TOTAL_EMPLOYEES"
      | "EMPLOYEE_COUNT"
      | "TICKET_STATUS"
      | "MEMBERSHIP"
      | "TERMINATION"
      | "OUTSTANDING_INVOICE"
      | "INVOICE_REPORT"
      | "DEFERRED_REVENUE"
      | "RECEIVED_PAYMENTS"
      | "ENROLLMENTS"
      | "ABANDONED_SIGN_UP_ATTEMPTS"
      | "COUPONS_IN_USE"
      | "LEAD_SOURCES"
      | "BAD_DEBTS"
      | "CHURN_REPORTS"
      | "EMPLOYERS"
      | "AFFILIATES"
      | "PATIENT_CATEGORIES"
      | "APPOINTMENT_STATUS_TYPE"
      | "UTILIZATION_ENGAGEMENT"
      | "HEALTH_TRENDS_DIAGNOSIS"
      | "CLINIC_PROVIDER_ACTIVITY"
      | "SAVINGS_REPORT"
      | "REFERRALS_ORDERS"
      | "PHARMACY_INVENTORY"
      | "EXPIRING_MEDICATIONS";
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAdminUserControllerServiceGetSupersetDashBoardIdKeyFn(
      { dashboardType },
      queryKey,
    ),
    queryFn: () =>
      AdminUserControllerService.getSupersetDashBoardId({
        dashboardType,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAdminUserControllerServiceGetUserDetails = <
  TData = Common.AdminUserControllerServiceGetUserDetailsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    userUuid,
  }: {
    userUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAdminUserControllerServiceGetUserDetailsKeyFn(
      { userUuid },
      queryKey,
    ),
    queryFn: () =>
      AdminUserControllerService.getUserDetails({ userUuid }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useAdminUserControllerServiceGetProfile2 = <
  TData = Common.AdminUserControllerServiceGetProfile2DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAdminUserControllerServiceGetProfile2KeyFn(queryKey),
    queryFn: () => AdminUserControllerService.getProfile2() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.roleName
 * @param data.notification
 * @param data.archive
 * @returns Response OK
 * @throws ApiError
 */
export const useAdminUserControllerServiceGetAllAdminUsers = <
  TData = Common.AdminUserControllerServiceGetAllAdminUsersDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    archive,
    notification,
    page,
    pageSize,
    roleName,
    searchString,
    sortBy,
    sortDirection,
  }: {
    archive?: boolean;
    notification?: boolean;
    page?: number;
    pageSize?: number;
    roleName?: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAdminUserControllerServiceGetAllAdminUsersKeyFn(
      {
        archive,
        notification,
        page,
        pageSize,
        roleName,
        searchString,
        sortBy,
        sortDirection,
      },
      queryKey,
    ),
    queryFn: () =>
      AdminUserControllerService.getAllAdminUsers({
        archive,
        notification,
        page,
        pageSize,
        roleName,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.status
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useSupervisingProviderRequestControllerServiceGetIncomingRequests =
  <
    TData =
      Common.SupervisingProviderRequestControllerServiceGetIncomingRequestsDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      page,
      pageSize,
      sortBy,
      sortDirection,
      status,
    }: {
      page?: number;
      pageSize?: number;
      sortBy?: string;
      sortDirection?: string;
      status?: "PENDING" | "EXPIRED" | "APPROVED" | "DENIED" | "REVOKED";
    } = {},
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseSupervisingProviderRequestControllerServiceGetIncomingRequestsKeyFn(
          { page, pageSize, sortBy, sortDirection, status },
          queryKey,
        ),
      queryFn: () =>
        SupervisingProviderRequestControllerService.getIncomingRequests({
          page,
          pageSize,
          sortBy,
          sortDirection,
          status,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.nurseStaffProviderUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useSupervisingProviderRequestControllerServiceGetApprovedProviders =
  <
    TData =
      Common.SupervisingProviderRequestControllerServiceGetApprovedProvidersDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      nurseStaffProviderUuid,
    }: {
      nurseStaffProviderUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseSupervisingProviderRequestControllerServiceGetApprovedProvidersKeyFn(
          { nurseStaffProviderUuid },
          queryKey,
        ),
      queryFn: () =>
        SupervisingProviderRequestControllerService.getApprovedProviders({
          nurseStaffProviderUuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.userTypes
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useShareCardControllerServiceGetSharedCardsByUser = <
  TData = Common.ShareCardControllerServiceGetSharedCardsByUserDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    size,
    sort,
    userTypes,
    uuid,
  }: {
    page?: number;
    size?: number;
    sort?: string[];
    userTypes?:
      | "EMPLOYER"
      | "PATIENT"
      | "BROKER"
      | "ADMIN_USER"
      | "PROVIDER"
      | "EMPLOYER_ADMINISTRATION"
      | "EMPLOYEE"
      | "PHP_USER"
      | "AFFILIATE_FIRM"
      | "BROKER_FIRM"
      | "NURSE_USER";
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseShareCardControllerServiceGetSharedCardsByUserKeyFn(
      { page, size, sort, userTypes, uuid },
      queryKey,
    ),
    queryFn: () =>
      ShareCardControllerService.getSharedCardsByUser({
        page,
        size,
        sort,
        userTypes,
        uuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.savedCardUuid
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useShareCardControllerServiceGetSharedCardCustomers = <
  TData =
    Common.ShareCardControllerServiceGetSharedCardCustomersDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    savedCardUuid,
    size,
    sort,
  }: {
    page?: number;
    savedCardUuid: string;
    size?: number;
    sort?: string[];
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseShareCardControllerServiceGetSharedCardCustomersKeyFn(
      { page, savedCardUuid, size, sort },
      queryKey,
    ),
    queryFn: () =>
      ShareCardControllerService.getSharedCardCustomers({
        page,
        savedCardUuid,
        size,
        sort,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response1 OK
 * @throws ApiError
 */
export const useShareCardControllerServiceGetSharedCardsByUser1 = <
  TData = Common.ShareCardControllerServiceGetSharedCardsByUser1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    size,
    sort,
    userUuid,
  }: {
    page?: number;
    size?: number;
    sort?: string[];
    userUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseShareCardControllerServiceGetSharedCardsByUser1KeyFn(
      { page, size, sort, userUuid },
      queryKey,
    ),
    queryFn: () =>
      ShareCardControllerService.getSharedCardsByUser1({
        page,
        size,
        sort,
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.userTypes
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useShareBankControllerServiceGetSharedBanksByUser = <
  TData = Common.ShareBankControllerServiceGetSharedBanksByUserDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    size,
    sort,
    userTypes,
    uuid,
  }: {
    page?: number;
    size?: number;
    sort?: string[];
    userTypes?:
      | "EMPLOYER"
      | "PATIENT"
      | "BROKER"
      | "ADMIN_USER"
      | "PROVIDER"
      | "EMPLOYER_ADMINISTRATION"
      | "EMPLOYEE"
      | "PHP_USER"
      | "AFFILIATE_FIRM"
      | "BROKER_FIRM"
      | "NURSE_USER";
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseShareBankControllerServiceGetSharedBanksByUserKeyFn(
      { page, size, sort, userTypes, uuid },
      queryKey,
    ),
    queryFn: () =>
      ShareBankControllerService.getSharedBanksByUser({
        page,
        size,
        sort,
        userTypes,
        uuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.savedBankAccountUuid
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useShareBankControllerServiceGetSharedBankCustomers = <
  TData =
    Common.ShareBankControllerServiceGetSharedBankCustomersDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    savedBankAccountUuid,
    size,
    sort,
  }: {
    page?: number;
    savedBankAccountUuid: string;
    size?: number;
    sort?: string[];
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseShareBankControllerServiceGetSharedBankCustomersKeyFn(
      { page, savedBankAccountUuid, size, sort },
      queryKey,
    ),
    queryFn: () =>
      ShareBankControllerService.getSharedBankCustomers({
        page,
        savedBankAccountUuid,
        size,
        sort,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.direction
 * @param data.status
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderCoverageControllerServiceGetCoverages = <
  TData = Common.ProviderCoverageControllerServiceGetCoveragesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    direction,
    page,
    pageSize,
    sortBy,
    sortDirection,
    status,
  }: {
    direction?: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
    status?: "PENDING" | "EXPIRED" | "APPROVED" | "DENIED" | "REVOKED";
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseProviderCoverageControllerServiceGetCoveragesKeyFn(
      { direction, page, pageSize, sortBy, sortDirection, status },
      queryKey,
    ),
    queryFn: () =>
      ProviderCoverageControllerService.getCoverages({
        direction,
        page,
        pageSize,
        sortBy,
        sortDirection,
        status,
      }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderCoverageControllerServiceGetUrgentMessageAlert = <
  TData =
    Common.ProviderCoverageControllerServiceGetUrgentMessageAlertDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseProviderCoverageControllerServiceGetUrgentMessageAlertKeyFn(
        queryKey,
      ),
    queryFn: () =>
      ProviderCoverageControllerService.getUrgentMessageAlert() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.coverageUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderCoverageControllerServiceGetCoverageByUuid = <
  TData =
    Common.ProviderCoverageControllerServiceGetCoverageByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    coverageUuid,
  }: {
    coverageUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseProviderCoverageControllerServiceGetCoverageByUuidKeyFn(
      { coverageUuid },
      queryKey,
    ),
    queryFn: () =>
      ProviderCoverageControllerService.getCoverageByUuid({
        coverageUuid,
      }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderCoverageControllerServiceGetActiveCoverage = <
  TData =
    Common.ProviderCoverageControllerServiceGetActiveCoverageDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseProviderCoverageControllerServiceGetActiveCoverageKeyFn(
        queryKey,
      ),
    queryFn: () =>
      ProviderCoverageControllerService.getActiveCoverage() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns string OK
 * @throws ApiError
 */
export const usePdfControllerServiceGetLabPdfByPatient = <
  TData = Common.PdfControllerServiceGetLabPdfByPatientDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePdfControllerServiceGetLabPdfByPatientKeyFn(
      { patientUuid },
      queryKey,
    ),
    queryFn: () =>
      PdfControllerService.getLabPdfByPatient({ patientUuid }) as TData,
    ...options,
  });
/**
 * Get user payout bank accounts
 * Retrieves all bank accounts configured for user payouts based on user type
 * @param data The data for the request.
 * @param data.userUuid
 * @param data.userTypes
 * @returns Response OK
 * @throws ApiError
 */
export const useAgentPayoutServiceGetPayoutBankAccounts = <
  TData = Common.AgentPayoutServiceGetPayoutBankAccountsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    userTypes,
    userUuid,
  }: {
    userTypes:
      | "EMPLOYER"
      | "PATIENT"
      | "BROKER"
      | "ADMIN_USER"
      | "PROVIDER"
      | "EMPLOYER_ADMINISTRATION"
      | "EMPLOYEE"
      | "PHP_USER"
      | "AFFILIATE_FIRM"
      | "BROKER_FIRM"
      | "NURSE_USER";
    userUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAgentPayoutServiceGetPayoutBankAccountsKeyFn(
      { userTypes, userUuid },
      queryKey,
    ),
    queryFn: () =>
      AgentPayoutService.getPayoutBankAccounts({
        userTypes,
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useInventoryOrderControllerServiceGetAllInventory = <
  TData = Common.InventoryOrderControllerServiceGetAllInventoryDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseInventoryOrderControllerServiceGetAllInventoryKeyFn(
      { page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      InventoryOrderControllerService.getAllInventory({
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.locationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useInventoryOrderControllerServiceLocationBasedFormulary = <
  TData =
    Common.InventoryOrderControllerServiceLocationBasedFormularyDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationUuid,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    locationUuid?: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseInventoryOrderControllerServiceLocationBasedFormularyKeyFn(
        { locationUuid, page, pageSize, searchString, sortBy, sortDirection },
        queryKey,
      ),
    queryFn: () =>
      InventoryOrderControllerService.locationBasedFormulary({
        locationUuid,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @returns string OK
 * @throws ApiError
 */
export const useInventoryOrderControllerServiceExportLocationBasedInventoryCsv =
  <
    TData =
      Common.InventoryOrderControllerServiceExportLocationBasedInventoryCsvDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseInventoryOrderControllerServiceExportLocationBasedInventoryCsvKeyFn(
          queryKey,
        ),
      queryFn: () =>
        InventoryOrderControllerService.exportLocationBasedInventoryCsv() as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.formulary
 * @returns string OK
 * @throws ApiError
 */
export const useInventoryOrderControllerServiceExportInventoryCsv = <
  TData =
    Common.InventoryOrderControllerServiceExportInventoryCsvDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    formulary,
  }: {
    formulary?: boolean;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseInventoryOrderControllerServiceExportInventoryCsvKeyFn(
      { formulary },
      queryKey,
    ),
    queryFn: () =>
      InventoryOrderControllerService.exportInventoryCsv({
        formulary,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.invoiceId
 * @returns Response OK
 * @throws ApiError
 */
export const useInventoryOrderControllerServiceGetAllShipmentMedicationByInvoiceNumber =
  <
    TData =
      Common.InventoryOrderControllerServiceGetAllShipmentMedicationByInvoiceNumberDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      invoiceId,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
    }: {
      invoiceId?: string;
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
    } = {},
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseInventoryOrderControllerServiceGetAllShipmentMedicationByInvoiceNumberKeyFn(
          { invoiceId, page, pageSize, searchString, sortBy, sortDirection },
          queryKey,
        ),
      queryFn: () =>
        InventoryOrderControllerService.getAllShipmentMedicationByInvoiceNumber(
          {
            invoiceId,
            page,
            pageSize,
            searchString,
            sortBy,
            sortDirection,
          },
        ) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useInventoryOrderControllerServiceGetAllShipment = <
  TData = Common.InventoryOrderControllerServiceGetAllShipmentDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseInventoryOrderControllerServiceGetAllShipmentKeyFn(
      { page, pageSize, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      InventoryOrderControllerService.getAllShipment({
        page,
        pageSize,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useInventoryOrderControllerServiceGetAllOrder = <
  TData = Common.InventoryOrderControllerServiceGetAllOrderDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseInventoryOrderControllerServiceGetAllOrderKeyFn(
      { page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      InventoryOrderControllerService.getAllOrder({
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.active
 * @param data.search
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useGoogleMapsControllerServiceGetAllShareLinks = <
  TData = Common.GoogleMapsControllerServiceGetAllShareLinksDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    active,
    page,
    search,
    size,
    sort,
  }: {
    active?: boolean;
    page?: number;
    search?: string;
    size?: number;
    sort?: string[];
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGoogleMapsControllerServiceGetAllShareLinksKeyFn(
      { active, page, search, size, sort },
      queryKey,
    ),
    queryFn: () =>
      GoogleMapsControllerService.getAllShareLinks({
        active,
        page,
        search,
        size,
        sort,
      }) as TData,
    ...options,
  });
/**
 * @returns binary OK
 * @throws ApiError
 */
export const useGoogleMapsControllerServiceDownloadPatientZipcodeCsvTemplate = <
  TData =
    Common.GoogleMapsControllerServiceDownloadPatientZipcodeCsvTemplateDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseGoogleMapsControllerServiceDownloadPatientZipcodeCsvTemplateKeyFn(
        queryKey,
      ),
    queryFn: () =>
      GoogleMapsControllerService.downloadPatientZipcodeCsvTemplate() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.onlyPhp
 * @param data.uploadBatchUuid
 * @param data.shareToken
 * @returns Response OK
 * @throws ApiError
 */
export const useGoogleMapsControllerServiceGetMapData = <
  TData = Common.GoogleMapsControllerServiceGetMapDataDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
    onlyPhp,
    shareToken,
    uploadBatchUuid,
  }: {
    employerUuid?: string;
    onlyPhp?: boolean;
    shareToken?: string;
    uploadBatchUuid?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGoogleMapsControllerServiceGetMapDataKeyFn(
      { employerUuid, onlyPhp, shareToken, uploadBatchUuid },
      queryKey,
    ),
    queryFn: () =>
      GoogleMapsControllerService.getMapData({
        employerUuid,
        onlyPhp,
        shareToken,
        uploadBatchUuid,
      }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useCsvControllerServiceGetEmployeeUploadTemplate = <
  TData = Common.CsvControllerServiceGetEmployeeUploadTemplateDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseCsvControllerServiceGetEmployeeUploadTemplateKeyFn(queryKey),
    queryFn: () => CsvControllerService.getEmployeeUploadTemplate() as TData,
    ...options,
  });
/**
 * @returns binary OK
 * @throws ApiError
 */
export const useCsvControllerServiceDownloadExcelTemplate = <
  TData = Common.CsvControllerServiceDownloadExcelTemplateDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseCsvControllerServiceDownloadExcelTemplateKeyFn(queryKey),
    queryFn: () => CsvControllerService.downloadExcelTemplate() as TData,
    ...options,
  });
/**
 * @returns binary OK
 * @throws ApiError
 */
export const useCsvControllerServiceDownloadCsvTemplate = <
  TData = Common.CsvControllerServiceDownloadCsvTemplateDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCsvControllerServiceDownloadCsvTemplateKeyFn(queryKey),
    queryFn: () => CsvControllerService.downloadCsvTemplate() as TData,
    ...options,
  });
/**
 * @returns binary OK
 * @throws ApiError
 */
export const useCsvControllerServiceGetCsvTemplateAsFile = <
  TData = Common.CsvControllerServiceGetCsvTemplateAsFileDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCsvControllerServiceGetCsvTemplateAsFileKeyFn(queryKey),
    queryFn: () => CsvControllerService.getCsvTemplateAsFile() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useCartControllerServiceGetAllCarts = <
  TData = Common.CartControllerServiceGetAllCartsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCartControllerServiceGetAllCartsKeyFn(
      { page, pageSize, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      CartControllerService.getAllCarts({
        page,
        pageSize,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.room
 * @returns Response OK
 * @throws ApiError
 */
export const useVideoControllerServiceJitsiToken = <
  TData = Common.VideoControllerServiceJitsiTokenDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    room,
  }: {
    room?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseVideoControllerServiceJitsiTokenKeyFn(
      { room },
      queryKey,
    ),
    queryFn: () => VideoControllerService.jitsiToken({ room }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useSpecialityControllerServiceGetAllSpecialities = <
  TData = Common.SpecialityControllerServiceGetAllSpecialitiesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    searchString,
    size,
    sort,
  }: {
    page?: number;
    searchString?: string;
    size?: number;
    sort?: string[];
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseSpecialityControllerServiceGetAllSpecialitiesKeyFn(
      { page, searchString, size, sort },
      queryKey,
    ),
    queryFn: () =>
      SpecialityControllerService.getAllSpecialities({
        page,
        searchString,
        size,
        sort,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const usePhysicianAccountTypeControllerServiceGetAllPhysicianAccountTypes =
  <
    TData =
      Common.PhysicianAccountTypeControllerServiceGetAllPhysicianAccountTypesDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      page,
      size,
      sort,
    }: {
      page?: number;
      size?: number;
      sort?: string[];
    } = {},
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UsePhysicianAccountTypeControllerServiceGetAllPhysicianAccountTypesKeyFn(
          { page, size, sort },
          queryKey,
        ),
      queryFn: () =>
        PhysicianAccountTypeControllerService.getAllPhysicianAccountTypes({
          page,
          size,
          sort,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.userId
 * @param data.page
 * @param data.pageSize
 * @param data.read
 * @returns Response OK
 * @throws ApiError
 */
export const useEmailHistoryControllerServiceGetEmailHistoryByUser = <
  TData =
    Common.EmailHistoryControllerServiceGetEmailHistoryByUserDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    read,
    userId,
  }: {
    page?: number;
    pageSize?: number;
    read?: boolean;
    userId: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseEmailHistoryControllerServiceGetEmailHistoryByUserKeyFn(
      { page, pageSize, read, userId },
      queryKey,
    ),
    queryFn: () =>
      EmailHistoryControllerService.getEmailHistoryByUser({
        page,
        pageSize,
        read,
        userId,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useDashboardControllerServiceGetEmployerManagementStats = <
  TData =
    Common.DashboardControllerServiceGetEmployerManagementStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
  }: {
    employerUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseDashboardControllerServiceGetEmployerManagementStatsKeyFn(
        { employerUuid },
        queryKey,
      ),
    queryFn: () =>
      DashboardControllerService.getEmployerManagementStats({
        employerUuid,
      }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useDashboardControllerServiceGetAffiliateStats = <
  TData = Common.DashboardControllerServiceGetAffiliateStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseDashboardControllerServiceGetAffiliateStatsKeyFn(queryKey),
    queryFn: () => DashboardControllerService.getAffiliateStats() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.affliateUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useDashboardControllerServiceGetAffiliatePortalStats = <
  TData =
    Common.DashboardControllerServiceGetAffiliatePortalStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    affliateUuid,
  }: {
    affliateUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseDashboardControllerServiceGetAffiliatePortalStatsKeyFn(
      { affliateUuid },
      queryKey,
    ),
    queryFn: () =>
      DashboardControllerService.getAffiliatePortalStats({
        affliateUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.resolved
 * @param data.categoryUuids
 * @param data.assignedToUuids
 * @param data.assignedByUuids
 * @param data.userUuid
 * @param data.providerUuids
 * @param data.isFrontdeskOrAdvocateUser
 * @returns Response OK
 * @throws ApiError
 */
export const useDashboardControllerServiceGetPendingItems = <
  TData = Common.DashboardControllerServiceGetPendingItemsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    assignedByUuids,
    assignedToUuids,
    categoryUuids,
    isFrontdeskOrAdvocateUser,
    page,
    pageSize,
    providerUuids,
    resolved,
    sortBy,
    sortDirection,
    userUuid,
  }: {
    assignedByUuids?: string[];
    assignedToUuids?: string[];
    categoryUuids?: string[];
    isFrontdeskOrAdvocateUser?: boolean;
    page?: number;
    pageSize?: number;
    providerUuids?: string[];
    resolved?: boolean;
    sortBy?: string;
    sortDirection?: string;
    userUuid?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseDashboardControllerServiceGetPendingItemsKeyFn(
      {
        assignedByUuids,
        assignedToUuids,
        categoryUuids,
        isFrontdeskOrAdvocateUser,
        page,
        pageSize,
        providerUuids,
        resolved,
        sortBy,
        sortDirection,
        userUuid,
      },
      queryKey,
    ),
    queryFn: () =>
      DashboardControllerService.getPendingItems({
        assignedByUuids,
        assignedToUuids,
        categoryUuids,
        isFrontdeskOrAdvocateUser,
        page,
        pageSize,
        providerUuids,
        resolved,
        sortBy,
        sortDirection,
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useDashboardControllerServiceGetPendingFormsCount = <
  TData = Common.DashboardControllerServiceGetPendingFormsCountDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseDashboardControllerServiceGetPendingFormsCountKeyFn(
      { patientUuid },
      queryKey,
    ),
    queryFn: () =>
      DashboardControllerService.getPendingFormsCount({ patientUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.patientUuid
 * @param data.status
 * @returns Response OK
 * @throws ApiError
 */
export const useDashboardControllerServiceGetPatientReports = <
  TData = Common.DashboardControllerServiceGetPatientReportsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    status,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid?: string;
    status?: boolean;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseDashboardControllerServiceGetPatientReportsKeyFn(
      { page, pageSize, patientUuid, status },
      queryKey,
    ),
    queryFn: () =>
      DashboardControllerService.getPatientReports({
        page,
        pageSize,
        patientUuid,
        status,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useDashboardControllerServiceGetPatientPortalCounts = <
  TData =
    Common.DashboardControllerServiceGetPatientPortalCountsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseDashboardControllerServiceGetPatientPortalCountsKeyFn(
      { patientUuid },
      queryKey,
    ),
    queryFn: () =>
      DashboardControllerService.getPatientPortalCounts({
        patientUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.providerUuids
 * @param data.locationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useDashboardControllerServiceGetMessegeInfo = <
  TData = Common.DashboardControllerServiceGetMessegeInfoDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationUuid,
    providerUuids,
  }: {
    locationUuid?: string;
    providerUuids?: string[];
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseDashboardControllerServiceGetMessegeInfoKeyFn(
      { locationUuid, providerUuids },
      queryKey,
    ),
    queryFn: () =>
      DashboardControllerService.getMessegeInfo({
        locationUuid,
        providerUuids,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.patientUuid
 * @param data.status
 * @param data.locationUuids
 * @param data.providerUuids
 * @returns Response OK
 * @throws ApiError
 */
export const useDashboardControllerServiceGetLabAndImagingResults = <
  TData =
    Common.DashboardControllerServiceGetLabAndImagingResultsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationUuids,
    page,
    pageSize,
    patientUuid,
    providerUuids,
    status,
  }: {
    locationUuids?: string[];
    page?: number;
    pageSize?: number;
    patientUuid?: string;
    providerUuids?: string[];
    status?: boolean;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseDashboardControllerServiceGetLabAndImagingResultsKeyFn(
      { locationUuids, page, pageSize, patientUuid, providerUuids, status },
      queryKey,
    ),
    queryFn: () =>
      DashboardControllerService.getLabAndImagingResults({
        locationUuids,
        page,
        pageSize,
        patientUuid,
        providerUuids,
        status,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useWorkNoteControllerServiceGetWorkNoteByUuid = <
  TData = Common.WorkNoteControllerServiceGetWorkNoteByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseWorkNoteControllerServiceGetWorkNoteByUuidKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () =>
      WorkNoteControllerService.getWorkNoteByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useWorkNoteControllerServiceGetAllWorkNotes = <
  TData = Common.WorkNoteControllerServiceGetAllWorkNotesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseWorkNoteControllerServiceGetAllWorkNotesKeyFn(
      { page, pageSize, patientUuid, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      WorkNoteControllerService.getAllWorkNotes({
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useVitalControllerServiceGetVitalByUuid = <
  TData = Common.VitalControllerServiceGetVitalByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseVitalControllerServiceGetVitalByUuidKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () => VitalControllerService.getVitalByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.startDate
 * @param data.endDate
 * @param data.draft
 * @returns Response OK
 * @throws ApiError
 */
export const useVitalControllerServiceGetAllVitals = <
  TData = Common.VitalControllerServiceGetAllVitalsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    draft,
    endDate,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
    startDate,
  }: {
    draft?: boolean;
    endDate?: string;
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
    startDate?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseVitalControllerServiceGetAllVitalsKeyFn(
      {
        draft,
        endDate,
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
        startDate,
      },
      queryKey,
    ),
    queryFn: () =>
      VitalControllerService.getAllVitals({
        draft,
        endDate,
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
        startDate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useVaccineControllerServiceGetVaccineByUuid = <
  TData = Common.VaccineControllerServiceGetVaccineByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseVaccineControllerServiceGetVaccineByUuidKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () => VaccineControllerService.getVaccineByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.type
 * @returns Response OK
 * @throws ApiError
 */
export const useVaccineControllerServiceGetAllVaccines = <
  TData = Common.VaccineControllerServiceGetAllVaccinesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    type,
  }: {
    page?: number;
    pageSize?: number;
    type?: "ADULT" | "CHILD";
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseVaccineControllerServiceGetAllVaccinesKeyFn(
      { page, pageSize, type },
      queryKey,
    ),
    queryFn: () =>
      VaccineControllerService.getAllVaccines({
        page,
        pageSize,
        type,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTaskControllerServiceGetTaskByUuid = <
  TData = Common.TaskControllerServiceGetTaskByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTaskControllerServiceGetTaskByUuidKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () => TaskControllerService.getTaskByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.threadUuid
 * @returns boolean OK
 * @throws ApiError
 */
export const useTaskControllerServiceHasUnresolvedTaskForThread = <
  TData = Common.TaskControllerServiceHasUnresolvedTaskForThreadDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    threadUuid,
  }: {
    threadUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTaskControllerServiceHasUnresolvedTaskForThreadKeyFn(
      { threadUuid },
      queryKey,
    ),
    queryFn: () =>
      TaskControllerService.hasUnresolvedTaskForThread({ threadUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.patientUuids
 * @param data.assignedByUuids
 * @param data.assignedToUuids
 * @param data.categoryUuids
 * @param data.priorities
 * @param data.createdStartDate
 * @param data.createdEndDate
 * @param data.dueStartDate
 * @param data.dueEndDate
 * @param data.flag
 * @param data.resolved
 * @param data.locationUuid
 * @param data.matchAll
 * @returns Response OK
 * @throws ApiError
 */
export const useTaskControllerServiceGetAllTasks = <
  TData = Common.TaskControllerServiceGetAllTasksDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    assignedByUuids,
    assignedToUuids,
    categoryUuids,
    createdEndDate,
    createdStartDate,
    dueEndDate,
    dueStartDate,
    flag,
    locationUuid,
    matchAll,
    page,
    pageSize,
    patientUuids,
    priorities,
    resolved,
    searchString,
    sortBy,
    sortDirection,
  }: {
    assignedByUuids?: string[];
    assignedToUuids?: string[];
    categoryUuids?: string[];
    createdEndDate?: string;
    createdStartDate?: string;
    dueEndDate?: string;
    dueStartDate?: string;
    flag?: boolean;
    locationUuid?: string;
    matchAll?: boolean;
    page?: number;
    pageSize?: number;
    patientUuids?: string[];
    priorities?: ("URGENT" | "REGULAR")[];
    resolved?: boolean;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTaskControllerServiceGetAllTasksKeyFn(
      {
        assignedByUuids,
        assignedToUuids,
        categoryUuids,
        createdEndDate,
        createdStartDate,
        dueEndDate,
        dueStartDate,
        flag,
        locationUuid,
        matchAll,
        page,
        pageSize,
        patientUuids,
        priorities,
        resolved,
        searchString,
        sortBy,
        sortDirection,
      },
      queryKey,
    ),
    queryFn: () =>
      TaskControllerService.getAllTasks({
        assignedByUuids,
        assignedToUuids,
        categoryUuids,
        createdEndDate,
        createdStartDate,
        dueEndDate,
        dueStartDate,
        flag,
        locationUuid,
        matchAll,
        page,
        pageSize,
        patientUuids,
        priorities,
        resolved,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.statusConfigurationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useStatusConfigurationControllerServiceGetStatusConfigurationByUuid =
  <
    TData =
      Common.StatusConfigurationControllerServiceGetStatusConfigurationByUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      statusConfigurationUuid,
    }: {
      statusConfigurationUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseStatusConfigurationControllerServiceGetStatusConfigurationByUuidKeyFn(
          { statusConfigurationUuid },
          queryKey,
        ),
      queryFn: () =>
        StatusConfigurationControllerService.getStatusConfigurationByUuid({
          statusConfigurationUuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useStatusConfigurationControllerServiceGetAllStatusConfigurations =
  <
    TData =
      Common.StatusConfigurationControllerServiceGetAllStatusConfigurationsDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      page,
      pageSize,
      sortBy,
      sortDirection,
    }: {
      page?: number;
      pageSize?: number;
      sortBy?: string;
      sortDirection?: string;
    } = {},
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseStatusConfigurationControllerServiceGetAllStatusConfigurationsKeyFn(
          { page, pageSize, sortBy, sortDirection },
          queryKey,
        ),
      queryFn: () =>
        StatusConfigurationControllerService.getAllStatusConfigurations({
          page,
          pageSize,
          sortBy,
          sortDirection,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useSocialHistoryControllerServiceGetSocialHistoryByUuid = <
  TData =
    Common.SocialHistoryControllerServiceGetSocialHistoryByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseSocialHistoryControllerServiceGetSocialHistoryByUuidKeyFn(
        { uuid },
        queryKey,
      ),
    queryFn: () =>
      SocialHistoryControllerService.getSocialHistoryByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useSocialHistoryControllerServiceGetAllSocialHistory = <
  TData =
    Common.SocialHistoryControllerServiceGetAllSocialHistoryDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseSocialHistoryControllerServiceGetAllSocialHistoryKeyFn(
      { page, pageSize, patientUuid, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      SocialHistoryControllerService.getAllSocialHistory({
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.soapNoteUuid
 * @param data.userUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteControllerServiceGetSoapNoteByUuid = <
  TData = Common.SoapNoteControllerServiceGetSoapNoteByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    soapNoteUuid,
    userUuid,
  }: {
    soapNoteUuid: string;
    userUuid?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseSoapNoteControllerServiceGetSoapNoteByUuidKeyFn(
      { soapNoteUuid, userUuid },
      queryKey,
    ),
    queryFn: () =>
      SoapNoteControllerService.getSoapNoteByUuid({
        soapNoteUuid,
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteControllerServiceGetAllWorkNotes1 = <
  TData = Common.SoapNoteControllerServiceGetAllWorkNotes1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseSoapNoteControllerServiceGetAllWorkNotes1KeyFn(
      { page, pageSize, patientUuid, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      SoapNoteControllerService.getAllWorkNotes1({
        page,
        pageSize,
        patientUuid,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.signed
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteControllerServiceGetSoapNotesByPatientUuid = <
  TData =
    Common.SoapNoteControllerServiceGetSoapNotesByPatientUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    signed,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    signed?: boolean;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseSoapNoteControllerServiceGetSoapNotesByPatientUuidKeyFn(
      { page, pageSize, patientUuid, signed, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      SoapNoteControllerService.getSoapNotesByPatientUuid({
        page,
        pageSize,
        patientUuid,
        signed,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteControllerServiceGetAllInstructions = <
  TData = Common.SoapNoteControllerServiceGetAllInstructionsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseSoapNoteControllerServiceGetAllInstructionsKeyFn(
      { page, pageSize, patientUuid, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      SoapNoteControllerService.getAllInstructions({
        page,
        pageSize,
        patientUuid,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.appointmentUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteControllerServiceGetSoapNoteByAppointmentUuid = <
  TData =
    Common.SoapNoteControllerServiceGetSoapNoteByAppointmentUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    appointmentUuid,
  }: {
    appointmentUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseSoapNoteControllerServiceGetSoapNoteByAppointmentUuidKeyFn(
        { appointmentUuid },
        queryKey,
      ),
    queryFn: () =>
      SoapNoteControllerService.getSoapNoteByAppointmentUuid({
        appointmentUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.appointmentUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteControllerServiceGetSoapNoteAndHandPnoteByAppointmentUuid =
  <
    TData =
      Common.SoapNoteControllerServiceGetSoapNoteAndHandPnoteByAppointmentUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      appointmentUuid,
    }: {
      appointmentUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseSoapNoteControllerServiceGetSoapNoteAndHandPnoteByAppointmentUuidKeyFn(
          { appointmentUuid },
          queryKey,
        ),
      queryFn: () =>
        SoapNoteControllerService.getSoapNoteAndHandPnoteByAppointmentUuid({
          appointmentUuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.isDraft
 * @param data.noteTypes
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteControllerServiceGetVisitNotesByPatientUuid = <
  TData =
    Common.SoapNoteControllerServiceGetVisitNotesByPatientUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    isDraft,
    noteTypes,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    isDraft?: boolean;
    noteTypes?: (
      | "INTERNAL_NOTE"
      | "EXTERNAL_NOTE"
      | "SOAP_NOTE"
      | "HANDP_NOTE"
      | "EMPLOYEE_NOTE"
      | "PHONE_NOTE"
      | "NON_VISIT_NOTE"
      | "EMAIL_NOTE"
      | "LIVE_NOTE"
    )[];
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseSoapNoteControllerServiceGetVisitNotesByPatientUuidKeyFn(
        {
          isDraft,
          noteTypes,
          page,
          pageSize,
          patientUuid,
          sortBy,
          sortDirection,
        },
        queryKey,
      ),
    queryFn: () =>
      SoapNoteControllerService.getVisitNotesByPatientUuid({
        isDraft,
        noteTypes,
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.noteType
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteControllerServiceGetAllEncounterDetails = <
  TData = Common.SoapNoteControllerServiceGetAllEncounterDetailsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    noteType,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    noteType?:
      | "INTERNAL_NOTE"
      | "EXTERNAL_NOTE"
      | "SOAP_NOTE"
      | "HANDP_NOTE"
      | "EMPLOYEE_NOTE"
      | "PHONE_NOTE"
      | "NON_VISIT_NOTE"
      | "EMAIL_NOTE"
      | "LIVE_NOTE";
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseSoapNoteControllerServiceGetAllEncounterDetailsKeyFn(
      { noteType, page, pageSize, patientUuid, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      SoapNoteControllerService.getAllEncounterDetails({
        noteType,
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteControllerServiceGetAllCarePlanNotes = <
  TData = Common.SoapNoteControllerServiceGetAllCarePlanNotesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseSoapNoteControllerServiceGetAllCarePlanNotesKeyFn(
      { page, pageSize, patientUuid, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      SoapNoteControllerService.getAllCarePlanNotes({
        page,
        pageSize,
        patientUuid,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.isDraft
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteControllerServiceGetAllSoapNotes = <
  TData = Common.SoapNoteControllerServiceGetAllSoapNotesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    isDraft,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    isDraft?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseSoapNoteControllerServiceGetAllSoapNotesKeyFn(
      { isDraft, page, pageSize, patientUuid, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      SoapNoteControllerService.getAllSoapNotes({
        isDraft,
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteTemplateControllerServiceGetSoapNoteTemplateByUuid = <
  TData =
    Common.SoapNoteTemplateControllerServiceGetSoapNoteTemplateByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseSoapNoteTemplateControllerServiceGetSoapNoteTemplateByUuidKeyFn(
        { uuid },
        queryKey,
      ),
    queryFn: () =>
      SoapNoteTemplateControllerService.getSoapNoteTemplateByUuid({
        uuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.isPrivate
 * @param data.flag
 * @param data.noteType
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteTemplateControllerServiceGetAllSoapNoteTemplates = <
  TData =
    Common.SoapNoteTemplateControllerServiceGetAllSoapNoteTemplatesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    flag,
    isPrivate,
    noteType,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    flag?: boolean;
    isPrivate?: boolean;
    noteType?:
      | "INTERNAL_NOTE"
      | "EXTERNAL_NOTE"
      | "SOAP_NOTE"
      | "HANDP_NOTE"
      | "EMPLOYEE_NOTE"
      | "PHONE_NOTE"
      | "NON_VISIT_NOTE"
      | "EMAIL_NOTE"
      | "LIVE_NOTE";
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseSoapNoteTemplateControllerServiceGetAllSoapNoteTemplatesKeyFn(
        {
          flag,
          isPrivate,
          noteType,
          page,
          pageSize,
          searchString,
          sortBy,
          sortDirection,
        },
        queryKey,
      ),
    queryFn: () =>
      SoapNoteTemplateControllerService.getAllSoapNoteTemplates({
        flag,
        isPrivate,
        noteType,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useScreenHistoryControllerServiceGetScreenHistoryByUuid = <
  TData =
    Common.ScreenHistoryControllerServiceGetScreenHistoryByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseScreenHistoryControllerServiceGetScreenHistoryByUuidKeyFn(
        { uuid },
        queryKey,
      ),
    queryFn: () =>
      ScreenHistoryControllerService.getScreenHistoryByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useScreenHistoryControllerServiceGetAllScreenHistory = <
  TData =
    Common.ScreenHistoryControllerServiceGetAllScreenHistoryDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseScreenHistoryControllerServiceGetAllScreenHistoryKeyFn(
      { page, pageSize, patientUuid, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      ScreenHistoryControllerService.getAllScreenHistory({
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useReviewOfSystemTemplateControllerServiceGetReviewOfSystemTemplateByUuid =
  <
    TData =
      Common.ReviewOfSystemTemplateControllerServiceGetReviewOfSystemTemplateByUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      uuid,
    }: {
      uuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseReviewOfSystemTemplateControllerServiceGetReviewOfSystemTemplateByUuidKeyFn(
          { uuid },
          queryKey,
        ),
      queryFn: () =>
        ReviewOfSystemTemplateControllerService.getReviewOfSystemTemplateByUuid(
          { uuid },
        ) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.size
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.isPrivate
 * @param data.flag
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useReviewOfSystemTemplateControllerServiceGetAllReviewOfSystemTemplates =
  <
    TData =
      Common.ReviewOfSystemTemplateControllerServiceGetAllReviewOfSystemTemplatesDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      flag,
      isPrivate,
      page,
      searchString,
      size,
      sortBy,
      sortDirection,
    }: {
      flag?: boolean;
      isPrivate?: boolean;
      page?: number;
      searchString?: string;
      size?: number;
      sortBy?: string;
      sortDirection?: string;
    } = {},
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseReviewOfSystemTemplateControllerServiceGetAllReviewOfSystemTemplatesKeyFn(
          { flag, isPrivate, page, searchString, size, sortBy, sortDirection },
          queryKey,
        ),
      queryFn: () =>
        ReviewOfSystemTemplateControllerService.getAllReviewOfSystemTemplates({
          flag,
          isPrivate,
          page,
          searchString,
          size,
          sortBy,
          sortDirection,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useReviewOfSystemControllerServiceGetReviewOfSystemByUuid = <
  TData =
    Common.ReviewOfSystemControllerServiceGetReviewOfSystemByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseReviewOfSystemControllerServiceGetReviewOfSystemByUuidKeyFn(
        { uuid },
        queryKey,
      ),
    queryFn: () =>
      ReviewOfSystemControllerService.getReviewOfSystemByUuid({
        uuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.size
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useReviewOfSystemControllerServiceGetAllReviewOfSystems = <
  TData =
    Common.ReviewOfSystemControllerServiceGetAllReviewOfSystemsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    patientUuid,
    size,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    patientUuid: string;
    size?: number;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseReviewOfSystemControllerServiceGetAllReviewOfSystemsKeyFn(
        { page, patientUuid, size, sortBy, sortDirection },
        queryKey,
      ),
    queryFn: () =>
      ReviewOfSystemControllerService.getAllReviewOfSystems({
        page,
        patientUuid,
        size,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.referralByUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useReferralControllerServiceGetReferralByUuid = <
  TData = Common.ReferralControllerServiceGetReferralByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    referralByUuid,
  }: {
    referralByUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseReferralControllerServiceGetReferralByUuidKeyFn(
      { referralByUuid },
      queryKey,
    ),
    queryFn: () =>
      ReferralControllerService.getReferralByUuid({ referralByUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.providerUuids
 * @param data.locationUuids
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useReferralControllerServiceGetAllReferralsByProviders = <
  TData =
    Common.ReferralControllerServiceGetAllReferralsByProvidersDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationUuids,
    page,
    pageSize,
    providerUuids,
    sortBy,
    sortDirection,
  }: {
    locationUuids?: string[];
    page?: number;
    pageSize?: number;
    providerUuids?: string[];
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseReferralControllerServiceGetAllReferralsByProvidersKeyFn(
        { locationUuids, page, pageSize, providerUuids, sortBy, sortDirection },
        queryKey,
      ),
    queryFn: () =>
      ReferralControllerService.getAllReferralsByProviders({
        locationUuids,
        page,
        pageSize,
        providerUuids,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.searchString
 * @param data.fax
 * @param data.phone
 * @param data.email
 * @param data.stat
 * @param data.referralType
 * @param data.referredBy
 * @param data.referredTo
 * @param data.startDate
 * @param data.endDate
 * @param data.providerUuids
 * @param data.locationUuids
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useReferralControllerServiceGetAllReferralsForGlobal = <
  TData =
    Common.ReferralControllerServiceGetAllReferralsForGlobalDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    email,
    endDate,
    fax,
    locationUuids,
    page,
    phone,
    providerUuids,
    referralType,
    referredBy,
    referredTo,
    searchString,
    size,
    sort,
    startDate,
    stat,
  }: {
    email?: string;
    endDate?: string;
    fax?: string;
    locationUuids?: string[];
    page?: number;
    phone?: string;
    providerUuids?: string[];
    referralType?:
      | "IMAGING"
      | "SPECIALIST"
      | "ACUPUNCTURIST"
      | "ADULT_COMPANION"
      | "ADVANCED_PRACTICE_DENTAL_THERAPIST"
      | "ADVANCED_PRACTICE_MIDWIFE"
      | "AIR_CARRIER"
      | "ALLERGY_IMMUNOLOGY"
      | "ALZHEIMER_CENTER_DEMENTIA_CENTER"
      | "AMBULANCE"
      | "ANAPLASTOLOGIST"
      | "ANESTHESIOLOGIST_ASSISTANT"
      | "ANESTHESIOLOGY"
      | "ART_THERAPIST"
      | "ASSISTANT_BEHAVIOR_ANALYST"
      | "ASSISTANT_PODIATRIC"
      | "ASSISTED_LIVING_FACILITY"
      | "AUDIOLOGIST"
      | "AUDIOLOGIST_HEARING_AID_FITTER"
      | "BEHAVIOR_ANALYST"
      | "BEHAVIOR_TECHNICIAN"
      | "BLOOD_BANK"
      | "BUS"
      | "CASE_MANAGEMENT"
      | "CASE_MANAGER_CARE_COORDINATOR"
      | "CHIROPRACTOR"
      | "CHORE_PROVIDER"
      | "CHRISTIAN_SCIENCE_FACILITY"
      | "CHRISTIAN_SCIENCE_SANITORIUM"
      | "CHRONIC_DISEASE_HOSPITAL"
      | "CLINIC_CENTER"
      | "CLINICAL_ETHICIST"
      | "CLINICAL_EXERCISE_PHYSIOLOGIST"
      | "CLINICAL_MEDICAL_LABORATORY"
      | "CLINICAL_NEUROPSYCHOLOGIST"
      | "CLINICAL_NURSE_SPECIALIST"
      | "CLINICAL_PHARMACOLOGY"
      | "COLON_RECTAL_SURGERY"
      | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
      | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_MENTAL_ILLNESS"
      | "COMMUNITY_HEALTH_WORKER"
      | "COMMUNITY_PARAMEDIC"
      | "COMMUNITY_BEHAVIORAL_HEALTH"
      | "CONTRACTOR"
      | "COUNSELOR"
      | "CUSTODIAL_CARE_FACILITY"
      | "DANCE_THERAPIST"
      | "DAY_TRAINING_DEVELOPMENTALLY_DISABLED_SERVICES"
      | "DAY_TRAINING_HABILITATION_SPECIALIST"
      | "DENTAL_ASSISTANT"
      | "DENTAL_HYGIENIST"
      | "DENTAL_LABORATORY"
      | "DENTAL_LABORATORY_TECHNICIAN"
      | "DENTAL_THERAPIST"
      | "DENTIST"
      | "DENTURIST"
      | "DEPARTMENT_OF_VETERANS_AFFAIRS_VA_PHARMACY"
      | "DERMATOLOGY"
      | "DEVELOPMENTAL_THERAPIST"
      | "DIETARY_MANAGER"
      | "DIETETIC_TECHNICIAN_REGISTERED"
      | "DIETITIAN_REGISTERED"
      | "DOULA"
      | "DRAMA_THERAPIST"
      | "DRIVER"
      | "DURABLE_MEDICAL_EQUIPMENT_MEDICAL_SUPPLIES"
      | "EARLY_INTERVENTION_PROVIDER_AGENCY"
      | "ELECTRODIAGNOSTIC_MEDICINE"
      | "EMERGENCY_MEDICAL_TECHNICIAN_BASIC"
      | "EMERGENCY_MEDICAL_TECHNICIAN_INTERMEDIATE"
      | "EMERGENCY_MEDICAL_TECHNICIAN_PARAMEDIC"
      | "EMERGENCY_MEDICINE"
      | "EMERGENCY_RESPONSE_SYSTEM_COMPANIES"
      | "EPILEPSY_UNIT"
      | "EXCLUSIVE_PROVIDER_ORGANIZATION"
      | "EYE_BANK"
      | "EYEWEAR_SUPPLIER"
      | "FAMILY_MEDICINE"
      | "FOSTER_CARE_AGENCY"
      | "FUNERAL_DIRECTOR"
      | "GENERAL_ACUTE_CARE_HOSPITAL"
      | "GENERAL_PRACTICE"
      | "GENETIC_COUNSELOR_MS"
      | "HEALTH_WELLNESS_COACH"
      | "HEALTH_EDUCATOR"
      | "HEALTH_MAINTENANCE_ORGANIZATION"
      | "HEARING_AID_EQUIPMENT"
      | "HEARING_INSTRUMENT_SPECIALIST"
      | "HOME_DELIVERED_MEALS"
      | "HOME_HEALTH"
      | "HOME_HEALTH_AIDE"
      | "HOME_INFUSION"
      | "HOMEMAKER"
      | "HOMEOPATH"
      | "HOSPICE_CARE_COMMUNITY_BASED"
      | "HOSPICE_INPATIENT"
      | "HOSPITALIST"
      | "IN_HOME_SUPPORTIVE_CARE"
      | "INDEPENDENT_MEDICAL_EXAMINER"
      | "INDIAN_HEALTH_SERVICE_TRIBAL_URBAN_INDIAN_HEALTH_I_T_U_PHARMACY"
      | "INTEGRATIVE_MEDICINE"
      | "INTERMEDIATE_CARE_FACILITY_INTELLECTUAL_DISABILITIES"
      | "INTERMEDIATE_CARE_FACILITY_MENTAL_ILLNESS"
      | "INTERNAL_MEDICINE"
      | "INTERPRETER"
      | "KINESIOTHERAPIST"
      | "LACTATION_CONSULTANT_NON_RN"
      | "LEGAL_MEDICINE"
      | "LICENSED_PRACTICAL_NURSE"
      | "LICENSED_PSYCHIATRIC_TECHNICIAN"
      | "LICENSED_VOCATIONAL_NURSE"
      | "LOCAL_EDUCATION_AGENCY_LEA"
      | "LODGING"
      | "LONG_TERM_CARE_HOSPITAL"
      | "MARRIAGE_FAMILY_THERAPIST"
      | "MASSAGE_THERAPIST"
      | "MASTECTOMY_FITTER"
      | "MEALS"
      | "MECHANOTHERAPIST"
      | "MEDICAL_FOODS_SUPPLIER"
      | "MEDICAL_GENETICS"
      | "MEDICAL_GENETICS_PH_D_MEDICAL_GENETICS"
      | "MEDICARE_DEFINED_SWING_BED_UNIT"
      | "MIDWIFE"
      | "MIDWIFE_LAY"
      | "MILITARY_CLINICAL_MEDICAL_LABORATORY"
      | "MILITARY_HEALTH_CARE_PROVIDER"
      | "MILITARY_HOSPITAL"
      | "MILITARY_U_S_COAST_GUARD_PHARMACY"
      | "MILITARY_U_S_COAST_GUARD_TRANSPORT"
      | "MULTI_SPECIALTY"
      | "MUSIC_THERAPIST"
      | "NAPRAPATH"
      | "NATUROPATH"
      | "NEUROLOGICAL_SURGERY"
      | "NEUROMUSCULOSKELETAL_MEDICINE_OMM"
      | "NEUROMUSCULOSKELETAL_MEDICINE_SPORTS_MEDICINE"
      | "NON_PHARMACY_DISPENSING_SITE"
      | "NON_EMERGENCY_MEDICAL_TRANSPORT_VAN"
      | "NUCLEAR_MEDICINE"
      | "NURSE_ANESTHETIST_CERTIFIED_REGISTERED"
      | "NURSE_PRACTITIONER"
      | "NURSE_S_AIDE"
      | "NURSING_CARE"
      | "NURSING_FACILITY_INTERMEDIATE_CARE_FACILITY"
      | "NURSING_HOME_ADMINISTRATOR"
      | "NUTRITIONIST"
      | "OBSTETRICS_GYNECOLOGY"
      | "OCCUPATIONAL_THERAPIST"
      | "OCCUPATIONAL_THERAPY_ASSISTANT"
      | "OPHTHALMOLOGY"
      | "OPTOMETRIST"
      | "ORAL_MAXILLOFACIAL_SURGERY"
      | "ORGAN_PROCUREMENT_ORGANIZATION"
      | "ORTHOPAEDIC_SURGERY"
      | "ORTHOTIC_FITTER"
      | "ORTHOTIST"
      | "OTOLARYNGOLOGY"
      | "PAIN_MEDICINE"
      | "PATHOLOGY"
      | "PEDIATRICS"
      | "PEDORTHIST"
      | "PEER_SPECIALIST"
      | "PERFUSIONIST"
      | "PERSONAL_EMERGENCY_RESPONSE_ATTENDANT"
      | "PHARMACIST"
      | "PHARMACY"
      | "PHARMACY_TECHNICIAN"
      | "PHLEBOLOGY"
      | "PHYSICAL_MEDICINE_REHABILITATION"
      | "PHYSICAL_THERAPIST"
      | "PHYSICAL_THERAPY_ASSISTANT"
      | "PHYSICIAN_ASSISTANT"
      | "PHYSIOLOGICAL_LABORATORY"
      | "PLASTIC_SURGERY"
      | "PODIATRIST"
      | "POETRY_THERAPIST"
      | "POINT_OF_SERVICE"
      | "PORTABLE_X_RAY_AND_OR_OTHER_PORTABLE_DIAGNOSTIC_IMAGING_SUPPLIER"
      | "PREFERRED_PROVIDER_ORGANIZATION"
      | "PREVENTION_PROFESSIONAL"
      | "PREVENTIVE_MEDICINE"
      | "PRIVATE_VEHICLE"
      | "PROGRAM_OF_ALL_INCLUSIVE_CARE_FOR_THE_ELDERLY_PACE_PROVIDER_ORGANIZATION"
      | "PROSTHETIC_ORTHOTIC_SUPPLIER"
      | "PROSTHETIST"
      | "PSYCHIATRIC_HOSPITAL"
      | "PSYCHIATRIC_RESIDENTIAL_TREATMENT_FACILITY"
      | "PSYCHIATRIC_UNIT"
      | "PSYCHIATRY_NEUROLOGY"
      | "PSYCHOANALYST"
      | "PSYCHOLOGIST"
      | "PUBLIC_HEALTH_OR_WELFARE"
      | "PULMONARY_FUNCTION_TECHNOLOGIST"
      | "RADIOLOGIC_TECHNOLOGIST"
      | "RADIOLOGY"
      | "RADIOLOGY_PRACTITIONER_ASSISTANT"
      | "RECREATION_THERAPIST"
      | "RECREATIONAL_THERAPIST_ASSISTANT"
      | "REFLEXOLOGIST"
      | "REGISTERED_NURSE"
      | "REHABILITATION_COUNSELOR"
      | "REHABILITATION_HOSPITAL"
      | "REHABILITATION_PRACTITIONER"
      | "REHABILITATION_UNIT"
      | "REHABILITATION_SUBSTANCE_USE_DISORDER_UNIT"
      | "RELIGIOUS_NONMEDICAL_HEALTH_CARE_INSTITUTION"
      | "RELIGIOUS_NONMEDICAL_NURSING_PERSONNEL"
      | "RELIGIOUS_NONMEDICAL_PRACTITIONER"
      | "RESIDENTIAL_TREATMENT_FACILITY_EMOTIONALLY_DISTURBED_CHILDREN"
      | "RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
      | "RESIDENTIAL_TREATMENT_FACILITY_PHYSICAL_DISABILITIES"
      | "RESPIRATORY_THERAPIST_CERTIFIED"
      | "RESPIRATORY_THERAPIST_REGISTERED"
      | "RESPITE_CARE"
      | "SECURED_MEDICAL_TRANSPORT_VAN"
      | "SINGLE_SPECIALTY"
      | "SKILLED_NURSING_FACILITY"
      | "SLEEP_SPECIALIST_PHD"
      | "SOCIAL_WORKER"
      | "SPECIAL_HOSPITAL"
      | "SPECIALIST_TECHNOLOGIST"
      | "SPECIALIST_TECHNOLOGIST_CARDIOVASCULAR"
      | "SPECIALIST_TECHNOLOGIST_HEALTH_INFORMATION"
      | "SPECIALIST_TECHNOLOGIST_OTHER"
      | "SPECIALIST_TECHNOLOGIST_PATHOLOGY"
      | "SPEECH_LANGUAGE_PATHOLOGIST"
      | "STUDENT_IN_AN_ORGANIZED_HEALTH_CARE_EDUCATION_TRAINING_PROGRAM"
      | "SUBSTANCE_ABUSE_REHABILITATION_FACILITY"
      | "SUPPORTS_BROKERAGE"
      | "SURGERY"
      | "TAXI"
      | "TECHNICIAN"
      | "TECHNICIAN_CARDIOLOGY"
      | "TECHNICIAN_HEALTH_INFORMATION"
      | "TECHNICIAN_OTHER"
      | "TECHNICIAN_PATHOLOGY"
      | "TECHNICIAN_TECHNOLOGIST"
      | "THORACIC_SURGERY_CARDIOTHORACIC_VASCULAR_SURGERY"
      | "TRAIN"
      | "TRANSPLANT_SURGERY"
      | "TRANSPORTATION_BROKER"
      | "TRANSPORTATION_NETWORK_COMPANY"
      | "UROLOGY"
      | "VETERINARIAN"
      | "VOLUNTARY_OR_CHARITABLE";
    referredBy?: string;
    referredTo?: string;
    searchString?: string;
    size?: number;
    sort?: string[];
    startDate?: string;
    stat?: boolean;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseReferralControllerServiceGetAllReferralsForGlobalKeyFn(
      {
        email,
        endDate,
        fax,
        locationUuids,
        page,
        phone,
        providerUuids,
        referralType,
        referredBy,
        referredTo,
        searchString,
        size,
        sort,
        startDate,
        stat,
      },
      queryKey,
    ),
    queryFn: () =>
      ReferralControllerService.getAllReferralsForGlobal({
        email,
        endDate,
        fax,
        locationUuids,
        page,
        phone,
        providerUuids,
        referralType,
        referredBy,
        referredTo,
        searchString,
        size,
        sort,
        startDate,
        stat,
      }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useReferralControllerServiceGetAllChartItem = <
  TData = Common.ReferralControllerServiceGetAllChartItemDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseReferralControllerServiceGetAllChartItemKeyFn(queryKey),
    queryFn: () => ReferralControllerService.getAllChartItem() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.searchString
 * @param data.fax
 * @param data.phone
 * @param data.email
 * @param data.stat
 * @param data.referralType
 * @param data.referredBy
 * @param data.referredTo
 * @param data.startDate
 * @param data.endDate
 * @param data.draft
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useReferralControllerServiceGetAllReferrals = <
  TData = Common.ReferralControllerServiceGetAllReferralsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    draft,
    email,
    endDate,
    fax,
    page,
    patientUuid,
    phone,
    referralType,
    referredBy,
    referredTo,
    searchString,
    size,
    sort,
    startDate,
    stat,
  }: {
    draft?: boolean;
    email?: string;
    endDate?: string;
    fax?: string;
    page?: number;
    patientUuid: string;
    phone?: string;
    referralType?:
      | "IMAGING"
      | "SPECIALIST"
      | "ACUPUNCTURIST"
      | "ADULT_COMPANION"
      | "ADVANCED_PRACTICE_DENTAL_THERAPIST"
      | "ADVANCED_PRACTICE_MIDWIFE"
      | "AIR_CARRIER"
      | "ALLERGY_IMMUNOLOGY"
      | "ALZHEIMER_CENTER_DEMENTIA_CENTER"
      | "AMBULANCE"
      | "ANAPLASTOLOGIST"
      | "ANESTHESIOLOGIST_ASSISTANT"
      | "ANESTHESIOLOGY"
      | "ART_THERAPIST"
      | "ASSISTANT_BEHAVIOR_ANALYST"
      | "ASSISTANT_PODIATRIC"
      | "ASSISTED_LIVING_FACILITY"
      | "AUDIOLOGIST"
      | "AUDIOLOGIST_HEARING_AID_FITTER"
      | "BEHAVIOR_ANALYST"
      | "BEHAVIOR_TECHNICIAN"
      | "BLOOD_BANK"
      | "BUS"
      | "CASE_MANAGEMENT"
      | "CASE_MANAGER_CARE_COORDINATOR"
      | "CHIROPRACTOR"
      | "CHORE_PROVIDER"
      | "CHRISTIAN_SCIENCE_FACILITY"
      | "CHRISTIAN_SCIENCE_SANITORIUM"
      | "CHRONIC_DISEASE_HOSPITAL"
      | "CLINIC_CENTER"
      | "CLINICAL_ETHICIST"
      | "CLINICAL_EXERCISE_PHYSIOLOGIST"
      | "CLINICAL_MEDICAL_LABORATORY"
      | "CLINICAL_NEUROPSYCHOLOGIST"
      | "CLINICAL_NURSE_SPECIALIST"
      | "CLINICAL_PHARMACOLOGY"
      | "COLON_RECTAL_SURGERY"
      | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
      | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_MENTAL_ILLNESS"
      | "COMMUNITY_HEALTH_WORKER"
      | "COMMUNITY_PARAMEDIC"
      | "COMMUNITY_BEHAVIORAL_HEALTH"
      | "CONTRACTOR"
      | "COUNSELOR"
      | "CUSTODIAL_CARE_FACILITY"
      | "DANCE_THERAPIST"
      | "DAY_TRAINING_DEVELOPMENTALLY_DISABLED_SERVICES"
      | "DAY_TRAINING_HABILITATION_SPECIALIST"
      | "DENTAL_ASSISTANT"
      | "DENTAL_HYGIENIST"
      | "DENTAL_LABORATORY"
      | "DENTAL_LABORATORY_TECHNICIAN"
      | "DENTAL_THERAPIST"
      | "DENTIST"
      | "DENTURIST"
      | "DEPARTMENT_OF_VETERANS_AFFAIRS_VA_PHARMACY"
      | "DERMATOLOGY"
      | "DEVELOPMENTAL_THERAPIST"
      | "DIETARY_MANAGER"
      | "DIETETIC_TECHNICIAN_REGISTERED"
      | "DIETITIAN_REGISTERED"
      | "DOULA"
      | "DRAMA_THERAPIST"
      | "DRIVER"
      | "DURABLE_MEDICAL_EQUIPMENT_MEDICAL_SUPPLIES"
      | "EARLY_INTERVENTION_PROVIDER_AGENCY"
      | "ELECTRODIAGNOSTIC_MEDICINE"
      | "EMERGENCY_MEDICAL_TECHNICIAN_BASIC"
      | "EMERGENCY_MEDICAL_TECHNICIAN_INTERMEDIATE"
      | "EMERGENCY_MEDICAL_TECHNICIAN_PARAMEDIC"
      | "EMERGENCY_MEDICINE"
      | "EMERGENCY_RESPONSE_SYSTEM_COMPANIES"
      | "EPILEPSY_UNIT"
      | "EXCLUSIVE_PROVIDER_ORGANIZATION"
      | "EYE_BANK"
      | "EYEWEAR_SUPPLIER"
      | "FAMILY_MEDICINE"
      | "FOSTER_CARE_AGENCY"
      | "FUNERAL_DIRECTOR"
      | "GENERAL_ACUTE_CARE_HOSPITAL"
      | "GENERAL_PRACTICE"
      | "GENETIC_COUNSELOR_MS"
      | "HEALTH_WELLNESS_COACH"
      | "HEALTH_EDUCATOR"
      | "HEALTH_MAINTENANCE_ORGANIZATION"
      | "HEARING_AID_EQUIPMENT"
      | "HEARING_INSTRUMENT_SPECIALIST"
      | "HOME_DELIVERED_MEALS"
      | "HOME_HEALTH"
      | "HOME_HEALTH_AIDE"
      | "HOME_INFUSION"
      | "HOMEMAKER"
      | "HOMEOPATH"
      | "HOSPICE_CARE_COMMUNITY_BASED"
      | "HOSPICE_INPATIENT"
      | "HOSPITALIST"
      | "IN_HOME_SUPPORTIVE_CARE"
      | "INDEPENDENT_MEDICAL_EXAMINER"
      | "INDIAN_HEALTH_SERVICE_TRIBAL_URBAN_INDIAN_HEALTH_I_T_U_PHARMACY"
      | "INTEGRATIVE_MEDICINE"
      | "INTERMEDIATE_CARE_FACILITY_INTELLECTUAL_DISABILITIES"
      | "INTERMEDIATE_CARE_FACILITY_MENTAL_ILLNESS"
      | "INTERNAL_MEDICINE"
      | "INTERPRETER"
      | "KINESIOTHERAPIST"
      | "LACTATION_CONSULTANT_NON_RN"
      | "LEGAL_MEDICINE"
      | "LICENSED_PRACTICAL_NURSE"
      | "LICENSED_PSYCHIATRIC_TECHNICIAN"
      | "LICENSED_VOCATIONAL_NURSE"
      | "LOCAL_EDUCATION_AGENCY_LEA"
      | "LODGING"
      | "LONG_TERM_CARE_HOSPITAL"
      | "MARRIAGE_FAMILY_THERAPIST"
      | "MASSAGE_THERAPIST"
      | "MASTECTOMY_FITTER"
      | "MEALS"
      | "MECHANOTHERAPIST"
      | "MEDICAL_FOODS_SUPPLIER"
      | "MEDICAL_GENETICS"
      | "MEDICAL_GENETICS_PH_D_MEDICAL_GENETICS"
      | "MEDICARE_DEFINED_SWING_BED_UNIT"
      | "MIDWIFE"
      | "MIDWIFE_LAY"
      | "MILITARY_CLINICAL_MEDICAL_LABORATORY"
      | "MILITARY_HEALTH_CARE_PROVIDER"
      | "MILITARY_HOSPITAL"
      | "MILITARY_U_S_COAST_GUARD_PHARMACY"
      | "MILITARY_U_S_COAST_GUARD_TRANSPORT"
      | "MULTI_SPECIALTY"
      | "MUSIC_THERAPIST"
      | "NAPRAPATH"
      | "NATUROPATH"
      | "NEUROLOGICAL_SURGERY"
      | "NEUROMUSCULOSKELETAL_MEDICINE_OMM"
      | "NEUROMUSCULOSKELETAL_MEDICINE_SPORTS_MEDICINE"
      | "NON_PHARMACY_DISPENSING_SITE"
      | "NON_EMERGENCY_MEDICAL_TRANSPORT_VAN"
      | "NUCLEAR_MEDICINE"
      | "NURSE_ANESTHETIST_CERTIFIED_REGISTERED"
      | "NURSE_PRACTITIONER"
      | "NURSE_S_AIDE"
      | "NURSING_CARE"
      | "NURSING_FACILITY_INTERMEDIATE_CARE_FACILITY"
      | "NURSING_HOME_ADMINISTRATOR"
      | "NUTRITIONIST"
      | "OBSTETRICS_GYNECOLOGY"
      | "OCCUPATIONAL_THERAPIST"
      | "OCCUPATIONAL_THERAPY_ASSISTANT"
      | "OPHTHALMOLOGY"
      | "OPTOMETRIST"
      | "ORAL_MAXILLOFACIAL_SURGERY"
      | "ORGAN_PROCUREMENT_ORGANIZATION"
      | "ORTHOPAEDIC_SURGERY"
      | "ORTHOTIC_FITTER"
      | "ORTHOTIST"
      | "OTOLARYNGOLOGY"
      | "PAIN_MEDICINE"
      | "PATHOLOGY"
      | "PEDIATRICS"
      | "PEDORTHIST"
      | "PEER_SPECIALIST"
      | "PERFUSIONIST"
      | "PERSONAL_EMERGENCY_RESPONSE_ATTENDANT"
      | "PHARMACIST"
      | "PHARMACY"
      | "PHARMACY_TECHNICIAN"
      | "PHLEBOLOGY"
      | "PHYSICAL_MEDICINE_REHABILITATION"
      | "PHYSICAL_THERAPIST"
      | "PHYSICAL_THERAPY_ASSISTANT"
      | "PHYSICIAN_ASSISTANT"
      | "PHYSIOLOGICAL_LABORATORY"
      | "PLASTIC_SURGERY"
      | "PODIATRIST"
      | "POETRY_THERAPIST"
      | "POINT_OF_SERVICE"
      | "PORTABLE_X_RAY_AND_OR_OTHER_PORTABLE_DIAGNOSTIC_IMAGING_SUPPLIER"
      | "PREFERRED_PROVIDER_ORGANIZATION"
      | "PREVENTION_PROFESSIONAL"
      | "PREVENTIVE_MEDICINE"
      | "PRIVATE_VEHICLE"
      | "PROGRAM_OF_ALL_INCLUSIVE_CARE_FOR_THE_ELDERLY_PACE_PROVIDER_ORGANIZATION"
      | "PROSTHETIC_ORTHOTIC_SUPPLIER"
      | "PROSTHETIST"
      | "PSYCHIATRIC_HOSPITAL"
      | "PSYCHIATRIC_RESIDENTIAL_TREATMENT_FACILITY"
      | "PSYCHIATRIC_UNIT"
      | "PSYCHIATRY_NEUROLOGY"
      | "PSYCHOANALYST"
      | "PSYCHOLOGIST"
      | "PUBLIC_HEALTH_OR_WELFARE"
      | "PULMONARY_FUNCTION_TECHNOLOGIST"
      | "RADIOLOGIC_TECHNOLOGIST"
      | "RADIOLOGY"
      | "RADIOLOGY_PRACTITIONER_ASSISTANT"
      | "RECREATION_THERAPIST"
      | "RECREATIONAL_THERAPIST_ASSISTANT"
      | "REFLEXOLOGIST"
      | "REGISTERED_NURSE"
      | "REHABILITATION_COUNSELOR"
      | "REHABILITATION_HOSPITAL"
      | "REHABILITATION_PRACTITIONER"
      | "REHABILITATION_UNIT"
      | "REHABILITATION_SUBSTANCE_USE_DISORDER_UNIT"
      | "RELIGIOUS_NONMEDICAL_HEALTH_CARE_INSTITUTION"
      | "RELIGIOUS_NONMEDICAL_NURSING_PERSONNEL"
      | "RELIGIOUS_NONMEDICAL_PRACTITIONER"
      | "RESIDENTIAL_TREATMENT_FACILITY_EMOTIONALLY_DISTURBED_CHILDREN"
      | "RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
      | "RESIDENTIAL_TREATMENT_FACILITY_PHYSICAL_DISABILITIES"
      | "RESPIRATORY_THERAPIST_CERTIFIED"
      | "RESPIRATORY_THERAPIST_REGISTERED"
      | "RESPITE_CARE"
      | "SECURED_MEDICAL_TRANSPORT_VAN"
      | "SINGLE_SPECIALTY"
      | "SKILLED_NURSING_FACILITY"
      | "SLEEP_SPECIALIST_PHD"
      | "SOCIAL_WORKER"
      | "SPECIAL_HOSPITAL"
      | "SPECIALIST_TECHNOLOGIST"
      | "SPECIALIST_TECHNOLOGIST_CARDIOVASCULAR"
      | "SPECIALIST_TECHNOLOGIST_HEALTH_INFORMATION"
      | "SPECIALIST_TECHNOLOGIST_OTHER"
      | "SPECIALIST_TECHNOLOGIST_PATHOLOGY"
      | "SPEECH_LANGUAGE_PATHOLOGIST"
      | "STUDENT_IN_AN_ORGANIZED_HEALTH_CARE_EDUCATION_TRAINING_PROGRAM"
      | "SUBSTANCE_ABUSE_REHABILITATION_FACILITY"
      | "SUPPORTS_BROKERAGE"
      | "SURGERY"
      | "TAXI"
      | "TECHNICIAN"
      | "TECHNICIAN_CARDIOLOGY"
      | "TECHNICIAN_HEALTH_INFORMATION"
      | "TECHNICIAN_OTHER"
      | "TECHNICIAN_PATHOLOGY"
      | "TECHNICIAN_TECHNOLOGIST"
      | "THORACIC_SURGERY_CARDIOTHORACIC_VASCULAR_SURGERY"
      | "TRAIN"
      | "TRANSPLANT_SURGERY"
      | "TRANSPORTATION_BROKER"
      | "TRANSPORTATION_NETWORK_COMPANY"
      | "UROLOGY"
      | "VETERINARIAN"
      | "VOLUNTARY_OR_CHARITABLE";
    referredBy?: string;
    referredTo?: string;
    searchString?: string;
    size?: number;
    sort?: string[];
    startDate?: string;
    stat?: boolean;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseReferralControllerServiceGetAllReferralsKeyFn(
      {
        draft,
        email,
        endDate,
        fax,
        page,
        patientUuid,
        phone,
        referralType,
        referredBy,
        referredTo,
        searchString,
        size,
        sort,
        startDate,
        stat,
      },
      queryKey,
    ),
    queryFn: () =>
      ReferralControllerService.getAllReferrals({
        draft,
        email,
        endDate,
        fax,
        page,
        patientUuid,
        phone,
        referralType,
        referredBy,
        referredTo,
        searchString,
        size,
        sort,
        startDate,
        stat,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.limit
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderDirectoryControllerServiceGetNppesImportHistory = <
  TData =
    Common.ProviderDirectoryControllerServiceGetNppesImportHistoryDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    limit,
  }: {
    limit?: number;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseProviderDirectoryControllerServiceGetNppesImportHistoryKeyFn(
        { limit },
        queryKey,
      ),
    queryFn: () =>
      ProviderDirectoryControllerService.getNppesImportHistory({
        limit,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.providerDirectoryUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderDirectoryControllerServiceGetProviderDirectoryUuid = <
  TData =
    Common.ProviderDirectoryControllerServiceGetProviderDirectoryUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    providerDirectoryUuid,
  }: {
    providerDirectoryUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseProviderDirectoryControllerServiceGetProviderDirectoryUuidKeyFn(
        { providerDirectoryUuid },
        queryKey,
      ),
    queryFn: () =>
      ProviderDirectoryControllerService.getProviderDirectoryUuid({
        providerDirectoryUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.searchString
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderDirectoryControllerServiceGetAllReferralTypes = <
  TData =
    Common.ProviderDirectoryControllerServiceGetAllReferralTypesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    searchString,
    size,
    sort,
  }: {
    page?: number;
    searchString?: string;
    size?: number;
    sort?: string[];
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseProviderDirectoryControllerServiceGetAllReferralTypesKeyFn(
        { page, searchString, size, sort },
        queryKey,
      ),
    queryFn: () =>
      ProviderDirectoryControllerService.getAllReferralTypes({
        page,
        searchString,
        size,
        sort,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.referralType
 * @param data.searchString
 * @param data.city
 * @param data.state
 * @returns unknown OK
 * @throws ApiError
 */
export const useProviderDirectoryControllerServiceProviderDirectoryExportCsv = <
  TData =
    Common.ProviderDirectoryControllerServiceProviderDirectoryExportCsvDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    city,
    referralType,
    searchString,
    state,
  }: {
    city?: string;
    referralType?:
      | "IMAGING"
      | "SPECIALIST"
      | "ACUPUNCTURIST"
      | "ADULT_COMPANION"
      | "ADVANCED_PRACTICE_DENTAL_THERAPIST"
      | "ADVANCED_PRACTICE_MIDWIFE"
      | "AIR_CARRIER"
      | "ALLERGY_IMMUNOLOGY"
      | "ALZHEIMER_CENTER_DEMENTIA_CENTER"
      | "AMBULANCE"
      | "ANAPLASTOLOGIST"
      | "ANESTHESIOLOGIST_ASSISTANT"
      | "ANESTHESIOLOGY"
      | "ART_THERAPIST"
      | "ASSISTANT_BEHAVIOR_ANALYST"
      | "ASSISTANT_PODIATRIC"
      | "ASSISTED_LIVING_FACILITY"
      | "AUDIOLOGIST"
      | "AUDIOLOGIST_HEARING_AID_FITTER"
      | "BEHAVIOR_ANALYST"
      | "BEHAVIOR_TECHNICIAN"
      | "BLOOD_BANK"
      | "BUS"
      | "CASE_MANAGEMENT"
      | "CASE_MANAGER_CARE_COORDINATOR"
      | "CHIROPRACTOR"
      | "CHORE_PROVIDER"
      | "CHRISTIAN_SCIENCE_FACILITY"
      | "CHRISTIAN_SCIENCE_SANITORIUM"
      | "CHRONIC_DISEASE_HOSPITAL"
      | "CLINIC_CENTER"
      | "CLINICAL_ETHICIST"
      | "CLINICAL_EXERCISE_PHYSIOLOGIST"
      | "CLINICAL_MEDICAL_LABORATORY"
      | "CLINICAL_NEUROPSYCHOLOGIST"
      | "CLINICAL_NURSE_SPECIALIST"
      | "CLINICAL_PHARMACOLOGY"
      | "COLON_RECTAL_SURGERY"
      | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
      | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_MENTAL_ILLNESS"
      | "COMMUNITY_HEALTH_WORKER"
      | "COMMUNITY_PARAMEDIC"
      | "COMMUNITY_BEHAVIORAL_HEALTH"
      | "CONTRACTOR"
      | "COUNSELOR"
      | "CUSTODIAL_CARE_FACILITY"
      | "DANCE_THERAPIST"
      | "DAY_TRAINING_DEVELOPMENTALLY_DISABLED_SERVICES"
      | "DAY_TRAINING_HABILITATION_SPECIALIST"
      | "DENTAL_ASSISTANT"
      | "DENTAL_HYGIENIST"
      | "DENTAL_LABORATORY"
      | "DENTAL_LABORATORY_TECHNICIAN"
      | "DENTAL_THERAPIST"
      | "DENTIST"
      | "DENTURIST"
      | "DEPARTMENT_OF_VETERANS_AFFAIRS_VA_PHARMACY"
      | "DERMATOLOGY"
      | "DEVELOPMENTAL_THERAPIST"
      | "DIETARY_MANAGER"
      | "DIETETIC_TECHNICIAN_REGISTERED"
      | "DIETITIAN_REGISTERED"
      | "DOULA"
      | "DRAMA_THERAPIST"
      | "DRIVER"
      | "DURABLE_MEDICAL_EQUIPMENT_MEDICAL_SUPPLIES"
      | "EARLY_INTERVENTION_PROVIDER_AGENCY"
      | "ELECTRODIAGNOSTIC_MEDICINE"
      | "EMERGENCY_MEDICAL_TECHNICIAN_BASIC"
      | "EMERGENCY_MEDICAL_TECHNICIAN_INTERMEDIATE"
      | "EMERGENCY_MEDICAL_TECHNICIAN_PARAMEDIC"
      | "EMERGENCY_MEDICINE"
      | "EMERGENCY_RESPONSE_SYSTEM_COMPANIES"
      | "EPILEPSY_UNIT"
      | "EXCLUSIVE_PROVIDER_ORGANIZATION"
      | "EYE_BANK"
      | "EYEWEAR_SUPPLIER"
      | "FAMILY_MEDICINE"
      | "FOSTER_CARE_AGENCY"
      | "FUNERAL_DIRECTOR"
      | "GENERAL_ACUTE_CARE_HOSPITAL"
      | "GENERAL_PRACTICE"
      | "GENETIC_COUNSELOR_MS"
      | "HEALTH_WELLNESS_COACH"
      | "HEALTH_EDUCATOR"
      | "HEALTH_MAINTENANCE_ORGANIZATION"
      | "HEARING_AID_EQUIPMENT"
      | "HEARING_INSTRUMENT_SPECIALIST"
      | "HOME_DELIVERED_MEALS"
      | "HOME_HEALTH"
      | "HOME_HEALTH_AIDE"
      | "HOME_INFUSION"
      | "HOMEMAKER"
      | "HOMEOPATH"
      | "HOSPICE_CARE_COMMUNITY_BASED"
      | "HOSPICE_INPATIENT"
      | "HOSPITALIST"
      | "IN_HOME_SUPPORTIVE_CARE"
      | "INDEPENDENT_MEDICAL_EXAMINER"
      | "INDIAN_HEALTH_SERVICE_TRIBAL_URBAN_INDIAN_HEALTH_I_T_U_PHARMACY"
      | "INTEGRATIVE_MEDICINE"
      | "INTERMEDIATE_CARE_FACILITY_INTELLECTUAL_DISABILITIES"
      | "INTERMEDIATE_CARE_FACILITY_MENTAL_ILLNESS"
      | "INTERNAL_MEDICINE"
      | "INTERPRETER"
      | "KINESIOTHERAPIST"
      | "LACTATION_CONSULTANT_NON_RN"
      | "LEGAL_MEDICINE"
      | "LICENSED_PRACTICAL_NURSE"
      | "LICENSED_PSYCHIATRIC_TECHNICIAN"
      | "LICENSED_VOCATIONAL_NURSE"
      | "LOCAL_EDUCATION_AGENCY_LEA"
      | "LODGING"
      | "LONG_TERM_CARE_HOSPITAL"
      | "MARRIAGE_FAMILY_THERAPIST"
      | "MASSAGE_THERAPIST"
      | "MASTECTOMY_FITTER"
      | "MEALS"
      | "MECHANOTHERAPIST"
      | "MEDICAL_FOODS_SUPPLIER"
      | "MEDICAL_GENETICS"
      | "MEDICAL_GENETICS_PH_D_MEDICAL_GENETICS"
      | "MEDICARE_DEFINED_SWING_BED_UNIT"
      | "MIDWIFE"
      | "MIDWIFE_LAY"
      | "MILITARY_CLINICAL_MEDICAL_LABORATORY"
      | "MILITARY_HEALTH_CARE_PROVIDER"
      | "MILITARY_HOSPITAL"
      | "MILITARY_U_S_COAST_GUARD_PHARMACY"
      | "MILITARY_U_S_COAST_GUARD_TRANSPORT"
      | "MULTI_SPECIALTY"
      | "MUSIC_THERAPIST"
      | "NAPRAPATH"
      | "NATUROPATH"
      | "NEUROLOGICAL_SURGERY"
      | "NEUROMUSCULOSKELETAL_MEDICINE_OMM"
      | "NEUROMUSCULOSKELETAL_MEDICINE_SPORTS_MEDICINE"
      | "NON_PHARMACY_DISPENSING_SITE"
      | "NON_EMERGENCY_MEDICAL_TRANSPORT_VAN"
      | "NUCLEAR_MEDICINE"
      | "NURSE_ANESTHETIST_CERTIFIED_REGISTERED"
      | "NURSE_PRACTITIONER"
      | "NURSE_S_AIDE"
      | "NURSING_CARE"
      | "NURSING_FACILITY_INTERMEDIATE_CARE_FACILITY"
      | "NURSING_HOME_ADMINISTRATOR"
      | "NUTRITIONIST"
      | "OBSTETRICS_GYNECOLOGY"
      | "OCCUPATIONAL_THERAPIST"
      | "OCCUPATIONAL_THERAPY_ASSISTANT"
      | "OPHTHALMOLOGY"
      | "OPTOMETRIST"
      | "ORAL_MAXILLOFACIAL_SURGERY"
      | "ORGAN_PROCUREMENT_ORGANIZATION"
      | "ORTHOPAEDIC_SURGERY"
      | "ORTHOTIC_FITTER"
      | "ORTHOTIST"
      | "OTOLARYNGOLOGY"
      | "PAIN_MEDICINE"
      | "PATHOLOGY"
      | "PEDIATRICS"
      | "PEDORTHIST"
      | "PEER_SPECIALIST"
      | "PERFUSIONIST"
      | "PERSONAL_EMERGENCY_RESPONSE_ATTENDANT"
      | "PHARMACIST"
      | "PHARMACY"
      | "PHARMACY_TECHNICIAN"
      | "PHLEBOLOGY"
      | "PHYSICAL_MEDICINE_REHABILITATION"
      | "PHYSICAL_THERAPIST"
      | "PHYSICAL_THERAPY_ASSISTANT"
      | "PHYSICIAN_ASSISTANT"
      | "PHYSIOLOGICAL_LABORATORY"
      | "PLASTIC_SURGERY"
      | "PODIATRIST"
      | "POETRY_THERAPIST"
      | "POINT_OF_SERVICE"
      | "PORTABLE_X_RAY_AND_OR_OTHER_PORTABLE_DIAGNOSTIC_IMAGING_SUPPLIER"
      | "PREFERRED_PROVIDER_ORGANIZATION"
      | "PREVENTION_PROFESSIONAL"
      | "PREVENTIVE_MEDICINE"
      | "PRIVATE_VEHICLE"
      | "PROGRAM_OF_ALL_INCLUSIVE_CARE_FOR_THE_ELDERLY_PACE_PROVIDER_ORGANIZATION"
      | "PROSTHETIC_ORTHOTIC_SUPPLIER"
      | "PROSTHETIST"
      | "PSYCHIATRIC_HOSPITAL"
      | "PSYCHIATRIC_RESIDENTIAL_TREATMENT_FACILITY"
      | "PSYCHIATRIC_UNIT"
      | "PSYCHIATRY_NEUROLOGY"
      | "PSYCHOANALYST"
      | "PSYCHOLOGIST"
      | "PUBLIC_HEALTH_OR_WELFARE"
      | "PULMONARY_FUNCTION_TECHNOLOGIST"
      | "RADIOLOGIC_TECHNOLOGIST"
      | "RADIOLOGY"
      | "RADIOLOGY_PRACTITIONER_ASSISTANT"
      | "RECREATION_THERAPIST"
      | "RECREATIONAL_THERAPIST_ASSISTANT"
      | "REFLEXOLOGIST"
      | "REGISTERED_NURSE"
      | "REHABILITATION_COUNSELOR"
      | "REHABILITATION_HOSPITAL"
      | "REHABILITATION_PRACTITIONER"
      | "REHABILITATION_UNIT"
      | "REHABILITATION_SUBSTANCE_USE_DISORDER_UNIT"
      | "RELIGIOUS_NONMEDICAL_HEALTH_CARE_INSTITUTION"
      | "RELIGIOUS_NONMEDICAL_NURSING_PERSONNEL"
      | "RELIGIOUS_NONMEDICAL_PRACTITIONER"
      | "RESIDENTIAL_TREATMENT_FACILITY_EMOTIONALLY_DISTURBED_CHILDREN"
      | "RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
      | "RESIDENTIAL_TREATMENT_FACILITY_PHYSICAL_DISABILITIES"
      | "RESPIRATORY_THERAPIST_CERTIFIED"
      | "RESPIRATORY_THERAPIST_REGISTERED"
      | "RESPITE_CARE"
      | "SECURED_MEDICAL_TRANSPORT_VAN"
      | "SINGLE_SPECIALTY"
      | "SKILLED_NURSING_FACILITY"
      | "SLEEP_SPECIALIST_PHD"
      | "SOCIAL_WORKER"
      | "SPECIAL_HOSPITAL"
      | "SPECIALIST_TECHNOLOGIST"
      | "SPECIALIST_TECHNOLOGIST_CARDIOVASCULAR"
      | "SPECIALIST_TECHNOLOGIST_HEALTH_INFORMATION"
      | "SPECIALIST_TECHNOLOGIST_OTHER"
      | "SPECIALIST_TECHNOLOGIST_PATHOLOGY"
      | "SPEECH_LANGUAGE_PATHOLOGIST"
      | "STUDENT_IN_AN_ORGANIZED_HEALTH_CARE_EDUCATION_TRAINING_PROGRAM"
      | "SUBSTANCE_ABUSE_REHABILITATION_FACILITY"
      | "SUPPORTS_BROKERAGE"
      | "SURGERY"
      | "TAXI"
      | "TECHNICIAN"
      | "TECHNICIAN_CARDIOLOGY"
      | "TECHNICIAN_HEALTH_INFORMATION"
      | "TECHNICIAN_OTHER"
      | "TECHNICIAN_PATHOLOGY"
      | "TECHNICIAN_TECHNOLOGIST"
      | "THORACIC_SURGERY_CARDIOTHORACIC_VASCULAR_SURGERY"
      | "TRAIN"
      | "TRANSPLANT_SURGERY"
      | "TRANSPORTATION_BROKER"
      | "TRANSPORTATION_NETWORK_COMPANY"
      | "UROLOGY"
      | "VETERINARIAN"
      | "VOLUNTARY_OR_CHARITABLE";
    searchString?: string;
    state?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseProviderDirectoryControllerServiceProviderDirectoryExportCsvKeyFn(
        { city, referralType, searchString, state },
        queryKey,
      ),
    queryFn: () =>
      ProviderDirectoryControllerService.providerDirectoryExportCsv({
        city,
        referralType,
        searchString,
        state,
      }) as TData,
    ...options,
  });
/**
 * @returns binary OK
 * @throws ApiError
 */
export const useProviderDirectoryControllerServiceDownloadCsvTemplate1 = <
  TData =
    Common.ProviderDirectoryControllerServiceDownloadCsvTemplate1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseProviderDirectoryControllerServiceDownloadCsvTemplate1KeyFn(
        queryKey,
      ),
    queryFn: () =>
      ProviderDirectoryControllerService.downloadCsvTemplate1() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.referralType
 * @param data.searchString
 * @param data.city
 * @param data.state
 * @param data.excludeImaging
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderDirectoryControllerServiceGetAllProviderDirectory = <
  TData =
    Common.ProviderDirectoryControllerServiceGetAllProviderDirectoryDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    city,
    excludeImaging,
    page,
    referralType,
    searchString,
    size,
    sort,
    state,
  }: {
    city?: string;
    excludeImaging?: boolean;
    page?: number;
    referralType?:
      | "IMAGING"
      | "SPECIALIST"
      | "ACUPUNCTURIST"
      | "ADULT_COMPANION"
      | "ADVANCED_PRACTICE_DENTAL_THERAPIST"
      | "ADVANCED_PRACTICE_MIDWIFE"
      | "AIR_CARRIER"
      | "ALLERGY_IMMUNOLOGY"
      | "ALZHEIMER_CENTER_DEMENTIA_CENTER"
      | "AMBULANCE"
      | "ANAPLASTOLOGIST"
      | "ANESTHESIOLOGIST_ASSISTANT"
      | "ANESTHESIOLOGY"
      | "ART_THERAPIST"
      | "ASSISTANT_BEHAVIOR_ANALYST"
      | "ASSISTANT_PODIATRIC"
      | "ASSISTED_LIVING_FACILITY"
      | "AUDIOLOGIST"
      | "AUDIOLOGIST_HEARING_AID_FITTER"
      | "BEHAVIOR_ANALYST"
      | "BEHAVIOR_TECHNICIAN"
      | "BLOOD_BANK"
      | "BUS"
      | "CASE_MANAGEMENT"
      | "CASE_MANAGER_CARE_COORDINATOR"
      | "CHIROPRACTOR"
      | "CHORE_PROVIDER"
      | "CHRISTIAN_SCIENCE_FACILITY"
      | "CHRISTIAN_SCIENCE_SANITORIUM"
      | "CHRONIC_DISEASE_HOSPITAL"
      | "CLINIC_CENTER"
      | "CLINICAL_ETHICIST"
      | "CLINICAL_EXERCISE_PHYSIOLOGIST"
      | "CLINICAL_MEDICAL_LABORATORY"
      | "CLINICAL_NEUROPSYCHOLOGIST"
      | "CLINICAL_NURSE_SPECIALIST"
      | "CLINICAL_PHARMACOLOGY"
      | "COLON_RECTAL_SURGERY"
      | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
      | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_MENTAL_ILLNESS"
      | "COMMUNITY_HEALTH_WORKER"
      | "COMMUNITY_PARAMEDIC"
      | "COMMUNITY_BEHAVIORAL_HEALTH"
      | "CONTRACTOR"
      | "COUNSELOR"
      | "CUSTODIAL_CARE_FACILITY"
      | "DANCE_THERAPIST"
      | "DAY_TRAINING_DEVELOPMENTALLY_DISABLED_SERVICES"
      | "DAY_TRAINING_HABILITATION_SPECIALIST"
      | "DENTAL_ASSISTANT"
      | "DENTAL_HYGIENIST"
      | "DENTAL_LABORATORY"
      | "DENTAL_LABORATORY_TECHNICIAN"
      | "DENTAL_THERAPIST"
      | "DENTIST"
      | "DENTURIST"
      | "DEPARTMENT_OF_VETERANS_AFFAIRS_VA_PHARMACY"
      | "DERMATOLOGY"
      | "DEVELOPMENTAL_THERAPIST"
      | "DIETARY_MANAGER"
      | "DIETETIC_TECHNICIAN_REGISTERED"
      | "DIETITIAN_REGISTERED"
      | "DOULA"
      | "DRAMA_THERAPIST"
      | "DRIVER"
      | "DURABLE_MEDICAL_EQUIPMENT_MEDICAL_SUPPLIES"
      | "EARLY_INTERVENTION_PROVIDER_AGENCY"
      | "ELECTRODIAGNOSTIC_MEDICINE"
      | "EMERGENCY_MEDICAL_TECHNICIAN_BASIC"
      | "EMERGENCY_MEDICAL_TECHNICIAN_INTERMEDIATE"
      | "EMERGENCY_MEDICAL_TECHNICIAN_PARAMEDIC"
      | "EMERGENCY_MEDICINE"
      | "EMERGENCY_RESPONSE_SYSTEM_COMPANIES"
      | "EPILEPSY_UNIT"
      | "EXCLUSIVE_PROVIDER_ORGANIZATION"
      | "EYE_BANK"
      | "EYEWEAR_SUPPLIER"
      | "FAMILY_MEDICINE"
      | "FOSTER_CARE_AGENCY"
      | "FUNERAL_DIRECTOR"
      | "GENERAL_ACUTE_CARE_HOSPITAL"
      | "GENERAL_PRACTICE"
      | "GENETIC_COUNSELOR_MS"
      | "HEALTH_WELLNESS_COACH"
      | "HEALTH_EDUCATOR"
      | "HEALTH_MAINTENANCE_ORGANIZATION"
      | "HEARING_AID_EQUIPMENT"
      | "HEARING_INSTRUMENT_SPECIALIST"
      | "HOME_DELIVERED_MEALS"
      | "HOME_HEALTH"
      | "HOME_HEALTH_AIDE"
      | "HOME_INFUSION"
      | "HOMEMAKER"
      | "HOMEOPATH"
      | "HOSPICE_CARE_COMMUNITY_BASED"
      | "HOSPICE_INPATIENT"
      | "HOSPITALIST"
      | "IN_HOME_SUPPORTIVE_CARE"
      | "INDEPENDENT_MEDICAL_EXAMINER"
      | "INDIAN_HEALTH_SERVICE_TRIBAL_URBAN_INDIAN_HEALTH_I_T_U_PHARMACY"
      | "INTEGRATIVE_MEDICINE"
      | "INTERMEDIATE_CARE_FACILITY_INTELLECTUAL_DISABILITIES"
      | "INTERMEDIATE_CARE_FACILITY_MENTAL_ILLNESS"
      | "INTERNAL_MEDICINE"
      | "INTERPRETER"
      | "KINESIOTHERAPIST"
      | "LACTATION_CONSULTANT_NON_RN"
      | "LEGAL_MEDICINE"
      | "LICENSED_PRACTICAL_NURSE"
      | "LICENSED_PSYCHIATRIC_TECHNICIAN"
      | "LICENSED_VOCATIONAL_NURSE"
      | "LOCAL_EDUCATION_AGENCY_LEA"
      | "LODGING"
      | "LONG_TERM_CARE_HOSPITAL"
      | "MARRIAGE_FAMILY_THERAPIST"
      | "MASSAGE_THERAPIST"
      | "MASTECTOMY_FITTER"
      | "MEALS"
      | "MECHANOTHERAPIST"
      | "MEDICAL_FOODS_SUPPLIER"
      | "MEDICAL_GENETICS"
      | "MEDICAL_GENETICS_PH_D_MEDICAL_GENETICS"
      | "MEDICARE_DEFINED_SWING_BED_UNIT"
      | "MIDWIFE"
      | "MIDWIFE_LAY"
      | "MILITARY_CLINICAL_MEDICAL_LABORATORY"
      | "MILITARY_HEALTH_CARE_PROVIDER"
      | "MILITARY_HOSPITAL"
      | "MILITARY_U_S_COAST_GUARD_PHARMACY"
      | "MILITARY_U_S_COAST_GUARD_TRANSPORT"
      | "MULTI_SPECIALTY"
      | "MUSIC_THERAPIST"
      | "NAPRAPATH"
      | "NATUROPATH"
      | "NEUROLOGICAL_SURGERY"
      | "NEUROMUSCULOSKELETAL_MEDICINE_OMM"
      | "NEUROMUSCULOSKELETAL_MEDICINE_SPORTS_MEDICINE"
      | "NON_PHARMACY_DISPENSING_SITE"
      | "NON_EMERGENCY_MEDICAL_TRANSPORT_VAN"
      | "NUCLEAR_MEDICINE"
      | "NURSE_ANESTHETIST_CERTIFIED_REGISTERED"
      | "NURSE_PRACTITIONER"
      | "NURSE_S_AIDE"
      | "NURSING_CARE"
      | "NURSING_FACILITY_INTERMEDIATE_CARE_FACILITY"
      | "NURSING_HOME_ADMINISTRATOR"
      | "NUTRITIONIST"
      | "OBSTETRICS_GYNECOLOGY"
      | "OCCUPATIONAL_THERAPIST"
      | "OCCUPATIONAL_THERAPY_ASSISTANT"
      | "OPHTHALMOLOGY"
      | "OPTOMETRIST"
      | "ORAL_MAXILLOFACIAL_SURGERY"
      | "ORGAN_PROCUREMENT_ORGANIZATION"
      | "ORTHOPAEDIC_SURGERY"
      | "ORTHOTIC_FITTER"
      | "ORTHOTIST"
      | "OTOLARYNGOLOGY"
      | "PAIN_MEDICINE"
      | "PATHOLOGY"
      | "PEDIATRICS"
      | "PEDORTHIST"
      | "PEER_SPECIALIST"
      | "PERFUSIONIST"
      | "PERSONAL_EMERGENCY_RESPONSE_ATTENDANT"
      | "PHARMACIST"
      | "PHARMACY"
      | "PHARMACY_TECHNICIAN"
      | "PHLEBOLOGY"
      | "PHYSICAL_MEDICINE_REHABILITATION"
      | "PHYSICAL_THERAPIST"
      | "PHYSICAL_THERAPY_ASSISTANT"
      | "PHYSICIAN_ASSISTANT"
      | "PHYSIOLOGICAL_LABORATORY"
      | "PLASTIC_SURGERY"
      | "PODIATRIST"
      | "POETRY_THERAPIST"
      | "POINT_OF_SERVICE"
      | "PORTABLE_X_RAY_AND_OR_OTHER_PORTABLE_DIAGNOSTIC_IMAGING_SUPPLIER"
      | "PREFERRED_PROVIDER_ORGANIZATION"
      | "PREVENTION_PROFESSIONAL"
      | "PREVENTIVE_MEDICINE"
      | "PRIVATE_VEHICLE"
      | "PROGRAM_OF_ALL_INCLUSIVE_CARE_FOR_THE_ELDERLY_PACE_PROVIDER_ORGANIZATION"
      | "PROSTHETIC_ORTHOTIC_SUPPLIER"
      | "PROSTHETIST"
      | "PSYCHIATRIC_HOSPITAL"
      | "PSYCHIATRIC_RESIDENTIAL_TREATMENT_FACILITY"
      | "PSYCHIATRIC_UNIT"
      | "PSYCHIATRY_NEUROLOGY"
      | "PSYCHOANALYST"
      | "PSYCHOLOGIST"
      | "PUBLIC_HEALTH_OR_WELFARE"
      | "PULMONARY_FUNCTION_TECHNOLOGIST"
      | "RADIOLOGIC_TECHNOLOGIST"
      | "RADIOLOGY"
      | "RADIOLOGY_PRACTITIONER_ASSISTANT"
      | "RECREATION_THERAPIST"
      | "RECREATIONAL_THERAPIST_ASSISTANT"
      | "REFLEXOLOGIST"
      | "REGISTERED_NURSE"
      | "REHABILITATION_COUNSELOR"
      | "REHABILITATION_HOSPITAL"
      | "REHABILITATION_PRACTITIONER"
      | "REHABILITATION_UNIT"
      | "REHABILITATION_SUBSTANCE_USE_DISORDER_UNIT"
      | "RELIGIOUS_NONMEDICAL_HEALTH_CARE_INSTITUTION"
      | "RELIGIOUS_NONMEDICAL_NURSING_PERSONNEL"
      | "RELIGIOUS_NONMEDICAL_PRACTITIONER"
      | "RESIDENTIAL_TREATMENT_FACILITY_EMOTIONALLY_DISTURBED_CHILDREN"
      | "RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
      | "RESIDENTIAL_TREATMENT_FACILITY_PHYSICAL_DISABILITIES"
      | "RESPIRATORY_THERAPIST_CERTIFIED"
      | "RESPIRATORY_THERAPIST_REGISTERED"
      | "RESPITE_CARE"
      | "SECURED_MEDICAL_TRANSPORT_VAN"
      | "SINGLE_SPECIALTY"
      | "SKILLED_NURSING_FACILITY"
      | "SLEEP_SPECIALIST_PHD"
      | "SOCIAL_WORKER"
      | "SPECIAL_HOSPITAL"
      | "SPECIALIST_TECHNOLOGIST"
      | "SPECIALIST_TECHNOLOGIST_CARDIOVASCULAR"
      | "SPECIALIST_TECHNOLOGIST_HEALTH_INFORMATION"
      | "SPECIALIST_TECHNOLOGIST_OTHER"
      | "SPECIALIST_TECHNOLOGIST_PATHOLOGY"
      | "SPEECH_LANGUAGE_PATHOLOGIST"
      | "STUDENT_IN_AN_ORGANIZED_HEALTH_CARE_EDUCATION_TRAINING_PROGRAM"
      | "SUBSTANCE_ABUSE_REHABILITATION_FACILITY"
      | "SUPPORTS_BROKERAGE"
      | "SURGERY"
      | "TAXI"
      | "TECHNICIAN"
      | "TECHNICIAN_CARDIOLOGY"
      | "TECHNICIAN_HEALTH_INFORMATION"
      | "TECHNICIAN_OTHER"
      | "TECHNICIAN_PATHOLOGY"
      | "TECHNICIAN_TECHNOLOGIST"
      | "THORACIC_SURGERY_CARDIOTHORACIC_VASCULAR_SURGERY"
      | "TRAIN"
      | "TRANSPLANT_SURGERY"
      | "TRANSPORTATION_BROKER"
      | "TRANSPORTATION_NETWORK_COMPANY"
      | "UROLOGY"
      | "VETERINARIAN"
      | "VOLUNTARY_OR_CHARITABLE";
    searchString?: string;
    size?: number;
    sort?: string[];
    state?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseProviderDirectoryControllerServiceGetAllProviderDirectoryKeyFn(
        {
          city,
          excludeImaging,
          page,
          referralType,
          searchString,
          size,
          sort,
          state,
        },
        queryKey,
      ),
    queryFn: () =>
      ProviderDirectoryControllerService.getAllProviderDirectory({
        city,
        excludeImaging,
        page,
        referralType,
        searchString,
        size,
        sort,
        state,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.pointOfCareUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePointsOfCareLabControllerServiceGetPointOfCareLabByUuid = <
  TData =
    Common.PointsOfCareLabControllerServiceGetPointOfCareLabByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    pointOfCareUuid,
  }: {
    pointOfCareUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UsePointsOfCareLabControllerServiceGetPointOfCareLabByUuidKeyFn(
        { pointOfCareUuid },
        queryKey,
      ),
    queryFn: () =>
      PointsOfCareLabControllerService.getPointOfCareLabByUuid({
        pointOfCareUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const usePointsOfCareLabControllerServiceGetAllPointOfCareLab = <
  TData =
    Common.PointsOfCareLabControllerServiceGetAllPointOfCareLabDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UsePointsOfCareLabControllerServiceGetAllPointOfCareLabKeyFn(
        { page, pageSize, patientUuid, searchString, sortBy, sortDirection },
        queryKey,
      ),
    queryFn: () =>
      PointsOfCareLabControllerService.getAllPointOfCareLab({
        page,
        pageSize,
        patientUuid,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePocLabTestControllerServiceGetPocLabTestById = <
  TData = Common.PocLabTestControllerServiceGetPocLabTestByIdDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePocLabTestControllerServiceGetPocLabTestByIdKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () =>
      PocLabTestControllerService.getPocLabTestById({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.active
 * @param data.createdBy
 * @param data.startDate
 * @param data.endDate
 * @returns Response OK
 * @throws ApiError
 */
export const usePocLabTestControllerServiceGetAllPocLabTests = <
  TData = Common.PocLabTestControllerServiceGetAllPocLabTestsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    active,
    createdBy,
    endDate,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
    startDate,
  }: {
    active?: boolean;
    createdBy?: string;
    endDate?: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    startDate?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePocLabTestControllerServiceGetAllPocLabTestsKeyFn(
      {
        active,
        createdBy,
        endDate,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
        startDate,
      },
      queryKey,
    ),
    queryFn: () =>
      PocLabTestControllerService.getAllPocLabTests({
        active,
        createdBy,
        endDate,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
        startDate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePocLabResultControllerServiceGetPocLabResultById = <
  TData =
    Common.PocLabResultControllerServiceGetPocLabResultByIdDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePocLabResultControllerServiceGetPocLabResultByIdKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () =>
      PocLabResultControllerService.getPocLabResultById({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.patientUuid
 * @param data.draft
 * @param data.status
 * @returns Response OK
 * @throws ApiError
 */
export const usePocLabResultControllerServiceGetAllPocLabResults = <
  TData =
    Common.PocLabResultControllerServiceGetAllPocLabResultsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    draft,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
    status,
  }: {
    draft?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: boolean;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePocLabResultControllerServiceGetAllPocLabResultsKeyFn(
      { draft, page, pageSize, patientUuid, sortBy, sortDirection, status },
      queryKey,
    ),
    queryFn: () =>
      PocLabResultControllerService.getAllPocLabResults({
        draft,
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
        status,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePhysicalExamTemplateControllerServiceGetPhysicalExamTemplateByUuid =
  <
    TData =
      Common.PhysicalExamTemplateControllerServiceGetPhysicalExamTemplateByUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      uuid,
    }: {
      uuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UsePhysicalExamTemplateControllerServiceGetPhysicalExamTemplateByUuidKeyFn(
          { uuid },
          queryKey,
        ),
      queryFn: () =>
        PhysicalExamTemplateControllerService.getPhysicalExamTemplateByUuid({
          uuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.isPrivate
 * @param data.flag
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const usePhysicalExamTemplateControllerServiceGetAllPhysicalExamTemplates =
  <
    TData =
      Common.PhysicalExamTemplateControllerServiceGetAllPhysicalExamTemplatesDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      flag,
      isPrivate,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
    }: {
      flag?: boolean;
      isPrivate?: boolean;
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
    } = {},
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UsePhysicalExamTemplateControllerServiceGetAllPhysicalExamTemplatesKeyFn(
          {
            flag,
            isPrivate,
            page,
            pageSize,
            searchString,
            sortBy,
            sortDirection,
          },
          queryKey,
        ),
      queryFn: () =>
        PhysicalExamTemplateControllerService.getAllPhysicalExamTemplates({
          flag,
          isPrivate,
          page,
          pageSize,
          searchString,
          sortBy,
          sortDirection,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePhysicalExamControllerServiceGetPhysicalExamByUuid = <
  TData =
    Common.PhysicalExamControllerServiceGetPhysicalExamByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePhysicalExamControllerServiceGetPhysicalExamByUuidKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () =>
      PhysicalExamControllerService.getPhysicalExamByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const usePhysicalExamControllerServiceGetAllPhysicalExams = <
  TData =
    Common.PhysicalExamControllerServiceGetAllPhysicalExamsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePhysicalExamControllerServiceGetAllPhysicalExamsKeyFn(
      { page, pageSize, patientUuid, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      PhysicalExamControllerService.getAllPhysicalExams({
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePharmacyControllerServiceGetPharmacyByUuid = <
  TData = Common.PharmacyControllerServiceGetPharmacyByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePharmacyControllerServiceGetPharmacyByUuidKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () =>
      PharmacyControllerService.getPharmacyByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePharmacyControllerServiceGetAllPharmacies = <
  TData = Common.PharmacyControllerServiceGetAllPharmaciesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePharmacyControllerServiceGetAllPharmaciesKeyFn(
      { page, pageSize, patientUuid, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      PharmacyControllerService.getAllPharmacies({
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientVaccinationControllerServiceGetPatientVaccinationByUuid =
  <
    TData =
      Common.PatientVaccinationControllerServiceGetPatientVaccinationByUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      uuid,
    }: {
      uuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UsePatientVaccinationControllerServiceGetPatientVaccinationByUuidKeyFn(
          { uuid },
          queryKey,
        ),
      queryFn: () =>
        PatientVaccinationControllerService.getPatientVaccinationByUuid({
          uuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientVaccinationControllerServiceGetAllVaccinationsForPdf = <
  TData =
    Common.PatientVaccinationControllerServiceGetAllVaccinationsForPdfDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UsePatientVaccinationControllerServiceGetAllVaccinationsForPdfKeyFn(
        { patientUuid },
        queryKey,
      ),
    queryFn: () =>
      PatientVaccinationControllerService.getAllVaccinationsForPdf({
        patientUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns string OK
 * @throws ApiError
 */
export const usePatientVaccinationControllerServiceExportPatientVaccinations = <
  TData =
    Common.PatientVaccinationControllerServiceExportPatientVaccinationsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UsePatientVaccinationControllerServiceExportPatientVaccinationsKeyFn(
        { patientUuid },
        queryKey,
      ),
    queryFn: () =>
      PatientVaccinationControllerService.exportPatientVaccinations({
        patientUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.isDraft
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientVaccinationControllerServiceGetAllPatientVaccination = <
  TData =
    Common.PatientVaccinationControllerServiceGetAllPatientVaccinationDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    isDraft,
    page,
    pageSize,
    patientUuid,
    searchString,
    sortBy,
    sortDirection,
  }: {
    isDraft?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UsePatientVaccinationControllerServiceGetAllPatientVaccinationKeyFn(
        {
          isDraft,
          page,
          pageSize,
          patientUuid,
          searchString,
          sortBy,
          sortDirection,
        },
        queryKey,
      ),
    queryFn: () =>
      PatientVaccinationControllerService.getAllPatientVaccination({
        isDraft,
        page,
        pageSize,
        patientUuid,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.type
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientVaccinationControllerServiceGetAllPatientVaccinationForVaccineTable =
  <
    TData =
      Common.PatientVaccinationControllerServiceGetAllPatientVaccinationForVaccineTableDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      page,
      pageSize,
      patientUuid,
      sortBy,
      sortDirection,
      type,
    }: {
      page?: number;
      pageSize?: number;
      patientUuid: string;
      sortBy?: string;
      sortDirection?: string;
      type?: "ADULT" | "CHILD";
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UsePatientVaccinationControllerServiceGetAllPatientVaccinationForVaccineTableKeyFn(
          { page, pageSize, patientUuid, sortBy, sortDirection, type },
          queryKey,
        ),
      queryFn: () =>
        PatientVaccinationControllerService.getAllPatientVaccinationForVaccineTable(
          {
            page,
            pageSize,
            patientUuid,
            sortBy,
            sortDirection,
            type,
          },
        ) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientFlagControllerServiceGetPatientFlagByUuid = <
  TData =
    Common.PatientFlagControllerServiceGetPatientFlagByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePatientFlagControllerServiceGetPatientFlagByUuidKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () =>
      PatientFlagControllerService.getPatientFlagByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientFlagControllerServiceGetAllPatientFlags = <
  TData = Common.PatientFlagControllerServiceGetAllPatientFlagsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UsePatientFlagControllerServiceGetAllPatientFlagsKeyFn(
      { page, pageSize, patientUuid, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      PatientFlagControllerService.getAllPatientFlags({
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePastSurgicalHistoryControllerServiceGetPastSurgicalHistoryByUuid =
  <
    TData =
      Common.PastSurgicalHistoryControllerServiceGetPastSurgicalHistoryByUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      uuid,
    }: {
      uuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UsePastSurgicalHistoryControllerServiceGetPastSurgicalHistoryByUuidKeyFn(
          { uuid },
          queryKey,
        ),
      queryFn: () =>
        PastSurgicalHistoryControllerService.getPastSurgicalHistoryByUuid({
          uuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.draft
 * @returns Response OK
 * @throws ApiError
 */
export const usePastSurgicalHistoryControllerServiceGetAllPastSurgicalHistory =
  <
    TData =
      Common.PastSurgicalHistoryControllerServiceGetAllPastSurgicalHistoryDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      draft,
      page,
      pageSize,
      patientUuid,
      sortBy,
      sortDirection,
    }: {
      draft?: boolean;
      page?: number;
      pageSize?: number;
      patientUuid: string;
      sortBy?: string;
      sortDirection?: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UsePastSurgicalHistoryControllerServiceGetAllPastSurgicalHistoryKeyFn(
          { draft, page, pageSize, patientUuid, sortBy, sortDirection },
          queryKey,
        ),
      queryFn: () =>
        PastSurgicalHistoryControllerService.getAllPastSurgicalHistory({
          draft,
          page,
          pageSize,
          patientUuid,
          sortBy,
          sortDirection,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePastMedicalHistoryControllerServiceGetPastMedicalHistoryByUuid =
  <
    TData =
      Common.PastMedicalHistoryControllerServiceGetPastMedicalHistoryByUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      uuid,
    }: {
      uuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UsePastMedicalHistoryControllerServiceGetPastMedicalHistoryByUuidKeyFn(
          { uuid },
          queryKey,
        ),
      queryFn: () =>
        PastMedicalHistoryControllerService.getPastMedicalHistoryByUuid({
          uuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.draft
 * @returns Response OK
 * @throws ApiError
 */
export const usePastMedicalHistoryControllerServiceGetAllPastMedicalHistory = <
  TData =
    Common.PastMedicalHistoryControllerServiceGetAllPastMedicalHistoryDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    draft,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    draft?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UsePastMedicalHistoryControllerServiceGetAllPastMedicalHistoryKeyFn(
        { draft, page, pageSize, patientUuid, sortBy, sortDirection },
        queryKey,
      ),
    queryFn: () =>
      PastMedicalHistoryControllerService.getAllPastMedicalHistory({
        draft,
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.noteByUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNoteControllerServiceGetNoteByUuid = <
  TData = Common.NoteControllerServiceGetNoteByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    noteByUuid,
  }: {
    noteByUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseNoteControllerServiceGetNoteByUuidKeyFn(
      { noteByUuid },
      queryKey,
    ),
    queryFn: () => NoteControllerService.getNoteByUuid({ noteByUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.threadUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNoteControllerServiceGetNoteByThreadUuid = <
  TData = Common.NoteControllerServiceGetNoteByThreadUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    threadUuid,
  }: {
    threadUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseNoteControllerServiceGetNoteByThreadUuidKeyFn(
      { threadUuid },
      queryKey,
    ),
    queryFn: () =>
      NoteControllerService.getNoteByThreadUuid({ threadUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.documentNote
 * @param data.note
 * @param data.createdDate
 * @param data.modifiedDate
 * @param data.createdBy
 * @param data.modifiedBy
 * @param data.isPrivate
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useNoteControllerServiceGetAllNotes = <
  TData = Common.NoteControllerServiceGetAllNotesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    createdBy,
    createdDate,
    documentNote,
    isPrivate,
    modifiedBy,
    modifiedDate,
    note,
    page,
    patientUuid,
    size,
    sort,
  }: {
    createdBy?: string[];
    createdDate?: string;
    documentNote?:
      | "INTERNAL_NOTE"
      | "EXTERNAL_NOTE"
      | "SOAP_NOTE"
      | "HANDP_NOTE"
      | "EMPLOYEE_NOTE"
      | "PHONE_NOTE"
      | "NON_VISIT_NOTE"
      | "EMAIL_NOTE"
      | "LIVE_NOTE";
    isPrivate?: boolean;
    modifiedBy?: string[];
    modifiedDate?: string;
    note?: string;
    page?: number;
    patientUuid: string;
    size?: number;
    sort?: string[];
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseNoteControllerServiceGetAllNotesKeyFn(
      {
        createdBy,
        createdDate,
        documentNote,
        isPrivate,
        modifiedBy,
        modifiedDate,
        note,
        page,
        patientUuid,
        size,
        sort,
      },
      queryKey,
    ),
    queryFn: () =>
      NoteControllerService.getAllNotes({
        createdBy,
        createdDate,
        documentNote,
        isPrivate,
        modifiedBy,
        modifiedDate,
        note,
        page,
        patientUuid,
        size,
        sort,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.flag
 * @param data.patientUuid
 * @param data.employerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNoteControllerServiceGetAllFlagNotes = <
  TData = Common.NoteControllerServiceGetAllFlagNotesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
    flag,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    employerUuid?: string;
    flag?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseNoteControllerServiceGetAllFlagNotesKeyFn(
      {
        employerUuid,
        flag,
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      },
      queryKey,
    ),
    queryFn: () =>
      NoteControllerService.getAllFlagNotes({
        employerUuid,
        flag,
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.medicationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useMedicationControllerServiceGetMedicationByUuid = <
  TData = Common.MedicationControllerServiceGetMedicationByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    medicationUuid,
  }: {
    medicationUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseMedicationControllerServiceGetMedicationByUuidKeyFn(
      { medicationUuid },
      queryKey,
    ),
    queryFn: () =>
      MedicationControllerService.getMedicationByUuid({
        medicationUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.medicationStatus
 * @param data.medicationUuids
 * @returns Response OK
 * @throws ApiError
 */
export const useMedicationControllerServiceGetAllMedicationsForPdf = <
  TData =
    Common.MedicationControllerServiceGetAllMedicationsForPdfDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    medicationStatus,
    medicationUuids,
    patientUuid,
  }: {
    medicationStatus?: "PAST" | "ACTIVE" | "PENDING" | "ONGOING" | "COMPLETED";
    medicationUuids?: string[];
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseMedicationControllerServiceGetAllMedicationsForPdfKeyFn(
      { medicationStatus, medicationUuids, patientUuid },
      queryKey,
    ),
    queryFn: () =>
      MedicationControllerService.getAllMedicationsForPdf({
        medicationStatus,
        medicationUuids,
        patientUuid,
      }) as TData,
    ...options,
  });
/**
 * @returns binary OK
 * @throws ApiError
 */
export const useMedicationControllerServiceDownloadCsvTemplate11 = <
  TData =
    Common.MedicationControllerServiceDownloadCsvTemplate11DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseMedicationControllerServiceDownloadCsvTemplate11KeyFn(queryKey),
    queryFn: () => MedicationControllerService.downloadCsvTemplate11() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.searchString
 * @param data.medicationStatus
 * @param data.draft
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useMedicationControllerServiceGetAllMedications = <
  TData = Common.MedicationControllerServiceGetAllMedicationsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    draft,
    medicationStatus,
    page,
    patientUuid,
    searchString,
    size,
    sort,
  }: {
    draft?: boolean;
    medicationStatus?: "PAST" | "ACTIVE" | "PENDING" | "ONGOING" | "COMPLETED";
    page?: number;
    patientUuid: string;
    searchString?: string;
    size?: number;
    sort?: string[];
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseMedicationControllerServiceGetAllMedicationsKeyFn(
      { draft, medicationStatus, page, patientUuid, searchString, size, sort },
      queryKey,
    ),
    queryFn: () =>
      MedicationControllerService.getAllMedications({
        draft,
        medicationStatus,
        page,
        patientUuid,
        searchString,
        size,
        sort,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.macroUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useMacroControllerServiceGetMacroByUuid = <
  TData = Common.MacroControllerServiceGetMacroByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    macroUuid,
  }: {
    macroUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseMacroControllerServiceGetMacroByUuidKeyFn(
      { macroUuid },
      queryKey,
    ),
    queryFn: () =>
      MacroControllerService.getMacroByUuid({ macroUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.macroText
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useMacroControllerServiceGetMacroByText = <
  TData = Common.MacroControllerServiceGetMacroByTextDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    macroText,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    macroText: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseMacroControllerServiceGetMacroByTextKeyFn(
      { macroText, page, pageSize, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      MacroControllerService.getMacroByText({
        macroText,
        page,
        pageSize,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.isPrivate
 * @param data.flag
 * @returns Response OK
 * @throws ApiError
 */
export const useMacroControllerServiceGetAllMacro = <
  TData = Common.MacroControllerServiceGetAllMacroDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    flag,
    isPrivate,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    flag?: boolean;
    isPrivate?: boolean;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseMacroControllerServiceGetAllMacroKeyFn(
      { flag, isPrivate, page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      MacroControllerService.getAllMacro({
        flag,
        isPrivate,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.locationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLocationControllerServiceGetLocationByUuid = <
  TData = Common.LocationControllerServiceGetLocationByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationUuid,
  }: {
    locationUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLocationControllerServiceGetLocationByUuidKeyFn(
      { locationUuid },
      queryKey,
    ),
    queryFn: () =>
      LocationControllerService.getLocationByUuid({ locationUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.locationGroupUuids
 * @param data.onlineSignUp
 * @param data.state
 * @returns Response OK
 * @throws ApiError
 */
export const useLocationControllerServiceExportLocationsToCsv = <
  TData = Common.LocationControllerServiceExportLocationsToCsvDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationGroupUuids,
    onlineSignUp,
    state,
  }: {
    locationGroupUuids?: string[];
    onlineSignUp?: boolean;
    state?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLocationControllerServiceExportLocationsToCsvKeyFn(
      { locationGroupUuids, onlineSignUp, state },
      queryKey,
    ),
    queryFn: () =>
      LocationControllerService.exportLocationsToCsv({
        locationGroupUuids,
        onlineSignUp,
        state,
      }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useLocationControllerServiceGetAllLocationList = <
  TData = Common.LocationControllerServiceGetAllLocationListDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseLocationControllerServiceGetAllLocationListKeyFn(queryKey),
    queryFn: () => LocationControllerService.getAllLocationList() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.status
 * @param data.providerUuid
 * @param data.adminUserUuid
 * @param data.nurseStaffUuid
 * @param data.onlineSignUp
 * @param data.locationGroupUuids
 * @param data.state
 * @param data.affiliateGroupUuids
 * @param data.isAffiliate
 * @returns Response OK
 * @throws ApiError
 */
export const useLocationControllerServiceGetAllLocation = <
  TData = Common.LocationControllerServiceGetAllLocationDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    adminUserUuid,
    affiliateGroupUuids,
    isAffiliate,
    locationGroupUuids,
    nurseStaffUuid,
    onlineSignUp,
    page,
    pageSize,
    providerUuid,
    searchString,
    sortBy,
    sortDirection,
    state,
    status,
  }: {
    adminUserUuid?: string;
    affiliateGroupUuids?: string[];
    isAffiliate?: boolean;
    locationGroupUuids?: string[];
    nurseStaffUuid?: string;
    onlineSignUp?: boolean;
    page?: number;
    pageSize?: number;
    providerUuid?: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    state?: string;
    status?: boolean;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLocationControllerServiceGetAllLocationKeyFn(
      {
        adminUserUuid,
        affiliateGroupUuids,
        isAffiliate,
        locationGroupUuids,
        nurseStaffUuid,
        onlineSignUp,
        page,
        pageSize,
        providerUuid,
        searchString,
        sortBy,
        sortDirection,
        state,
        status,
      },
      queryKey,
    ),
    queryFn: () =>
      LocationControllerService.getAllLocation({
        adminUserUuid,
        affiliateGroupUuids,
        isAffiliate,
        locationGroupUuids,
        nurseStaffUuid,
        onlineSignUp,
        page,
        pageSize,
        providerUuid,
        searchString,
        sortBy,
        sortDirection,
        state,
        status,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.locationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLocationShareableSettingControllerServiceGetAllSettingsByLocation =
  <
    TData =
      Common.LocationShareableSettingControllerServiceGetAllSettingsByLocationDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      locationUuid,
    }: {
      locationUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseLocationShareableSettingControllerServiceGetAllSettingsByLocationKeyFn(
          { locationUuid },
          queryKey,
        ),
      queryFn: () =>
        LocationShareableSettingControllerService.getAllSettingsByLocation({
          locationUuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.locationGroupUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLocationGroupControllerServiceGetLocationGroupByUuid = <
  TData =
    Common.LocationGroupControllerServiceGetLocationGroupByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationGroupUuid,
  }: {
    locationGroupUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseLocationGroupControllerServiceGetLocationGroupByUuidKeyFn(
        { locationGroupUuid },
        queryKey,
      ),
    queryFn: () =>
      LocationGroupControllerService.getLocationGroupByUuid({
        locationGroupUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.status
 * @returns Response OK
 * @throws ApiError
 */
export const useLocationGroupControllerServiceGetAllLocationGroup = <
  TData =
    Common.LocationGroupControllerServiceGetAllLocationGroupDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
    status,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: boolean;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLocationGroupControllerServiceGetAllLocationGroupKeyFn(
      { page, pageSize, searchString, sortBy, sortDirection, status },
      queryKey,
    ),
    queryFn: () =>
      LocationGroupControllerService.getAllLocationGroup({
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
        status,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLocationAvailabilityControllerServiceGetLocationAvailabilityByUuid =
  <
    TData =
      Common.LocationAvailabilityControllerServiceGetLocationAvailabilityByUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      uuid,
    }: {
      uuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseLocationAvailabilityControllerServiceGetLocationAvailabilityByUuidKeyFn(
          { uuid },
          queryKey,
        ),
      queryFn: () =>
        LocationAvailabilityControllerService.getLocationAvailabilityByUuid({
          uuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useLocationAvailabilityControllerServiceGetAllLocationAvailability =
  <
    TData =
      Common.LocationAvailabilityControllerServiceGetAllLocationAvailabilityDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      page,
      pageSize,
      sortBy,
      sortDirection,
    }: {
      page?: number;
      pageSize?: number;
      sortBy?: string;
      sortDirection?: string;
    } = {},
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseLocationAvailabilityControllerServiceGetAllLocationAvailabilityKeyFn(
          { page, pageSize, sortBy, sortDirection },
          queryKey,
        ),
      queryFn: () =>
        LocationAvailabilityControllerService.getAllLocationAvailability({
          page,
          pageSize,
          sortBy,
          sortDirection,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientLinkPharmacyControllerServiceGetAllPharmaciesForPatient =
  <
    TData =
      Common.PatientLinkPharmacyControllerServiceGetAllPharmaciesForPatientDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      page,
      pageSize,
      patientUuid,
      sortBy,
      sortDirection,
    }: {
      page?: number;
      pageSize?: number;
      patientUuid: string;
      sortBy?: string;
      sortDirection?: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UsePatientLinkPharmacyControllerServiceGetAllPharmaciesForPatientKeyFn(
          { page, pageSize, patientUuid, sortBy, sortDirection },
          queryKey,
        ),
      queryFn: () =>
        PatientLinkPharmacyControllerService.getAllPharmaciesForPatient({
          page,
          pageSize,
          patientUuid,
          sortBy,
          sortDirection,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.labTestUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLabTestControllerServiceGetLabTestByUuid = <
  TData = Common.LabTestControllerServiceGetLabTestByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    labTestUuid,
  }: {
    labTestUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLabTestControllerServiceGetLabTestByUuidKeyFn(
      { labTestUuid },
      queryKey,
    ),
    queryFn: () =>
      LabTestControllerService.getLabTestByUuid({ labTestUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useLabTestControllerServiceGetAllLabTest = <
  TData = Common.LabTestControllerServiceGetAllLabTestDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLabTestControllerServiceGetAllLabTestKeyFn(
      { page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      LabTestControllerService.getAllLabTest({
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.orderUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useLabResultControllerServiceGetAllLabResultsByOrderUuid = <
  TData =
    Common.LabResultControllerServiceGetAllLabResultsByOrderUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    orderUuid,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    orderUuid: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseLabResultControllerServiceGetAllLabResultsByOrderUuidKeyFn(
        { orderUuid, page, pageSize, sortBy, sortDirection },
        queryKey,
      ),
    queryFn: () =>
      LabResultControllerService.getAllLabResultsByOrderUuid({
        orderUuid,
        page,
        pageSize,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.search
 * @param data.status
 * @returns Response OK
 * @throws ApiError
 */
export const useLabResultControllerServiceGetAllLabResultsByPatientUuid = <
  TData =
    Common.LabResultControllerServiceGetAllLabResultsByPatientUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    search,
    sortBy,
    sortDirection,
    status,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: boolean;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseLabResultControllerServiceGetAllLabResultsByPatientUuidKeyFn(
        { page, pageSize, patientUuid, search, sortBy, sortDirection, status },
        queryKey,
      ),
    queryFn: () =>
      LabResultControllerService.getAllLabResultsByPatientUuid({
        page,
        pageSize,
        patientUuid,
        search,
        sortBy,
        sortDirection,
        status,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.status
 * @param data.providerUuids
 * @param data.locationUuids
 * @returns Response OK
 * @throws ApiError
 */
export const useLabResultControllerServiceGetAllLabResults = <
  TData = Common.LabResultControllerServiceGetAllLabResultsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationUuids,
    page,
    pageSize,
    providerUuids,
    sortBy,
    sortDirection,
    status,
  }: {
    locationUuids?: string[];
    page?: number;
    pageSize?: number;
    providerUuids?: string[];
    sortBy?: string;
    sortDirection?: string;
    status?: boolean;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLabResultControllerServiceGetAllLabResultsKeyFn(
      {
        locationUuids,
        page,
        pageSize,
        providerUuids,
        sortBy,
        sortDirection,
        status,
      },
      queryKey,
    ),
    queryFn: () =>
      LabResultControllerService.getAllLabResults({
        locationUuids,
        page,
        pageSize,
        providerUuids,
        sortBy,
        sortDirection,
        status,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.labOrderUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLabOrderControllerServiceGetLabOrderByUuid = <
  TData = Common.LabOrderControllerServiceGetLabOrderByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    labOrderUuid,
  }: {
    labOrderUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLabOrderControllerServiceGetLabOrderByUuidKeyFn(
      { labOrderUuid },
      queryKey,
    ),
    queryFn: () =>
      LabOrderControllerService.getLabOrderByUuid({ labOrderUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.labOrderUuid
 * @returns string OK
 * @throws ApiError
 */
export const useLabOrderControllerServiceGetSpecimenLabel = <
  TData = Common.LabOrderControllerServiceGetSpecimenLabelDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    labOrderUuid,
  }: {
    labOrderUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLabOrderControllerServiceGetSpecimenLabelKeyFn(
      { labOrderUuid },
      queryKey,
    ),
    queryFn: () =>
      LabOrderControllerService.getSpecimenLabel({ labOrderUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.labOrderUuid
 * @param data.limit
 * @returns Response OK
 * @throws ApiError
 */
export const useLabOrderControllerServiceGetLabOrderHistory = <
  TData = Common.LabOrderControllerServiceGetLabOrderHistoryDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    labOrderUuid,
    limit,
  }: {
    labOrderUuid: string;
    limit?: number;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLabOrderControllerServiceGetLabOrderHistoryKeyFn(
      { labOrderUuid, limit },
      queryKey,
    ),
    queryFn: () =>
      LabOrderControllerService.getLabOrderHistory({
        labOrderUuid,
        limit,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.isTrible
 * @param data.searchString
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useLabOrderControllerServiceGetTestCodesWithOrderSets = <
  TData =
    Common.LabOrderControllerServiceGetTestCodesWithOrderSetsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    isTrible,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    isTrible: boolean;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLabOrderControllerServiceGetTestCodesWithOrderSetsKeyFn(
      { isTrible, page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      LabOrderControllerService.getTestCodesWithOrderSets({
        isTrible,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLabOrderControllerServiceGetAllLabOrdersForPdf1 = <
  TData = Common.LabOrderControllerServiceGetAllLabOrdersForPdf1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLabOrderControllerServiceGetAllLabOrdersForPdf1KeyFn(
      { patientUuid },
      queryKey,
    ),
    queryFn: () =>
      LabOrderControllerService.getAllLabOrdersForPdf1({
        patientUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.patientUuid
 * @param data.locationUuids
 * @param data.providerUuids
 * @returns Response OK
 * @throws ApiError
 */
export const useLabOrderControllerServiceGetAllDraftLabAndImagingOrders = <
  TData =
    Common.LabOrderControllerServiceGetAllDraftLabAndImagingOrdersDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationUuids,
    page,
    pageSize,
    patientUuid,
    providerUuids,
    sortBy,
    sortDirection,
  }: {
    locationUuids?: string[];
    page?: number;
    pageSize?: number;
    patientUuid?: string;
    providerUuids?: string[];
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseLabOrderControllerServiceGetAllDraftLabAndImagingOrdersKeyFn(
        {
          locationUuids,
          page,
          pageSize,
          patientUuid,
          providerUuids,
          sortBy,
          sortDirection,
        },
        queryKey,
      ),
    queryFn: () =>
      LabOrderControllerService.getAllDraftLabAndImagingOrders({
        locationUuids,
        page,
        pageSize,
        patientUuid,
        providerUuids,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.patientUuid
 * @param data.archive
 * @param data.draft
 * @returns Response OK
 * @throws ApiError
 */
export const useLabOrderControllerServiceGetAllLabOrder = <
  TData = Common.LabOrderControllerServiceGetAllLabOrderDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    archive,
    draft,
    page,
    pageSize,
    patientUuid,
    searchString,
    sortBy,
    sortDirection,
  }: {
    archive?: boolean;
    draft?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid?: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLabOrderControllerServiceGetAllLabOrderKeyFn(
      {
        archive,
        draft,
        page,
        pageSize,
        patientUuid,
        searchString,
        sortBy,
        sortDirection,
      },
      queryKey,
    ),
    queryFn: () =>
      LabOrderControllerService.getAllLabOrder({
        archive,
        draft,
        page,
        pageSize,
        patientUuid,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.labOrderSetUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLabOrderSetControllerServiceGetLabOrderSetByUuid = <
  TData =
    Common.LabOrderSetControllerServiceGetLabOrderSetByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    labOrderSetUuid,
  }: {
    labOrderSetUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLabOrderSetControllerServiceGetLabOrderSetByUuidKeyFn(
      { labOrderSetUuid },
      queryKey,
    ),
    queryFn: () =>
      LabOrderSetControllerService.getLabOrderSetByUuid({
        labOrderSetUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useLabOrderSetControllerServiceGetAllLabOrderSet = <
  TData = Common.LabOrderSetControllerServiceGetAllLabOrderSetDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLabOrderSetControllerServiceGetAllLabOrderSetKeyFn(
      { page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      LabOrderSetControllerService.getAllLabOrderSet({
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useLabOrderSetControllerServiceGetGlobalLabOrderSet = <
  TData =
    Common.LabOrderSetControllerServiceGetGlobalLabOrderSetDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseLabOrderSetControllerServiceGetGlobalLabOrderSetKeyFn(
      { page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      LabOrderSetControllerService.getGlobalLabOrderSet({
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useInvoiceControllerServiceGetInvoiceByUuid = <
  TData = Common.InvoiceControllerServiceGetInvoiceByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    invoiceUuid,
  }: {
    invoiceUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseInvoiceControllerServiceGetInvoiceByUuidKeyFn(
      { invoiceUuid },
      queryKey,
    ),
    queryFn: () =>
      InvoiceControllerService.getInvoiceByUuid({ invoiceUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useInvoiceControllerServiceGetInvoiceStatement1 = <
  TData = Common.InvoiceControllerServiceGetInvoiceStatement1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    patientUuid,
    size,
    sort,
  }: {
    page?: number;
    patientUuid: string;
    size?: number;
    sort?: string[];
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseInvoiceControllerServiceGetInvoiceStatement1KeyFn(
      { page, patientUuid, size, sort },
      queryKey,
    ),
    queryFn: () =>
      InvoiceControllerService.getInvoiceStatement1({
        page,
        patientUuid,
        size,
        sort,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @param data.employerUuidForBrokerInvoice
 * @param data.userTypes
 * @param data.startDate
 * @param data.endDate
 * @param data.invoiceUuid
 * @param data.invoiceUuids
 * @param data.invoiceChargeType
 * @param data.invoiceStatus
 * @param data.brokerFirmUuids
 * @param data.searchString
 * @returns string OK
 * @throws ApiError
 */
export const useInvoiceControllerServiceExportInvoicesToCsv = <
  TData = Common.InvoiceControllerServiceExportInvoicesToCsvDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    brokerFirmUuids,
    employerUuidForBrokerInvoice,
    endDate,
    invoiceChargeType,
    invoiceStatus,
    invoiceUuid,
    invoiceUuids,
    searchString,
    startDate,
    userTypes,
    userUuid,
  }: {
    brokerFirmUuids?: string[];
    employerUuidForBrokerInvoice?: string;
    endDate?: string;
    invoiceChargeType?:
      | "MEMBERSHIP_CHARGE"
      | "PROCEDURE_CHARGE"
      | "MEDICATION_CHARGE"
      | "LAB_CHARGE"
      | "PANEL_CHARGE"
      | "ANCILLARY_CHARGE"
      | "AFFILIATE_COMMISSION_INVOICE"
      | "ADDITIONAL_SERVICE_INVOICE"
      | "COMMISSION_CHARGE";
    invoiceStatus?: (
      | "PAID"
      | "PARTIALLY_PAID"
      | "UNPAID"
      | "BAD_DEBT"
      | "VOID"
      | "OVERDUE"
      | "DRAFT"
      | "PARTIALLY_REFUNDED"
      | "REFUNDED"
      | "PROCESSING"
      | "ISSUED"
    )[];
    invoiceUuid?: string;
    invoiceUuids?: string[];
    searchString?: string;
    startDate?: string;
    userTypes?:
      | "EMPLOYER"
      | "PATIENT"
      | "BROKER"
      | "ADMIN_USER"
      | "PROVIDER"
      | "EMPLOYER_ADMINISTRATION"
      | "EMPLOYEE"
      | "PHP_USER"
      | "AFFILIATE_FIRM"
      | "BROKER_FIRM"
      | "NURSE_USER";
    userUuid?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseInvoiceControllerServiceExportInvoicesToCsvKeyFn(
      {
        brokerFirmUuids,
        employerUuidForBrokerInvoice,
        endDate,
        invoiceChargeType,
        invoiceStatus,
        invoiceUuid,
        invoiceUuids,
        searchString,
        startDate,
        userTypes,
        userUuid,
      },
      queryKey,
    ),
    queryFn: () =>
      InvoiceControllerService.exportInvoicesToCsv({
        brokerFirmUuids,
        employerUuidForBrokerInvoice,
        endDate,
        invoiceChargeType,
        invoiceStatus,
        invoiceUuid,
        invoiceUuids,
        searchString,
        startDate,
        userTypes,
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userTypes
 * @param data.userUuid
 * @param data.employerUuidForBrokerInvoice
 * @param data.startDate
 * @param data.endDate
 * @param data.invoiceUuid
 * @param data.invoiceChargeType
 * @param data.invoiceStatus
 * @param data.brokerFirmUuids
 * @param data.searchString
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useInvoiceControllerServiceGetAllInvoices = <
  TData = Common.InvoiceControllerServiceGetAllInvoicesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    brokerFirmUuids,
    employerUuidForBrokerInvoice,
    endDate,
    invoiceChargeType,
    invoiceStatus,
    invoiceUuid,
    page,
    searchString,
    size,
    sort,
    startDate,
    userTypes,
    userUuid,
  }: {
    brokerFirmUuids?: string[];
    employerUuidForBrokerInvoice?: string;
    endDate?: string;
    invoiceChargeType?:
      | "MEMBERSHIP_CHARGE"
      | "PROCEDURE_CHARGE"
      | "MEDICATION_CHARGE"
      | "LAB_CHARGE"
      | "PANEL_CHARGE"
      | "ANCILLARY_CHARGE"
      | "AFFILIATE_COMMISSION_INVOICE"
      | "ADDITIONAL_SERVICE_INVOICE"
      | "COMMISSION_CHARGE";
    invoiceStatus?: (
      | "PAID"
      | "PARTIALLY_PAID"
      | "UNPAID"
      | "BAD_DEBT"
      | "VOID"
      | "OVERDUE"
      | "DRAFT"
      | "PARTIALLY_REFUNDED"
      | "REFUNDED"
      | "PROCESSING"
      | "ISSUED"
    )[];
    invoiceUuid?: string;
    page?: number;
    searchString?: string;
    size?: number;
    sort?: string[];
    startDate?: string;
    userTypes:
      | "EMPLOYER"
      | "PATIENT"
      | "BROKER"
      | "ADMIN_USER"
      | "PROVIDER"
      | "EMPLOYER_ADMINISTRATION"
      | "EMPLOYEE"
      | "PHP_USER"
      | "AFFILIATE_FIRM"
      | "BROKER_FIRM"
      | "NURSE_USER";
    userUuid?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseInvoiceControllerServiceGetAllInvoicesKeyFn(
      {
        brokerFirmUuids,
        employerUuidForBrokerInvoice,
        endDate,
        invoiceChargeType,
        invoiceStatus,
        invoiceUuid,
        page,
        searchString,
        size,
        sort,
        startDate,
        userTypes,
        userUuid,
      },
      queryKey,
    ),
    queryFn: () =>
      InvoiceControllerService.getAllInvoices({
        brokerFirmUuids,
        employerUuidForBrokerInvoice,
        endDate,
        invoiceChargeType,
        invoiceStatus,
        invoiceUuid,
        page,
        searchString,
        size,
        sort,
        startDate,
        userTypes,
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useInsuranceControllerServiceGetAllPatientInsuranceWithDependents =
  <
    TData =
      Common.InsuranceControllerServiceGetAllPatientInsuranceWithDependentsDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      patientUuid,
    }: {
      patientUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseInsuranceControllerServiceGetAllPatientInsuranceWithDependentsKeyFn(
          { patientUuid },
          queryKey,
        ),
      queryFn: () =>
        InsuranceControllerService.getAllPatientInsuranceWithDependents({
          patientUuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.insuranceUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useInsuranceControllerServiceGetInsuranceByUuid = <
  TData = Common.InsuranceControllerServiceGetInsuranceByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    insuranceUuid,
  }: {
    insuranceUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseInsuranceControllerServiceGetInsuranceByUuidKeyFn(
      { insuranceUuid },
      queryKey,
    ),
    queryFn: () =>
      InsuranceControllerService.getInsuranceByUuid({ insuranceUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.active
 * @returns Response OK
 * @throws ApiError
 */
export const useInsuranceControllerServiceGetAllPatientInsurance = <
  TData =
    Common.InsuranceControllerServiceGetAllPatientInsuranceDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    active,
    page,
    pageSize,
    patientUuid,
    searchString,
    sortBy,
    sortDirection,
  }: {
    active?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseInsuranceControllerServiceGetAllPatientInsuranceKeyFn(
      {
        active,
        page,
        pageSize,
        patientUuid,
        searchString,
        sortBy,
        sortDirection,
      },
      queryKey,
    ),
    queryFn: () =>
      InsuranceControllerService.getAllPatientInsurance({
        active,
        page,
        pageSize,
        patientUuid,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.imagingResultByUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useImagingResultControllerServiceGetImagingResultByUuid = <
  TData =
    Common.ImagingResultControllerServiceGetImagingResultByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    imagingResultByUuid,
  }: {
    imagingResultByUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseImagingResultControllerServiceGetImagingResultByUuidKeyFn(
        { imagingResultByUuid },
        queryKey,
      ),
    queryFn: () =>
      ImagingResultControllerService.getImagingResultByUuid({
        imagingResultByUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useImagingResultControllerServiceExportCsv1 = <
  TData = Common.ImagingResultControllerServiceExportCsv1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseImagingResultControllerServiceExportCsv1KeyFn(
      { patientUuid },
      queryKey,
    ),
    queryFn: () =>
      ImagingResultControllerService.exportCsv1({ patientUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.searchString
 * @param data.status
 * @param data.providerUuids
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useImagingResultControllerServiceGetAllImagingResults = <
  TData =
    Common.ImagingResultControllerServiceGetAllImagingResultsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    patientUuid,
    providerUuids,
    searchString,
    size,
    sort,
    status,
  }: {
    page?: number;
    patientUuid: string;
    providerUuids?: string[];
    searchString?: string;
    size?: number;
    sort?: string[];
    status?: boolean;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseImagingResultControllerServiceGetAllImagingResultsKeyFn(
      { page, patientUuid, providerUuids, searchString, size, sort, status },
      queryKey,
    ),
    queryFn: () =>
      ImagingResultControllerService.getAllImagingResults({
        page,
        patientUuid,
        providerUuids,
        searchString,
        size,
        sort,
        status,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.imagingOrderByUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useImagingOrderControllerServiceGetImagingOrderByUuid = <
  TData =
    Common.ImagingOrderControllerServiceGetImagingOrderByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    imagingOrderByUuid,
  }: {
    imagingOrderByUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseImagingOrderControllerServiceGetImagingOrderByUuidKeyFn(
      { imagingOrderByUuid },
      queryKey,
    ),
    queryFn: () =>
      ImagingOrderControllerService.getImagingOrderByUuid({
        imagingOrderByUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useImagingOrderControllerServiceGetAllImagingOrder = <
  TData = Common.ImagingOrderControllerServiceGetAllImagingOrderDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    patientUuid,
    size,
    sort,
  }: {
    page?: number;
    patientUuid: string;
    size?: number;
    sort?: string[];
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseImagingOrderControllerServiceGetAllImagingOrderKeyFn(
      { page, patientUuid, size, sort },
      queryKey,
    ),
    queryFn: () =>
      ImagingOrderControllerService.getAllImagingOrder({
        page,
        patientUuid,
        size,
        sort,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useIcdCodeControllerServiceGetIcdCodeByUuid = <
  TData = Common.IcdCodeControllerServiceGetIcdCodeByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseIcdCodeControllerServiceGetIcdCodeByUuidKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () => IcdCodeControllerService.getIcdCodeByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useIcdCodeControllerServiceSearchExternalIcdCodes = <
  TData = Common.IcdCodeControllerServiceSearchExternalIcdCodesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseIcdCodeControllerServiceSearchExternalIcdCodesKeyFn(
      { page, pageSize, searchString },
      queryKey,
    ),
    queryFn: () =>
      IcdCodeControllerService.searchExternalIcdCodes({
        page,
        pageSize,
        searchString,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useIcdCodeControllerServiceGetAllIcdCodes = <
  TData = Common.IcdCodeControllerServiceGetAllIcdCodesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseIcdCodeControllerServiceGetAllIcdCodesKeyFn(
      { page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      IcdCodeControllerService.getAllIcdCodes({
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.userUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useHAndPNoteControllerServiceGetHandPnoteByUuid = <
  TData = Common.HAndPNoteControllerServiceGetHandPnoteByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    userUuid,
    uuid,
  }: {
    userUuid?: string;
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseHAndPNoteControllerServiceGetHandPnoteByUuidKeyFn(
      { userUuid, uuid },
      queryKey,
    ),
    queryFn: () =>
      HAndPNoteControllerService.getHandPnoteByUuid({
        userUuid,
        uuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.startDateTime
 * @param data.endDateTime
 * @param data.patientUuids
 * @param data.providerUuids
 * @param data.locationUuids
 * @param data.appointmentModes
 * @param data.appointmentTypeUuids
 * @returns Response OK
 * @throws ApiError
 */
export const useHAndPNoteControllerServiceGetUnsignedNotesByUser = <
  TData =
    Common.HAndPNoteControllerServiceGetUnsignedNotesByUserDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    appointmentModes,
    appointmentTypeUuids,
    endDateTime,
    locationUuids,
    page,
    pageSize,
    patientUuids,
    providerUuids,
    searchString,
    sortBy,
    sortDirection,
    startDateTime,
    userUuid,
  }: {
    appointmentModes?: ("IN_PERSON" | "VIDEO" | "TELEPHONE")[];
    appointmentTypeUuids?: string[];
    endDateTime?: string;
    locationUuids?: string[];
    page?: number;
    pageSize?: number;
    patientUuids?: string[];
    providerUuids?: string[];
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    startDateTime?: string;
    userUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseHAndPNoteControllerServiceGetUnsignedNotesByUserKeyFn(
      {
        appointmentModes,
        appointmentTypeUuids,
        endDateTime,
        locationUuids,
        page,
        pageSize,
        patientUuids,
        providerUuids,
        searchString,
        sortBy,
        sortDirection,
        startDateTime,
        userUuid,
      },
      queryKey,
    ),
    queryFn: () =>
      HAndPNoteControllerService.getUnsignedNotesByUser({
        appointmentModes,
        appointmentTypeUuids,
        endDateTime,
        locationUuids,
        page,
        pageSize,
        patientUuids,
        providerUuids,
        searchString,
        sortBy,
        sortDirection,
        startDateTime,
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useHAndPNoteControllerServiceGetHandPnotesByPatientUuid = <
  TData =
    Common.HAndPNoteControllerServiceGetHandPnotesByPatientUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseHAndPNoteControllerServiceGetHandPnotesByPatientUuidKeyFn(
        { page, pageSize, patientUuid, sortBy, sortDirection },
        queryKey,
      ),
    queryFn: () =>
      HAndPNoteControllerService.getHandPnotesByPatientUuid({
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.appointmentUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useHAndPNoteControllerServiceGetHandPnoteByAppointmentUuid = <
  TData =
    Common.HAndPNoteControllerServiceGetHandPnoteByAppointmentUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    appointmentUuid,
  }: {
    appointmentUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseHAndPNoteControllerServiceGetHandPnoteByAppointmentUuidKeyFn(
        { appointmentUuid },
        queryKey,
      ),
    queryFn: () =>
      HAndPNoteControllerService.getHandPnoteByAppointmentUuid({
        appointmentUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.patientUuids
 * @param data.providerUuids
 * @param data.locationUuids
 * @param data.appointmentModes
 * @param data.appointmentTypeUuids
 * @param data.signed
 * @returns Response OK
 * @throws ApiError
 */
export const useHAndPNoteControllerServiceGetAllEncountersWithoutDateFilter = <
  TData =
    Common.HAndPNoteControllerServiceGetAllEncountersWithoutDateFilterDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    appointmentModes,
    appointmentTypeUuids,
    locationUuids,
    page,
    pageSize,
    patientUuids,
    providerUuids,
    searchString,
    signed,
    sortBy,
    sortDirection,
  }: {
    appointmentModes?: ("IN_PERSON" | "VIDEO" | "TELEPHONE")[];
    appointmentTypeUuids?: string[];
    locationUuids?: string[];
    page?: number;
    pageSize?: number;
    patientUuids?: string[];
    providerUuids?: string[];
    searchString?: string;
    signed?: boolean;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseHAndPNoteControllerServiceGetAllEncountersWithoutDateFilterKeyFn(
        {
          appointmentModes,
          appointmentTypeUuids,
          locationUuids,
          page,
          pageSize,
          patientUuids,
          providerUuids,
          searchString,
          signed,
          sortBy,
          sortDirection,
        },
        queryKey,
      ),
    queryFn: () =>
      HAndPNoteControllerService.getAllEncountersWithoutDateFilter({
        appointmentModes,
        appointmentTypeUuids,
        locationUuids,
        page,
        pageSize,
        patientUuids,
        providerUuids,
        searchString,
        signed,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.isDraft
 * @returns Response OK
 * @throws ApiError
 */
export const useHAndPNoteControllerServiceGetAllHandPnotes = <
  TData = Common.HAndPNoteControllerServiceGetAllHandPnotesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    isDraft,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    isDraft?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseHAndPNoteControllerServiceGetAllHandPnotesKeyFn(
      { isDraft, page, pageSize, patientUuid, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      HAndPNoteControllerService.getAllHandPnotes({
        isDraft,
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.startDateTime
 * @param data.endDateTime
 * @param data.patientUuids
 * @param data.providerUuids
 * @param data.locationUuids
 * @param data.appointmentModes
 * @param data.appointmentTypeUuids
 * @param data.signed
 * @returns Response OK
 * @throws ApiError
 */
export const useHAndPNoteControllerServiceGetAllEncounter = <
  TData = Common.HAndPNoteControllerServiceGetAllEncounterDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    appointmentModes,
    appointmentTypeUuids,
    endDateTime,
    locationUuids,
    page,
    pageSize,
    patientUuids,
    providerUuids,
    searchString,
    signed,
    sortBy,
    sortDirection,
    startDateTime,
  }: {
    appointmentModes?: ("IN_PERSON" | "VIDEO" | "TELEPHONE")[];
    appointmentTypeUuids?: string[];
    endDateTime?: string;
    locationUuids?: string[];
    page?: number;
    pageSize?: number;
    patientUuids?: string[];
    providerUuids?: string[];
    searchString?: string;
    signed?: boolean;
    sortBy?: string;
    sortDirection?: string;
    startDateTime?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseHAndPNoteControllerServiceGetAllEncounterKeyFn(
      {
        appointmentModes,
        appointmentTypeUuids,
        endDateTime,
        locationUuids,
        page,
        pageSize,
        patientUuids,
        providerUuids,
        searchString,
        signed,
        sortBy,
        sortDirection,
        startDateTime,
      },
      queryKey,
    ),
    queryFn: () =>
      HAndPNoteControllerService.getAllEncounter({
        appointmentModes,
        appointmentTypeUuids,
        endDateTime,
        locationUuids,
        page,
        pageSize,
        patientUuids,
        providerUuids,
        searchString,
        signed,
        sortBy,
        sortDirection,
        startDateTime,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useHabitsControllerServiceGetHabitsByUuid = <
  TData = Common.HabitsControllerServiceGetHabitsByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseHabitsControllerServiceGetHabitsByUuidKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () => HabitsControllerService.getHabitsByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useHabitsControllerServiceGetAllHabits = <
  TData = Common.HabitsControllerServiceGetAllHabitsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseHabitsControllerServiceGetAllHabitsKeyFn(
      { page, pageSize, patientUuid, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      HabitsControllerService.getAllHabits({
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useGlobalHolidayControllerServiceGetGlobalHolidayByUuid = <
  TData =
    Common.GlobalHolidayControllerServiceGetGlobalHolidayByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseGlobalHolidayControllerServiceGetGlobalHolidayByUuidKeyFn(
        { uuid },
        queryKey,
      ),
    queryFn: () =>
      GlobalHolidayControllerService.getGlobalHolidayByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.locationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useGlobalHolidayControllerServiceGetHolidaysForLocation = <
  TData =
    Common.GlobalHolidayControllerServiceGetHolidaysForLocationDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationUuid,
  }: {
    locationUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseGlobalHolidayControllerServiceGetHolidaysForLocationKeyFn(
        { locationUuid },
        queryKey,
      ),
    queryFn: () =>
      GlobalHolidayControllerService.getHolidaysForLocation({
        locationUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.year
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useGlobalHolidayControllerServiceGetAllGlobalHolidays = <
  TData =
    Common.GlobalHolidayControllerServiceGetAllGlobalHolidaysDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
    year,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    year?: number;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGlobalHolidayControllerServiceGetAllGlobalHolidaysKeyFn(
      { page, pageSize, searchString, sortBy, sortDirection, year },
      queryKey,
    ),
    queryFn: () =>
      GlobalHolidayControllerService.getAllGlobalHolidays({
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
        year,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.formTemplateUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useFormTemplateControllerServiceGetFormTemplateByUuid = <
  TData =
    Common.FormTemplateControllerServiceGetFormTemplateByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    formTemplateUuid,
  }: {
    formTemplateUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseFormTemplateControllerServiceGetFormTemplateByUuidKeyFn(
      { formTemplateUuid },
      queryKey,
    ),
    queryFn: () =>
      FormTemplateControllerService.getFormTemplateByUuid({
        formTemplateUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.searchString
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.startDate
 * @param data.endDate
 * @param data.formBuilderType
 * @param data.createdBy
 * @returns Response OK
 * @throws ApiError
 */
export const useFormTemplateControllerServiceGetAllFormTemplates = <
  TData =
    Common.FormTemplateControllerServiceGetAllFormTemplatesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    createdBy,
    endDate,
    formBuilderType,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
    startDate,
  }: {
    createdBy?: string[];
    endDate?: string;
    formBuilderType?: (
      | "MEMBERSHIP"
      | "INTAKE"
      | "APPOINTMENTS"
      | "AGREEMENTS"
      | "AFFILIATE_AGREEMENTS"
      | "PATIENT_AGREEMENT"
      | "AGENT_FIRM_AGREEMENTS"
      | "CONSENT"
      | "SEND_SMS"
    )[];
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    startDate?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseFormTemplateControllerServiceGetAllFormTemplatesKeyFn(
      {
        createdBy,
        endDate,
        formBuilderType,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
        startDate,
      },
      queryKey,
    ),
    queryFn: () =>
      FormTemplateControllerService.getAllFormTemplates({
        createdBy,
        endDate,
        formBuilderType,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
        startDate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.formTemplateUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useFormTemplateControllerServiceGetFormJson = <
  TData = Common.FormTemplateControllerServiceGetFormJsonDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    formTemplateUuid,
  }: {
    formTemplateUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseFormTemplateControllerServiceGetFormJsonKeyFn(
      { formTemplateUuid },
      queryKey,
    ),
    queryFn: () =>
      FormTemplateControllerService.getFormJson({ formTemplateUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.formTemplateUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useFormTemplateControllerServiceCheckIfFormDefaultExists = <
  TData =
    Common.FormTemplateControllerServiceCheckIfFormDefaultExistsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    formTemplateUuid,
  }: {
    formTemplateUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseFormTemplateControllerServiceCheckIfFormDefaultExistsKeyFn(
        { formTemplateUuid },
        queryKey,
      ),
    queryFn: () =>
      FormTemplateControllerService.checkIfFormDefaultExists({
        formTemplateUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.formBuilderType
 * @returns Response OK
 * @throws ApiError
 */
export const useFormTemplateControllerServiceGetFormTemplateContentByType = <
  TData =
    Common.FormTemplateControllerServiceGetFormTemplateContentByTypeDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    formBuilderType,
  }: {
    formBuilderType:
      | "MEMBERSHIP"
      | "INTAKE"
      | "APPOINTMENTS"
      | "AGREEMENTS"
      | "AFFILIATE_AGREEMENTS"
      | "PATIENT_AGREEMENT"
      | "AGENT_FIRM_AGREEMENTS"
      | "CONSENT"
      | "SEND_SMS";
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseFormTemplateControllerServiceGetFormTemplateContentByTypeKeyFn(
        { formBuilderType },
        queryKey,
      ),
    queryFn: () =>
      FormTemplateControllerService.getFormTemplateContentByType({
        formBuilderType,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useFdbMedicationsControllerServiceGetFdbMedicationByUuid = <
  TData =
    Common.FdbMedicationsControllerServiceGetFdbMedicationByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseFdbMedicationsControllerServiceGetFdbMedicationByUuidKeyFn(
        { uuid },
        queryKey,
      ),
    queryFn: () =>
      FdbMedicationsControllerService.getFdbMedicationByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.search
 * @returns Response OK
 * @throws ApiError
 */
export const useFdbMedicationsControllerServiceGetAllFdbMedications = <
  TData =
    Common.FdbMedicationsControllerServiceGetAllFdbMedicationsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    search,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseFdbMedicationsControllerServiceGetAllFdbMedicationsKeyFn(
        { page, pageSize, search, sortBy, sortDirection },
        queryKey,
      ),
    queryFn: () =>
      FdbMedicationsControllerService.getAllFdbMedications({
        page,
        pageSize,
        search,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useFamilyHistoryControllerServiceGetFamilyHistoryByUuid = <
  TData =
    Common.FamilyHistoryControllerServiceGetFamilyHistoryByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseFamilyHistoryControllerServiceGetFamilyHistoryByUuidKeyFn(
        { uuid },
        queryKey,
      ),
    queryFn: () =>
      FamilyHistoryControllerService.getFamilyHistoryByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.draft
 * @returns Response OK
 * @throws ApiError
 */
export const useFamilyHistoryControllerServiceGetAllFamilyHistory = <
  TData =
    Common.FamilyHistoryControllerServiceGetAllFamilyHistoryDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    draft,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    draft?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseFamilyHistoryControllerServiceGetAllFamilyHistoryKeyFn(
      { draft, page, pageSize, patientUuid, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      FamilyHistoryControllerService.getAllFamilyHistory({
        draft,
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.educationalMaterialUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEducationalMaterialControllerServiceGetEducationalMaterialByUuid =
  <
    TData =
      Common.EducationalMaterialControllerServiceGetEducationalMaterialByUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      educationalMaterialUuid,
    }: {
      educationalMaterialUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseEducationalMaterialControllerServiceGetEducationalMaterialByUuidKeyFn(
          { educationalMaterialUuid },
          queryKey,
        ),
      queryFn: () =>
        EducationalMaterialControllerService.getEducationalMaterialByUuid({
          educationalMaterialUuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.startDate
 * @param data.endDate
 * @param data.fileTypes
 * @param data.patientUuid
 * @param data.createdByList
 * @param data.isGlobal
 * @param data.includeAssignments
 * @returns Response OK
 * @throws ApiError
 */
export const useEducationalMaterialControllerServiceGetAllEducationalMaterials =
  <
    TData =
      Common.EducationalMaterialControllerServiceGetAllEducationalMaterialsDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      createdByList,
      endDate,
      fileTypes,
      includeAssignments,
      isGlobal,
      page,
      pageSize,
      patientUuid,
      searchString,
      sortBy,
      sortDirection,
      startDate,
    }: {
      createdByList?: string[];
      endDate?: string;
      fileTypes?: string;
      includeAssignments?: boolean;
      isGlobal?: boolean;
      page?: number;
      pageSize?: number;
      patientUuid?: string;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
      startDate?: string;
    } = {},
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseEducationalMaterialControllerServiceGetAllEducationalMaterialsKeyFn(
          {
            createdByList,
            endDate,
            fileTypes,
            includeAssignments,
            isGlobal,
            page,
            pageSize,
            patientUuid,
            searchString,
            sortBy,
            sortDirection,
            startDate,
          },
          queryKey,
        ),
      queryFn: () =>
        EducationalMaterialControllerService.getAllEducationalMaterials({
          createdByList,
          endDate,
          fileTypes,
          includeAssignments,
          isGlobal,
          page,
          pageSize,
          patientUuid,
          searchString,
          sortBy,
          sortDirection,
          startDate,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.drugIntoleranceUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useDrugIntoleranceControllerServiceGetDrugIntoleranceByUuid = <
  TData =
    Common.DrugIntoleranceControllerServiceGetDrugIntoleranceByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    drugIntoleranceUuid,
  }: {
    drugIntoleranceUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseDrugIntoleranceControllerServiceGetDrugIntoleranceByUuidKeyFn(
        { drugIntoleranceUuid },
        queryKey,
      ),
    queryFn: () =>
      DrugIntoleranceControllerService.getDrugIntoleranceByUuid({
        drugIntoleranceUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useDrugIntoleranceControllerServiceGetAllDrugIntolerancesForPdf = <
  TData =
    Common.DrugIntoleranceControllerServiceGetAllDrugIntolerancesForPdfDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseDrugIntoleranceControllerServiceGetAllDrugIntolerancesForPdfKeyFn(
        { patientUuid },
        queryKey,
      ),
    queryFn: () =>
      DrugIntoleranceControllerService.getAllDrugIntolerancesForPdf({
        patientUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useDrugIntoleranceControllerServiceGetAllDrugIntolerances = <
  TData =
    Common.DrugIntoleranceControllerServiceGetAllDrugIntolerancesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseDrugIntoleranceControllerServiceGetAllDrugIntolerancesKeyFn(
        { page, pageSize, patientUuid, sortBy, sortDirection },
        queryKey,
      ),
    queryFn: () =>
      DrugIntoleranceControllerService.getAllDrugIntolerances({
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.documentTypeUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useDocumentTypeControllerServiceGetDocumentTypeByUuid = <
  TData =
    Common.DocumentTypeControllerServiceGetDocumentTypeByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    documentTypeUuid,
  }: {
    documentTypeUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseDocumentTypeControllerServiceGetDocumentTypeByUuidKeyFn(
      { documentTypeUuid },
      queryKey,
    ),
    queryFn: () =>
      DocumentTypeControllerService.getDocumentTypeByUuid({
        documentTypeUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.documentType
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useDocumentTypeControllerServiceGetAllDocumentTypes = <
  TData =
    Common.DocumentTypeControllerServiceGetAllDocumentTypesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    documentType,
    page,
    size,
    sort,
  }: {
    documentType?: string;
    page?: number;
    size?: number;
    sort?: string[];
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseDocumentTypeControllerServiceGetAllDocumentTypesKeyFn(
      { documentType, page, size, sort },
      queryKey,
    ),
    queryFn: () =>
      DocumentTypeControllerService.getAllDocumentTypes({
        documentType,
        page,
        size,
        sort,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useDiagnosisControllerServiceGetDiagnosisByUuid = <
  TData = Common.DiagnosisControllerServiceGetDiagnosisByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseDiagnosisControllerServiceGetDiagnosisByUuidKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () =>
      DiagnosisControllerService.getDiagnosisByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.status
 * @returns Response OK
 * @throws ApiError
 */
export const useDiagnosisControllerServiceGetAllDiagnosisForPdf = <
  TData = Common.DiagnosisControllerServiceGetAllDiagnosisForPdfDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
    status,
  }: {
    patientUuid: string;
    status?: "ACTIVE" | "HISTORICAL" | "RESOLVED";
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseDiagnosisControllerServiceGetAllDiagnosisForPdfKeyFn(
      { patientUuid, status },
      queryKey,
    ),
    queryFn: () =>
      DiagnosisControllerService.getAllDiagnosisForPdf({
        patientUuid,
        status,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.type
 * @param data.status
 * @returns Response OK
 * @throws ApiError
 */
export const useDiagnosisControllerServiceGetAllDiagnoses = <
  TData = Common.DiagnosisControllerServiceGetAllDiagnosesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    patientUuid,
    searchString,
    sortBy,
    sortDirection,
    status,
    type,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: "ACTIVE" | "HISTORICAL" | "RESOLVED";
    type?: "ACUTE" | "CHRONIC";
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseDiagnosisControllerServiceGetAllDiagnosesKeyFn(
      {
        page,
        pageSize,
        patientUuid,
        searchString,
        sortBy,
        sortDirection,
        status,
        type,
      },
      queryKey,
    ),
    queryFn: () =>
      DiagnosisControllerService.getAllDiagnoses({
        page,
        pageSize,
        patientUuid,
        searchString,
        sortBy,
        sortDirection,
        status,
        type,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.cptCodeUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCptCodeControllerServiceGetIcdCodeByUuid1 = <
  TData = Common.CptCodeControllerServiceGetIcdCodeByUuid1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    cptCodeUuid,
  }: {
    cptCodeUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCptCodeControllerServiceGetIcdCodeByUuid1KeyFn(
      { cptCodeUuid },
      queryKey,
    ),
    queryFn: () =>
      CptCodeControllerService.getIcdCodeByUuid1({ cptCodeUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useCptCodeControllerServiceGetAllIcdCodes1 = <
  TData = Common.CptCodeControllerServiceGetAllIcdCodes1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCptCodeControllerServiceGetAllIcdCodes1KeyFn(
      { page, pageSize, searchString },
      queryKey,
    ),
    queryFn: () =>
      CptCodeControllerService.getAllIcdCodes1({
        page,
        pageSize,
        searchString,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCommentControllerServiceGetMessageByUuid = <
  TData = Common.CommentControllerServiceGetMessageByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCommentControllerServiceGetMessageByUuidKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () => CommentControllerService.getMessageByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.taskUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCommentControllerServiceGetAssignableUsersForTask = <
  TData =
    Common.CommentControllerServiceGetAssignableUsersForTaskDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    taskUuid,
  }: {
    taskUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCommentControllerServiceGetAssignableUsersForTaskKeyFn(
      { taskUuid },
      queryKey,
    ),
    queryFn: () =>
      CommentControllerService.getAssignableUsersForTask({ taskUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.taskUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCommentControllerServiceGetAllMessages = <
  TData = Common.CommentControllerServiceGetAllMessagesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    sortBy,
    sortDirection,
    taskUuid,
  }: {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
    taskUuid?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCommentControllerServiceGetAllMessagesKeyFn(
      { page, pageSize, sortBy, sortDirection, taskUuid },
      queryKey,
    ),
    queryFn: () =>
      CommentControllerService.getAllMessages({
        page,
        pageSize,
        sortBy,
        sortDirection,
        taskUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.carePlanUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCarePlanControllerServiceGetCarePlanByUuid = <
  TData = Common.CarePlanControllerServiceGetCarePlanByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    carePlanUuid,
  }: {
    carePlanUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCarePlanControllerServiceGetCarePlanByUuidKeyFn(
      { carePlanUuid },
      queryKey,
    ),
    queryFn: () =>
      CarePlanControllerService.getCarePlanByUuid({ carePlanUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.page
 * @param data.size
 * @returns Response OK
 * @throws ApiError
 */
export const useCarePlanControllerServiceGetCarePlans = <
  TData = Common.CarePlanControllerServiceGetCarePlansDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    size,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    size?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCarePlanControllerServiceGetCarePlansKeyFn(
      { page, size, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      CarePlanControllerService.getCarePlans({
        page,
        size,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.name
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.page
 * @param data.size
 * @returns Response OK
 * @throws ApiError
 */
export const useCarePlanControllerServiceGetAllCarePlans = <
  TData = Common.CarePlanControllerServiceGetAllCarePlansDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    name,
    page,
    size,
    sortBy,
    sortDirection,
  }: {
    name?: string;
    page?: number;
    size?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCarePlanControllerServiceGetAllCarePlansKeyFn(
      { name, page, size, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      CarePlanControllerService.getAllCarePlans({
        name,
        page,
        size,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.providerUuid
 * @param data.locationUuid
 * @param data.blockDate
 * @returns Response OK
 * @throws ApiError
 */
export const useAvailabilityControllerServiceGetBlockDaysForProviders = <
  TData =
    Common.AvailabilityControllerServiceGetBlockDaysForProvidersDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    blockDate,
    locationUuid,
    providerUuid,
  }: {
    blockDate?: string;
    locationUuid?: string;
    providerUuid?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAvailabilityControllerServiceGetBlockDaysForProvidersKeyFn(
        { blockDate, locationUuid, providerUuid },
        queryKey,
      ),
    queryFn: () =>
      AvailabilityControllerService.getBlockDaysForProviders({
        blockDate,
        locationUuid,
        providerUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.providerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAvailabilityControllerServiceGetAvailabilityByProviderUuid = <
  TData =
    Common.AvailabilityControllerServiceGetAvailabilityByProviderUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    providerUuid,
  }: {
    providerUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAvailabilityControllerServiceGetAvailabilityByProviderUuidKeyFn(
        { providerUuid },
        queryKey,
      ),
    queryFn: () =>
      AvailabilityControllerService.getAvailabilityByProviderUuid({
        providerUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.startDateTime
 * @param data.endDateTime
 * @param data.providerUuid
 * @param data.locationUuid
 * @param data.duration
 * @param data.coBook
 * @param data.dayOfWeek
 * @param data.appointmentMode
 * @returns Response OK
 * @throws ApiError
 */
export const useAvailabilityControllerServiceGetAvailabilitySlots = <
  TData =
    Common.AvailabilityControllerServiceGetAvailabilitySlotsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    appointmentMode,
    coBook,
    dayOfWeek,
    duration,
    endDateTime,
    locationUuid,
    providerUuid,
    startDateTime,
  }: {
    appointmentMode?: "IN_PERSON" | "VIDEO" | "TELEPHONE";
    coBook?: boolean;
    dayOfWeek?:
      | "MONDAY"
      | "TUESDAY"
      | "WEDNESDAY"
      | "THURSDAY"
      | "FRIDAY"
      | "SATURDAY"
      | "SUNDAY";
    duration?: number;
    endDateTime: string;
    locationUuid?: string;
    providerUuid?: string;
    startDateTime: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAvailabilityControllerServiceGetAvailabilitySlotsKeyFn(
      {
        appointmentMode,
        coBook,
        dayOfWeek,
        duration,
        endDateTime,
        locationUuid,
        providerUuid,
        startDateTime,
      },
      queryKey,
    ),
    queryFn: () =>
      AvailabilityControllerService.getAvailabilitySlots({
        appointmentMode,
        coBook,
        dayOfWeek,
        duration,
        endDateTime,
        locationUuid,
        providerUuid,
        startDateTime,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.startDateTime
 * @param data.endDateTime
 * @param data.providerUuid
 * @param data.locationUuid
 * @param data.blockDayUuid
 * @param data.recurringBlockDayUuid
 * @param data.appointmentMode
 * @returns Response OK
 * @throws ApiError
 */
export const useAvailabilityControllerServiceGetAvailabilitySlotForCalendar = <
  TData =
    Common.AvailabilityControllerServiceGetAvailabilitySlotForCalendarDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    appointmentMode,
    blockDayUuid,
    endDateTime,
    locationUuid,
    providerUuid,
    recurringBlockDayUuid,
    startDateTime,
  }: {
    appointmentMode?: "IN_PERSON" | "VIDEO" | "TELEPHONE";
    blockDayUuid?: string;
    endDateTime?: string;
    locationUuid?: string;
    providerUuid?: string;
    recurringBlockDayUuid?: string;
    startDateTime?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAvailabilityControllerServiceGetAvailabilitySlotForCalendarKeyFn(
        {
          appointmentMode,
          blockDayUuid,
          endDateTime,
          locationUuid,
          providerUuid,
          recurringBlockDayUuid,
          startDateTime,
        },
        queryKey,
      ),
    queryFn: () =>
      AvailabilityControllerService.getAvailabilitySlotForCalendar({
        appointmentMode,
        blockDayUuid,
        endDateTime,
        locationUuid,
        providerUuid,
        recurringBlockDayUuid,
        startDateTime,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useAvailabilityControllerServiceGetAllAvailability = <
  TData = Common.AvailabilityControllerServiceGetAllAvailabilityDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAvailabilityControllerServiceGetAllAvailabilityKeyFn(
      { page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      AvailabilityControllerService.getAllAvailability({
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.appointmentUuid
 * @param data.occurrenceDate
 * @returns Response OK
 * @throws ApiError
 */
export const useAppointmentControllerServiceGetAppointmentByUuid = <
  TData =
    Common.AppointmentControllerServiceGetAppointmentByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    appointmentUuid,
    occurrenceDate,
  }: {
    appointmentUuid: string;
    occurrenceDate?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAppointmentControllerServiceGetAppointmentByUuidKeyFn(
      { appointmentUuid, occurrenceDate },
      queryKey,
    ),
    queryFn: () =>
      AppointmentControllerService.getAppointmentByUuid({
        appointmentUuid,
        occurrenceDate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.visitType
 * @param data.patientUuid
 * @param data.confidential
 * @returns Response OK
 * @throws ApiError
 */
export const useAppointmentControllerServiceGetAppointmentVisitDetails = <
  TData =
    Common.AppointmentControllerServiceGetAppointmentVisitDetailsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    confidential,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
    visitType,
  }: {
    confidential?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid?: string;
    sortBy?: string;
    sortDirection?: string;
    visitType?: "PAST" | "UPCOMING";
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAppointmentControllerServiceGetAppointmentVisitDetailsKeyFn(
        {
          confidential,
          page,
          pageSize,
          patientUuid,
          sortBy,
          sortDirection,
          visitType,
        },
        queryKey,
      ),
    queryFn: () =>
      AppointmentControllerService.getAppointmentVisitDetails({
        confidential,
        page,
        pageSize,
        patientUuid,
        sortBy,
        sortDirection,
        visitType,
      }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useAppointmentControllerServiceGetVideoConsentForm = <
  TData = Common.AppointmentControllerServiceGetVideoConsentFormDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAppointmentControllerServiceGetVideoConsentFormKeyFn(queryKey),
    queryFn: () => AppointmentControllerService.getVideoConsentForm() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAppointmentControllerServiceGetAppointmentForDashBoard = <
  TData =
    Common.AppointmentControllerServiceGetAppointmentForDashBoardDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAppointmentControllerServiceGetAppointmentForDashBoardKeyFn(
        { patientUuid },
        queryKey,
      ),
    queryFn: () =>
      AppointmentControllerService.getAppointmentForDashBoard({
        patientUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.token
 * @returns string OK
 * @throws ApiError
 */
export const useAppointmentControllerServiceGetProviderCalendarIcs = <
  TData =
    Common.AppointmentControllerServiceGetProviderCalendarIcsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    token,
  }: {
    token: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAppointmentControllerServiceGetProviderCalendarIcsKeyFn(
      { token },
      queryKey,
    ),
    queryFn: () =>
      AppointmentControllerService.getProviderCalendarIcs({ token }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.startDateTime
 * @param data.endDateTime
 * @param data.patientUuids
 * @param data.providerUuids
 * @param data.locationUuids
 * @param data.appointmentModes
 * @param data.appointmentTypeUuids
 * @param data.statusConfigurationUuids
 * @param data.calendar
 * @returns Response OK
 * @throws ApiError
 */
export const useAppointmentControllerServiceGetAllAppointments = <
  TData = Common.AppointmentControllerServiceGetAllAppointmentsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    appointmentModes,
    appointmentTypeUuids,
    calendar,
    endDateTime,
    locationUuids,
    page,
    pageSize,
    patientUuids,
    providerUuids,
    searchString,
    sortBy,
    sortDirection,
    startDateTime,
    statusConfigurationUuids,
  }: {
    appointmentModes?: ("IN_PERSON" | "VIDEO" | "TELEPHONE")[];
    appointmentTypeUuids?: string[];
    calendar?: boolean;
    endDateTime?: string;
    locationUuids?: string[];
    page?: number;
    pageSize?: number;
    patientUuids?: string[];
    providerUuids?: string[];
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    startDateTime?: string;
    statusConfigurationUuids?: string[];
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAppointmentControllerServiceGetAllAppointmentsKeyFn(
      {
        appointmentModes,
        appointmentTypeUuids,
        calendar,
        endDateTime,
        locationUuids,
        page,
        pageSize,
        patientUuids,
        providerUuids,
        searchString,
        sortBy,
        sortDirection,
        startDateTime,
        statusConfigurationUuids,
      },
      queryKey,
    ),
    queryFn: () =>
      AppointmentControllerService.getAllAppointments({
        appointmentModes,
        appointmentTypeUuids,
        calendar,
        endDateTime,
        locationUuids,
        page,
        pageSize,
        patientUuids,
        providerUuids,
        searchString,
        sortBy,
        sortDirection,
        startDateTime,
        statusConfigurationUuids,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.appointmentTypeUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAppointmentTypeControllerServiceGetAppointmentTypeByUuid = <
  TData =
    Common.AppointmentTypeControllerServiceGetAppointmentTypeByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    appointmentTypeUuid,
  }: {
    appointmentTypeUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAppointmentTypeControllerServiceGetAppointmentTypeByUuidKeyFn(
        { appointmentTypeUuid },
        queryKey,
      ),
    queryFn: () =>
      AppointmentTypeControllerService.getAppointmentTypeByUuid({
        appointmentTypeUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.appointmentMode
 * @returns Response OK
 * @throws ApiError
 */
export const useAppointmentTypeControllerServiceGetAllAppointmentType = <
  TData =
    Common.AppointmentTypeControllerServiceGetAllAppointmentTypeDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    appointmentMode,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    appointmentMode?: "IN_PERSON" | "VIDEO" | "TELEPHONE";
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAppointmentTypeControllerServiceGetAllAppointmentTypeKeyFn(
        { appointmentMode, page, pageSize, sortBy, sortDirection },
        queryKey,
      ),
    queryFn: () =>
      AppointmentTypeControllerService.getAllAppointmentType({
        appointmentMode,
        page,
        pageSize,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAnnotableImageControllerServiceGetAnnotableImage = <
  TData =
    Common.AnnotableImageControllerServiceGetAnnotableImageDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAnnotableImageControllerServiceGetAnnotableImageKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () =>
      AnnotableImageControllerService.getAnnotableImage({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.size
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useAnnotableImageControllerServiceGetAllAnnotableImages = <
  TData =
    Common.AnnotableImageControllerServiceGetAllAnnotableImagesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    patientUuid,
    size,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    patientUuid: string;
    size?: number;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAnnotableImageControllerServiceGetAllAnnotableImagesKeyFn(
        { page, patientUuid, size, sortBy, sortDirection },
        queryKey,
      ),
    queryFn: () =>
      AnnotableImageControllerService.getAllAnnotableImages({
        page,
        patientUuid,
        size,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.anotableImageTemplateUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAnnotableImageTemplateControllerServiceGetAnnotableImageTemplateByUuid =
  <
    TData =
      Common.AnnotableImageTemplateControllerServiceGetAnnotableImageTemplateByUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      anotableImageTemplateUuid,
    }: {
      anotableImageTemplateUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseAnnotableImageTemplateControllerServiceGetAnnotableImageTemplateByUuidKeyFn(
          { anotableImageTemplateUuid },
          queryKey,
        ),
      queryFn: () =>
        AnnotableImageTemplateControllerService.getAnnotableImageTemplateByUuid(
          {
            anotableImageTemplateUuid,
          },
        ) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.isPrivate
 * @param data.flag
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useAnnotableImageTemplateControllerServiceGetAllAnnotableImageTemplate =
  <
    TData =
      Common.AnnotableImageTemplateControllerServiceGetAllAnnotableImageTemplateDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      flag,
      isPrivate,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
    }: {
      flag?: boolean;
      isPrivate?: boolean;
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
    } = {},
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseAnnotableImageTemplateControllerServiceGetAllAnnotableImageTemplateKeyFn(
          {
            flag,
            isPrivate,
            page,
            pageSize,
            searchString,
            sortBy,
            sortDirection,
          },
          queryKey,
        ),
      queryFn: () =>
        AnnotableImageTemplateControllerService.getAllAnnotableImageTemplate({
          flag,
          isPrivate,
          page,
          pageSize,
          searchString,
          sortBy,
          sortDirection,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAnnotableImagePinControllerServiceGetAnnotableImagePinByUuid = <
  TData =
    Common.AnnotableImagePinControllerServiceGetAnnotableImagePinByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAnnotableImagePinControllerServiceGetAnnotableImagePinByUuidKeyFn(
        { uuid },
        queryKey,
      ),
    queryFn: () =>
      AnnotableImagePinControllerService.getAnnotableImagePinByUuid({
        uuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.size
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useAnnotableImagePinControllerServiceGetAllAnnotableImagePins = <
  TData =
    Common.AnnotableImagePinControllerServiceGetAllAnnotableImagePinsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    size,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    size?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAnnotableImagePinControllerServiceGetAllAnnotableImagePinsKeyFn(
        { page, size, sortBy, sortDirection },
        queryKey,
      ),
    queryFn: () =>
      AnnotableImagePinControllerService.getAllAnnotableImagePins({
        page,
        size,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAllergyControllerServiceGetAllergyByUuid = <
  TData = Common.AllergyControllerServiceGetAllergyByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAllergyControllerServiceGetAllergyByUuidKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () => AllergyControllerService.getAllergyByUuid({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.status
 * @returns Response OK
 * @throws ApiError
 */
export const useAllergyControllerServiceGetAllAllergiesForPdf = <
  TData = Common.AllergyControllerServiceGetAllAllergiesForPdfDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
    status,
  }: {
    patientUuid: string;
    status?: boolean;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAllergyControllerServiceGetAllAllergiesForPdfKeyFn(
      { patientUuid, status },
      queryKey,
    ),
    queryFn: () =>
      AllergyControllerService.getAllAllergiesForPdf({
        patientUuid,
        status,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.filter
 * @param data.searchString
 * @param data.draft
 * @returns Response OK
 * @throws ApiError
 */
export const useAllergyControllerServiceGetAllAllergies = <
  TData = Common.AllergyControllerServiceGetAllAllergiesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    draft,
    filter,
    page,
    pageSize,
    patientUuid,
    searchString,
    sortBy,
    sortDirection,
  }: {
    draft?: boolean;
    filter?: "ALL" | "CURRENT" | "INACTIVE" | "ARCHIVED";
    page?: number;
    pageSize?: number;
    patientUuid: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAllergyControllerServiceGetAllAllergiesKeyFn(
      {
        draft,
        filter,
        page,
        pageSize,
        patientUuid,
        searchString,
        sortBy,
        sortDirection,
      },
      queryKey,
    ),
    queryFn: () =>
      AllergyControllerService.getAllAllergies({
        draft,
        filter,
        page,
        pageSize,
        patientUuid,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.questionnaireUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useQuestionnaireControllerServiceGetQuestionnairePdfUrls = <
  TData =
    Common.QuestionnaireControllerServiceGetQuestionnairePdfUrlsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    questionnaireUuid,
  }: {
    questionnaireUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseQuestionnaireControllerServiceGetQuestionnairePdfUrlsKeyFn(
        { questionnaireUuid },
        queryKey,
      ),
    queryFn: () =>
      QuestionnaireControllerService.getQuestionnairePdfUrls({
        questionnaireUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.questionnaireUuid
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useQuestionnaireControllerServiceGetQuestionnaireTableMappings = <
  TData =
    Common.QuestionnaireControllerServiceGetQuestionnaireTableMappingsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
    questionnaireUuid,
  }: {
    patientUuid: string;
    questionnaireUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseQuestionnaireControllerServiceGetQuestionnaireTableMappingsKeyFn(
        { patientUuid, questionnaireUuid },
        queryKey,
      ),
    queryFn: () =>
      QuestionnaireControllerService.getQuestionnaireTableMappings({
        patientUuid,
        questionnaireUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.questionnaireUuid
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useQuestionnaireControllerServiceGetQuestionnaireContentForPatient =
  <
    TData =
      Common.QuestionnaireControllerServiceGetQuestionnaireContentForPatientDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      patientUuid,
      questionnaireUuid,
    }: {
      patientUuid: string;
      questionnaireUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseQuestionnaireControllerServiceGetQuestionnaireContentForPatientKeyFn(
          { patientUuid, questionnaireUuid },
          queryKey,
        ),
      queryFn: () =>
        QuestionnaireControllerService.getQuestionnaireContentForPatient({
          patientUuid,
          questionnaireUuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.submitted
 * @param data.formBuilderType
 * @param data.isPdfFormSubmission
 * @param data.appointmentUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.startDate
 * @param data.endDate
 * @returns Response OK
 * @throws ApiError
 */
export const useQuestionnaireControllerServiceGetQuestionnairesForPatientPortal =
  <
    TData =
      Common.QuestionnaireControllerServiceGetQuestionnairesForPatientPortalDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      appointmentUuid,
      endDate,
      formBuilderType,
      isPdfFormSubmission,
      page,
      pageSize,
      patientUuid,
      searchString,
      sortBy,
      sortDirection,
      startDate,
      submitted,
    }: {
      appointmentUuid?: string;
      endDate?: string;
      formBuilderType?: string;
      isPdfFormSubmission?: boolean;
      page?: number;
      pageSize?: number;
      patientUuid: string;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
      startDate?: string;
      submitted?: boolean;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseQuestionnaireControllerServiceGetQuestionnairesForPatientPortalKeyFn(
          {
            appointmentUuid,
            endDate,
            formBuilderType,
            isPdfFormSubmission,
            page,
            pageSize,
            patientUuid,
            searchString,
            sortBy,
            sortDirection,
            startDate,
            submitted,
          },
          queryKey,
        ),
      queryFn: () =>
        QuestionnaireControllerService.getQuestionnairesForPatientPortal({
          appointmentUuid,
          endDate,
          formBuilderType,
          isPdfFormSubmission,
          page,
          pageSize,
          patientUuid,
          searchString,
          sortBy,
          sortDirection,
          startDate,
          submitted,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.search
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useQuestControllerServiceGetAllCptCodes = <
  TData = Common.QuestControllerServiceGetAllCptCodesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    search,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseQuestControllerServiceGetAllCptCodesKeyFn(
      { page, pageSize, search, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      QuestControllerService.getAllCptCodes({
        page,
        pageSize,
        search,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.testCode
 * @returns Response OK
 * @throws ApiError
 */
export const useQuestControllerServiceGetAoeQuestions = <
  TData = Common.QuestControllerServiceGetAoeQuestionsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    testCode,
  }: {
    testCode: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseQuestControllerServiceGetAoeQuestionsKeyFn(
      { testCode },
      queryKey,
    ),
    queryFn: () =>
      QuestControllerService.getAoeQuestions({ testCode }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.search
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useQuestControllerServiceGetAllCodes = <
  TData = Common.QuestControllerServiceGetAllCodesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    search,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseQuestControllerServiceGetAllCodesKeyFn(
      { page, pageSize, search, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      QuestControllerService.getAllCodes({
        page,
        pageSize,
        search,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.documentUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useDocumentControllerServiceGetDocumentByUuid = <
  TData = Common.DocumentControllerServiceGetDocumentByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    documentUuid,
  }: {
    documentUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseDocumentControllerServiceGetDocumentByUuidKeyFn(
      { documentUuid },
      queryKey,
    ),
    queryFn: () =>
      DocumentControllerService.getDocumentByUuid({ documentUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.fileName
 * @param data.documentType
 * @param data.startDate
 * @param data.endDate
 * @param data.shared
 * @param data.includeArchived
 * @param data.reviewRequired
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useDocumentControllerServiceGetAllDocuments1 = <
  TData = Common.DocumentControllerServiceGetAllDocuments1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    documentType,
    endDate,
    fileName,
    includeArchived,
    page,
    patientUuid,
    reviewRequired,
    shared,
    size,
    sort,
    startDate,
  }: {
    documentType?: string;
    endDate?: string;
    fileName?: string;
    includeArchived?: boolean;
    page?: number;
    patientUuid: string;
    reviewRequired?: boolean;
    shared?: boolean;
    size?: number;
    sort?: string[];
    startDate?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseDocumentControllerServiceGetAllDocuments1KeyFn(
      {
        documentType,
        endDate,
        fileName,
        includeArchived,
        page,
        patientUuid,
        reviewRequired,
        shared,
        size,
        sort,
        startDate,
      },
      queryKey,
    ),
    queryFn: () =>
      DocumentControllerService.getAllDocuments1({
        documentType,
        endDate,
        fileName,
        includeArchived,
        page,
        patientUuid,
        reviewRequired,
        shared,
        size,
        sort,
        startDate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.contactDirectoryUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useContactDirectoryControllerServiceGetContactDirectoryUuid = <
  TData =
    Common.ContactDirectoryControllerServiceGetContactDirectoryUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    contactDirectoryUuid,
  }: {
    contactDirectoryUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseContactDirectoryControllerServiceGetContactDirectoryUuidKeyFn(
        { contactDirectoryUuid },
        queryKey,
      ),
    queryFn: () =>
      ContactDirectoryControllerService.getContactDirectoryUuid({
        contactDirectoryUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.referralType
 * @param data.searchString
 * @param data.city
 * @param data.state
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useContactDirectoryControllerServiceGetAllContactDirectory = <
  TData =
    Common.ContactDirectoryControllerServiceGetAllContactDirectoryDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    city,
    page,
    referralType,
    searchString,
    size,
    sort,
    state,
  }: {
    city?: string;
    page?: number;
    referralType?:
      | "IMAGING"
      | "SPECIALIST"
      | "ACUPUNCTURIST"
      | "ADULT_COMPANION"
      | "ADVANCED_PRACTICE_DENTAL_THERAPIST"
      | "ADVANCED_PRACTICE_MIDWIFE"
      | "AIR_CARRIER"
      | "ALLERGY_IMMUNOLOGY"
      | "ALZHEIMER_CENTER_DEMENTIA_CENTER"
      | "AMBULANCE"
      | "ANAPLASTOLOGIST"
      | "ANESTHESIOLOGIST_ASSISTANT"
      | "ANESTHESIOLOGY"
      | "ART_THERAPIST"
      | "ASSISTANT_BEHAVIOR_ANALYST"
      | "ASSISTANT_PODIATRIC"
      | "ASSISTED_LIVING_FACILITY"
      | "AUDIOLOGIST"
      | "AUDIOLOGIST_HEARING_AID_FITTER"
      | "BEHAVIOR_ANALYST"
      | "BEHAVIOR_TECHNICIAN"
      | "BLOOD_BANK"
      | "BUS"
      | "CASE_MANAGEMENT"
      | "CASE_MANAGER_CARE_COORDINATOR"
      | "CHIROPRACTOR"
      | "CHORE_PROVIDER"
      | "CHRISTIAN_SCIENCE_FACILITY"
      | "CHRISTIAN_SCIENCE_SANITORIUM"
      | "CHRONIC_DISEASE_HOSPITAL"
      | "CLINIC_CENTER"
      | "CLINICAL_ETHICIST"
      | "CLINICAL_EXERCISE_PHYSIOLOGIST"
      | "CLINICAL_MEDICAL_LABORATORY"
      | "CLINICAL_NEUROPSYCHOLOGIST"
      | "CLINICAL_NURSE_SPECIALIST"
      | "CLINICAL_PHARMACOLOGY"
      | "COLON_RECTAL_SURGERY"
      | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
      | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_MENTAL_ILLNESS"
      | "COMMUNITY_HEALTH_WORKER"
      | "COMMUNITY_PARAMEDIC"
      | "COMMUNITY_BEHAVIORAL_HEALTH"
      | "CONTRACTOR"
      | "COUNSELOR"
      | "CUSTODIAL_CARE_FACILITY"
      | "DANCE_THERAPIST"
      | "DAY_TRAINING_DEVELOPMENTALLY_DISABLED_SERVICES"
      | "DAY_TRAINING_HABILITATION_SPECIALIST"
      | "DENTAL_ASSISTANT"
      | "DENTAL_HYGIENIST"
      | "DENTAL_LABORATORY"
      | "DENTAL_LABORATORY_TECHNICIAN"
      | "DENTAL_THERAPIST"
      | "DENTIST"
      | "DENTURIST"
      | "DEPARTMENT_OF_VETERANS_AFFAIRS_VA_PHARMACY"
      | "DERMATOLOGY"
      | "DEVELOPMENTAL_THERAPIST"
      | "DIETARY_MANAGER"
      | "DIETETIC_TECHNICIAN_REGISTERED"
      | "DIETITIAN_REGISTERED"
      | "DOULA"
      | "DRAMA_THERAPIST"
      | "DRIVER"
      | "DURABLE_MEDICAL_EQUIPMENT_MEDICAL_SUPPLIES"
      | "EARLY_INTERVENTION_PROVIDER_AGENCY"
      | "ELECTRODIAGNOSTIC_MEDICINE"
      | "EMERGENCY_MEDICAL_TECHNICIAN_BASIC"
      | "EMERGENCY_MEDICAL_TECHNICIAN_INTERMEDIATE"
      | "EMERGENCY_MEDICAL_TECHNICIAN_PARAMEDIC"
      | "EMERGENCY_MEDICINE"
      | "EMERGENCY_RESPONSE_SYSTEM_COMPANIES"
      | "EPILEPSY_UNIT"
      | "EXCLUSIVE_PROVIDER_ORGANIZATION"
      | "EYE_BANK"
      | "EYEWEAR_SUPPLIER"
      | "FAMILY_MEDICINE"
      | "FOSTER_CARE_AGENCY"
      | "FUNERAL_DIRECTOR"
      | "GENERAL_ACUTE_CARE_HOSPITAL"
      | "GENERAL_PRACTICE"
      | "GENETIC_COUNSELOR_MS"
      | "HEALTH_WELLNESS_COACH"
      | "HEALTH_EDUCATOR"
      | "HEALTH_MAINTENANCE_ORGANIZATION"
      | "HEARING_AID_EQUIPMENT"
      | "HEARING_INSTRUMENT_SPECIALIST"
      | "HOME_DELIVERED_MEALS"
      | "HOME_HEALTH"
      | "HOME_HEALTH_AIDE"
      | "HOME_INFUSION"
      | "HOMEMAKER"
      | "HOMEOPATH"
      | "HOSPICE_CARE_COMMUNITY_BASED"
      | "HOSPICE_INPATIENT"
      | "HOSPITALIST"
      | "IN_HOME_SUPPORTIVE_CARE"
      | "INDEPENDENT_MEDICAL_EXAMINER"
      | "INDIAN_HEALTH_SERVICE_TRIBAL_URBAN_INDIAN_HEALTH_I_T_U_PHARMACY"
      | "INTEGRATIVE_MEDICINE"
      | "INTERMEDIATE_CARE_FACILITY_INTELLECTUAL_DISABILITIES"
      | "INTERMEDIATE_CARE_FACILITY_MENTAL_ILLNESS"
      | "INTERNAL_MEDICINE"
      | "INTERPRETER"
      | "KINESIOTHERAPIST"
      | "LACTATION_CONSULTANT_NON_RN"
      | "LEGAL_MEDICINE"
      | "LICENSED_PRACTICAL_NURSE"
      | "LICENSED_PSYCHIATRIC_TECHNICIAN"
      | "LICENSED_VOCATIONAL_NURSE"
      | "LOCAL_EDUCATION_AGENCY_LEA"
      | "LODGING"
      | "LONG_TERM_CARE_HOSPITAL"
      | "MARRIAGE_FAMILY_THERAPIST"
      | "MASSAGE_THERAPIST"
      | "MASTECTOMY_FITTER"
      | "MEALS"
      | "MECHANOTHERAPIST"
      | "MEDICAL_FOODS_SUPPLIER"
      | "MEDICAL_GENETICS"
      | "MEDICAL_GENETICS_PH_D_MEDICAL_GENETICS"
      | "MEDICARE_DEFINED_SWING_BED_UNIT"
      | "MIDWIFE"
      | "MIDWIFE_LAY"
      | "MILITARY_CLINICAL_MEDICAL_LABORATORY"
      | "MILITARY_HEALTH_CARE_PROVIDER"
      | "MILITARY_HOSPITAL"
      | "MILITARY_U_S_COAST_GUARD_PHARMACY"
      | "MILITARY_U_S_COAST_GUARD_TRANSPORT"
      | "MULTI_SPECIALTY"
      | "MUSIC_THERAPIST"
      | "NAPRAPATH"
      | "NATUROPATH"
      | "NEUROLOGICAL_SURGERY"
      | "NEUROMUSCULOSKELETAL_MEDICINE_OMM"
      | "NEUROMUSCULOSKELETAL_MEDICINE_SPORTS_MEDICINE"
      | "NON_PHARMACY_DISPENSING_SITE"
      | "NON_EMERGENCY_MEDICAL_TRANSPORT_VAN"
      | "NUCLEAR_MEDICINE"
      | "NURSE_ANESTHETIST_CERTIFIED_REGISTERED"
      | "NURSE_PRACTITIONER"
      | "NURSE_S_AIDE"
      | "NURSING_CARE"
      | "NURSING_FACILITY_INTERMEDIATE_CARE_FACILITY"
      | "NURSING_HOME_ADMINISTRATOR"
      | "NUTRITIONIST"
      | "OBSTETRICS_GYNECOLOGY"
      | "OCCUPATIONAL_THERAPIST"
      | "OCCUPATIONAL_THERAPY_ASSISTANT"
      | "OPHTHALMOLOGY"
      | "OPTOMETRIST"
      | "ORAL_MAXILLOFACIAL_SURGERY"
      | "ORGAN_PROCUREMENT_ORGANIZATION"
      | "ORTHOPAEDIC_SURGERY"
      | "ORTHOTIC_FITTER"
      | "ORTHOTIST"
      | "OTOLARYNGOLOGY"
      | "PAIN_MEDICINE"
      | "PATHOLOGY"
      | "PEDIATRICS"
      | "PEDORTHIST"
      | "PEER_SPECIALIST"
      | "PERFUSIONIST"
      | "PERSONAL_EMERGENCY_RESPONSE_ATTENDANT"
      | "PHARMACIST"
      | "PHARMACY"
      | "PHARMACY_TECHNICIAN"
      | "PHLEBOLOGY"
      | "PHYSICAL_MEDICINE_REHABILITATION"
      | "PHYSICAL_THERAPIST"
      | "PHYSICAL_THERAPY_ASSISTANT"
      | "PHYSICIAN_ASSISTANT"
      | "PHYSIOLOGICAL_LABORATORY"
      | "PLASTIC_SURGERY"
      | "PODIATRIST"
      | "POETRY_THERAPIST"
      | "POINT_OF_SERVICE"
      | "PORTABLE_X_RAY_AND_OR_OTHER_PORTABLE_DIAGNOSTIC_IMAGING_SUPPLIER"
      | "PREFERRED_PROVIDER_ORGANIZATION"
      | "PREVENTION_PROFESSIONAL"
      | "PREVENTIVE_MEDICINE"
      | "PRIVATE_VEHICLE"
      | "PROGRAM_OF_ALL_INCLUSIVE_CARE_FOR_THE_ELDERLY_PACE_PROVIDER_ORGANIZATION"
      | "PROSTHETIC_ORTHOTIC_SUPPLIER"
      | "PROSTHETIST"
      | "PSYCHIATRIC_HOSPITAL"
      | "PSYCHIATRIC_RESIDENTIAL_TREATMENT_FACILITY"
      | "PSYCHIATRIC_UNIT"
      | "PSYCHIATRY_NEUROLOGY"
      | "PSYCHOANALYST"
      | "PSYCHOLOGIST"
      | "PUBLIC_HEALTH_OR_WELFARE"
      | "PULMONARY_FUNCTION_TECHNOLOGIST"
      | "RADIOLOGIC_TECHNOLOGIST"
      | "RADIOLOGY"
      | "RADIOLOGY_PRACTITIONER_ASSISTANT"
      | "RECREATION_THERAPIST"
      | "RECREATIONAL_THERAPIST_ASSISTANT"
      | "REFLEXOLOGIST"
      | "REGISTERED_NURSE"
      | "REHABILITATION_COUNSELOR"
      | "REHABILITATION_HOSPITAL"
      | "REHABILITATION_PRACTITIONER"
      | "REHABILITATION_UNIT"
      | "REHABILITATION_SUBSTANCE_USE_DISORDER_UNIT"
      | "RELIGIOUS_NONMEDICAL_HEALTH_CARE_INSTITUTION"
      | "RELIGIOUS_NONMEDICAL_NURSING_PERSONNEL"
      | "RELIGIOUS_NONMEDICAL_PRACTITIONER"
      | "RESIDENTIAL_TREATMENT_FACILITY_EMOTIONALLY_DISTURBED_CHILDREN"
      | "RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
      | "RESIDENTIAL_TREATMENT_FACILITY_PHYSICAL_DISABILITIES"
      | "RESPIRATORY_THERAPIST_CERTIFIED"
      | "RESPIRATORY_THERAPIST_REGISTERED"
      | "RESPITE_CARE"
      | "SECURED_MEDICAL_TRANSPORT_VAN"
      | "SINGLE_SPECIALTY"
      | "SKILLED_NURSING_FACILITY"
      | "SLEEP_SPECIALIST_PHD"
      | "SOCIAL_WORKER"
      | "SPECIAL_HOSPITAL"
      | "SPECIALIST_TECHNOLOGIST"
      | "SPECIALIST_TECHNOLOGIST_CARDIOVASCULAR"
      | "SPECIALIST_TECHNOLOGIST_HEALTH_INFORMATION"
      | "SPECIALIST_TECHNOLOGIST_OTHER"
      | "SPECIALIST_TECHNOLOGIST_PATHOLOGY"
      | "SPEECH_LANGUAGE_PATHOLOGIST"
      | "STUDENT_IN_AN_ORGANIZED_HEALTH_CARE_EDUCATION_TRAINING_PROGRAM"
      | "SUBSTANCE_ABUSE_REHABILITATION_FACILITY"
      | "SUPPORTS_BROKERAGE"
      | "SURGERY"
      | "TAXI"
      | "TECHNICIAN"
      | "TECHNICIAN_CARDIOLOGY"
      | "TECHNICIAN_HEALTH_INFORMATION"
      | "TECHNICIAN_OTHER"
      | "TECHNICIAN_PATHOLOGY"
      | "TECHNICIAN_TECHNOLOGIST"
      | "THORACIC_SURGERY_CARDIOTHORACIC_VASCULAR_SURGERY"
      | "TRAIN"
      | "TRANSPLANT_SURGERY"
      | "TRANSPORTATION_BROKER"
      | "TRANSPORTATION_NETWORK_COMPANY"
      | "UROLOGY"
      | "VETERINARIAN"
      | "VOLUNTARY_OR_CHARITABLE";
    searchString?: string;
    size?: number;
    sort?: string[];
    state?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseContactDirectoryControllerServiceGetAllContactDirectoryKeyFn(
        { city, page, referralType, searchString, size, sort, state },
        queryKey,
      ),
    queryFn: () =>
      ContactDirectoryControllerService.getAllContactDirectory({
        city,
        page,
        referralType,
        searchString,
        size,
        sort,
        state,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.key
 * @returns Response OK
 * @throws ApiError
 */
export const useAwsControllerServiceGetFile = <
  TData = Common.AwsControllerServiceGetFileDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    key,
  }: {
    key: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAwsControllerServiceGetFileKeyFn({ key }, queryKey),
    queryFn: () => AwsControllerService.getFile({ key }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.key
 * @returns Response OK
 * @throws ApiError
 */
export const useAwsControllerServiceGetFile1 = <
  TData = Common.AwsControllerServiceGetFile1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    key,
  }: {
    key: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAwsControllerServiceGetFile1KeyFn({ key }, queryKey),
    queryFn: () => AwsControllerService.getFile1({ key }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.key
 * @returns Response OK
 * @throws ApiError
 */
export const useAwsControllerServiceGetDownloadUrl = <
  TData = Common.AwsControllerServiceGetDownloadUrlDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    key,
  }: {
    key: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAwsControllerServiceGetDownloadUrlKeyFn(
      { key },
      queryKey,
    ),
    queryFn: () => AwsControllerService.getDownloadUrl({ key }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.key
 * @returns Response OK
 * @throws ApiError
 */
export const useAwsControllerServiceGetDownloadUrl1 = <
  TData = Common.AwsControllerServiceGetDownloadUrl1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    key,
  }: {
    key: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAwsControllerServiceGetDownloadUrl1KeyFn(
      { key },
      queryKey,
    ),
    queryFn: () => AwsControllerService.getDownloadUrl1({ key }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.agreementUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAgreementControllerServiceGetAgreementByUuid = <
  TData = Common.AgreementControllerServiceGetAgreementByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    agreementUuid,
  }: {
    agreementUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAgreementControllerServiceGetAgreementByUuidKeyFn(
      { agreementUuid },
      queryKey,
    ),
    queryFn: () =>
      AgreementControllerService.getAgreementByUuid({ agreementUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.agreementUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAgreementControllerServiceGetAgreementPdfUrls = <
  TData = Common.AgreementControllerServiceGetAgreementPdfUrlsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    agreementUuid,
  }: {
    agreementUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAgreementControllerServiceGetAgreementPdfUrlsKeyFn(
      { agreementUuid },
      queryKey,
    ),
    queryFn: () =>
      AgreementControllerService.getAgreementPdfUrls({
        agreementUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.agreementUuid
 * @param data.affiliateGroupUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAgreementControllerServiceGetAgreementContentForAffiliateGroup =
  <
    TData =
      Common.AgreementControllerServiceGetAgreementContentForAffiliateGroupDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      affiliateGroupUuid,
      agreementUuid,
    }: {
      affiliateGroupUuid: string;
      agreementUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseAgreementControllerServiceGetAgreementContentForAffiliateGroupKeyFn(
          { affiliateGroupUuid, agreementUuid },
          queryKey,
        ),
      queryFn: () =>
        AgreementControllerService.getAgreementContentForAffiliateGroup({
          affiliateGroupUuid,
          agreementUuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.signed
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useAgreementControllerServiceGetAgreementsForPortal = <
  TData =
    Common.AgreementControllerServiceGetAgreementsForPortalDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    signed,
    sortBy,
    sortDirection,
    uuid,
  }: {
    page?: number;
    pageSize?: number;
    signed?: boolean;
    sortBy?: string;
    sortDirection?: string;
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAgreementControllerServiceGetAgreementsForPortalKeyFn(
      { page, pageSize, signed, sortBy, sortDirection, uuid },
      queryKey,
    ),
    queryFn: () =>
      AgreementControllerService.getAgreementsForPortal({
        page,
        pageSize,
        signed,
        sortBy,
        sortDirection,
        uuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useAgreementControllerServiceGetAllAgreementsForFirms = <
  TData =
    Common.AgreementControllerServiceGetAllAgreementsForFirmsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAgreementControllerServiceGetAllAgreementsForFirmsKeyFn(
      { page, pageSize, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      AgreementControllerService.getAllAgreementsForFirms({
        page,
        pageSize,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.affiliateGroupUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAgreementControllerServiceGetPendingAgreementForLogin = <
  TData =
    Common.AgreementControllerServiceGetPendingAgreementForLoginDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    affiliateGroupUuid,
  }: {
    affiliateGroupUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAgreementControllerServiceGetPendingAgreementForLoginKeyFn(
        { affiliateGroupUuid },
        queryKey,
      ),
    queryFn: () =>
      AgreementControllerService.getPendingAgreementForLogin({
        affiliateGroupUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.pageable
 * @param data.search
 * @returns PageTribleTestCodesDto OK
 * @throws ApiError
 */
export const useTribleLabControllerServiceGetAllTribleTestCodes = <
  TData = Common.TribleLabControllerServiceGetAllTribleTestCodesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    pageable,
    search,
  }: {
    pageable: Pageable;
    search?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTribleLabControllerServiceGetAllTribleTestCodesKeyFn(
      { pageable, search },
      queryKey,
    ),
    queryFn: () =>
      TribleLabControllerService.getAllTribleTestCodes({
        pageable,
        search,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.isApprove
 * @returns Response OK
 * @throws ApiError
 */
export const useTribleLabControllerServiceGetByPatientUuid = <
  TData = Common.TribleLabControllerServiceGetByPatientUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    isApprove,
    patientUuid,
  }: {
    isApprove?: boolean;
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTribleLabControllerServiceGetByPatientUuidKeyFn(
      { isApprove, patientUuid },
      queryKey,
    ),
    queryFn: () =>
      TribleLabControllerService.getByPatientUuid({
        isApprove,
        patientUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTribleLabControllerServiceGetAllLabOrdersForPdf = <
  TData = Common.TribleLabControllerServiceGetAllLabOrdersForPdfDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTribleLabControllerServiceGetAllLabOrdersForPdfKeyFn(
      { patientUuid },
      queryKey,
    ),
    queryFn: () =>
      TribleLabControllerService.getAllLabOrdersForPdf({
        patientUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @returns Response OK
 * @throws ApiError
 */
export const useTribleLabControllerServiceGetAll1 = <
  TData = Common.TribleLabControllerServiceGetAll1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
  }: {
    page?: number;
    pageSize?: number;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTribleLabControllerServiceGetAll1KeyFn(
      { page, pageSize },
      queryKey,
    ),
    queryFn: () =>
      TribleLabControllerService.getAll1({ page, pageSize }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @returns Response OK
 * @throws ApiError
 */
export const useTaskCategoryControllerServiceGetAllTaskCategories = <
  TData =
    Common.TaskCategoryControllerServiceGetAllTaskCategoriesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
  }: {
    page?: number;
    pageSize?: number;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTaskCategoryControllerServiceGetAllTaskCategoriesKeyFn(
      { page, pageSize },
      queryKey,
    ),
    queryFn: () =>
      TaskCategoryControllerService.getAllTaskCategories({
        page,
        pageSize,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.code
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useProcedureCodeControllerServiceGetProcedureCodes = <
  TData = Common.ProcedureCodeControllerServiceGetProcedureCodesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    code,
    page,
    size,
    sort,
  }: {
    code?: string;
    page?: number;
    size?: number;
    sort?: string[];
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseProcedureCodeControllerServiceGetProcedureCodesKeyFn(
      { code, page, size, sort },
      queryKey,
    ),
    queryFn: () =>
      ProcedureCodeControllerService.getProcedureCodes({
        code,
        page,
        size,
        sort,
      }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const usePlaceholderControllerServiceGetAllPlaceholders = <
  TData = Common.PlaceholderControllerServiceGetAllPlaceholdersDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UsePlaceholderControllerServiceGetAllPlaceholdersKeyFn(queryKey),
    queryFn: () => PlaceholderControllerService.getAllPlaceholders() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.studyName
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useOrderStudyControllerServiceGetAllDocuments = <
  TData = Common.OrderStudyControllerServiceGetAllDocumentsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    size,
    sort,
    studyName,
  }: {
    page?: number;
    size?: number;
    sort?: string[];
    studyName?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseOrderStudyControllerServiceGetAllDocumentsKeyFn(
      { page, size, sort, studyName },
      queryKey,
    ),
    queryFn: () =>
      OrderStudyControllerService.getAllDocuments({
        page,
        size,
        sort,
        studyName,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.chartType
 * @param data.standard
 * @param data.combined
 * @param data.gestationalAgeWeeks
 * @returns Response OK
 * @throws ApiError
 */
export const useGrowthChartControllerServiceGetGrowthChart = <
  TData = Common.GrowthChartControllerServiceGetGrowthChartDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    chartType,
    combined,
    gestationalAgeWeeks,
    patientUuid,
    standard,
  }: {
    chartType?:
      | "WEIGHT_FOR_AGE"
      | "LENGTH_HEIGHT_FOR_AGE"
      | "WEIGHT_FOR_LENGTH"
      | "BMI_FOR_AGE"
      | "HEAD_CIRCUMFERENCE_FOR_AGE";
    combined?: boolean;
    gestationalAgeWeeks?: number;
    patientUuid: string;
    standard?: "WHO" | "CDC" | "DOWN_SYNDROME" | "PRETERM";
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseGrowthChartControllerServiceGetGrowthChartKeyFn(
      { chartType, combined, gestationalAgeWeeks, patientUuid, standard },
      queryKey,
    ),
    queryFn: () =>
      GrowthChartControllerService.getGrowthChart({
        chartType,
        combined,
        gestationalAgeWeeks,
        patientUuid,
        standard,
      }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useDynamicMappingControllerServiceGetAvailableFields = <
  TData =
    Common.DynamicMappingControllerServiceGetAvailableFieldsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseDynamicMappingControllerServiceGetAvailableFieldsKeyFn(
        queryKey,
      ),
    queryFn: () =>
      DynamicMappingControllerService.getAvailableFields() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.entityName
 * @param data.auditUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceGetAuditHistoryByUuid = <
  TData =
    Common.AuditHistoryControllerServiceGetAuditHistoryByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    auditUuid,
    entityName,
  }: {
    auditUuid: string;
    entityName: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAuditHistoryControllerServiceGetAuditHistoryByUuidKeyFn(
      { auditUuid, entityName },
      queryKey,
    ),
    queryFn: () =>
      AuditHistoryControllerService.getAuditHistoryByUuid({
        auditUuid,
        entityName,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @param data.entityNames
 * @param data.startDate
 * @param data.endDate
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceGetUserAuditLogs = <
  TData = Common.AuditHistoryControllerServiceGetUserAuditLogsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    entityNames,
    page,
    size,
    sort,
    startDate,
    userUuid,
  }: {
    endDate?: string;
    entityNames?: string[];
    page?: number;
    size?: number;
    sort?: string[];
    startDate?: string;
    userUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAuditHistoryControllerServiceGetUserAuditLogsKeyFn(
      { endDate, entityNames, page, size, sort, startDate, userUuid },
      queryKey,
    ),
    queryFn: () =>
      AuditHistoryControllerService.getUserAuditLogs({
        endDate,
        entityNames,
        page,
        size,
        sort,
        startDate,
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.ticketUuid
 * @param data.entityNames
 * @param data.startDate
 * @param data.endDate
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceGetTicketAuditLogs = <
  TData = Common.AuditHistoryControllerServiceGetTicketAuditLogsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    entityNames,
    page,
    size,
    sort,
    startDate,
    ticketUuid,
  }: {
    endDate?: string;
    entityNames?: string[];
    page?: number;
    size?: number;
    sort?: string[];
    startDate?: string;
    ticketUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAuditHistoryControllerServiceGetTicketAuditLogsKeyFn(
      { endDate, entityNames, page, size, sort, startDate, ticketUuid },
      queryKey,
    ),
    queryFn: () =>
      AuditHistoryControllerService.getTicketAuditLogs({
        endDate,
        entityNames,
        page,
        size,
        sort,
        startDate,
        ticketUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @param data.flag
 * @param data.pageable
 * @returns PageGenericAuditLogResponse OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceGetTaskAuditLogs = <
  TData = Common.AuditHistoryControllerServiceGetTaskAuditLogsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    flag,
    pageable,
    userUuid,
  }: {
    flag: boolean;
    pageable: Pageable;
    userUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAuditHistoryControllerServiceGetTaskAuditLogsKeyFn(
      { flag, pageable, userUuid },
      queryKey,
    ),
    queryFn: () =>
      AuditHistoryControllerService.getTaskAuditLogs({
        flag,
        pageable,
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.soapNoteUuid
 * @param data.entityNames
 * @param data.startDate
 * @param data.endDate
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceGetSoapNoteAuditLogs = <
  TData =
    Common.AuditHistoryControllerServiceGetSoapNoteAuditLogsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    entityNames,
    page,
    size,
    soapNoteUuid,
    sort,
    startDate,
  }: {
    endDate?: string;
    entityNames?: string[];
    page?: number;
    size?: number;
    soapNoteUuid: string;
    sort?: string[];
    startDate?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAuditHistoryControllerServiceGetSoapNoteAuditLogsKeyFn(
      { endDate, entityNames, page, size, soapNoteUuid, sort, startDate },
      queryKey,
    ),
    queryFn: () =>
      AuditHistoryControllerService.getSoapNoteAuditLogs({
        endDate,
        entityNames,
        page,
        size,
        soapNoteUuid,
        sort,
        startDate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.startDate
 * @param data.endDate
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceGetPatientModuleAccessAuditLogs = <
  TData =
    Common.AuditHistoryControllerServiceGetPatientModuleAccessAuditLogsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    page,
    patientUuid,
    size,
    sort,
    startDate,
  }: {
    endDate?: string;
    page?: number;
    patientUuid: string;
    size?: number;
    sort?: string[];
    startDate?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAuditHistoryControllerServiceGetPatientModuleAccessAuditLogsKeyFn(
        { endDate, page, patientUuid, size, sort, startDate },
        queryKey,
      ),
    queryFn: () =>
      AuditHistoryControllerService.getPatientModuleAccessAuditLogs({
        endDate,
        page,
        patientUuid,
        size,
        sort,
        startDate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.entityNames
 * @param data.startDate
 * @param data.endDate
 * @param data.username
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceGetInventoryAuditLogs = <
  TData =
    Common.AuditHistoryControllerServiceGetInventoryAuditLogsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    entityNames,
    page,
    size,
    sort,
    startDate,
    username,
  }: {
    endDate?: string;
    entityNames?: string[];
    page?: number;
    size?: number;
    sort?: string[];
    startDate?: string;
    username?: string[];
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAuditHistoryControllerServiceGetInventoryAuditLogsKeyFn(
      { endDate, entityNames, page, size, sort, startDate, username },
      queryKey,
    ),
    queryFn: () =>
      AuditHistoryControllerService.getInventoryAuditLogs({
        endDate,
        entityNames,
        page,
        size,
        sort,
        startDate,
        username,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.hAndPnoteUuid
 * @param data.entityNames
 * @param data.startDate
 * @param data.endDate
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceGetHandPnoteAuditLogs = <
  TData =
    Common.AuditHistoryControllerServiceGetHandPnoteAuditLogsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    entityNames,
    hAndPnoteUuid,
    page,
    size,
    sort,
    startDate,
  }: {
    endDate?: string;
    entityNames?: string[];
    hAndPnoteUuid: string;
    page?: number;
    size?: number;
    sort?: string[];
    startDate?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAuditHistoryControllerServiceGetHandPnoteAuditLogsKeyFn(
      { endDate, entityNames, hAndPnoteUuid, page, size, sort, startDate },
      queryKey,
    ),
    queryFn: () =>
      AuditHistoryControllerService.getHandPnoteAuditLogs({
        endDate,
        entityNames,
        hAndPnoteUuid,
        page,
        size,
        sort,
        startDate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @param data.flag
 * @returns unknown OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceExportTaskAuditLogsCsv = <
  TData =
    Common.AuditHistoryControllerServiceExportTaskAuditLogsCsvDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    flag,
    userUuid,
  }: {
    flag: boolean;
    userUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAuditHistoryControllerServiceExportTaskAuditLogsCsvKeyFn(
        { flag, userUuid },
        queryKey,
      ),
    queryFn: () =>
      AuditHistoryControllerService.exportTaskAuditLogsCsv({
        flag,
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.startDate
 * @param data.endDate
 * @param data.actions
 * @param data.roleTypes
 * @param data.roles
 * @param data.username
 * @returns string OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceExportAuditLogsPdf = <
  TData = Common.AuditHistoryControllerServiceExportAuditLogsPdfDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    actions,
    endDate,
    roles,
    roleTypes,
    startDate,
    username,
  }: {
    actions?: string[];
    endDate?: string;
    roles?: string[];
    roleTypes?: string[];
    startDate?: string;
    username?: string[];
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAuditHistoryControllerServiceExportAuditLogsPdfKeyFn(
      { actions, endDate, roles, roleTypes, startDate, username },
      queryKey,
    ),
    queryFn: () =>
      AuditHistoryControllerService.exportAuditLogsPdf({
        actions,
        endDate,
        roles,
        roleTypes,
        startDate,
        username,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.entityNames
 * @param data.startDate
 * @param data.endDate
 * @param data.username
 * @returns string OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceExportInventoryAuditLogsPdf = <
  TData =
    Common.AuditHistoryControllerServiceExportInventoryAuditLogsPdfDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    entityNames,
    startDate,
    username,
  }: {
    endDate?: string;
    entityNames?: string[];
    startDate?: string;
    username?: string[];
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAuditHistoryControllerServiceExportInventoryAuditLogsPdfKeyFn(
        { endDate, entityNames, startDate, username },
        queryKey,
      ),
    queryFn: () =>
      AuditHistoryControllerService.exportInventoryAuditLogsPdf({
        endDate,
        entityNames,
        startDate,
        username,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.entityNames
 * @param data.startDate
 * @param data.endDate
 * @param data.username
 * @returns unknown OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceExportInventoryAuditLogsCsv = <
  TData =
    Common.AuditHistoryControllerServiceExportInventoryAuditLogsCsvDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    entityNames,
    startDate,
    username,
  }: {
    endDate?: string;
    entityNames?: string[];
    startDate?: string;
    username?: string[];
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAuditHistoryControllerServiceExportInventoryAuditLogsCsvKeyFn(
        { endDate, entityNames, startDate, username },
        queryKey,
      ),
    queryFn: () =>
      AuditHistoryControllerService.exportInventoryAuditLogsCsv({
        endDate,
        entityNames,
        startDate,
        username,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.entityNames
 * @param data.startDate
 * @param data.endDate
 * @returns unknown OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceExportEmployerAuditLogsCsv = <
  TData =
    Common.AuditHistoryControllerServiceExportEmployerAuditLogsCsvDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
    endDate,
    entityNames,
    startDate,
  }: {
    employerUuid: string;
    endDate?: string;
    entityNames?: string[];
    startDate?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAuditHistoryControllerServiceExportEmployerAuditLogsCsvKeyFn(
        { employerUuid, endDate, entityNames, startDate },
        queryKey,
      ),
    queryFn: () =>
      AuditHistoryControllerService.exportEmployerAuditLogsCsv({
        employerUuid,
        endDate,
        entityNames,
        startDate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employeeUuid
 * @param data.entityNames
 * @param data.startDate
 * @param data.endDate
 * @returns unknown OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceExportEmployeeAuditLogsCsv = <
  TData =
    Common.AuditHistoryControllerServiceExportEmployeeAuditLogsCsvDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employeeUuid,
    endDate,
    entityNames,
    startDate,
  }: {
    employeeUuid: string;
    endDate?: string;
    entityNames?: string[];
    startDate?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAuditHistoryControllerServiceExportEmployeeAuditLogsCsvKeyFn(
        { employeeUuid, endDate, entityNames, startDate },
        queryKey,
      ),
    queryFn: () =>
      AuditHistoryControllerService.exportEmployeeAuditLogsCsv({
        employeeUuid,
        endDate,
        entityNames,
        startDate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.entityNames
 * @param data.startDate
 * @param data.endDate
 * @param data.patientUuid
 * @returns unknown OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceExportAuditLogsCsv = <
  TData = Common.AuditHistoryControllerServiceExportAuditLogsCsvDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    entityNames,
    patientUuid,
    startDate,
  }: {
    endDate?: string;
    entityNames?: string[];
    patientUuid?: string;
    startDate?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAuditHistoryControllerServiceExportAuditLogsCsvKeyFn(
      { endDate, entityNames, patientUuid, startDate },
      queryKey,
    ),
    queryFn: () =>
      AuditHistoryControllerService.exportAuditLogsCsv({
        endDate,
        entityNames,
        patientUuid,
        startDate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.startDate
 * @param data.endDate
 * @param data.actions
 * @param data.roleTypes
 * @param data.roles
 * @param data.username
 * @returns unknown OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceExportAuditLogsCsv1 = <
  TData =
    Common.AuditHistoryControllerServiceExportAuditLogsCsv1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    actions,
    endDate,
    roles,
    roleTypes,
    startDate,
    username,
  }: {
    actions?: string[];
    endDate?: string;
    roles?: string[];
    roleTypes?: string[];
    startDate?: string;
    username?: string[];
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAuditHistoryControllerServiceExportAuditLogsCsv1KeyFn(
      { actions, endDate, roles, roleTypes, startDate, username },
      queryKey,
    ),
    queryFn: () =>
      AuditHistoryControllerService.exportAuditLogsCsv1({
        actions,
        endDate,
        roles,
        roleTypes,
        startDate,
        username,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.startDate
 * @param data.endDate
 * @param data.actions
 * @param data.roleTypes
 * @param data.roles
 * @param data.username
 * @returns unknown OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceExportAdminAuditLogsCsv = <
  TData =
    Common.AuditHistoryControllerServiceExportAdminAuditLogsCsvDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    actions,
    endDate,
    roles,
    roleTypes,
    startDate,
    username,
  }: {
    actions?: string[];
    endDate?: string;
    roles?: string[];
    roleTypes?: string[];
    startDate?: string;
    username?: string[];
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAuditHistoryControllerServiceExportAdminAuditLogsCsvKeyFn(
        { actions, endDate, roles, roleTypes, startDate, username },
        queryKey,
      ),
    queryFn: () =>
      AuditHistoryControllerService.exportAdminAuditLogsCsv({
        actions,
        endDate,
        roles,
        roleTypes,
        startDate,
        username,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.entityNames
 * @param data.startDate
 * @param data.endDate
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceGetTicketRelatedAuditLogs = <
  TData =
    Common.AuditHistoryControllerServiceGetTicketRelatedAuditLogsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
    endDate,
    entityNames,
    page,
    size,
    sort,
    startDate,
  }: {
    employerUuid: string;
    endDate?: string;
    entityNames?: string[];
    page?: number;
    size?: number;
    sort?: string[];
    startDate?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAuditHistoryControllerServiceGetTicketRelatedAuditLogsKeyFn(
        { employerUuid, endDate, entityNames, page, size, sort, startDate },
        queryKey,
      ),
    queryFn: () =>
      AuditHistoryControllerService.getTicketRelatedAuditLogs({
        employerUuid,
        endDate,
        entityNames,
        page,
        size,
        sort,
        startDate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.entityNames
 * @param data.startDate
 * @param data.endDate
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceGetEmployerAuditLogs = <
  TData =
    Common.AuditHistoryControllerServiceGetEmployerAuditLogsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
    endDate,
    entityNames,
    page,
    size,
    sort,
    startDate,
  }: {
    employerUuid: string;
    endDate?: string;
    entityNames?: string[];
    page?: number;
    size?: number;
    sort?: string[];
    startDate?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAuditHistoryControllerServiceGetEmployerAuditLogsKeyFn(
      { employerUuid, endDate, entityNames, page, size, sort, startDate },
      queryKey,
    ),
    queryFn: () =>
      AuditHistoryControllerService.getEmployerAuditLogs({
        employerUuid,
        endDate,
        entityNames,
        page,
        size,
        sort,
        startDate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerAdministratorUuid
 * @param data.entityNames
 * @param data.startDate
 * @param data.endDate
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceGetEmployerAdministratorAuditLogs =
  <
    TData =
      Common.AuditHistoryControllerServiceGetEmployerAdministratorAuditLogsDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      employerAdministratorUuid,
      endDate,
      entityNames,
      page,
      size,
      sort,
      startDate,
    }: {
      employerAdministratorUuid: string;
      endDate?: string;
      entityNames?: string[];
      page?: number;
      size?: number;
      sort?: string[];
      startDate?: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseAuditHistoryControllerServiceGetEmployerAdministratorAuditLogsKeyFn(
          {
            employerAdministratorUuid,
            endDate,
            entityNames,
            page,
            size,
            sort,
            startDate,
          },
          queryKey,
        ),
      queryFn: () =>
        AuditHistoryControllerService.getEmployerAdministratorAuditLogs({
          employerAdministratorUuid,
          endDate,
          entityNames,
          page,
          size,
          sort,
          startDate,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.employeeUuid
 * @param data.entityNames
 * @param data.startDate
 * @param data.endDate
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceGetEmployeeAuditLogs = <
  TData =
    Common.AuditHistoryControllerServiceGetEmployeeAuditLogsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employeeUuid,
    endDate,
    entityNames,
    page,
    size,
    sort,
    startDate,
  }: {
    employeeUuid: string;
    endDate?: string;
    entityNames?: string[];
    page?: number;
    size?: number;
    sort?: string[];
    startDate?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAuditHistoryControllerServiceGetEmployeeAuditLogsKeyFn(
      { employeeUuid, endDate, entityNames, page, size, sort, startDate },
      queryKey,
    ),
    queryFn: () =>
      AuditHistoryControllerService.getEmployeeAuditLogs({
        employeeUuid,
        endDate,
        entityNames,
        page,
        size,
        sort,
        startDate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.locationUuid
 * @param data.entityNames
 * @param data.startDate
 * @param data.endDate
 * @param data.providerUuid
 * @param data.clinicUserUuid
 * @param data.patientUuid
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceGetBreakGlassAuditLogs = <
  TData =
    Common.AuditHistoryControllerServiceGetBreakGlassAuditLogsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    clinicUserUuid,
    endDate,
    entityNames,
    locationUuid,
    page,
    patientUuid,
    providerUuid,
    size,
    sort,
    startDate,
  }: {
    clinicUserUuid?: string;
    endDate?: string;
    entityNames?: string[];
    locationUuid: string;
    page?: number;
    patientUuid?: string;
    providerUuid?: string;
    size?: number;
    sort?: string[];
    startDate?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAuditHistoryControllerServiceGetBreakGlassAuditLogsKeyFn(
        {
          clinicUserUuid,
          endDate,
          entityNames,
          locationUuid,
          page,
          patientUuid,
          providerUuid,
          size,
          sort,
          startDate,
        },
        queryKey,
      ),
    queryFn: () =>
      AuditHistoryControllerService.getBreakGlassAuditLogs({
        clinicUserUuid,
        endDate,
        entityNames,
        locationUuid,
        page,
        patientUuid,
        providerUuid,
        size,
        sort,
        startDate,
      }) as TData,
    ...options,
  });
/**
 * @returns string OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceGetAllAuditEntities = <
  TData =
    Common.AuditHistoryControllerServiceGetAllAuditEntitiesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseAuditHistoryControllerServiceGetAllAuditEntitiesKeyFn(queryKey),
    queryFn: () => AuditHistoryControllerService.getAllAuditEntities() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.entityNames
 * @param data.startDate
 * @param data.endDate
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceGetAllTicketAuditLogs = <
  TData =
    Common.AuditHistoryControllerServiceGetAllTicketAuditLogsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    entityNames,
    page,
    size,
    sort,
    startDate,
  }: {
    endDate?: string;
    entityNames?: string[];
    page?: number;
    size?: number;
    sort?: string[];
    startDate?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAuditHistoryControllerServiceGetAllTicketAuditLogsKeyFn(
      { endDate, entityNames, page, size, sort, startDate },
      queryKey,
    ),
    queryFn: () =>
      AuditHistoryControllerService.getAllTicketAuditLogs({
        endDate,
        entityNames,
        page,
        size,
        sort,
        startDate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.entityNames
 * @param data.startDate
 * @param data.endDate
 * @param data.patientUuid
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceGetAllAuditHistory = <
  TData = Common.AuditHistoryControllerServiceGetAllAuditHistoryDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    endDate,
    entityNames,
    page,
    patientUuid,
    size,
    sort,
    startDate,
  }: {
    endDate?: string;
    entityNames?: string[];
    page?: number;
    patientUuid?: string;
    size?: number;
    sort?: string[];
    startDate?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAuditHistoryControllerServiceGetAllAuditHistoryKeyFn(
      { endDate, entityNames, page, patientUuid, size, sort, startDate },
      queryKey,
    ),
    queryFn: () =>
      AuditHistoryControllerService.getAllAuditHistory({
        endDate,
        entityNames,
        page,
        patientUuid,
        size,
        sort,
        startDate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.startDate
 * @param data.endDate
 * @param data.actions
 * @param data.roleTypes
 * @param data.roles
 * @param data.username
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useAuditHistoryControllerServiceGetAdminAuditLogs = <
  TData = Common.AuditHistoryControllerServiceGetAdminAuditLogsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    actions,
    endDate,
    page,
    roles,
    roleTypes,
    size,
    sort,
    startDate,
    username,
  }: {
    actions?: string[];
    endDate?: string;
    page?: number;
    roles?: string[];
    roleTypes?: string[];
    size?: number;
    sort?: string[];
    startDate?: string;
    username?: string[];
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseAuditHistoryControllerServiceGetAdminAuditLogsKeyFn(
      {
        actions,
        endDate,
        page,
        roles,
        roleTypes,
        size,
        sort,
        startDate,
        username,
      },
      queryKey,
    ),
    queryFn: () =>
      AuditHistoryControllerService.getAdminAuditLogs({
        actions,
        endDate,
        page,
        roles,
        roleTypes,
        size,
        sort,
        startDate,
        username,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.isRead
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationControllerServiceGetAllNotifications = <
  TData =
    Common.NotificationControllerServiceGetAllNotificationsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    isRead,
    page,
    pageSize,
    sortBy,
    sortDirection,
    userUuid,
  }: {
    isRead?: boolean;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
    userUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseNotificationControllerServiceGetAllNotificationsKeyFn(
      { isRead, page, pageSize, sortBy, sortDirection, userUuid },
      queryKey,
    ),
    queryFn: () =>
      NotificationControllerService.getAllNotifications({
        isRead,
        page,
        pageSize,
        sortBy,
        sortDirection,
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationControllerServiceGetNotification = <
  TData = Common.NotificationControllerServiceGetNotificationDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseNotificationControllerServiceGetNotificationKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () =>
      NotificationControllerService.getNotification({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationControllerServiceGetNotificationCountByUserUuid = <
  TData =
    Common.NotificationControllerServiceGetNotificationCountByUserUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    userUuid,
  }: {
    userUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseNotificationControllerServiceGetNotificationCountByUserUuidKeyFn(
        { userUuid },
        queryKey,
      ),
    queryFn: () =>
      NotificationControllerService.getNotificationCountByUserUuid({
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationPreferenceControllerServiceGetAllNotificationPreference =
  <
    TData =
      Common.NotificationPreferenceControllerServiceGetAllNotificationPreferenceDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseNotificationPreferenceControllerServiceGetAllNotificationPreferenceKeyFn(
          queryKey,
        ),
      queryFn: () =>
        NotificationPreferenceControllerService.getAllNotificationPreference() as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.employerManagementNotificationSettingyUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerManagementNotificationSettingControllerServiceGetEmployerManagementNotificationSettingyUuid =
  <
    TData =
      Common.EmployerManagementNotificationSettingControllerServiceGetEmployerManagementNotificationSettingyUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      employerManagementNotificationSettingyUuid,
    }: {
      employerManagementNotificationSettingyUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseEmployerManagementNotificationSettingControllerServiceGetEmployerManagementNotificationSettingyUuidKeyFn(
          { employerManagementNotificationSettingyUuid },
          queryKey,
        ),
      queryFn: () =>
        EmployerManagementNotificationSettingControllerService.getEmployerManagementNotificationSettingyUuid(
          { employerManagementNotificationSettingyUuid },
        ) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerManagementNotificationSettingControllerServiceGetAllSettingsByEmployer =
  <
    TData =
      Common.EmployerManagementNotificationSettingControllerServiceGetAllSettingsByEmployerDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      employerUuid,
    }: {
      employerUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseEmployerManagementNotificationSettingControllerServiceGetAllSettingsByEmployerKeyFn(
          { employerUuid },
          queryKey,
        ),
      queryFn: () =>
        EmployerManagementNotificationSettingControllerService.getAllSettingsByEmployer(
          {
            employerUuid,
          },
        ) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.category
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerManagementNotificationSettingControllerServiceGetAllEmployerManagementNotificationSettings =
  <
    TData =
      Common.EmployerManagementNotificationSettingControllerServiceGetAllEmployerManagementNotificationSettingsDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      category,
      page,
      size,
      sort,
    }: {
      category?: string;
      page?: number;
      size?: number;
      sort?: string[];
    } = {},
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseEmployerManagementNotificationSettingControllerServiceGetAllEmployerManagementNotificationSettingsKeyFn(
          { category, page, size, sort },
          queryKey,
        ),
      queryFn: () =>
        EmployerManagementNotificationSettingControllerService.getAllEmployerManagementNotificationSettings(
          { category, page, size, sort },
        ) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.notificationSettingUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceGetNotificationSettingyUuid =
  <
    TData =
      Common.NotificationSettingControllerServiceGetNotificationSettingyUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      notificationSettingUuid,
    }: {
      notificationSettingUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseNotificationSettingControllerServiceGetNotificationSettingyUuidKeyFn(
          { notificationSettingUuid },
          queryKey,
        ),
      queryFn: () =>
        NotificationSettingControllerService.getNotificationSettingyUuid({
          notificationSettingUuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.key
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceGetFile1 = <
  TData = Common.NotificationSettingControllerServiceGetFile1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    key,
  }: {
    key: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseNotificationSettingControllerServiceGetFile1KeyFn(
      { key },
      queryKey,
    ),
    queryFn: () =>
      NotificationSettingControllerService.getFile1({ key }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.key
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceGetFile11 = <
  TData = Common.NotificationSettingControllerServiceGetFile11DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    key,
  }: {
    key: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseNotificationSettingControllerServiceGetFile11KeyFn(
      { key },
      queryKey,
    ),
    queryFn: () =>
      NotificationSettingControllerService.getFile11({ key }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.category
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceGetAllNotificationSettings =
  <
    TData =
      Common.NotificationSettingControllerServiceGetAllNotificationSettingsDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      category,
      page,
      size,
      sort,
    }: {
      category?: string;
      page?: number;
      size?: number;
      sort?: string[];
    } = {},
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseNotificationSettingControllerServiceGetAllNotificationSettingsKeyFn(
          { category, page, size, sort },
          queryKey,
        ),
      queryFn: () =>
        NotificationSettingControllerService.getAllNotificationSettings({
          category,
          page,
          size,
          sort,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.employerNotificationSettingUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerNotificationSettingControllerServiceEmployerNotificationSettingUuid =
  <
    TData =
      Common.EmployerNotificationSettingControllerServiceEmployerNotificationSettingUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      employerNotificationSettingUuid,
    }: {
      employerNotificationSettingUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseEmployerNotificationSettingControllerServiceEmployerNotificationSettingUuidKeyFn(
          { employerNotificationSettingUuid },
          queryKey,
        ),
      queryFn: () =>
        EmployerNotificationSettingControllerService.employerNotificationSettingUuid(
          {
            employerNotificationSettingUuid,
          },
        ) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.category
 * @param data.page Zero-based page index (0..N)
 * @param data.size The size of the page to be returned
 * @param data.sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerNotificationSettingControllerServiceGetAllEmployerNotificationSettings =
  <
    TData =
      Common.EmployerNotificationSettingControllerServiceGetAllEmployerNotificationSettingsDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      category,
      page,
      size,
      sort,
    }: {
      category?: string;
      page?: number;
      size?: number;
      sort?: string[];
    } = {},
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseEmployerNotificationSettingControllerServiceGetAllEmployerNotificationSettingsKeyFn(
          { category, page, size, sort },
          queryKey,
        ),
      queryFn: () =>
        EmployerNotificationSettingControllerService.getAllEmployerNotificationSettings(
          {
            category,
            page,
            size,
            sort,
          },
        ) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.subscriptionId
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceGetSubscription1 = <
  TData = Common.StripControllerServiceGetSubscription1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    subscriptionId,
  }: {
    subscriptionId: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseStripControllerServiceGetSubscription1KeyFn(
      { subscriptionId },
      queryKey,
    ),
    queryFn: () =>
      StripControllerService.getSubscription1({ subscriptionId }) as TData,
    ...options,
  });
/**
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceGetStripeConfig1 = <
  TData = Common.StripControllerServiceGetStripeConfig1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseStripControllerServiceGetStripeConfig1KeyFn(queryKey),
    queryFn: () => StripControllerService.getStripeConfig1() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.ticketUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketControllerServiceGetTicketByUuid = <
  TData = Common.TicketControllerServiceGetTicketByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    ticketUuid,
  }: {
    ticketUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTicketControllerServiceGetTicketByUuidKeyFn(
      { ticketUuid },
      queryKey,
    ),
    queryFn: () =>
      TicketControllerService.getTicketByUuid({ ticketUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.status
 * @param data.searchString
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.priority
 * @param data.ticketType
 * @param data.createdByUuids
 * @param data.requestedByUuids
 * @param data.employerUuids
 * @param data.assignToUuids
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketControllerServiceGetTicketsByEmployerUuid = <
  TData = Common.TicketControllerServiceGetTicketsByEmployerUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    assignToUuids,
    createdByUuids,
    employerUuid,
    employerUuids,
    page,
    pageSize,
    priority,
    requestedByUuids,
    searchString,
    sortBy,
    sortDirection,
    status,
    ticketType,
  }: {
    assignToUuids?: string[];
    createdByUuids?: string[];
    employerUuid: string;
    employerUuids?: string[];
    page?: number;
    pageSize?: number;
    priority?: "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";
    requestedByUuids?: string[];
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    status?:
      | "PENDING"
      | "ONGOING"
      | "RESOLVED"
      | "OPEN"
      | "CLOSED"
      | "ASSIGNED"
      | "UNDER_REVIEW"
      | "IN_PROGRESS";
    ticketType?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTicketControllerServiceGetTicketsByEmployerUuidKeyFn(
      {
        assignToUuids,
        createdByUuids,
        employerUuid,
        employerUuids,
        page,
        pageSize,
        priority,
        requestedByUuids,
        searchString,
        sortBy,
        sortDirection,
        status,
        ticketType,
      },
      queryKey,
    ),
    queryFn: () =>
      TicketControllerService.getTicketsByEmployerUuid({
        assignToUuids,
        createdByUuids,
        employerUuid,
        employerUuids,
        page,
        pageSize,
        priority,
        requestedByUuids,
        searchString,
        sortBy,
        sortDirection,
        status,
        ticketType,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.requestedByUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketControllerServiceGetTotalTicketsCountByUuid = <
  TData =
    Common.TicketControllerServiceGetTotalTicketsCountByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
    requestedByUuid,
  }: {
    employerUuid?: string;
    requestedByUuid?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTicketControllerServiceGetTotalTicketsCountByUuidKeyFn(
      { employerUuid, requestedByUuid },
      queryKey,
    ),
    queryFn: () =>
      TicketControllerService.getTotalTicketsCountByUuid({
        employerUuid,
        requestedByUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.requestedByUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketControllerServiceGetTicketCountsByStatusByUuid = <
  TData =
    Common.TicketControllerServiceGetTicketCountsByStatusByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
    requestedByUuid,
  }: {
    employerUuid?: string;
    requestedByUuid?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseTicketControllerServiceGetTicketCountsByStatusByUuidKeyFn(
        { employerUuid, requestedByUuid },
        queryKey,
      ),
    queryFn: () =>
      TicketControllerService.getTicketCountsByStatusByUuid({
        employerUuid,
        requestedByUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketControllerServiceGetEmployerInfo = <
  TData = Common.TicketControllerServiceGetEmployerInfoDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
  }: {
    employerUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTicketControllerServiceGetEmployerInfoKeyFn(
      { employerUuid },
      queryKey,
    ),
    queryFn: () =>
      TicketControllerService.getEmployerInfo({ employerUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.search
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketControllerServiceGetEmployerStats = <
  TData = Common.TicketControllerServiceGetEmployerStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    search,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTicketControllerServiceGetEmployerStatsKeyFn(
      { page, pageSize, search, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      TicketControllerService.getEmployerStats({
        page,
        pageSize,
        search,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.creatorUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketControllerServiceGetCreatorTicketStats = <
  TData = Common.TicketControllerServiceGetCreatorTicketStatsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    creatorUuid,
  }: {
    creatorUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTicketControllerServiceGetCreatorTicketStatsKeyFn(
      { creatorUuid },
      queryKey,
    ),
    queryFn: () =>
      TicketControllerService.getCreatorTicketStats({ creatorUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerAdminUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketControllerServiceGetTicketCounts = <
  TData = Common.TicketControllerServiceGetTicketCountsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerAdminUuid,
  }: {
    employerAdminUuid?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTicketControllerServiceGetTicketCountsKeyFn(
      { employerAdminUuid },
      queryKey,
    ),
    queryFn: () =>
      TicketControllerService.getTicketCounts({ employerAdminUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.ticketUuids
 * @param data.createdByUuids
 * @param data.requestedByUuids
 * @param data.assignToUuids
 * @param data.employerUuids
 * @param data.priority
 * @param data.ticketType
 * @param data.status
 * @param data.excludeClosed
 * @param data.requestedStartDate
 * @param data.endDate
 * @param data.searchString
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketControllerServiceGetAllTicketsWithFilters = <
  TData = Common.TicketControllerServiceGetAllTicketsWithFiltersDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    assignToUuids,
    createdByUuids,
    employerUuids,
    endDate,
    excludeClosed,
    page,
    pageSize,
    priority,
    requestedByUuids,
    requestedStartDate,
    searchString,
    sortBy,
    sortDirection,
    status,
    ticketType,
    ticketUuids,
  }: {
    assignToUuids?: string[];
    createdByUuids?: string[];
    employerUuids?: string[];
    endDate?: string;
    excludeClosed?: boolean;
    page?: number;
    pageSize?: number;
    priority?: "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";
    requestedByUuids?: string[];
    requestedStartDate?: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    status?:
      | "PENDING"
      | "ONGOING"
      | "RESOLVED"
      | "OPEN"
      | "CLOSED"
      | "ASSIGNED"
      | "UNDER_REVIEW"
      | "IN_PROGRESS";
    ticketType?: string;
    ticketUuids?: string[];
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTicketControllerServiceGetAllTicketsWithFiltersKeyFn(
      {
        assignToUuids,
        createdByUuids,
        employerUuids,
        endDate,
        excludeClosed,
        page,
        pageSize,
        priority,
        requestedByUuids,
        requestedStartDate,
        searchString,
        sortBy,
        sortDirection,
        status,
        ticketType,
        ticketUuids,
      },
      queryKey,
    ),
    queryFn: () =>
      TicketControllerService.getAllTicketsWithFilters({
        assignToUuids,
        createdByUuids,
        employerUuids,
        endDate,
        excludeClosed,
        page,
        pageSize,
        priority,
        requestedByUuids,
        requestedStartDate,
        searchString,
        sortBy,
        sortDirection,
        status,
        ticketType,
        ticketUuids,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.search
 * @param data.employerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketControllerServiceGetAdminTicketStatus = <
  TData = Common.TicketControllerServiceGetAdminTicketStatusDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
    page,
    pageSize,
    search,
    sortBy,
    sortDirection,
  }: {
    employerUuid?: string;
    page?: number;
    pageSize?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTicketControllerServiceGetAdminTicketStatusKeyFn(
      { employerUuid, page, pageSize, search, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      TicketControllerService.getAdminTicketStatus({
        employerUuid,
        page,
        pageSize,
        search,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.taskUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketTaskControllerServiceGetTicketTaskByUuid = <
  TData = Common.TicketTaskControllerServiceGetTicketTaskByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    taskUuid,
  }: {
    taskUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTicketTaskControllerServiceGetTicketTaskByUuidKeyFn(
      { taskUuid },
      queryKey,
    ),
    queryFn: () =>
      TicketTaskControllerService.getTicketTaskByUuid({ taskUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.status
 * @param data.priority
 * @param data.assignToUuids
 * @param data.createdByUuids
 * @param data.startDate
 * @param data.endDate
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketTaskControllerServiceGetAllTasksByEmployer = <
  TData =
    Common.TicketTaskControllerServiceGetAllTasksByEmployerDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    assignToUuids,
    createdByUuids,
    employerUuid,
    endDate,
    page,
    pageSize,
    priority,
    searchString,
    sortBy,
    sortDirection,
    startDate,
    status,
  }: {
    assignToUuids?: string[];
    createdByUuids?: string[];
    employerUuid: string;
    endDate?: string;
    page?: number;
    pageSize?: number;
    priority?: "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    startDate?: string;
    status?: "OPEN" | "CLOSED";
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTicketTaskControllerServiceGetAllTasksByEmployerKeyFn(
      {
        assignToUuids,
        createdByUuids,
        employerUuid,
        endDate,
        page,
        pageSize,
        priority,
        searchString,
        sortBy,
        sortDirection,
        startDate,
        status,
      },
      queryKey,
    ),
    queryFn: () =>
      TicketTaskControllerService.getAllTasksByEmployer({
        assignToUuids,
        createdByUuids,
        employerUuid,
        endDate,
        page,
        pageSize,
        priority,
        searchString,
        sortBy,
        sortDirection,
        startDate,
        status,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.ticketUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.priority
 * @param data.assignToUuids
 * @param data.createdByUuids
 * @param data.startDate
 * @param data.endDate
 * @param data.status
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketTaskControllerServiceGetAllTasksByTicketUuid = <
  TData =
    Common.TicketTaskControllerServiceGetAllTasksByTicketUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    assignToUuids,
    createdByUuids,
    endDate,
    page,
    pageSize,
    priority,
    searchString,
    sortBy,
    sortDirection,
    startDate,
    status,
    ticketUuid,
  }: {
    assignToUuids?: string[];
    createdByUuids?: string[];
    endDate?: string;
    page?: number;
    pageSize?: number;
    priority?: "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    startDate?: string;
    status?: "OPEN" | "CLOSED";
    ticketUuid?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTicketTaskControllerServiceGetAllTasksByTicketUuidKeyFn(
      {
        assignToUuids,
        createdByUuids,
        endDate,
        page,
        pageSize,
        priority,
        searchString,
        sortBy,
        sortDirection,
        startDate,
        status,
        ticketUuid,
      },
      queryKey,
    ),
    queryFn: () =>
      TicketTaskControllerService.getAllTasksByTicketUuid({
        assignToUuids,
        createdByUuids,
        endDate,
        page,
        pageSize,
        priority,
        searchString,
        sortBy,
        sortDirection,
        startDate,
        status,
        ticketUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.notesUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketNotesControllerServiceGetTicketNotesByUuid = <
  TData =
    Common.TicketNotesControllerServiceGetTicketNotesByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    notesUuid,
  }: {
    notesUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTicketNotesControllerServiceGetTicketNotesByUuidKeyFn(
      { notesUuid },
      queryKey,
    ),
    queryFn: () =>
      TicketNotesControllerService.getTicketNotesByUuid({ notesUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.createdByUuids
 * @param data.searchString
 * @param data.startDate
 * @param data.endDate
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketNotesControllerServiceGetAllNotesByEmployer = <
  TData =
    Common.TicketNotesControllerServiceGetAllNotesByEmployerDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    createdByUuids,
    employerUuid,
    endDate,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
    startDate,
  }: {
    createdByUuids?: string[];
    employerUuid: string;
    endDate?: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    startDate?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTicketNotesControllerServiceGetAllNotesByEmployerKeyFn(
      {
        createdByUuids,
        employerUuid,
        endDate,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
        startDate,
      },
      queryKey,
    ),
    queryFn: () =>
      TicketNotesControllerService.getAllNotesByEmployer({
        createdByUuids,
        employerUuid,
        endDate,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
        startDate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.ticketUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketNotesControllerServiceGetAllTicketNotes = <
  TData = Common.TicketNotesControllerServiceGetAllTicketNotesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    sortBy,
    sortDirection,
    ticketUuid,
  }: {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
    ticketUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTicketNotesControllerServiceGetAllTicketNotesKeyFn(
      { page, pageSize, sortBy, sortDirection, ticketUuid },
      queryKey,
    ),
    queryFn: () =>
      TicketNotesControllerService.getAllTicketNotes({
        page,
        pageSize,
        sortBy,
        sortDirection,
        ticketUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.attachmentUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketAttachmentControllerServiceGetAttachmentByUuid = <
  TData =
    Common.TicketAttachmentControllerServiceGetAttachmentByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    attachmentUuid,
  }: {
    attachmentUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseTicketAttachmentControllerServiceGetAttachmentByUuidKeyFn(
        { attachmentUuid },
        queryKey,
      ),
    queryFn: () =>
      TicketAttachmentControllerService.getAttachmentByUuid({
        attachmentUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.startDate
 * @param data.endDate
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketAttachmentControllerServiceGetAllAttachmentsByEmployer = <
  TData =
    Common.TicketAttachmentControllerServiceGetAllAttachmentsByEmployerDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    employerUuid,
    endDate,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
    startDate,
  }: {
    employerUuid: string;
    endDate?: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    startDate?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseTicketAttachmentControllerServiceGetAllAttachmentsByEmployerKeyFn(
        {
          employerUuid,
          endDate,
          page,
          pageSize,
          searchString,
          sortBy,
          sortDirection,
          startDate,
        },
        queryKey,
      ),
    queryFn: () =>
      TicketAttachmentControllerService.getAllAttachmentsByEmployer({
        employerUuid,
        endDate,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
        startDate,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.ticketUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketAttachmentControllerServiceGetAllAttachmentsByTicketUuid =
  <
    TData =
      Common.TicketAttachmentControllerServiceGetAllAttachmentsByTicketUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
      ticketUuid,
    }: {
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
      ticketUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseTicketAttachmentControllerServiceGetAllAttachmentsByTicketUuidKeyFn(
          { page, pageSize, searchString, sortBy, sortDirection, ticketUuid },
          queryKey,
        ),
      queryFn: () =>
        TicketAttachmentControllerService.getAllAttachmentsByTicketUuid({
          page,
          pageSize,
          searchString,
          sortBy,
          sortDirection,
          ticketUuid,
        }) as TData,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.templateUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmTemplateControllerServiceGetTemplate = <
  TData = Common.CrmTemplateControllerServiceGetTemplateDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    templateUuid,
  }: {
    templateUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCrmTemplateControllerServiceGetTemplateKeyFn(
      { templateUuid },
      queryKey,
    ),
    queryFn: () =>
      CrmTemplateControllerService.getTemplate({ templateUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmTemplateControllerServiceGetAllTemplates = <
  TData = Common.CrmTemplateControllerServiceGetAllTemplatesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCrmTemplateControllerServiceGetAllTemplatesKeyFn(
      { page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      CrmTemplateControllerService.getAllTemplates({
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @param data.templateCategory
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmTemplateControllerServiceGetAllTemplates1 = <
  TData = Common.CrmTemplateControllerServiceGetAllTemplates1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
    templateCategory,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    templateCategory?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCrmTemplateControllerServiceGetAllTemplates1KeyFn(
      { page, pageSize, searchString, sortBy, sortDirection, templateCategory },
      queryKey,
    ),
    queryFn: () =>
      CrmTemplateControllerService.getAllTemplates1({
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
        templateCategory,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.taskUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmTaskControllerServiceGetTaskByUuid1 = <
  TData = Common.CrmTaskControllerServiceGetTaskByUuid1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    taskUuid,
  }: {
    taskUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCrmTaskControllerServiceGetTaskByUuid1KeyFn(
      { taskUuid },
      queryKey,
    ),
    queryFn: () =>
      CrmTaskControllerService.getTaskByUuid1({ taskUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.contactUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.priority
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmTaskControllerServiceGetAllTasksByContactUuid = <
  TData =
    Common.CrmTaskControllerServiceGetAllTasksByContactUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    contactUuid,
    page,
    pageSize,
    priority,
    searchString,
    sortBy,
    sortDirection,
  }: {
    contactUuid: string;
    page?: number;
    pageSize?: number;
    priority?: "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCrmTaskControllerServiceGetAllTasksByContactUuidKeyFn(
      {
        contactUuid,
        page,
        pageSize,
        priority,
        searchString,
        sortBy,
        sortDirection,
      },
      queryKey,
    ),
    queryFn: () =>
      CrmTaskControllerService.getAllTasksByContactUuid({
        contactUuid,
        page,
        pageSize,
        priority,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.priority
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmTaskControllerServiceGetAllTasks1 = <
  TData = Common.CrmTaskControllerServiceGetAllTasks1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    priority,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    priority?: "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCrmTaskControllerServiceGetAllTasks1KeyFn(
      { page, pageSize, priority, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      CrmTaskControllerService.getAllTasks1({
        page,
        pageSize,
        priority,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.taskLogUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTaskLogControllerServiceGetTaskLogByUuid = <
  TData = Common.TaskLogControllerServiceGetTaskLogByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    taskLogUuid,
  }: {
    taskLogUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTaskLogControllerServiceGetTaskLogByUuidKeyFn(
      { taskLogUuid },
      queryKey,
    ),
    queryFn: () =>
      TaskLogControllerService.getTaskLogByUuid({ taskLogUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.leadUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useTaskLogControllerServiceGetAllTaskLogs = <
  TData = Common.TaskLogControllerServiceGetAllTaskLogsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    leadUuid,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    leadUuid: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTaskLogControllerServiceGetAllTaskLogsKeyFn(
      { leadUuid, page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      TaskLogControllerService.getAllTaskLogs({
        leadUuid,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmNewsletterControllerServiceGetNewsletterByUuid = <
  TData =
    Common.CrmNewsletterControllerServiceGetNewsletterByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseCrmNewsletterControllerServiceGetNewsletterByUuidKeyFn(
        queryKey,
      ),
    queryFn: () =>
      CrmNewsletterControllerService.getNewsletterByUuid() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmNewsletterControllerServiceGetAllNewsletter = <
  TData = Common.CrmNewsletterControllerServiceGetAllNewsletterDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCrmNewsletterControllerServiceGetAllNewsletterKeyFn(
      { page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      CrmNewsletterControllerService.getAllNewsletter({
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.campaignUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmCampaignControllerServiceGetCampaignByUuid = <
  TData = Common.CrmCampaignControllerServiceGetCampaignByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    campaignUuid,
  }: {
    campaignUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCrmCampaignControllerServiceGetCampaignByUuidKeyFn(
      { campaignUuid },
      queryKey,
    ),
    queryFn: () =>
      CrmCampaignControllerService.getCampaignByUuid({ campaignUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmCampaignControllerServiceGetAllCampaign = <
  TData = Common.CrmCampaignControllerServiceGetAllCampaignDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCrmCampaignControllerServiceGetAllCampaignKeyFn(
      { page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      CrmCampaignControllerService.getAllCampaign({
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.callLogUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCallLogsControllerServiceGetCallLogByUuid = <
  TData = Common.CallLogsControllerServiceGetCallLogByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    callLogUuid,
  }: {
    callLogUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCallLogsControllerServiceGetCallLogByUuidKeyFn(
      { callLogUuid },
      queryKey,
    ),
    queryFn: () =>
      CallLogsControllerService.getCallLogByUuid({ callLogUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.leadUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useCallLogsControllerServiceGetAllCallLogs = <
  TData = Common.CallLogsControllerServiceGetAllCallLogsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    leadUuid,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    leadUuid: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseCallLogsControllerServiceGetAllCallLogsKeyFn(
      { leadUuid, page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      CallLogsControllerService.getAllCallLogs({
        leadUuid,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketMergeControllerServiceGetMergedTicket = <
  TData = Common.TicketMergeControllerServiceGetMergedTicketDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTicketMergeControllerServiceGetMergedTicketKeyFn(
      { uuid },
      queryKey,
    ),
    queryFn: () =>
      TicketMergeControllerService.getMergedTicket({ uuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketMergeControllerServiceGetAllMergedTickets = <
  TData = Common.TicketMergeControllerServiceGetAllMergedTicketsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTicketMergeControllerServiceGetAllMergedTicketsKeyFn(
      { page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      TicketMergeControllerService.getAllMergedTickets({
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.linkedUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketLinkedControllerServiceGetLinkedTicketByUuid = <
  TData =
    Common.TicketLinkedControllerServiceGetLinkedTicketByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    linkedUuid,
  }: {
    linkedUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTicketLinkedControllerServiceGetLinkedTicketByUuidKeyFn(
      { linkedUuid },
      queryKey,
    ),
    queryFn: () =>
      TicketLinkedControllerService.getLinkedTicketByUuid({
        linkedUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.mainTicketUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketLinkedControllerServiceGetAllLinkedTickets = <
  TData =
    Common.TicketLinkedControllerServiceGetAllLinkedTicketsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    mainTicketUuid,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    mainTicketUuid: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTicketLinkedControllerServiceGetAllLinkedTicketsKeyFn(
      { mainTicketUuid, page, pageSize, searchString, sortBy, sortDirection },
      queryKey,
    ),
    queryFn: () =>
      TicketLinkedControllerService.getAllLinkedTickets({
        mainTicketUuid,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.conversationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketConversationControllerServiceGetConversationByUuid = <
  TData =
    Common.TicketConversationControllerServiceGetConversationByUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    conversationUuid,
  }: {
    conversationUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseTicketConversationControllerServiceGetConversationByUuidKeyFn(
        { conversationUuid },
        queryKey,
      ),
    queryFn: () =>
      TicketConversationControllerService.getConversationByUuid({
        conversationUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.ticketUuid
 * @param data.page
 * @param data.pageSize
 * @param data.sortBy
 * @param data.sortDirection
 * @param data.searchString
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketConversationControllerServiceGetAllConversationsByTicketUuid =
  <
    TData =
      Common.TicketConversationControllerServiceGetAllConversationsByTicketUuidDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
      ticketUuid,
    }: {
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
      ticketUuid: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseTicketConversationControllerServiceGetAllConversationsByTicketUuidKeyFn(
          { page, pageSize, searchString, sortBy, sortDirection, ticketUuid },
          queryKey,
        ),
      queryFn: () =>
        TicketConversationControllerService.getAllConversationsByTicketUuid({
          page,
          pageSize,
          searchString,
          sortBy,
          sortDirection,
          ticketUuid,
        }) as TData,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceGetMessageReminderSetting = <
  TData =
    Common.MessageControllerServiceGetMessageReminderSettingDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseMessageControllerServiceGetMessageReminderSettingKeyFn(
        queryKey,
      ),
    queryFn: () =>
      MessageControllerService.getMessageReminderSetting() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceGetUnreadMessageCountByUserUuid = <
  TData =
    Common.MessageControllerServiceGetUnreadMessageCountByUserUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    userUuid,
  }: {
    userUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseMessageControllerServiceGetUnreadMessageCountByUserUuidKeyFn(
        { userUuid },
        queryKey,
      ),
    queryFn: () =>
      MessageControllerService.getUnreadMessageCountByUserUuid({
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @param data.search
 * @param data.locationUuid
 * @param data.providerUuids
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceGetMessageSummariesByUserUuid = <
  TData =
    Common.MessageControllerServiceGetMessageSummariesByUserUuidDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationUuid,
    providerUuids,
    search,
    userUuid,
  }: {
    locationUuid?: string;
    providerUuids?: string[];
    search?: string;
    userUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseMessageControllerServiceGetMessageSummariesByUserUuidKeyFn(
        { locationUuid, providerUuids, search, userUuid },
        queryKey,
      ),
    queryFn: () =>
      MessageControllerService.getMessageSummariesByUserUuid({
        locationUuid,
        providerUuids,
        search,
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.size
 * @param data.locationUuid
 * @param data.providerUuids
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceGetUrgentUnreadMessagesForUser = <
  TData =
    Common.MessageControllerServiceGetUrgentUnreadMessagesForUserDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationUuid,
    page,
    providerUuids,
    size,
  }: {
    locationUuid?: string;
    page?: number;
    providerUuids?: string[];
    size?: number;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseMessageControllerServiceGetUrgentUnreadMessagesForUserKeyFn(
        { locationUuid, page, providerUuids, size },
        queryKey,
      ),
    queryFn: () =>
      MessageControllerService.getUrgentUnreadMessagesForUser({
        locationUuid,
        page,
        providerUuids,
        size,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.locationUuid
 * @param data.providerUuids
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceGetUrgentUnreadMessageCountForUser = <
  TData =
    Common.MessageControllerServiceGetUrgentUnreadMessageCountForUserDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    locationUuid,
    providerUuids,
  }: {
    locationUuid?: string;
    providerUuids?: string[];
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseMessageControllerServiceGetUrgentUnreadMessageCountForUserKeyFn(
        { locationUuid, providerUuids },
        queryKey,
      ),
    queryFn: () =>
      MessageControllerService.getUrgentUnreadMessageCountForUser({
        locationUuid,
        providerUuids,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.size
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceGetUnreadMessagesForUser = <
  TData =
    Common.MessageControllerServiceGetUnreadMessagesForUserDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    size,
  }: {
    page?: number;
    size?: number;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseMessageControllerServiceGetUnreadMessagesForUserKeyFn(
      { page, size },
      queryKey,
    ),
    queryFn: () =>
      MessageControllerService.getUnreadMessagesForUser({
        page,
        size,
      }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceGetUnreadMessageCountForUser = <
  TData =
    Common.MessageControllerServiceGetUnreadMessageCountForUserDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseMessageControllerServiceGetUnreadMessageCountForUserKeyFn(
        queryKey,
      ),
    queryFn: () =>
      MessageControllerService.getUnreadMessageCountForUser() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.page
 * @param data.size
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceGetReminderMessagesForUser = <
  TData =
    Common.MessageControllerServiceGetReminderMessagesForUserDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    size,
  }: {
    page?: number;
    size?: number;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseMessageControllerServiceGetReminderMessagesForUserKeyFn(
      { page, size },
      queryKey,
    ),
    queryFn: () =>
      MessageControllerService.getReminderMessagesForUser({
        page,
        size,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.threadUuid
 * @param data.page
 * @param data.size
 * @param data.filter
 * @param data.search
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceListMessages = <
  TData = Common.MessageControllerServiceListMessagesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    filter,
    page,
    search,
    size,
    threadUuid,
  }: {
    filter?: "TEXT" | "IMAGE" | "FILE" | "SYSTEM";
    page?: number;
    search?: string;
    size?: number;
    threadUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseMessageControllerServiceListMessagesKeyFn(
      { filter, page, search, size, threadUuid },
      queryKey,
    ),
    queryFn: () =>
      MessageControllerService.listMessages({
        filter,
        page,
        search,
        size,
        threadUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.threadUuid
 * @param data.page
 * @param data.size
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceGetScheduledMessages = <
  TData = Common.MessageControllerServiceGetScheduledMessagesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    size,
    threadUuid,
  }: {
    page?: number;
    size?: number;
    threadUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseMessageControllerServiceGetScheduledMessagesKeyFn(
      { page, size, threadUuid },
      queryKey,
    ),
    queryFn: () =>
      MessageControllerService.getScheduledMessages({
        page,
        size,
        threadUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.threadUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceCountUnread = <
  TData = Common.MessageControllerServiceCountUnreadDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    threadUuid,
  }: {
    threadUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseMessageControllerServiceCountUnreadKeyFn(
      { threadUuid },
      queryKey,
    ),
    queryFn: () =>
      MessageControllerService.countUnread({ threadUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.threadUuid
 * @param data.userUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceCountUnreadForUser = <
  TData = Common.MessageControllerServiceCountUnreadForUserDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    threadUuid,
    userUuid,
  }: {
    threadUuid: string;
    userUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseMessageControllerServiceCountUnreadForUserKeyFn(
      { threadUuid, userUuid },
      queryKey,
    ),
    queryFn: () =>
      MessageControllerService.countUnreadForUser({
        threadUuid,
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * Search messages
 * Search messages by content, including attachments
 * @param data The data for the request.
 * @param data.query Search query for message content
 * @param data.includeAttachments Include attachments in search
 * @param data.threadUuid Thread UUID to search within (optional)
 * @param data.page Page number (0-based)
 * @param data.size Page size
 * @returns Response Messages found successfully
 * @throws ApiError
 */
export const useMessageControllerServiceSearchMessages = <
  TData = Common.MessageControllerServiceSearchMessagesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    includeAttachments,
    page,
    query,
    size,
    threadUuid,
  }: {
    includeAttachments?: boolean;
    page?: number;
    query: string;
    size?: number;
    threadUuid?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseMessageControllerServiceSearchMessagesKeyFn(
      { includeAttachments, page, query, size, threadUuid },
      queryKey,
    ),
    queryFn: () =>
      MessageControllerService.searchMessages({
        includeAttachments,
        page,
        query,
        size,
        threadUuid,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.search
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceGetPatientDependentsMessageSummary = <
  TData =
    Common.MessageControllerServiceGetPatientDependentsMessageSummaryDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    patientUuid,
    search,
  }: {
    patientUuid: string;
    search?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseMessageControllerServiceGetPatientDependentsMessageSummaryKeyFn(
        { patientUuid, search },
        queryKey,
      ),
    queryFn: () =>
      MessageControllerService.getPatientDependentsMessageSummary({
        patientUuid,
        search,
      }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.callUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useVideoCallControllerServiceGetCall = <
  TData = Common.VideoCallControllerServiceGetCallDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    callUuid,
  }: {
    callUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseVideoCallControllerServiceGetCallKeyFn(
      { callUuid },
      queryKey,
    ),
    queryFn: () => VideoCallControllerService.getCall({ callUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.direction
 * @param data.fromUserUuid
 * @param data.toUserUuid
 * @param data.patientUuid
 * @param data.providerUuid
 * @param data.phoneNumber
 * @param data.from
 * @param data.to
 * @param data.page
 * @param data.size
 * @returns Response OK
 * @throws ApiError
 */
export const useTwilioVoiceControllerServiceCallLog = <
  TData = Common.TwilioVoiceControllerServiceCallLogDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    direction,
    from,
    fromUserUuid,
    page,
    patientUuid,
    phoneNumber,
    providerUuid,
    size,
    to,
    toUserUuid,
  }: {
    direction?: "UNKNOWN" | "INBOUND" | "OUTBOUND";
    from?: string;
    fromUserUuid?: string;
    page?: number;
    patientUuid?: string;
    phoneNumber?: string;
    providerUuid?: string;
    size?: number;
    to?: string;
    toUserUuid?: string;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTwilioVoiceControllerServiceCallLogKeyFn(
      {
        direction,
        from,
        fromUserUuid,
        page,
        patientUuid,
        phoneNumber,
        providerUuid,
        size,
        to,
        toUserUuid,
      },
      queryKey,
    ),
    queryFn: () =>
      TwilioVoiceControllerService.callLog({
        direction,
        from,
        fromUserUuid,
        page,
        patientUuid,
        phoneNumber,
        providerUuid,
        size,
        to,
        toUserUuid,
      }) as TData,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useTwilioVoiceControllerServiceStatus = <
  TData = Common.TwilioVoiceControllerServiceStatusDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTwilioVoiceControllerServiceStatusKeyFn(queryKey),
    queryFn: () => TwilioVoiceControllerService.status() as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.callUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTwilioVoiceControllerServiceGetCall1 = <
  TData = Common.TwilioVoiceControllerServiceGetCall1DefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    callUuid,
  }: {
    callUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTwilioVoiceControllerServiceGetCall1KeyFn(
      { callUuid },
      queryKey,
    ),
    queryFn: () => TwilioVoiceControllerService.getCall1({ callUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.callUuid
 * @returns binary OK
 * @throws ApiError
 */
export const useTwilioVoiceControllerServiceReadTranscript = <
  TData = Common.TwilioVoiceControllerServiceReadTranscriptDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    callUuid,
  }: {
    callUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTwilioVoiceControllerServiceReadTranscriptKeyFn(
      { callUuid },
      queryKey,
    ),
    queryFn: () =>
      TwilioVoiceControllerService.readTranscript({ callUuid }) as TData,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.callUuid
 * @param data.range
 * @returns binary OK
 * @throws ApiError
 */
export const useTwilioVoiceControllerServicePlayRecording = <
  TData = Common.TwilioVoiceControllerServicePlayRecordingDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    callUuid,
    range,
  }: {
    callUuid: string;
    range?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTwilioVoiceControllerServicePlayRecordingKeyFn(
      { callUuid, range },
      queryKey,
    ),
    queryFn: () =>
      TwilioVoiceControllerService.playRecording({ callUuid, range }) as TData,
    ...options,
  });
/**
 * Generate Twilio access token
 * Generates a new access token for Twilio Conversations
 * @returns Response Token generated successfully
 * @throws ApiError
 */
export const useTwilioControllerServiceGenerateAccessToken = <
  TData = Common.TwilioControllerServiceGenerateAccessTokenDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseTwilioControllerServiceGenerateAccessTokenKeyFn(queryKey),
    queryFn: () => TwilioControllerService.generateAccessToken() as TData,
    ...options,
  });
/**
 * Get Twilio service status
 * Returns the current status and configuration information of the Twilio service
 * @returns Response Service status retrieved successfully
 * @throws ApiError
 */
export const useTwilioControllerServiceGetServiceStatus = <
  TData = Common.TwilioControllerServiceGetServiceStatusDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTwilioControllerServiceGetServiceStatusKeyFn(queryKey),
    queryFn: () => TwilioControllerService.getServiceStatus() as TData,
    ...options,
  });
/**
 * Check Twilio connection health
 * Tests the connection to Twilio API and validates credentials
 * @returns string Twilio connection is healthy
 * @throws ApiError
 */
export const useTwilioControllerServiceCheckHealth = <
  TData = Common.TwilioControllerServiceCheckHealthDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseTwilioControllerServiceCheckHealthKeyFn(queryKey),
    queryFn: () => TwilioControllerService.checkHealth() as TData,
    ...options,
  });
/**
 * Get thread by ID
 * Retrieves a specific thread by its UUID
 * @param data The data for the request.
 * @param data.threadUuid Thread UUID
 * @returns Response Thread retrieved successfully
 * @throws ApiError
 */
export const useThreadControllerServiceGetThreadById = <
  TData = Common.ThreadControllerServiceGetThreadByIdDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    threadUuid,
  }: {
    threadUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseThreadControllerServiceGetThreadByIdKeyFn(
      { threadUuid },
      queryKey,
    ),
    queryFn: () =>
      ThreadControllerService.getThreadById({ threadUuid }) as TData,
    ...options,
  });
/**
 * Get users who have a thread open
 * Retrieves the uuid and username of every user whose open flag is true for the thread
 * @param data The data for the request.
 * @param data.threadUuid Thread UUID
 * @returns Response Open thread users retrieved successfully
 * @throws ApiError
 */
export const useThreadControllerServiceGetOpenThreadUsers = <
  TData = Common.ThreadControllerServiceGetOpenThreadUsersDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    threadUuid,
  }: {
    threadUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseThreadControllerServiceGetOpenThreadUsersKeyFn(
      { threadUuid },
      queryKey,
    ),
    queryFn: () =>
      ThreadControllerService.getOpenThreadUsers({ threadUuid }) as TData,
    ...options,
  });
/**
 * Search threads
 * Search threads by subject and categories
 * @param data The data for the request.
 * @param data.subject Search query for thread subject
 * @param data.categories Categories to filter by
 * @param data.patientUuid Patient UUID to filter by (optional)
 * @param data.urgentOnly Include urgent threads only
 * @param data.page Page number (0-based)
 * @param data.size Page size
 * @returns Response Threads found successfully
 * @throws ApiError
 */
export const useThreadControllerServiceSearchThreads = <
  TData = Common.ThreadControllerServiceSearchThreadsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    categories,
    page,
    patientUuid,
    size,
    subject,
    urgentOnly,
  }: {
    categories?: string[];
    page?: number;
    patientUuid?: string;
    size?: number;
    subject?: string;
    urgentOnly?: boolean;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseThreadControllerServiceSearchThreadsKeyFn(
      { categories, page, patientUuid, size, subject, urgentOnly },
      queryKey,
    ),
    queryFn: () =>
      ThreadControllerService.searchThreads({
        categories,
        page,
        patientUuid,
        size,
        subject,
        urgentOnly,
      }) as TData,
    ...options,
  });
/**
 * Get threads by patient
 * Retrieves all threads for a specific patient
 * @param data The data for the request.
 * @param data.patientUuid Patient UUID
 * @param data.page Page number (0-based)
 * @param data.size Page size
 * @returns Response Threads retrieved successfully
 * @throws ApiError
 */
export const useThreadControllerServiceGetThreadsByPatient = <
  TData = Common.ThreadControllerServiceGetThreadsByPatientDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    patientUuid,
    size,
  }: {
    page?: number;
    patientUuid: string;
    size?: number;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseThreadControllerServiceGetThreadsByPatientKeyFn(
      { page, patientUuid, size },
      queryKey,
    ),
    queryFn: () =>
      ThreadControllerService.getThreadsByPatient({
        page,
        patientUuid,
        size,
      }) as TData,
    ...options,
  });
/**
 * Get optimized threads list for patient
 * Retrieves threads list with filters, unread counts, and last message info
 * @param data The data for the request.
 * @param data.patientUuid Patient UUID
 * @param data.filter Filter: ALL, INBOX, SENT, RESOLVED, URGENT
 * @param data.search Search by subject name
 * @param data.excludeResolved Exclude resolved threads from results
 * @param data.userUuid Only threads where both the patient and this user are participants
 * @param data.page Page number (0-based)
 * @param data.size Page size
 * @returns Response Threads list retrieved successfully
 * @throws ApiError
 */
export const useThreadControllerServiceGetThreadsList = <
  TData = Common.ThreadControllerServiceGetThreadsListDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    excludeResolved,
    filter,
    page,
    patientUuid,
    search,
    size,
    userUuid,
  }: {
    excludeResolved?: boolean;
    filter?: string;
    page?: number;
    patientUuid: string;
    search?: string;
    size?: number;
    userUuid?: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseThreadControllerServiceGetThreadsListKeyFn(
      { excludeResolved, filter, page, patientUuid, search, size, userUuid },
      queryKey,
    ),
    queryFn: () =>
      ThreadControllerService.getThreadsList({
        excludeResolved,
        filter,
        page,
        patientUuid,
        search,
        size,
        userUuid,
      }) as TData,
    ...options,
  });
/**
 * Get threads for current user
 * Retrieves all threads where the current user is a participant
 * @param data The data for the request.
 * @param data.page Page number (0-based)
 * @param data.size Page size
 * @param data.providerUuids
 * @returns Response Threads retrieved successfully
 * @throws ApiError
 */
export const useThreadControllerServiceGetMyThreads = <
  TData = Common.ThreadControllerServiceGetMyThreadsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    providerUuids,
    size,
  }: {
    page?: number;
    providerUuids?: string[];
    size?: number;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseThreadControllerServiceGetMyThreadsKeyFn(
      { page, providerUuids, size },
      queryKey,
    ),
    queryFn: () =>
      ThreadControllerService.getMyThreads({
        page,
        providerUuids,
        size,
      }) as TData,
    ...options,
  });
/**
 * Get thread categories
 * Retrieves list of available thread categories
 * @returns Response Categories retrieved successfully
 * @throws ApiError
 */
export const useThreadControllerServiceGetThreadCategories = <
  TData = Common.ThreadControllerServiceGetThreadCategoriesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseThreadControllerServiceGetThreadCategoriesKeyFn(queryKey),
    queryFn: () => ThreadControllerService.getThreadCategories() as TData,
    ...options,
  });
/**
 * Get bookmarked threads
 * Retrieves paginated list of user's bookmarked threads. For non-patient users, patientUuid is required.
 * @param data The data for the request.
 * @param data.page Page number (0-based)
 * @param data.size Page size
 * @param data.patientUuid Patient UUID (required for non-patient users)
 * @returns Response Bookmarked threads retrieved successfully
 * @throws ApiError
 */
export const useBookmarkControllerServiceGetBookmarkedThreads = <
  TData = Common.BookmarkControllerServiceGetBookmarkedThreadsDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    patientUuid,
    size,
  }: {
    page?: number;
    patientUuid?: string;
    size?: number;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseBookmarkControllerServiceGetBookmarkedThreadsKeyFn(
      { page, patientUuid, size },
      queryKey,
    ),
    queryFn: () =>
      BookmarkControllerService.getBookmarkedThreads({
        page,
        patientUuid,
        size,
      }) as TData,
    ...options,
  });
/**
 * Get bookmarked messages
 * Retrieves paginated list of user's bookmarked messages grouped by category and date. For non-patient users, patientUuid is required.
 * @param data The data for the request.
 * @param data.page Page number (0-based)
 * @param data.size Page size
 * @param data.patientUuid Patient UUID (required for non-patient users)
 * @returns Response Bookmarked messages retrieved successfully
 * @throws ApiError
 */
export const useBookmarkControllerServiceGetBookmarkedMessages = <
  TData = Common.BookmarkControllerServiceGetBookmarkedMessagesDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    patientUuid,
    size,
  }: {
    page?: number;
    patientUuid?: string;
    size?: number;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey: Common.UseBookmarkControllerServiceGetBookmarkedMessagesKeyFn(
      { page, patientUuid, size },
      queryKey,
    ),
    queryFn: () =>
      BookmarkControllerService.getBookmarkedMessages({
        page,
        patientUuid,
        size,
      }) as TData,
    ...options,
  });
/**
 * Get message position in thread
 * Returns the position (1-based index) of a message within a thread, ordered by creation time (newest first)
 * @param data The data for the request.
 * @param data.messageUuid Message UUID
 * @param data.threadUuid Thread UUID
 * @returns Response Message position retrieved successfully
 * @throws ApiError
 */
export const useBookmarkControllerServiceGetMessagePositionInThread = <
  TData =
    Common.BookmarkControllerServiceGetMessagePositionInThreadDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    messageUuid,
    threadUuid,
  }: {
    messageUuid: string;
    threadUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseBookmarkControllerServiceGetMessagePositionInThreadKeyFn(
        { messageUuid, threadUuid },
        queryKey,
      ),
    queryFn: () =>
      BookmarkControllerService.getMessagePositionInThread({
        messageUuid,
        threadUuid,
      }) as TData,
    ...options,
  });
/**
 * Get bookmarked messages by thread
 * Retrieves paginated list of user's bookmarked messages for a specific thread. For non-patient users, patientUuid is required.
 * @param data The data for the request.
 * @param data.threadUuid Thread UUID
 * @param data.page Page number (0-based)
 * @param data.size Page size
 * @param data.patientUuid Patient UUID (required for non-patient users)
 * @returns Response Bookmarked messages retrieved successfully
 * @throws ApiError
 */
export const useBookmarkControllerServiceGetBookmarkedMessagesByThread = <
  TData =
    Common.BookmarkControllerServiceGetBookmarkedMessagesByThreadDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    page,
    patientUuid,
    size,
    threadUuid,
  }: {
    page?: number;
    patientUuid?: string;
    size?: number;
    threadUuid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseBookmarkControllerServiceGetBookmarkedMessagesByThreadKeyFn(
        { page, patientUuid, size, threadUuid },
        queryKey,
      ),
    queryFn: () =>
      BookmarkControllerService.getBookmarkedMessagesByThread({
        page,
        patientUuid,
        size,
        threadUuid,
      }) as TData,
    ...options,
  });
/**
 * Add Staff User
 * Add a new Staff User into the system
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceAddUser = <
  TData = Common.UserControllerServiceAddUserMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: User;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: User;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      UserControllerService.addUser({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns string OK
 * @throws ApiError
 */
export const useUserControllerServiceHandleStripeWebhook = <
  TData = Common.UserControllerServiceHandleStripeWebhookMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    "mutationFn"
  >,
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      UserControllerService.handleStripeWebhook() as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.roleType
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceRegisterUsersOnKeycloak = <
  TData = Common.UserControllerServiceRegisterUsersOnKeycloakMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        roleType?:
          | "ADMIN"
          | "USER"
          | "EHR"
          | "EMPLOYER"
          | "PATIENT"
          | "AGENT"
          | "AFFILIATE"
          | "BROKER"
          | "CLINIC_USER";
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      roleType?:
        | "ADMIN"
        | "USER"
        | "EHR"
        | "EMPLOYER"
        | "PATIENT"
        | "AGENT"
        | "AFFILIATE"
        | "BROKER"
        | "CLINIC_USER";
    },
    TContext
  >({
    mutationFn: ({ roleType }) =>
      UserControllerService.registerUsersOnKeycloak({
        roleType,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userEmails
 * @param data.appointmentUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceSendInvite = <
  TData = Common.UserControllerServiceSendInviteMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        appointmentUuid: string;
        userEmails: string[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      appointmentUuid: string;
      userEmails: string[];
    },
    TContext
  >({
    mutationFn: ({ appointmentUuid, userEmails }) =>
      UserControllerService.sendInvite({
        appointmentUuid,
        userEmails,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceRegisterUserWithUuid = <
  TData = Common.UserControllerServiceRegisterUserWithUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: RegisterUserRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: RegisterUserRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      UserControllerService.registerUserWithUuid({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployeeUploadControllerServiceUploadFile = <
  TData = Common.EmployeeUploadControllerServiceUploadFileMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        employerUuid: string;
        requestBody?: { file: Blob | File };
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      employerUuid: string;
      requestBody?: { file: Blob | File };
    },
    TContext
  >({
    mutationFn: ({ employerUuid, requestBody }) =>
      EmployeeUploadControllerService.uploadFile({
        employerUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceCreatePromotionalCoupon = <
  TData = Common.StripeControllerServiceCreatePromotionalCouponMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PromotionalCodeDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PromotionalCodeDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripeControllerService.createPromotionalCoupon({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns string OK
 * @throws ApiError
 */
export const useStripeControllerServiceHandleStripeWebhook1 = <
  TData = Common.StripeControllerServiceHandleStripeWebhook1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    "mutationFn"
  >,
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      StripeControllerService.handleStripeWebhook1() as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceCreateSubscription = <
  TData = Common.StripeControllerServiceCreateSubscriptionMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: StripeSubscriptionRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: StripeSubscriptionRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripeControllerService.createSubscription({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceCreateSubscriptionWithPayment = <
  TData =
    Common.StripeControllerServiceCreateSubscriptionWithPaymentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: StripeSubscriptionRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: StripeSubscriptionRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripeControllerService.createSubscriptionWithPayment({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceCompleteSubscription = <
  TData = Common.StripeControllerServiceCompleteSubscriptionMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CompleteSubscriptionRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CompleteSubscriptionRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripeControllerService.completeSubscription({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.customerId
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceCreateSetupIntent = <
  TData = Common.StripeControllerServiceCreateSetupIntentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        customerId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      customerId: string;
    },
    TContext
  >({
    mutationFn: ({ customerId }) =>
      StripeControllerService.createSetupIntent({
        customerId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceCreateSetupIntentWithCustomer = <
  TData =
    Common.StripeControllerServiceCreateSetupIntentWithCustomerMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: StripeCustomerRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: StripeCustomerRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripeControllerService.createSetupIntentWithCustomer({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.customerId
 * @param data.paymentMethodId
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceSetDefaultPaymentMethod = <
  TData = Common.StripeControllerServiceSetDefaultPaymentMethodMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        customerId: string;
        paymentMethodId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      customerId: string;
      paymentMethodId: string;
    },
    TContext
  >({
    mutationFn: ({ customerId, paymentMethodId }) =>
      StripeControllerService.setDefaultPaymentMethod({
        customerId,
        paymentMethodId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceSaveCardToCustomerWithCharging = <
  TData =
    Common.StripeControllerServiceSaveCardToCustomerWithChargingMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: SaveCardRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: SaveCardRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripeControllerService.saveCardToCustomerWithCharging({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceSaveCardToCustomer = <
  TData = Common.StripeControllerServiceSaveCardToCustomerMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: SaveCardRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: SaveCardRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripeControllerService.saveCardToCustomer({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceRefundAmount = <
  TData = Common.StripeControllerServiceRefundAmountMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: StripeRefundRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: StripeRefundRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripeControllerService.refundAmount({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceCreateProduct = <
  TData = Common.StripeControllerServiceCreateProductMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CreateProductRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CreateProductRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripeControllerService.createProduct({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.productId
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceCreatePriceForProduct = <
  TData = Common.StripeControllerServiceCreatePriceForProductMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        productId: string;
        requestBody: CreateProductPriceRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      productId: string;
      requestBody: CreateProductPriceRequest;
    },
    TContext
  >({
    mutationFn: ({ productId, requestBody }) =>
      StripeControllerService.createPriceForProduct({
        productId,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceCreateProductAndPrice = <
  TData = Common.StripeControllerServiceCreateProductAndPriceMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CreateProductPriceRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CreateProductPriceRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripeControllerService.createProductAndPrice({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceCreateFlexiblePayment = <
  TData = Common.StripeControllerServiceCreateFlexiblePaymentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: FlexiblePaymentRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: FlexiblePaymentRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripeControllerService.createFlexiblePayment({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceCreatePaymentIntentWithProductPrice = <
  TData =
    Common.StripeControllerServiceCreatePaymentIntentWithProductPriceMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: StripeProductPaymentRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: StripeProductPaymentRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripeControllerService.createPaymentIntentWithProductPrice({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceCreatePaymentIntent = <
  TData = Common.StripeControllerServiceCreatePaymentIntentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: StripePaymentRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: StripePaymentRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripeControllerService.createPaymentIntent({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceCreateCustomer = <
  TData = Common.StripeControllerServiceCreateCustomerMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: StripeCustomerRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: StripeCustomerRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripeControllerService.createCustomer({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceCreateCoupon1 = <
  TData = Common.StripeControllerServiceCreateCoupon1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CreateCouponDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CreateCouponDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripeControllerService.createCoupon1({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceAddSaveCardToCustomer = <
  TData = Common.StripeControllerServiceAddSaveCardToCustomerMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: SaveCardRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: SaveCardRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripeControllerService.addSaveCardToCustomer({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.sessionToken
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceCreateScriptSurePatient = <
  TData =
    Common.ScriptSureControllerServiceCreateScriptSurePatientMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ScriptSurePatientDto;
        sessionToken?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ScriptSurePatientDto;
      sessionToken?: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, sessionToken }) =>
      ScriptSureControllerService.createScriptSurePatient({
        requestBody,
        sessionToken,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.apiKeyHash
 * @param data.email
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceVendorLogin = <
  TData = Common.ScriptSureControllerServiceVendorLoginMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        apiKeyHash: string;
        email: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      apiKeyHash: string;
      email: string;
    },
    TContext
  >({
    mutationFn: ({ apiKeyHash, email }) =>
      ScriptSureControllerService.vendorLogin({
        apiKeyHash,
        email,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.providerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceRegisterProviderToScriptSure = <
  TData =
    Common.ScriptSureControllerServiceRegisterProviderToScriptSureMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        providerUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      providerUuid: string;
    },
    TContext
  >({
    mutationFn: ({ providerUuid }) =>
      ScriptSureControllerService.registerProviderToScriptSure({
        providerUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.nurseStaffUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceRegisterNurseStaffToScriptSure = <
  TData =
    Common.ScriptSureControllerServiceRegisterNurseStaffToScriptSureMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        nurseStaffUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      nurseStaffUuid: string;
    },
    TContext
  >({
    mutationFn: ({ nurseStaffUuid }) =>
      ScriptSureControllerService.registerNurseStaffToScriptSure({
        nurseStaffUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.locationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceRegisterLocationToScriptSure = <
  TData =
    Common.ScriptSureControllerServiceRegisterLocationToScriptSureMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        locationUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      locationUuid: string;
    },
    TContext
  >({
    mutationFn: ({ locationUuid }) =>
      ScriptSureControllerService.registerLocationToScriptSure({
        locationUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceSaveMedicationPrescription = <
  TData =
    Common.ScriptSureControllerServiceSaveMedicationPrescriptionMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: MedicationRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: MedicationRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ScriptSureControllerService.saveMedicationPrescription({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.xScriptSureForwarded
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceGetPatientMedications = <
  TData = Common.ScriptSureControllerServiceGetPatientMedicationsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ScriptSureMedicationPrescriptionDto;
        xScriptSureForwarded?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ScriptSureMedicationPrescriptionDto;
      xScriptSureForwarded?: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, xScriptSureForwarded }) =>
      ScriptSureControllerService.getPatientMedications({
        requestBody,
        xScriptSureForwarded,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.xScriptSureForwarded
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceGetPatientPharmacy = <
  TData = Common.ScriptSureControllerServiceGetPatientPharmacyMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ScriptSurePharmacyDto;
        xScriptSureForwarded?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ScriptSurePharmacyDto;
      xScriptSureForwarded?: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, xScriptSureForwarded }) =>
      ScriptSureControllerService.getPatientPharmacy({
        requestBody,
        xScriptSureForwarded,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceSaveAllergy = <
  TData = Common.ScriptSureControllerServiceSaveAllergyMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        requestBody: AllergyDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      requestBody: AllergyDto;
    },
    TContext
  >({
    mutationFn: ({ patientUuid, requestBody }) =>
      ScriptSureControllerService.saveAllergy({
        patientUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceSaveNoKnownAllergy = <
  TData = Common.ScriptSureControllerServiceSaveNoKnownAllergyMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        requestBody: AllergyDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      requestBody: AllergyDto;
    },
    TContext
  >({
    mutationFn: ({ patientUuid, requestBody }) =>
      ScriptSureControllerService.saveNoKnownAllergy({
        patientUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.xScriptSureForwarded
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceGetPatientAllergies = <
  TData = Common.ScriptSureControllerServiceGetPatientAllergiesMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ScriptSureAllergyDto;
        xScriptSureForwarded?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ScriptSureAllergyDto;
      xScriptSureForwarded?: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, xScriptSureForwarded }) =>
      ScriptSureControllerService.getPatientAllergies({
        requestBody,
        xScriptSureForwarded,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.customerId
 * @param data.savedCardUuid
 * @returns unknown OK
 * @throws ApiError
 */
export const useSavedCardControllerServiceSetDefaultSavedCardByUuid = <
  TData =
    Common.SavedCardControllerServiceSetDefaultSavedCardByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        customerId: string;
        savedCardUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      customerId: string;
      savedCardUuid: string;
    },
    TContext
  >({
    mutationFn: ({ customerId, savedCardUuid }) =>
      SavedCardControllerService.setDefaultSavedCardByUuid({
        customerId,
        savedCardUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.customerId
 * @param data.savedBankAccountUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useSavedBankControllerServiceSetDefaultSavedBankByUuid = <
  TData =
    Common.SavedBankControllerServiceSetDefaultSavedBankByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        customerId: string;
        savedBankAccountUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      customerId: string;
      savedBankAccountUuid: string;
    },
    TContext
  >({
    mutationFn: ({ customerId, savedBankAccountUuid }) =>
      SavedBankControllerService.setDefaultSavedBankByUuid({
        customerId,
        savedBankAccountUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.customerId
 * @returns Response OK
 * @throws ApiError
 */
export const useSavedBankControllerServiceCreateSetupIntent1 = <
  TData = Common.SavedBankControllerServiceCreateSetupIntent1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        customerId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      customerId: string;
    },
    TContext
  >({
    mutationFn: ({ customerId }) =>
      SavedBankControllerService.createSetupIntent1({
        customerId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.setupIntentId
 * @param data.uuid
 * @param data.userTypes
 * @param data.label
 * @param data.isDefault
 * @param data.customerId
 * @param data.autopay
 * @returns Response OK
 * @throws ApiError
 */
export const useSavedBankControllerServiceConfirmBankAccount = <
  TData = Common.SavedBankControllerServiceConfirmBankAccountMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        autopay?: boolean;
        customerId?: string;
        isDefault?: boolean;
        label?: string;
        setupIntentId?: string;
        userTypes?:
          | "EMPLOYER"
          | "PATIENT"
          | "BROKER"
          | "ADMIN_USER"
          | "PROVIDER"
          | "EMPLOYER_ADMINISTRATION"
          | "EMPLOYEE"
          | "PHP_USER"
          | "AFFILIATE_FIRM"
          | "BROKER_FIRM"
          | "NURSE_USER";
        uuid?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      autopay?: boolean;
      customerId?: string;
      isDefault?: boolean;
      label?: string;
      setupIntentId?: string;
      userTypes?:
        | "EMPLOYER"
        | "PATIENT"
        | "BROKER"
        | "ADMIN_USER"
        | "PROVIDER"
        | "EMPLOYER_ADMINISTRATION"
        | "EMPLOYEE"
        | "PHP_USER"
        | "AFFILIATE_FIRM"
        | "BROKER_FIRM"
        | "NURSE_USER";
      uuid?: string;
    },
    TContext
  >({
    mutationFn: ({
      autopay,
      customerId,
      isDefault,
      label,
      setupIntentId,
      userTypes,
      uuid,
    }) =>
      SavedBankControllerService.confirmBankAccount({
        autopay,
        customerId,
        isDefault,
        label,
        setupIntentId,
        userTypes,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.customerId
 * @returns Response1 OK
 * @throws ApiError
 */
export const useSavedBankControllerServiceCreateSetupIntent11 = <
  TData = Common.SavedBankControllerServiceCreateSetupIntent11MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        customerId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      customerId: string;
    },
    TContext
  >({
    mutationFn: ({ customerId }) =>
      SavedBankControllerService.createSetupIntent11({
        customerId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.setupIntentId
 * @returns Response1 OK
 * @throws ApiError
 */
export const useSavedBankControllerServiceConfirmBankAccount1 = <
  TData = Common.SavedBankControllerServiceConfirmBankAccount1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        setupIntentId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      setupIntentId: string;
    },
    TContext
  >({
    mutationFn: ({ setupIntentId }) =>
      SavedBankControllerService.confirmBankAccount1({
        setupIntentId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useSalesTaxProfileControllerServiceSaveSalesTaxProfile = <
  TData =
    Common.SalesTaxProfileControllerServiceSaveSalesTaxProfileMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: SalesTaxProfileRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: SalesTaxProfileRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      SalesTaxProfileControllerService.saveSalesTaxProfile({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useSalesTaxJurisdictionControllerServiceSaveSalesTaxJurisdiction =
  <
    TData =
      Common.SalesTaxJurisdictionControllerServiceSaveSalesTaxJurisdictionMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: SalesTaxJurisdictionRequest;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: SalesTaxJurisdictionRequest;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        SalesTaxJurisdictionControllerService.saveSalesTaxJurisdiction({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useRolesAndPermissionControllerServiceCreateRole = <
  TData = Common.RolesAndPermissionControllerServiceCreateRoleMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: RoleRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: RoleRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      RolesAndPermissionControllerService.createRole({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useRoleTypeManagementControllerServiceCreateRoleType = <
  TData =
    Common.RoleTypeManagementControllerServiceCreateRoleTypeMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: RoleTypeRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: RoleTypeRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      RoleTypeManagementControllerService.createRoleType({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useRoleTypeFeatureManagementControllerServiceCreateRoleTypeFeature =
  <
    TData =
      Common.RoleTypeFeatureManagementControllerServiceCreateRoleTypeFeatureMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: RoleTypeFeatureRequest;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: RoleTypeFeatureRequest;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        RoleTypeFeatureManagementControllerService.createRoleTypeFeature({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderControllerServiceAddProvider = <
  TData = Common.ProviderControllerServiceAddProviderMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ProviderRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ProviderRequestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ProviderControllerService.addProvider({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePlanControllerServiceCreatePlan = <
  TData = Common.PlanControllerServiceCreatePlanMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PlanDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PlanDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PlanControllerService.createPlan({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePaymentTransactionControllerServiceCreatePaymentTransaction = <
  TData =
    Common.PaymentTransactionControllerServiceCreatePaymentTransactionMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PaymentTransactionRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PaymentTransactionRequestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PaymentTransactionControllerService.createPaymentTransaction({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceAddPatient = <
  TData = Common.PatientControllerServiceAddPatientMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PatientRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PatientRequestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PatientControllerService.addPatient({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.providerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceMarkPatientViewed = <
  TData = Common.PatientControllerServiceMarkPatientViewedMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        providerUuid?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      providerUuid?: string;
    },
    TContext
  >({
    mutationFn: ({ patientUuid, providerUuid }) =>
      PatientControllerService.markPatientViewed({
        patientUuid,
        providerUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceSyncPatientWithScriptSure = <
  TData =
    Common.PatientControllerServiceSyncPatientWithScriptSureMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
    },
    TContext
  >({
    mutationFn: ({ patientUuid }) =>
      PatientControllerService.syncPatientWithScriptSure({
        patientUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceSendNotificationMailForBasicPaymentDetails =
  <
    TData =
      Common.PatientControllerServiceSendNotificationMailForBasicPaymentDetailsMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          patientUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        patientUuid: string;
      },
      TContext
    >({
      mutationFn: ({ patientUuid }) =>
        PatientControllerService.sendNotificationMailForBasicPaymentDetails({
          patientUuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns string OK
 * @throws ApiError
 */
export const usePatientControllerServiceGeneratePatientChartPdf = <
  TData = Common.PatientControllerServiceGeneratePatientChartPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PatientChartItemsDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PatientChartItemsDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PatientControllerService.generatePatientChartPdf({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceUpdateEngagedPatientEmployerMembershipInvoice =
  <
    TData =
      Common.PatientControllerServiceUpdateEngagedPatientEmployerMembershipInvoiceMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          employerUuid: string;
          patientUuid?: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        employerUuid: string;
        patientUuid?: string;
      },
      TContext
    >({
      mutationFn: ({ employerUuid, patientUuid }) =>
        PatientControllerService.updateEngagedPatientEmployerMembershipInvoice({
          employerUuid,
          patientUuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceCheckPatientCredentials = <
  TData = Common.PatientControllerServiceCheckPatientCredentialsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PatientDetailsRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PatientDetailsRequestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PatientControllerService.checkPatientCredentials({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceCancelPlanChange = <
  TData = Common.PatientControllerServiceCancelPlanChangeMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CancelPlanChangeDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CancelPlanChangeDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PatientControllerService.cancelPlanChange({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceEvictPatientCaches = <
  TData = Common.PatientControllerServiceEvictPatientCachesMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    "mutationFn"
  >,
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      PatientControllerService.evictPatientCaches() as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.brokerFirmUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceUpdateEngagedPatientBrokerFirmMembershipInvoice =
  <
    TData =
      Common.PatientControllerServiceUpdateEngagedPatientBrokerFirmMembershipInvoiceMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          brokerFirmUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        brokerFirmUuid: string;
      },
      TContext
    >({
      mutationFn: ({ brokerFirmUuid }) =>
        PatientControllerService.updateEngagedPatientBrokerFirmMembershipInvoice(
          {
            brokerFirmUuid,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.affiliateFirmUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceUpdateEngagedPatientAffiliateFirmMembershipInvoice =
  <
    TData =
      Common.PatientControllerServiceUpdateEngagedPatientAffiliateFirmMembershipInvoiceMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          affiliateFirmUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        affiliateFirmUuid: string;
      },
      TContext
    >({
      mutationFn: ({ affiliateFirmUuid }) =>
        PatientControllerService.updateEngagedPatientAffiliateFirmMembershipInvoice(
          {
            affiliateFirmUuid,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceAddPatientToStripe = <
  TData = Common.PatientControllerServiceAddPatientToStripeMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
    },
    TContext
  >({
    mutationFn: ({ patientUuid }) =>
      PatientControllerService.addPatientToStripe({
        patientUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.retail
 * @param data.requestBody
 * @param data.planUuid
 * @param data.planChange
 * @param data.update
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceAddMembership = <
  TData = Common.PatientControllerServiceAddMembershipMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        planChange?: boolean;
        planUuid?: string;
        requestBody: AddMemberShipDto;
        retail: boolean;
        update?: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      planChange?: boolean;
      planUuid?: string;
      requestBody: AddMemberShipDto;
      retail: boolean;
      update?: boolean;
    },
    TContext
  >({
    mutationFn: ({ planChange, planUuid, requestBody, retail, update }) =>
      PatientControllerService.addMembership({
        planChange,
        planUuid,
        requestBody,
        retail,
        update,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientModuleControllerServiceCreate = <
  TData = Common.PatientModuleControllerServiceCreateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PatientModuleRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PatientModuleRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PatientModuleControllerService.create({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientModuleAccessControllerServiceCreate1 = <
  TData = Common.PatientModuleAccessControllerServiceCreate1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PatientModuleAccessRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PatientModuleAccessRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PatientModuleAccessControllerService.create1({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientInformationControllerServiceCreate2 = <
  TData = Common.PatientInformationControllerServiceCreate2MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PatientInformationRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PatientInformationRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PatientInformationControllerService.create2({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNurseStaffProviderControllerServiceAddNurseStaffProvider = <
  TData =
    Common.NurseStaffProviderControllerServiceAddNurseStaffProviderMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: NurseStaffProviderRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: NurseStaffProviderRequestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      NurseStaffProviderControllerService.addNurseStaffProvider({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useLeadControllerServiceCreateLead = <
  TData = Common.LeadControllerServiceCreateLeadMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LeadResponseDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LeadResponseDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      LeadControllerService.createLead({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.leadUuid
 * @param data.paymentMethodId
 * @returns Response OK
 * @throws ApiError
 */
export const useLeadControllerServiceCreateSubscriptionAfterPayment = <
  TData =
    Common.LeadControllerServiceCreateSubscriptionAfterPaymentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        leadUuid: string;
        paymentMethodId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      leadUuid: string;
      paymentMethodId: string;
    },
    TContext
  >({
    mutationFn: ({ leadUuid, paymentMethodId }) =>
      LeadControllerService.createSubscriptionAfterPayment({
        leadUuid,
        paymentMethodId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useInvoiceSettingControllerServiceCreateInvoiceSetting = <
  TData =
    Common.InvoiceSettingControllerServiceCreateInvoiceSettingMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: InvoiceSettingDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: InvoiceSettingDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      InvoiceSettingControllerService.createInvoiceSetting({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useFeatureManagementControllerServiceCreateFeature = <
  TData = Common.FeatureManagementControllerServiceCreateFeatureMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: FeatureRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: FeatureRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      FeatureManagementControllerService.createFeature({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceUpdateFaxStatus = <
  TData = Common.FaxControllerServiceUpdateFaxStatusMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: FaxStatusRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: FaxStatusRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      FaxControllerService.updateFaxStatus({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendFax = <
  TData = Common.FaxControllerServiceSendFaxMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: QueueFaxRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: QueueFaxRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      FaxControllerService.sendFax({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.fax
 * @param data.workUuid
 * @param data.locationUuid
 * @param data.comment
 * @param data.srFax
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendWorkNoteByFax = <
  TData = Common.FaxControllerServiceSendWorkNoteByFaxMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        comment?: string;
        fax: string;
        locationUuid: string;
        srFax?: boolean;
        workUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      comment?: string;
      fax: string;
      locationUuid: string;
      srFax?: boolean;
      workUuid: string;
    },
    TContext
  >({
    mutationFn: ({ comment, fax, locationUuid, srFax, workUuid }) =>
      FaxControllerService.sendWorkNoteByFax({
        comment,
        fax,
        locationUuid,
        srFax,
        workUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.email
 * @param data.workNoteUuid
 * @param data.comment
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendWorkNoteByEmail = <
  TData = Common.FaxControllerServiceSendWorkNoteByEmailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        comment?: string;
        email: string;
        workNoteUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      comment?: string;
      email: string;
      workNoteUuid: string;
    },
    TContext
  >({
    mutationFn: ({ comment, email, workNoteUuid }) =>
      FaxControllerService.sendWorkNoteByEmail({
        comment,
        email,
        workNoteUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.fax
 * @param data.soapNoteUuid
 * @param data.locationUuid
 * @param data.localDateTime
 * @param data.comment
 * @param data.srFax
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendSoapNoteByFax = <
  TData = Common.FaxControllerServiceSendSoapNoteByFaxMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        comment?: string;
        fax: string;
        localDateTime?: string;
        locationUuid: string;
        soapNoteUuid: string;
        srFax?: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      comment?: string;
      fax: string;
      localDateTime?: string;
      locationUuid: string;
      soapNoteUuid: string;
      srFax?: boolean;
    },
    TContext
  >({
    mutationFn: ({
      comment,
      fax,
      localDateTime,
      locationUuid,
      soapNoteUuid,
      srFax,
    }) =>
      FaxControllerService.sendSoapNoteByFax({
        comment,
        fax,
        localDateTime,
        locationUuid,
        soapNoteUuid,
        srFax,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.email
 * @param data.soapNoteUuid
 * @param data.localDateTime
 * @param data.comment
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendSoapNoteByEmail = <
  TData = Common.FaxControllerServiceSendSoapNoteByEmailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        comment?: string;
        email: string;
        localDateTime?: string;
        soapNoteUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      comment?: string;
      email: string;
      localDateTime?: string;
      soapNoteUuid: string;
    },
    TContext
  >({
    mutationFn: ({ comment, email, localDateTime, soapNoteUuid }) =>
      FaxControllerService.sendSoapNoteByEmail({
        comment,
        email,
        localDateTime,
        soapNoteUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.fax
 * @param data.referralUuid
 * @param data.locationUuid
 * @param data.comment
 * @param data.srFax
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendReferralByFax = <
  TData = Common.FaxControllerServiceSendReferralByFaxMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        comment?: string;
        fax: string;
        locationUuid: string;
        referralUuid: string;
        srFax?: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      comment?: string;
      fax: string;
      locationUuid: string;
      referralUuid: string;
      srFax?: boolean;
    },
    TContext
  >({
    mutationFn: ({ comment, fax, locationUuid, referralUuid, srFax }) =>
      FaxControllerService.sendReferralByFax({
        comment,
        fax,
        locationUuid,
        referralUuid,
        srFax,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.email
 * @param data.referralUuid
 * @param data.comment
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendReferralByEmail = <
  TData = Common.FaxControllerServiceSendReferralByEmailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        comment?: string;
        email: string;
        referralUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      comment?: string;
      email: string;
      referralUuid: string;
    },
    TContext
  >({
    mutationFn: ({ comment, email, referralUuid }) =>
      FaxControllerService.sendReferralByEmail({
        comment,
        email,
        referralUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.fax
 * @param data.pocUuid
 * @param data.locationUuid
 * @param data.comment
 * @param data.srFax
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendPocByFax = <
  TData = Common.FaxControllerServiceSendPocByFaxMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        comment?: string;
        fax: string;
        locationUuid: string;
        pocUuid: string;
        srFax?: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      comment?: string;
      fax: string;
      locationUuid: string;
      pocUuid: string;
      srFax?: boolean;
    },
    TContext
  >({
    mutationFn: ({ comment, fax, locationUuid, pocUuid, srFax }) =>
      FaxControllerService.sendPocByFax({
        comment,
        fax,
        locationUuid,
        pocUuid,
        srFax,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.email
 * @param data.pocUuid
 * @param data.comment
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendPocByEmail = <
  TData = Common.FaxControllerServiceSendPocByEmailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        comment?: string;
        email: string;
        pocUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      comment?: string;
      email: string;
      pocUuid: string;
    },
    TContext
  >({
    mutationFn: ({ comment, email, pocUuid }) =>
      FaxControllerService.sendPocByEmail({
        comment,
        email,
        pocUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.fax
 * @param data.patientInformationUuid
 * @param data.locationUuid
 * @param data.srFax
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendPatientInformationByFax = <
  TData = Common.FaxControllerServiceSendPatientInformationByFaxMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        fax: string;
        locationUuid: string;
        patientInformationUuid: string;
        srFax?: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      fax: string;
      locationUuid: string;
      patientInformationUuid: string;
      srFax?: boolean;
    },
    TContext
  >({
    mutationFn: ({ fax, locationUuid, patientInformationUuid, srFax }) =>
      FaxControllerService.sendPatientInformationByFax({
        fax,
        locationUuid,
        patientInformationUuid,
        srFax,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.email
 * @param data.patientInformationUuid
 * @param data.comment
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendPatientInformationByEmail = <
  TData =
    Common.FaxControllerServiceSendPatientInformationByEmailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        comment?: string;
        email: string;
        patientInformationUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      comment?: string;
      email: string;
      patientInformationUuid: string;
    },
    TContext
  >({
    mutationFn: ({ comment, email, patientInformationUuid }) =>
      FaxControllerService.sendPatientInformationByEmail({
        comment,
        email,
        patientInformationUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendLabResultBySms = <
  TData = Common.FaxControllerServiceSendLabResultBySmsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LabResultFaxDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LabResultFaxDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      FaxControllerService.sendLabResultBySms({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceGetFaxDetailService = <
  TData = Common.FaxControllerServiceGetFaxDetailServiceMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LabResultFaxDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LabResultFaxDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      FaxControllerService.getFaxDetailService({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.fax
 * @param data.imagingUuid
 * @param data.locationUuid
 * @param data.comment
 * @param data.srFax
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendImagingByFax = <
  TData = Common.FaxControllerServiceSendImagingByFaxMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        comment?: string;
        fax: string;
        imagingUuid: string;
        locationUuid: string;
        srFax?: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      comment?: string;
      fax: string;
      imagingUuid: string;
      locationUuid: string;
      srFax?: boolean;
    },
    TContext
  >({
    mutationFn: ({ comment, fax, imagingUuid, locationUuid, srFax }) =>
      FaxControllerService.sendImagingByFax({
        comment,
        fax,
        imagingUuid,
        locationUuid,
        srFax,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.email
 * @param data.imagingUuid
 * @param data.comment
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendImagingByEmail = <
  TData = Common.FaxControllerServiceSendImagingByEmailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        comment?: string;
        email: string;
        imagingUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      comment?: string;
      email: string;
      imagingUuid: string;
    },
    TContext
  >({
    mutationFn: ({ comment, email, imagingUuid }) =>
      FaxControllerService.sendImagingByEmail({
        comment,
        email,
        imagingUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.fax
 * @param data.handpNoteUuid
 * @param data.locationUuid
 * @param data.localDateTime
 * @param data.comment
 * @param data.srFax
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendHandpNoteByFax = <
  TData = Common.FaxControllerServiceSendHandpNoteByFaxMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        comment?: string;
        fax: string;
        handpNoteUuid: string;
        localDateTime?: string;
        locationUuid: string;
        srFax?: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      comment?: string;
      fax: string;
      handpNoteUuid: string;
      localDateTime?: string;
      locationUuid: string;
      srFax?: boolean;
    },
    TContext
  >({
    mutationFn: ({
      comment,
      fax,
      handpNoteUuid,
      localDateTime,
      locationUuid,
      srFax,
    }) =>
      FaxControllerService.sendHandpNoteByFax({
        comment,
        fax,
        handpNoteUuid,
        localDateTime,
        locationUuid,
        srFax,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.email
 * @param data.handpNoteUuid
 * @param data.localDateTime
 * @param data.comment
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendHandpNoteByEmail = <
  TData = Common.FaxControllerServiceSendHandpNoteByEmailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        comment?: string;
        email: string;
        handpNoteUuid: string;
        localDateTime?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      comment?: string;
      email: string;
      handpNoteUuid: string;
      localDateTime?: string;
    },
    TContext
  >({
    mutationFn: ({ comment, email, handpNoteUuid, localDateTime }) =>
      FaxControllerService.sendHandpNoteByEmail({
        comment,
        email,
        handpNoteUuid,
        localDateTime,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.fax
 * @param data.documentUuid
 * @param data.locationUuid
 * @param data.comment
 * @param data.srFax
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendDocumentByFax = <
  TData = Common.FaxControllerServiceSendDocumentByFaxMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        comment?: string;
        documentUuid: string;
        fax: string;
        locationUuid: string;
        srFax?: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      comment?: string;
      documentUuid: string;
      fax: string;
      locationUuid: string;
      srFax?: boolean;
    },
    TContext
  >({
    mutationFn: ({ comment, documentUuid, fax, locationUuid, srFax }) =>
      FaxControllerService.sendDocumentByFax({
        comment,
        documentUuid,
        fax,
        locationUuid,
        srFax,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.email
 * @param data.documentUuid
 * @param data.comment
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendDocumentByEmail = <
  TData = Common.FaxControllerServiceSendDocumentByEmailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        comment?: string;
        documentUuid: string;
        email: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      comment?: string;
      documentUuid: string;
      email: string;
    },
    TContext
  >({
    mutationFn: ({ comment, documentUuid, email }) =>
      FaxControllerService.sendDocumentByEmail({
        comment,
        documentUuid,
        email,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.srFax
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendFaxToRefferal = <
  TData = Common.FaxControllerServiceSendFaxToRefferalMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ReferralFaxDto;
        srFax?: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ReferralFaxDto;
      srFax?: boolean;
    },
    TContext
  >({
    mutationFn: ({ requestBody, srFax }) =>
      FaxControllerService.sendFaxToRefferal({
        requestBody,
        srFax,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendQuestionnaireFax = <
  TData = Common.FaxControllerServiceSendQuestionnaireFaxMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: QuestionnaireFaxDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: QuestionnaireFaxDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      FaxControllerService.sendQuestionnaireFax({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.srFax
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendFaxToLabOrder = <
  TData = Common.FaxControllerServiceSendFaxToLabOrderMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LabOrderFaxDto;
        srFax?: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LabOrderFaxDto;
      srFax?: boolean;
    },
    TContext
  >({
    mutationFn: ({ requestBody, srFax }) =>
      FaxControllerService.sendFaxToLabOrder({
        requestBody,
        srFax,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.srFax
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendFaxToImaging = <
  TData = Common.FaxControllerServiceSendFaxToImagingMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ImagingFaxDto;
        srFax?: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ImagingFaxDto;
      srFax?: boolean;
    },
    TContext
  >({
    mutationFn: ({ requestBody, srFax }) =>
      FaxControllerService.sendFaxToImaging({
        requestBody,
        srFax,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceSendFaxToLabOrder1 = <
  TData = Common.FaxControllerServiceSendFaxToLabOrder1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LabResultFaxDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LabResultFaxDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      FaxControllerService.sendFaxToLabOrder1({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.faxId
 * @param data.locationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceCancelEfaxFax = <
  TData = Common.FaxControllerServiceCancelEfaxFaxMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        faxId: string;
        locationUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      faxId: string;
      locationUuid: string;
    },
    TContext
  >({
    mutationFn: ({ faxId, locationUuid }) =>
      FaxControllerService.cancelEfaxFax({
        faxId,
        locationUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.referenceType
 * @param data.documentUuid
 * @param data.resultUuid
 * @param data.reviewRequired
 * @param data.patientUuid
 * @param data.labName
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceAttachDocument = <
  TData = Common.FaxControllerServiceAttachDocumentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        documentUuid: string;
        labName?: string;
        patientUuid?: string;
        referenceType:
          | "SOAP_NOTE"
          | "HANDP_NOTE"
          | "IMAGING"
          | "LOCATION_PROFILE"
          | "PROVIDER_PROFILE"
          | "PATIENT_DOCUMENTS"
          | "DOCUMENTS"
          | "INVOICE"
          | "CUSTOM_LOGO"
          | "PATIENT_PROFILE"
          | "LAB_ORDER"
          | "INSURANCE"
          | "REFERRAL"
          | "ANNOTABLE_IMAGE"
          | "EMAIL_STRUCTURE"
          | "EMAIL_TEMPLATE"
          | "TICKET"
          | "QUESTIONNAIRE_PDF"
          | "CHAT_ATTACHMENTS"
          | "AGREEMENT_PDF"
          | "FORM_TEMPLATE_PDF"
          | "NORTHWIND_ORDER"
          | "NORTHWIND_SHIPMENT"
          | "PROVIDER_APPOINTMENTS"
          | "POC_RESULT"
          | "LAB_RESULT"
          | "PATIENT_INFORMATION";
        resultUuid?: string;
        reviewRequired?: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      documentUuid: string;
      labName?: string;
      patientUuid?: string;
      referenceType:
        | "SOAP_NOTE"
        | "HANDP_NOTE"
        | "IMAGING"
        | "LOCATION_PROFILE"
        | "PROVIDER_PROFILE"
        | "PATIENT_DOCUMENTS"
        | "DOCUMENTS"
        | "INVOICE"
        | "CUSTOM_LOGO"
        | "PATIENT_PROFILE"
        | "LAB_ORDER"
        | "INSURANCE"
        | "REFERRAL"
        | "ANNOTABLE_IMAGE"
        | "EMAIL_STRUCTURE"
        | "EMAIL_TEMPLATE"
        | "TICKET"
        | "QUESTIONNAIRE_PDF"
        | "CHAT_ATTACHMENTS"
        | "AGREEMENT_PDF"
        | "FORM_TEMPLATE_PDF"
        | "NORTHWIND_ORDER"
        | "NORTHWIND_SHIPMENT"
        | "PROVIDER_APPOINTMENTS"
        | "POC_RESULT"
        | "LAB_RESULT"
        | "PATIENT_INFORMATION";
      resultUuid?: string;
      reviewRequired?: boolean;
    },
    TContext
  >({
    mutationFn: ({
      documentUuid,
      labName,
      patientUuid,
      referenceType,
      resultUuid,
      reviewRequired,
    }) =>
      FaxControllerService.attachDocument({
        documentUuid,
        labName,
        patientUuid,
        referenceType,
        resultUuid,
        reviewRequired,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceAddEmployer = <
  TData = Common.EmployerControllerServiceAddEmployerMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: EmployerDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: EmployerDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      EmployerControllerService.addEmployer({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.requestBody
 * @param data.employerInvoiceSettingUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceUpdateInvoiceSetting1 = <
  TData = Common.EmployerControllerServiceUpdateInvoiceSetting1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        employerInvoiceSettingUuid?: string;
        employerUuid: string;
        requestBody: EmployerInvoiceSettingRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      employerInvoiceSettingUuid?: string;
      employerUuid: string;
      requestBody: EmployerInvoiceSettingRequest;
    },
    TContext
  >({
    mutationFn: ({ employerInvoiceSettingUuid, employerUuid, requestBody }) =>
      EmployerControllerService.updateInvoiceSetting1({
        employerInvoiceSettingUuid,
        employerUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.employerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerPageControllerServiceCreateEmployerPage = <
  TData = Common.EmployerPageControllerServiceCreateEmployerPageMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        employerUuid?: string;
        requestBody: EmployerPageDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      employerUuid?: string;
      requestBody: EmployerPageDto;
    },
    TContext
  >({
    mutationFn: ({ employerUuid, requestBody }) =>
      EmployerPageControllerService.createEmployerPage({
        employerUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerDivisionControllerServiceCreateEmployerDivision = <
  TData =
    Common.EmployerDivisionControllerServiceCreateEmployerDivisionMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: EmployerDivisionDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: EmployerDivisionDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      EmployerDivisionControllerService.createEmployerDivision({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerAdministratorControllerServiceCreateEmployerAdministrator =
  <
    TData =
      Common.EmployerAdministratorControllerServiceCreateEmployerAdministratorMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: EmployerAdministratorDto;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: EmployerAdministratorDto;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        EmployerAdministratorControllerService.createEmployerAdministrator({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCreditControllerServiceAddCredit = <
  TData = Common.CreditControllerServiceAddCreditMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CreditDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CreditDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      CreditControllerService.addCredit({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCoverageRuleControllerServiceCreateCoverageRule = <
  TData = Common.CoverageRuleControllerServiceCreateCoverageRuleMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CoverageRuleDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CoverageRuleDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      CoverageRuleControllerService.createCoverageRule({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCoveragePlanControllerServiceCreateCoveragePlan = <
  TData = Common.CoveragePlanControllerServiceCreateCoveragePlanMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CoveragePlanDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CoveragePlanDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      CoveragePlanControllerService.createCoveragePlan({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCouponControllerServiceCreateCoupon = <
  TData = Common.CouponControllerServiceCreateCouponMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CouponRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CouponRequestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      CouponControllerService.createCoupon({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useChargeItemControllerServiceUploadCsv = <
  TData = Common.ChargeItemControllerServiceUploadCsvMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: { file: Blob | File };
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: { file: Blob | File };
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ChargeItemControllerService.uploadCsv({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useChargeItemControllerServiceUpdatePricesFromCsv = <
  TData = Common.ChargeItemControllerServiceUpdatePricesFromCsvMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: { file: Blob | File };
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: { file: Blob | File };
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ChargeItemControllerService.updatePricesFromCsv({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useChargeItemControllerServiceSaveChargeItem = <
  TData = Common.ChargeItemControllerServiceSaveChargeItemMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ChargeItemRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ChargeItemRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ChargeItemControllerService.saveChargeItem({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useChargeCategoryControllerServiceSaveChargeCategory = <
  TData =
    Common.ChargeCategoryControllerServiceSaveChargeCategoryMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ChargeCategoryRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ChargeCategoryRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ChargeCategoryControllerService.saveChargeCategory({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCancellationControllerServiceSaveCancellation = <
  TData = Common.CancellationControllerServiceSaveCancellationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CancellationRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CancellationRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      CancellationControllerService.saveCancellation({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useBrokerControllerServiceCreateBroker = <
  TData = Common.BrokerControllerServiceCreateBrokerMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: BrokerDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: BrokerDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      BrokerControllerService.createBroker({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useBreakGlassControllerServiceCreate3 = <
  TData = Common.BreakGlassControllerServiceCreate3MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: BreakGlassRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: BreakGlassRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      BreakGlassControllerService.create3({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceUpdatePlanRenewalDatesForActiveRetailPatients =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceUpdatePlanRenewalDatesForActiveRetailPatientsMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        AncillaryServiceChargesControllerService.updatePlanRenewalDatesForActiveRetailPatients() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceSyncEmployerInvoice = <
  TData =
    Common.AncillaryServiceChargesControllerServiceSyncEmployerInvoiceMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        employerUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      employerUuid: string;
    },
    TContext
  >({
    mutationFn: ({ employerUuid }) =>
      AncillaryServiceChargesControllerService.syncEmployerInvoice({
        employerUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceScheduledPaymentProcessing =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceScheduledPaymentProcessingMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        AncillaryServiceChargesControllerService.scheduledPaymentProcessing() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceScheduledPayment = <
  TData =
    Common.AncillaryServiceChargesControllerServiceScheduledPaymentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ScheduledPaymentRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ScheduledPaymentRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AncillaryServiceChargesControllerService.scheduledPayment({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @param data.patientUuid
 * @param data.invoiceStatus
 * @param data.paymentMethod
 * @param data.paymentMethodReason
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceUpdateExistingRetailPatientMembershipInvoice =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceUpdateExistingRetailPatientMembershipInvoiceMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          invoiceStatus?:
            | "PAID"
            | "PARTIALLY_PAID"
            | "UNPAID"
            | "BAD_DEBT"
            | "VOID"
            | "OVERDUE"
            | "DRAFT"
            | "PARTIALLY_REFUNDED"
            | "REFUNDED"
            | "PROCESSING"
            | "ISSUED";
          invoiceUuid: string;
          patientUuid: string;
          paymentMethod?: string;
          paymentMethodReason?: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        invoiceStatus?:
          | "PAID"
          | "PARTIALLY_PAID"
          | "UNPAID"
          | "BAD_DEBT"
          | "VOID"
          | "OVERDUE"
          | "DRAFT"
          | "PARTIALLY_REFUNDED"
          | "REFUNDED"
          | "PROCESSING"
          | "ISSUED";
        invoiceUuid: string;
        patientUuid: string;
        paymentMethod?: string;
        paymentMethodReason?: string;
      },
      TContext
    >({
      mutationFn: ({
        invoiceStatus,
        invoiceUuid,
        patientUuid,
        paymentMethod,
        paymentMethodReason,
      }) =>
        AncillaryServiceChargesControllerService.updateExistingRetailPatientMembershipInvoice(
          {
            invoiceStatus,
            invoiceUuid,
            patientUuid,
            paymentMethod,
            paymentMethodReason,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceRefundAmount1 = <
  TData =
    Common.AncillaryServiceChargesControllerServiceRefundAmount1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: StripeRefundRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: StripeRefundRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AncillaryServiceChargesControllerService.refundAmount1({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceReactiveEmployerMembership =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceReactiveEmployerMembershipMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: string[];
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: string[];
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        AncillaryServiceChargesControllerService.reactiveEmployerMembership({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceProcessOverdueInvoicesAndGeneratePdfs =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceProcessOverdueInvoicesAndGeneratePdfsMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        AncillaryServiceChargesControllerService.processOverdueInvoicesAndGeneratePdfs() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceSaveMiscellaneousServiceCharge =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceSaveMiscellaneousServiceChargeMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          invoiceUuid: string;
          requestBody: MiscellaneousServiceChargeRequest;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        invoiceUuid: string;
        requestBody: MiscellaneousServiceChargeRequest;
      },
      TContext
    >({
      mutationFn: ({ invoiceUuid, requestBody }) =>
        AncillaryServiceChargesControllerService.saveMiscellaneousServiceCharge(
          {
            invoiceUuid,
            requestBody,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceMakePayment = <
  TData =
    Common.AncillaryServiceChargesControllerServiceMakePaymentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: MakePaymentRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: MakePaymentRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AncillaryServiceChargesControllerService.makePayment({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.chargeItemUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceLinkChargeItemsToPatient =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceLinkChargeItemsToPatientMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          chargeItemUuid: string;
          patientUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        chargeItemUuid: string;
        patientUuid: string;
      },
      TContext
    >({
      mutationFn: ({ chargeItemUuid, patientUuid }) =>
        AncillaryServiceChargesControllerService.linkChargeItemsToPatient({
          chargeItemUuid,
          patientUuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.labOrderUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceMarkLabOrderAsDrawn = <
  TData =
    Common.AncillaryServiceChargesControllerServiceMarkLabOrderAsDrawnMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        labOrderUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      labOrderUuid: string;
    },
    TContext
  >({
    mutationFn: ({ labOrderUuid }) =>
      AncillaryServiceChargesControllerService.markLabOrderAsDrawn({
        labOrderUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.labOrderUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceInvoiceLabOrderNow = <
  TData =
    Common.AncillaryServiceChargesControllerServiceInvoiceLabOrderNowMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        labOrderUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      labOrderUuid: string;
    },
    TContext
  >({
    mutationFn: ({ labOrderUuid }) =>
      AncillaryServiceChargesControllerService.invoiceLabOrderNow({
        labOrderUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceSendLabInvoicePaymentReminders =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceSendLabInvoicePaymentRemindersMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        AncillaryServiceChargesControllerService.sendLabInvoicePaymentReminders() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceLabInvoiceAutopayProcessing =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceLabInvoiceAutopayProcessingMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        AncillaryServiceChargesControllerService.labInvoiceAutopayProcessing() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.stripeClientSecret
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceCreateRetailMembershipInvoice =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceCreateRetailMembershipInvoiceMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          stripeClientSecret: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        stripeClientSecret: string;
      },
      TContext
    >({
      mutationFn: ({ stripeClientSecret }) =>
        AncillaryServiceChargesControllerService.createRetailMembershipInvoice({
          stripeClientSecret,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceRetailPatientAutopayProcessing =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceRetailPatientAutopayProcessingMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        AncillaryServiceChargesControllerService.retailPatientAutopayProcessing() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceGenerateMonthlyEmployerInvoices =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceGenerateMonthlyEmployerInvoicesMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        AncillaryServiceChargesControllerService.generateMonthlyEmployerInvoices() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceGenerateMonthlyBrokerFirmInvoices =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceGenerateMonthlyBrokerFirmInvoicesMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        AncillaryServiceChargesControllerService.generateMonthlyBrokerFirmInvoices() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceGenerateMonthlyAffiliateFirmInvoices =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceGenerateMonthlyAffiliateFirmInvoicesMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        AncillaryServiceChargesControllerService.generateMonthlyAffiliateFirmInvoices() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceGenerateLabOrderInvoices =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceGenerateLabOrderInvoicesMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        AncillaryServiceChargesControllerService.generateLabOrderInvoices() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @param data.salesTaxProfileUuid
 * @param data.rate
 * @param data.savedBankUuid
 * @param data.savedCardUuid
 * @param data.paymentMethod
 * @param data.paymentMethodReason
 * @param data.userTypes
 * @param data.issueDate
 * @param data.dueDate
 * @param data.invoiceStatus
 * @param data.invoiceUuid
 * @param data.reason
 * @param data.makePayment
 * @param data.applyCredit
 * @param data.partialAmount
 * @param data.sharedCard
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceGenerateInvoiceOfAncillaryForUser =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceGenerateInvoiceOfAncillaryForUserMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          applyCredit?: boolean;
          dueDate?: string;
          invoiceStatus?:
            | "PAID"
            | "PARTIALLY_PAID"
            | "UNPAID"
            | "BAD_DEBT"
            | "VOID"
            | "OVERDUE"
            | "DRAFT"
            | "PARTIALLY_REFUNDED"
            | "REFUNDED"
            | "PROCESSING"
            | "ISSUED";
          invoiceUuid?: string;
          issueDate?: string;
          makePayment?: boolean;
          partialAmount?: number;
          paymentMethod?: string;
          paymentMethodReason?: string;
          rate?: number;
          reason?: string;
          salesTaxProfileUuid?: string;
          savedBankUuid?: string;
          savedCardUuid?: string;
          sharedCard?: boolean;
          userTypes?:
            | "EMPLOYER"
            | "PATIENT"
            | "BROKER"
            | "ADMIN_USER"
            | "PROVIDER"
            | "EMPLOYER_ADMINISTRATION"
            | "EMPLOYEE"
            | "PHP_USER"
            | "AFFILIATE_FIRM"
            | "BROKER_FIRM"
            | "NURSE_USER";
          userUuid?: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        applyCredit?: boolean;
        dueDate?: string;
        invoiceStatus?:
          | "PAID"
          | "PARTIALLY_PAID"
          | "UNPAID"
          | "BAD_DEBT"
          | "VOID"
          | "OVERDUE"
          | "DRAFT"
          | "PARTIALLY_REFUNDED"
          | "REFUNDED"
          | "PROCESSING"
          | "ISSUED";
        invoiceUuid?: string;
        issueDate?: string;
        makePayment?: boolean;
        partialAmount?: number;
        paymentMethod?: string;
        paymentMethodReason?: string;
        rate?: number;
        reason?: string;
        salesTaxProfileUuid?: string;
        savedBankUuid?: string;
        savedCardUuid?: string;
        sharedCard?: boolean;
        userTypes?:
          | "EMPLOYER"
          | "PATIENT"
          | "BROKER"
          | "ADMIN_USER"
          | "PROVIDER"
          | "EMPLOYER_ADMINISTRATION"
          | "EMPLOYEE"
          | "PHP_USER"
          | "AFFILIATE_FIRM"
          | "BROKER_FIRM"
          | "NURSE_USER";
        userUuid?: string;
      },
      TContext
    >({
      mutationFn: ({
        applyCredit,
        dueDate,
        invoiceStatus,
        invoiceUuid,
        issueDate,
        makePayment,
        partialAmount,
        paymentMethod,
        paymentMethodReason,
        rate,
        reason,
        salesTaxProfileUuid,
        savedBankUuid,
        savedCardUuid,
        sharedCard,
        userTypes,
        userUuid,
      }) =>
        AncillaryServiceChargesControllerService.generateInvoiceOfAncillaryForUser(
          {
            applyCredit,
            dueDate,
            invoiceStatus,
            invoiceUuid,
            issueDate,
            makePayment,
            partialAmount,
            paymentMethod,
            paymentMethodReason,
            rate,
            reason,
            salesTaxProfileUuid,
            savedBankUuid,
            savedCardUuid,
            sharedCard,
            userTypes,
            userUuid,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.invoiceUuid
 * @param data.invoiceStatus
 * @param data.issueDate
 * @param data.dueDate
 * @param data.savedBankUuid
 * @param data.savedCardUuid
 * @param data.paymentMethod
 * @param data.paymentMethodReason
 * @param data.makePayment
 * @param data.salesTaxProfileUuid
 * @param data.rate
 * @param data.partialAmount
 * @param data.sharedCard
 * @param data.reason
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceGenerateInvoiceEmployerMembership =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceGenerateInvoiceEmployerMembershipMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          dueDate?: string;
          employerUuid: string;
          invoiceStatus:
            | "PAID"
            | "PARTIALLY_PAID"
            | "UNPAID"
            | "BAD_DEBT"
            | "VOID"
            | "OVERDUE"
            | "DRAFT"
            | "PARTIALLY_REFUNDED"
            | "REFUNDED"
            | "PROCESSING"
            | "ISSUED";
          invoiceUuid: string;
          issueDate?: string;
          makePayment?: boolean;
          partialAmount?: number;
          paymentMethod?: string;
          paymentMethodReason?: string;
          rate?: number;
          reason?: string;
          salesTaxProfileUuid?: string;
          savedBankUuid?: string;
          savedCardUuid?: string;
          sharedCard?: boolean;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        dueDate?: string;
        employerUuid: string;
        invoiceStatus:
          | "PAID"
          | "PARTIALLY_PAID"
          | "UNPAID"
          | "BAD_DEBT"
          | "VOID"
          | "OVERDUE"
          | "DRAFT"
          | "PARTIALLY_REFUNDED"
          | "REFUNDED"
          | "PROCESSING"
          | "ISSUED";
        invoiceUuid: string;
        issueDate?: string;
        makePayment?: boolean;
        partialAmount?: number;
        paymentMethod?: string;
        paymentMethodReason?: string;
        rate?: number;
        reason?: string;
        salesTaxProfileUuid?: string;
        savedBankUuid?: string;
        savedCardUuid?: string;
        sharedCard?: boolean;
      },
      TContext
    >({
      mutationFn: ({
        dueDate,
        employerUuid,
        invoiceStatus,
        invoiceUuid,
        issueDate,
        makePayment,
        partialAmount,
        paymentMethod,
        paymentMethodReason,
        rate,
        reason,
        salesTaxProfileUuid,
        savedBankUuid,
        savedCardUuid,
        sharedCard,
      }) =>
        AncillaryServiceChargesControllerService.generateInvoiceEmployerMembership(
          {
            dueDate,
            employerUuid,
            invoiceStatus,
            invoiceUuid,
            issueDate,
            makePayment,
            partialAmount,
            paymentMethod,
            paymentMethodReason,
            rate,
            reason,
            salesTaxProfileUuid,
            savedBankUuid,
            savedCardUuid,
            sharedCard,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceEmployerInvoiceSetting =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceEmployerInvoiceSettingMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        AncillaryServiceChargesControllerService.employerInvoiceSetting() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceDeactivateRetailPatientsWithUnpaidInvoices =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceDeactivateRetailPatientsWithUnpaidInvoicesMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        AncillaryServiceChargesControllerService.deactivateRetailPatientsWithUnpaidInvoices() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceProcessEmployerDeactivation =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceProcessEmployerDeactivationMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        AncillaryServiceChargesControllerService.processEmployerDeactivation() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceCreateChargeItemAndInvoice =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceCreateChargeItemAndInvoiceMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: CreateChargeItemAndInvoiceRequest;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: CreateChargeItemAndInvoiceRequest;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        AncillaryServiceChargesControllerService.createChargeItemAndInvoice({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceSaveAncillaryServiceCharges =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceSaveAncillaryServiceChargesMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: AncillaryServiceChargesRequest;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: AncillaryServiceChargesRequest;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        AncillaryServiceChargesControllerService.saveAncillaryServiceCharges({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceConvertPatientMembership =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceConvertPatientMembershipMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        AncillaryServiceChargesControllerService.convertPatientMembership() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceCheckChargeCoverage = <
  TData =
    Common.AncillaryServiceChargesControllerServiceCheckChargeCoverageMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CheckChargeCoverageRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CheckChargeCoverageRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AncillaryServiceChargesControllerService.checkChargeCoverage({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceChangeInvoiceStatus = <
  TData =
    Common.AncillaryServiceChargesControllerServiceChangeInvoiceStatusMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ChangeInvoiceStatusRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ChangeInvoiceStatusRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AncillaryServiceChargesControllerService.changeInvoiceStatus({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @param data.affiliateFirmUuid
 * @param data.issueDate
 * @param data.invoiceStatus
 * @param data.paymentMethod
 * @param data.paymentMethodReason
 * @param data.makePayment
 * @param data.dueDate
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceUpdateExistingAffiliateFirmMembershipInvoice =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceUpdateExistingAffiliateFirmMembershipInvoiceMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          affiliateFirmUuid: string;
          dueDate?: string;
          invoiceStatus?:
            | "PAID"
            | "PARTIALLY_PAID"
            | "UNPAID"
            | "BAD_DEBT"
            | "VOID"
            | "OVERDUE"
            | "DRAFT"
            | "PARTIALLY_REFUNDED"
            | "REFUNDED"
            | "PROCESSING"
            | "ISSUED";
          invoiceUuid: string;
          issueDate?: string;
          makePayment?: boolean;
          paymentMethod?: string;
          paymentMethodReason?: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        affiliateFirmUuid: string;
        dueDate?: string;
        invoiceStatus?:
          | "PAID"
          | "PARTIALLY_PAID"
          | "UNPAID"
          | "BAD_DEBT"
          | "VOID"
          | "OVERDUE"
          | "DRAFT"
          | "PARTIALLY_REFUNDED"
          | "REFUNDED"
          | "PROCESSING"
          | "ISSUED";
        invoiceUuid: string;
        issueDate?: string;
        makePayment?: boolean;
        paymentMethod?: string;
        paymentMethodReason?: string;
      },
      TContext
    >({
      mutationFn: ({
        affiliateFirmUuid,
        dueDate,
        invoiceStatus,
        invoiceUuid,
        issueDate,
        makePayment,
        paymentMethod,
        paymentMethodReason,
      }) =>
        AncillaryServiceChargesControllerService.updateExistingAffiliateFirmMembershipInvoice(
          {
            affiliateFirmUuid,
            dueDate,
            invoiceStatus,
            invoiceUuid,
            issueDate,
            makePayment,
            paymentMethod,
            paymentMethodReason,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @param data.agentFirmUuid
 * @param data.issueDate
 * @param data.dueDate
 * @param data.invoiceStatus
 * @param data.paymentMethod
 * @param data.paymentMethodReason
 * @param data.makePayment
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceUpdateExistingBrokerFirmMembershipInvoice =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceUpdateExistingBrokerFirmMembershipInvoiceMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          agentFirmUuid: string;
          dueDate?: string;
          invoiceStatus?:
            | "PAID"
            | "PARTIALLY_PAID"
            | "UNPAID"
            | "BAD_DEBT"
            | "VOID"
            | "OVERDUE"
            | "DRAFT"
            | "PARTIALLY_REFUNDED"
            | "REFUNDED"
            | "PROCESSING"
            | "ISSUED";
          invoiceUuid: string;
          issueDate?: string;
          makePayment?: boolean;
          paymentMethod?: string;
          paymentMethodReason?: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        agentFirmUuid: string;
        dueDate?: string;
        invoiceStatus?:
          | "PAID"
          | "PARTIALLY_PAID"
          | "UNPAID"
          | "BAD_DEBT"
          | "VOID"
          | "OVERDUE"
          | "DRAFT"
          | "PARTIALLY_REFUNDED"
          | "REFUNDED"
          | "PROCESSING"
          | "ISSUED";
        invoiceUuid: string;
        issueDate?: string;
        makePayment?: boolean;
        paymentMethod?: string;
        paymentMethodReason?: string;
      },
      TContext
    >({
      mutationFn: ({
        agentFirmUuid,
        dueDate,
        invoiceStatus,
        invoiceUuid,
        issueDate,
        makePayment,
        paymentMethod,
        paymentMethodReason,
      }) =>
        AncillaryServiceChargesControllerService.updateExistingBrokerFirmMembershipInvoice(
          {
            agentFirmUuid,
            dueDate,
            invoiceStatus,
            invoiceUuid,
            issueDate,
            makePayment,
            paymentMethod,
            paymentMethodReason,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceActivatePendingEmployeePatients =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceActivatePendingEmployeePatientsMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        AncillaryServiceChargesControllerService.activatePendingEmployeePatients() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAgentFirmControllerServiceCreateAgentFirm = <
  TData = Common.AgentFirmControllerServiceCreateAgentFirmMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AgentFirmDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AgentFirmDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AgentFirmControllerService.createAgentFirm({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAgentDealControllerServiceCreateAgentDeal = <
  TData = Common.AgentDealControllerServiceCreateAgentDealMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AgentDealDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AgentDealDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AgentDealControllerService.createAgentDeal({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAffiliateGroupControllerServiceAddAffiliate = <
  TData = Common.AffiliateGroupControllerServiceAddAffiliateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AffiliateGroupDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AffiliateGroupDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AffiliateGroupControllerService.addAffiliate({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.affiliateGroupUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAffiliateGroupControllerServiceAddAffiliateUser = <
  TData = Common.AffiliateGroupControllerServiceAddAffiliateUserMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        affiliateGroupUuid: string;
        requestBody: User;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      affiliateGroupUuid: string;
      requestBody: User;
    },
    TContext
  >({
    mutationFn: ({ affiliateGroupUuid, requestBody }) =>
      AffiliateGroupControllerService.addAffiliateUser({
        affiliateGroupUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAdminUserControllerServiceResetUserMfa = <
  TData = Common.AdminUserControllerServiceResetUserMfaMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        userUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      userUuid: string;
    },
    TContext
  >({
    mutationFn: ({ userUuid }) =>
      AdminUserControllerService.resetUserMfa({
        userUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.dashBoardId
 * @returns Response OK
 * @throws ApiError
 */
export const useAdminUserControllerServiceGenerateGuestToken = <
  TData = Common.AdminUserControllerServiceGenerateGuestTokenMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        dashBoardId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      dashBoardId: string;
    },
    TContext
  >({
    mutationFn: ({ dashBoardId }) =>
      AdminUserControllerService.generateGuestToken({
        dashBoardId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @param data.userTypes
 * @returns Response OK
 * @throws ApiError
 */
export const useAdminUserControllerServiceResendLink = <
  TData = Common.AdminUserControllerServiceResendLinkMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        userTypes:
          | "EMPLOYER"
          | "PATIENT"
          | "BROKER"
          | "ADMIN_USER"
          | "PROVIDER"
          | "EMPLOYER_ADMINISTRATION"
          | "EMPLOYEE"
          | "PHP_USER"
          | "AFFILIATE_FIRM"
          | "BROKER_FIRM"
          | "NURSE_USER";
        userUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      userTypes:
        | "EMPLOYER"
        | "PATIENT"
        | "BROKER"
        | "ADMIN_USER"
        | "PROVIDER"
        | "EMPLOYER_ADMINISTRATION"
        | "EMPLOYEE"
        | "PHP_USER"
        | "AFFILIATE_FIRM"
        | "BROKER_FIRM"
        | "NURSE_USER";
      userUuid: string;
    },
    TContext
  >({
    mutationFn: ({ userTypes, userUuid }) =>
      AdminUserControllerService.resendLink({
        userTypes,
        userUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAdminUserControllerServiceSaveAdminUser = <
  TData = Common.AdminUserControllerServiceSaveAdminUserMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AdminUserRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AdminUserRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AdminUserControllerService.saveAdminUser({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useSupervisingProviderRequestControllerServiceSendRequests = <
  TData =
    Common.SupervisingProviderRequestControllerServiceSendRequestsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: SupervisingRequestCreateDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: SupervisingRequestCreateDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      SupervisingProviderRequestControllerService.sendRequests({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useShareCardControllerServiceShareCard = <
  TData = Common.ShareCardControllerServiceShareCardMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ShareCardRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ShareCardRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ShareCardControllerService.shareCard({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response1 OK
 * @throws ApiError
 */
export const useShareCardControllerServiceShareCard1 = <
  TData = Common.ShareCardControllerServiceShareCard1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ShareCardRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ShareCardRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ShareCardControllerService.shareCard1({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response1 OK
 * @throws ApiError
 */
export const useShareCardControllerServiceAddMetadata = <
  TData = Common.ShareCardControllerServiceAddMetadataMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AddMetadataRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AddMetadataRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ShareCardControllerService.addMetadata({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useShareBankControllerServiceShareBank = <
  TData = Common.ShareBankControllerServiceShareBankMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ShareBankRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ShareBankRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ShareBankControllerService.shareBank({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderCoverageControllerServiceCreateRequest = <
  TData = Common.ProviderCoverageControllerServiceCreateRequestMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CoverageRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CoverageRequestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ProviderCoverageControllerService.createRequest({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.coverageUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderCoverageControllerServiceResyncScriptSure = <
  TData =
    Common.ProviderCoverageControllerServiceResyncScriptSureMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        coverageUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      coverageUuid: string;
    },
    TContext
  >({
    mutationFn: ({ coverageUuid }) =>
      ProviderCoverageControllerService.resyncScriptSure({
        coverageUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.soapNoteUuid
 * @param data.localDateTime
 * @returns Response OK
 * @throws ApiError
 */
export const usePdfControllerServiceUploadSoapNotePdf = <
  TData = Common.PdfControllerServiceUploadSoapNotePdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        localDateTime?: string;
        soapNoteUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      localDateTime?: string;
      soapNoteUuid: string;
    },
    TContext
  >({
    mutationFn: ({ localDateTime, soapNoteUuid }) =>
      PdfControllerService.uploadSoapNotePdf({
        localDateTime,
        soapNoteUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePdfControllerServiceUploadSingleLabOrderPdf = <
  TData = Common.PdfControllerServiceUploadSingleLabOrderPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LabOrderPdfDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LabOrderPdfDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PdfControllerService.uploadSingleLabOrderPdf({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.pocUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePdfControllerServiceUploadPocPdf = <
  TData = Common.PdfControllerServiceUploadPocPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        pocUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      pocUuid: string;
    },
    TContext
  >({
    mutationFn: ({ pocUuid }) =>
      PdfControllerService.uploadPocPdf({
        pocUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientInformationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePdfControllerServiceUploadPatientInformationPdf = <
  TData = Common.PdfControllerServiceUploadPatientInformationPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientInformationUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientInformationUuid: string;
    },
    TContext
  >({
    mutationFn: ({ patientInformationUuid }) =>
      PdfControllerService.uploadPatientInformationPdf({
        patientInformationUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.labResultUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePdfControllerServiceUploadLabResultPdf = <
  TData = Common.PdfControllerServiceUploadLabResultPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        labResultUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      labResultUuid: string;
    },
    TContext
  >({
    mutationFn: ({ labResultUuid }) =>
      PdfControllerService.uploadLabResultPdf({
        labResultUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.imagingResultUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePdfControllerServiceUploadImagingResultPdf = <
  TData = Common.PdfControllerServiceUploadImagingResultPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        imagingResultUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      imagingResultUuid: string;
    },
    TContext
  >({
    mutationFn: ({ imagingResultUuid }) =>
      PdfControllerService.uploadImagingResultPdf({
        imagingResultUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.handpNoteUuid
 * @param data.localDateTime
 * @returns Response OK
 * @throws ApiError
 */
export const usePdfControllerServiceUploadHandpNotePdf = <
  TData = Common.PdfControllerServiceUploadHandpNotePdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        handpNoteUuid: string;
        localDateTime?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      handpNoteUuid: string;
      localDateTime?: string;
    },
    TContext
  >({
    mutationFn: ({ handpNoteUuid, localDateTime }) =>
      PdfControllerService.uploadHandpNotePdf({
        handpNoteUuid,
        localDateTime,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.signatureImage
 * @param data.x
 * @param data.y
 * @param data.requestBody
 * @returns string OK
 * @throws ApiError
 */
export const usePdfControllerServiceSignExistingPdf = <
  TData = Common.PdfControllerServiceSignExistingPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: { pdf: Blob | File };
        signatureImage: string;
        x?: number;
        y?: number;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: { pdf: Blob | File };
      signatureImage: string;
      x?: number;
      y?: number;
    },
    TContext
  >({
    mutationFn: ({ requestBody, signatureImage, x, y }) =>
      PdfControllerService.signExistingPdf({
        requestBody,
        signatureImage,
        x,
        y,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.reportName
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const usePdfControllerServiceGeneratePdf = <
  TData = Common.PdfControllerServiceGeneratePdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        reportName: string;
        requestBody: { [key: string]: { [key: string]: unknown } };
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      reportName: string;
      requestBody: { [key: string]: { [key: string]: unknown } };
    },
    TContext
  >({
    mutationFn: ({ reportName, requestBody }) =>
      PdfControllerService.generatePdf({
        reportName,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.appointmentUuid
 * @returns unknown OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateWorkNotePdf = <
  TData = Common.PdfControllerServiceGenerateWorkNotePdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        appointmentUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      appointmentUuid: string;
    },
    TContext
  >({
    mutationFn: ({ appointmentUuid }) =>
      PdfControllerService.generateWorkNotePdf({
        appointmentUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @param data.userTypes
 * @param data.startDate
 * @param data.endDate
 * @returns unknown OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateExportStatementPdf = <
  TData = Common.PdfControllerServiceGenerateExportStatementPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        endDate?: string;
        startDate?: string;
        userTypes:
          | "EMPLOYER"
          | "PATIENT"
          | "BROKER"
          | "ADMIN_USER"
          | "PROVIDER"
          | "EMPLOYER_ADMINISTRATION"
          | "EMPLOYEE"
          | "PHP_USER"
          | "AFFILIATE_FIRM"
          | "BROKER_FIRM"
          | "NURSE_USER";
        userUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      endDate?: string;
      startDate?: string;
      userTypes:
        | "EMPLOYER"
        | "PATIENT"
        | "BROKER"
        | "ADMIN_USER"
        | "PROVIDER"
        | "EMPLOYER_ADMINISTRATION"
        | "EMPLOYEE"
        | "PHP_USER"
        | "AFFILIATE_FIRM"
        | "BROKER_FIRM"
        | "NURSE_USER";
      userUuid: string;
    },
    TContext
  >({
    mutationFn: ({ endDate, startDate, userTypes, userUuid }) =>
      PdfControllerService.generateExportStatementPdf({
        endDate,
        startDate,
        userTypes,
        userUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns string OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateSpecimenLabel = <
  TData = Common.PdfControllerServiceGenerateSpecimenLabelMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: SpecimenLabelDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: SpecimenLabelDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PdfControllerService.generateSpecimenLabel({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.soapNoteUuid
 * @param data.localDateTime
 * @returns unknown OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateSoapNotePdf = <
  TData = Common.PdfControllerServiceGenerateSoapNotePdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        localDateTime: string;
        soapNoteUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      localDateTime: string;
      soapNoteUuid: string;
    },
    TContext
  >({
    mutationFn: ({ localDateTime, soapNoteUuid }) =>
      PdfControllerService.generateSoapNotePdf({
        localDateTime,
        soapNoteUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateSingleLabOrderPdf = <
  TData = Common.PdfControllerServiceGenerateSingleLabOrderPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LabOrderPdfDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LabOrderPdfDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PdfControllerService.generateSingleLabOrderPdf({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.workNoteUuid
 * @returns string OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateReturnLetterPdf = <
  TData = Common.PdfControllerServiceGenerateReturnLetterPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        workNoteUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      workNoteUuid: string;
    },
    TContext
  >({
    mutationFn: ({ workNoteUuid }) =>
      PdfControllerService.generateReturnLetterPdf({
        workNoteUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.referralUuid
 * @returns unknown OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateReferralPdf = <
  TData = Common.PdfControllerServiceGenerateReferralPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        referralUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      referralUuid: string;
    },
    TContext
  >({
    mutationFn: ({ referralUuid }) =>
      PdfControllerService.generateReferralPdf({
        referralUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.providerUuid
 * @param data.startDate
 * @returns unknown OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateProviderAppointmentsPdf = <
  TData =
    Common.PdfControllerServiceGenerateProviderAppointmentsPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        providerUuid: string;
        startDate?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      providerUuid: string;
      startDate?: string;
    },
    TContext
  >({
    mutationFn: ({ providerUuid, startDate }) =>
      PdfControllerService.generateProviderAppointmentsPdf({
        providerUuid,
        startDate,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.pocUuid
 * @returns string OK
 * @throws ApiError
 */
export const usePdfControllerServiceGeneratePocPdf = <
  TData = Common.PdfControllerServiceGeneratePocPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        pocUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      pocUuid: string;
    },
    TContext
  >({
    mutationFn: ({ pocUuid }) =>
      PdfControllerService.generatePocPdf({
        pocUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientInformationUuid
 * @returns string OK
 * @throws ApiError
 */
export const usePdfControllerServiceGeneratePatientInformationPdf = <
  TData =
    Common.PdfControllerServiceGeneratePatientInformationPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientInformationUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientInformationUuid: string;
    },
    TContext
  >({
    mutationFn: ({ patientInformationUuid }) =>
      PdfControllerService.generatePatientInformationPdf({
        patientInformationUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.medicationUuids
 * @param data.status
 * @param data.requestBody
 * @returns string OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateMedicationsPdf = <
  TData = Common.PdfControllerServiceGenerateMedicationsPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        medicationUuids?: string[];
        patientUuid: string;
        requestBody?: string[];
        status?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      medicationUuids?: string[];
      patientUuid: string;
      requestBody?: string[];
      status?: string;
    },
    TContext
  >({
    mutationFn: ({ medicationUuids, patientUuid, requestBody, status }) =>
      PdfControllerService.generateMedicationsPdf({
        medicationUuids,
        patientUuid,
        requestBody,
        status,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateLabResultPdf = <
  TData = Common.PdfControllerServiceGenerateLabResultPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LabResultPdfDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LabResultPdfDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PdfControllerService.generateLabResultPdf({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.labResultUuid
 * @returns unknown OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateLabResultPdfByUuid = <
  TData = Common.PdfControllerServiceGenerateLabResultPdfByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        labResultUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      labResultUuid: string;
    },
    TContext
  >({
    mutationFn: ({ labResultUuid }) =>
      PdfControllerService.generateLabResultPdfByUuid({
        labResultUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns unknown OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateLabOrdersPdf = <
  TData = Common.PdfControllerServiceGenerateLabOrdersPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
    },
    TContext
  >({
    mutationFn: ({ patientUuid }) =>
      PdfControllerService.generateLabOrdersPdf({
        patientUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.inventoryOrderUuid
 * @returns string OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateInventoryOrderPdf = <
  TData = Common.PdfControllerServiceGenerateInventoryOrderPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        inventoryOrderUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      inventoryOrderUuid: string;
    },
    TContext
  >({
    mutationFn: ({ inventoryOrderUuid }) =>
      PdfControllerService.generateInventoryOrderPdf({
        inventoryOrderUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.locationInventoryUuid
 * @returns string OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateInventoryDetailPdf = <
  TData = Common.PdfControllerServiceGenerateInventoryDetailPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        locationInventoryUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      locationInventoryUuid: string;
    },
    TContext
  >({
    mutationFn: ({ locationInventoryUuid }) =>
      PdfControllerService.generateInventoryDetailPdf({
        locationInventoryUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns unknown OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateImmunizationsPdf = <
  TData = Common.PdfControllerServiceGenerateImmunizationsPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
    },
    TContext
  >({
    mutationFn: ({ patientUuid }) =>
      PdfControllerService.generateImmunizationsPdf({
        patientUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.imagingResultUuid
 * @returns unknown OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateImagingResultPdf = <
  TData = Common.PdfControllerServiceGenerateImagingResultPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        imagingResultUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      imagingResultUuid: string;
    },
    TContext
  >({
    mutationFn: ({ imagingResultUuid }) =>
      PdfControllerService.generateImagingResultPdf({
        imagingResultUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.handpNoteUuid
 * @param data.localDateTime
 * @returns unknown OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateHandpNotePdf = <
  TData = Common.PdfControllerServiceGenerateHandpNotePdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        handpNoteUuid: string;
        localDateTime: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      handpNoteUuid: string;
      localDateTime: string;
    },
    TContext
  >({
    mutationFn: ({ handpNoteUuid, localDateTime }) =>
      PdfControllerService.generateHandpNotePdf({
        handpNoteUuid,
        localDateTime,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns unknown OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateFacesheetPdf = <
  TData = Common.PdfControllerServiceGenerateFacesheetPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
    },
    TContext
  >({
    mutationFn: ({ patientUuid }) =>
      PdfControllerService.generateFacesheetPdf({
        patientUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.status
 * @returns unknown OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateDiagnosisPdf = <
  TData = Common.PdfControllerServiceGenerateDiagnosisPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        status?: "ACTIVE" | "HISTORICAL" | "RESOLVED";
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      status?: "ACTIVE" | "HISTORICAL" | "RESOLVED";
    },
    TContext
  >({
    mutationFn: ({ patientUuid, status }) =>
      PdfControllerService.generateDiagnosisPdf({
        patientUuid,
        status,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns string OK
 * @throws ApiError
 */
export const usePdfControllerServiceGenerateAuditLogPdf = <
  TData = Common.PdfControllerServiceGenerateAuditLogPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: { [key: string]: { [key: string]: unknown } };
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: { [key: string]: { [key: string]: unknown } };
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PdfControllerService.generateAuditLogPdf({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Make payout to agent/broker
 * Creates an ACH payout to the specified bank account for agent commission payments
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAgentPayoutServiceMakePayout = <
  TData = Common.AgentPayoutServiceMakePayoutMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: MakePayoutRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: MakePayoutRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AgentPayoutService.makePayout({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Add bank account for agent payouts
 * Creates a Stripe bank account token for agent commission payouts
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAgentPayoutServiceAddPayoutBankAccount = <
  TData = Common.AgentPayoutServiceAddPayoutBankAccountMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AddPayoutBankAccountRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AddPayoutBankAccountRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AgentPayoutService.addPayoutBankAccount({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Verify agent bank account
 * Verifies bank account ownership using micro-deposit amounts
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAgentPayoutServiceVerifyPayoutBankAccount = <
  TData = Common.AgentPayoutServiceVerifyPayoutBankAccountMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: VerifyPayoutBankAccountRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: VerifyPayoutBankAccountRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AgentPayoutService.verifyPayoutBankAccount({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useInventoryOrderControllerServiceAddToInventory = <
  TData = Common.InventoryOrderControllerServiceAddToInventoryMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AddInventoryRequest[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AddInventoryRequest[];
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      InventoryOrderControllerService.addToInventory({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useInventoryOrderControllerServicePollShipments = <
  TData = Common.InventoryOrderControllerServicePollShipmentsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    "mutationFn"
  >,
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      InventoryOrderControllerService.pollShipments() as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useInventoryOrderControllerServicePlaceOrderOnNorthWind = <
  TData =
    Common.InventoryOrderControllerServicePlaceOrderOnNorthWindMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: { file: Blob | File };
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: { file: Blob | File };
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      InventoryOrderControllerService.placeOrderOnNorthWind({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useInventoryOrderControllerServiceTransferInventory = <
  TData = Common.InventoryOrderControllerServiceTransferInventoryMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LocationInventoryTransferRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LocationInventoryTransferRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      InventoryOrderControllerService.transferInventory({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useInventoryOrderControllerServiceAddInventoryQuantity = <
  TData =
    Common.InventoryOrderControllerServiceAddInventoryQuantityMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AddInventoryRequest[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AddInventoryRequest[];
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      InventoryOrderControllerService.addInventoryQuantity({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useGoogleMapsControllerServiceUploadPatientAddressesCsv = <
  TData =
    Common.GoogleMapsControllerServiceUploadPatientAddressesCsvMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        employerUuid: string;
        requestBody?: { file: Blob | File };
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      employerUuid: string;
      requestBody?: { file: Blob | File };
    },
    TContext
  >({
    mutationFn: ({ employerUuid, requestBody }) =>
      GoogleMapsControllerService.uploadPatientAddressesCsv({
        employerUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.onlyPhp
 * @param data.name
 * @param data.uploadBatchUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useGoogleMapsControllerServiceGenerateShareLink = <
  TData = Common.GoogleMapsControllerServiceGenerateShareLinkMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        employerUuid?: string;
        name?: string;
        onlyPhp?: boolean;
        uploadBatchUuid?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      employerUuid?: string;
      name?: string;
      onlyPhp?: boolean;
      uploadBatchUuid?: string;
    },
    TContext
  >({
    mutationFn: ({ employerUuid, name, onlyPhp, uploadBatchUuid }) =>
      GoogleMapsControllerService.generateShareLink({
        employerUuid,
        name,
        onlyPhp,
        uploadBatchUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useFutureBillingControllerServiceRegenerateInvoiceWithCurrentRenewalDate =
  <
    TData =
      Common.FutureBillingControllerServiceRegenerateInvoiceWithCurrentRenewalDateMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          patientUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        patientUuid: string;
      },
      TContext
    >({
      mutationFn: ({ patientUuid }) =>
        FutureBillingControllerService.regenerateInvoiceWithCurrentRenewalDate({
          patientUuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useFutureBillingControllerServiceRegenerateEmployerMembershipInvoice =
  <
    TData =
      Common.FutureBillingControllerServiceRegenerateEmployerMembershipInvoiceMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          employerUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        employerUuid: string;
      },
      TContext
    >({
      mutationFn: ({ employerUuid }) =>
        FutureBillingControllerService.regenerateEmployerMembershipInvoice({
          employerUuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.force
 * @returns Response OK
 * @throws ApiError
 */
export const useCsvControllerServiceUploadEmployeeUploadTemplate = <
  TData = Common.CsvControllerServiceUploadEmployeeUploadTemplateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        force?: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      force?: boolean;
    },
    TContext
  >({
    mutationFn: ({ force }) =>
      CsvControllerService.uploadEmployeeUploadTemplate({
        force,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCartControllerServicePlaceOrder = <
  TData = Common.CartControllerServicePlaceOrderMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: string[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: string[];
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      CartControllerService.placeOrder({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.locationInventoryUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCartControllerServiceAddToCart = <
  TData = Common.CartControllerServiceAddToCartMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        locationInventoryUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      locationInventoryUuid: string;
    },
    TContext
  >({
    mutationFn: ({ locationInventoryUuid }) =>
      CartControllerService.addToCart({
        locationInventoryUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Refresh Token
 * Get a new access token using a valid refresh token
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useMobileAuthControllerServiceRefresh = <
  TData = Common.MobileAuthControllerServiceRefreshMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: RefreshTokenRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: RefreshTokenRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      MobileAuthControllerService.refresh({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Confirm MFA Enrollment
 * Confirm the initial TOTP code after scanning the QR, persists the OTP credential in Keycloak, and returns tokens.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useMobileAuthControllerServiceConfirmEnrollment = <
  TData = Common.MobileAuthControllerServiceConfirmEnrollmentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ConfirmEnrollmentRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ConfirmEnrollmentRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      MobileAuthControllerService.confirmEnrollment({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Mobile Logout
 * Invalidate the user's refresh token in Keycloak
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useMobileAuthControllerServiceLogout = <
  TData = Common.MobileAuthControllerServiceLogoutMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LogoutRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LogoutRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      MobileAuthControllerService.logout({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Mobile Login
 * Authenticate mobile user with username/email and password. Returns tokens, or an MFA challenge, or an enrollment challenge depending on the user's MFA state and enforcement policy.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useMobileAuthControllerServiceLogin = <
  TData = Common.MobileAuthControllerServiceLoginMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: MobileLoginRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: MobileLoginRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      MobileAuthControllerService.login({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Verify MFA OTP
 * Exchange a valid mfaToken and TOTP code for access & refresh tokens
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useMobileAuthControllerServiceVerifyOtp = <
  TData = Common.MobileAuthControllerServiceVerifyOtpMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: VerifyOtpRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: VerifyOtpRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      MobileAuthControllerService.verifyOtp({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Forgot Password
 * Emails the user a one-time link to set a new password — the same Keycloak UPDATE_PASSWORD action email the web forgot-password flow sends. Accepts a username or an email address. The response is identical whether or not the account exists, so it cannot be used to enumerate accounts.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useMobileAuthControllerServiceForgotPassword = <
  TData = Common.MobileAuthControllerServiceForgotPasswordMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ForgotPasswordRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ForgotPasswordRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      MobileAuthControllerService.forgotPassword({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.resultUuid
 * @param data.resultType
 * @param data.reviewComment
 * @returns Response OK
 * @throws ApiError
 */
export const useDashboardControllerServiceMarkReviewResult = <
  TData = Common.DashboardControllerServiceMarkReviewResultMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        resultType: "LAB_RESULT" | "IMAGING_RESULT" | "POC_LAB_RESULT";
        resultUuid: string;
        reviewComment?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      resultType: "LAB_RESULT" | "IMAGING_RESULT" | "POC_LAB_RESULT";
      resultUuid: string;
      reviewComment?: string;
    },
    TContext
  >({
    mutationFn: ({ resultType, resultUuid, reviewComment }) =>
      DashboardControllerService.markReviewResult({
        resultType,
        resultUuid,
        reviewComment,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useWorkNoteControllerServiceAddWorkNote = <
  TData = Common.WorkNoteControllerServiceAddWorkNoteMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: WorkNoteRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: WorkNoteRequestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      WorkNoteControllerService.addWorkNote({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.draft
 * @returns Response OK
 * @throws ApiError
 */
export const useVitalControllerServiceAddVital = <
  TData = Common.VitalControllerServiceAddVitalMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        draft?: boolean;
        requestBody: VitalDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      draft?: boolean;
      requestBody: VitalDto;
    },
    TContext
  >({
    mutationFn: ({ draft, requestBody }) =>
      VitalControllerService.addVital({
        draft,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useVitalControllerServiceRecalculateGrowthPercentiles = <
  TData =
    Common.VitalControllerServiceRecalculateGrowthPercentilesMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    "mutationFn"
  >,
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      VitalControllerService.recalculateGrowthPercentiles() as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useVaccineControllerServiceCreateVaccine = <
  TData = Common.VaccineControllerServiceCreateVaccineMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: VaccineDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: VaccineDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      VaccineControllerService.createVaccine({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useTaskControllerServiceAddTask = <
  TData = Common.TaskControllerServiceAddTaskMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: TaskRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: TaskRequestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TaskControllerService.addTask({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.threadUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTaskControllerServiceResolveTasksForThread = <
  TData = Common.TaskControllerServiceResolveTasksForThreadMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        threadUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      threadUuid: string;
    },
    TContext
  >({
    mutationFn: ({ threadUuid }) =>
      TaskControllerService.resolveTasksForThread({
        threadUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useTaskControllerServiceProcessTaskReminders = <
  TData = Common.TaskControllerServiceProcessTaskRemindersMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    "mutationFn"
  >,
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      TaskControllerService.processTaskReminders() as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useStatusConfigurationControllerServiceCreateStatusConfiguration =
  <
    TData =
      Common.StatusConfigurationControllerServiceCreateStatusConfigurationMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: StatusConfigurationDto;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: StatusConfigurationDto;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        StatusConfigurationControllerService.createStatusConfiguration({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useSocialHistoryControllerServiceCreate1 = <
  TData = Common.SocialHistoryControllerServiceCreate1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PatientModuleAccessRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PatientModuleAccessRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      SocialHistoryControllerService.create1({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteControllerServiceAddSoapNote = <
  TData = Common.SoapNoteControllerServiceAddSoapNoteMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: SoapNoteRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: SoapNoteRequestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      SoapNoteControllerService.addSoapNote({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteTemplateControllerServiceAddSoapNoteTemplate = <
  TData =
    Common.SoapNoteTemplateControllerServiceAddSoapNoteTemplateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: SoapNoteTemplateDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: SoapNoteTemplateDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      SoapNoteTemplateControllerService.addSoapNoteTemplate({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useScreenHistoryControllerServiceCreate11 = <
  TData = Common.ScreenHistoryControllerServiceCreate11MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ScreenHistoryDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ScreenHistoryDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ScreenHistoryControllerService.create11({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useReviewOfSystemTemplateControllerServiceAddReviewOfSystemTemplate =
  <
    TData =
      Common.ReviewOfSystemTemplateControllerServiceAddReviewOfSystemTemplateMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: ReviewOfSystemTemplateDto;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: ReviewOfSystemTemplateDto;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        ReviewOfSystemTemplateControllerService.addReviewOfSystemTemplate({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useReviewOfSystemControllerServiceAddReviewOfSystem = <
  TData = Common.ReviewOfSystemControllerServiceAddReviewOfSystemMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ReviewOfSystemDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ReviewOfSystemDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ReviewOfSystemControllerService.addReviewOfSystem({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.draft
 * @returns Response OK
 * @throws ApiError
 */
export const useReferralControllerServiceSaveReferral = <
  TData = Common.ReferralControllerServiceSaveReferralMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        draft?: boolean;
        requestBody: ReferralRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      draft?: boolean;
      requestBody: ReferralRequest;
    },
    TContext
  >({
    mutationFn: ({ draft, requestBody }) =>
      ReferralControllerService.saveReferral({
        draft,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderDirectoryControllerServiceUploadCsv1 = <
  TData = Common.ProviderDirectoryControllerServiceUploadCsv1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: { file: Blob | File };
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: { file: Blob | File };
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ProviderDirectoryControllerService.uploadCsv1({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderDirectoryControllerServiceTriggerNppesImport = <
  TData =
    Common.ProviderDirectoryControllerServiceTriggerNppesImportMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    "mutationFn"
  >,
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      ProviderDirectoryControllerService.triggerNppesImport() as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.fileType
 * @param data.fileName
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderDirectoryControllerServiceTriggerNppesFileImport = <
  TData =
    Common.ProviderDirectoryControllerServiceTriggerNppesFileImportMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        fileName: string;
        fileType: "MONTHLY" | "WEEKLY" | "DEACTIVATION";
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      fileName: string;
      fileType: "MONTHLY" | "WEEKLY" | "DEACTIVATION";
    },
    TContext
  >({
    mutationFn: ({ fileName, fileType }) =>
      ProviderDirectoryControllerService.triggerNppesFileImport({
        fileName,
        fileType,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderDirectoryControllerServiceSaveProviderDirectory = <
  TData =
    Common.ProviderDirectoryControllerServiceSaveProviderDirectoryMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ProviderDirectoryRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ProviderDirectoryRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ProviderDirectoryControllerService.saveProviderDirectory({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePointsOfCareLabControllerServiceCreatePointOfCareLab = <
  TData =
    Common.PointsOfCareLabControllerServiceCreatePointOfCareLabMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PointOfCareLabDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PointOfCareLabDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PointsOfCareLabControllerService.createPointOfCareLab({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePocLabTestControllerServiceAddPocLabTest = <
  TData = Common.PocLabTestControllerServiceAddPocLabTestMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PocLabTestRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PocLabTestRequestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PocLabTestControllerService.addPocLabTest({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.draft
 * @returns Response OK
 * @throws ApiError
 */
export const usePocLabResultControllerServiceAddPocLabResult = <
  TData = Common.PocLabResultControllerServiceAddPocLabResultMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        draft?: boolean;
        requestBody: PocLabResultRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      draft?: boolean;
      requestBody: PocLabResultRequestDto;
    },
    TContext
  >({
    mutationFn: ({ draft, requestBody }) =>
      PocLabResultControllerService.addPocLabResult({
        draft,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePhysicalExamTemplateControllerServiceAddPhysicalExamTemplate = <
  TData =
    Common.PhysicalExamTemplateControllerServiceAddPhysicalExamTemplateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PhysicalExamTemplateDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PhysicalExamTemplateDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PhysicalExamTemplateControllerService.addPhysicalExamTemplate({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePhysicalExamControllerServiceAddPhysicalExam = <
  TData = Common.PhysicalExamControllerServiceAddPhysicalExamMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PhysicalExamDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PhysicalExamDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PhysicalExamControllerService.addPhysicalExam({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePharmacyControllerServiceAddPharmacy = <
  TData = Common.PharmacyControllerServiceAddPharmacyMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PharmacyDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PharmacyDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PharmacyControllerService.addPharmacy({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.draft
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientVaccinationControllerServiceCreatePatientVaccination = <
  TData =
    Common.PatientVaccinationControllerServiceCreatePatientVaccinationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        draft?: boolean;
        requestBody: PatientVaccinationDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      draft?: boolean;
      requestBody: PatientVaccinationDto;
    },
    TContext
  >({
    mutationFn: ({ draft, requestBody }) =>
      PatientVaccinationControllerService.createPatientVaccination({
        draft,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientFlagControllerServiceAddPatientFlag = <
  TData = Common.PatientFlagControllerServiceAddPatientFlagMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PatientFlagDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PatientFlagDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PatientFlagControllerService.addPatientFlag({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePastSurgicalHistoryControllerServiceAddPastSurgicalHistory = <
  TData =
    Common.PastSurgicalHistoryControllerServiceAddPastSurgicalHistoryMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PastSurgicalHistoryDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PastSurgicalHistoryDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PastSurgicalHistoryControllerService.addPastSurgicalHistory({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.draft
 * @returns Response OK
 * @throws ApiError
 */
export const usePastMedicalHistoryControllerServiceAddPastMedicalHistory = <
  TData =
    Common.PastMedicalHistoryControllerServiceAddPastMedicalHistoryMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        draft?: boolean;
        requestBody: PastMedicalHistoryDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      draft?: boolean;
      requestBody: PastMedicalHistoryDto;
    },
    TContext
  >({
    mutationFn: ({ draft, requestBody }) =>
      PastMedicalHistoryControllerService.addPastMedicalHistory({
        draft,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.threadUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNoteControllerServiceSaveThreadToChart = <
  TData = Common.NoteControllerServiceSaveThreadToChartMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: NoteRequest;
        threadUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: NoteRequest;
      threadUuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, threadUuid }) =>
      NoteControllerService.saveThreadToChart({
        requestBody,
        threadUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNoteControllerServiceSaveNote = <
  TData = Common.NoteControllerServiceSaveNoteMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: NoteRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: NoteRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      NoteControllerService.saveNote({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useMedicationControllerServiceUploadMedications = <
  TData = Common.MedicationControllerServiceUploadMedicationsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        requestBody?: { file: Blob | File };
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      requestBody?: { file: Blob | File };
    },
    TContext
  >({
    mutationFn: ({ patientUuid, requestBody }) =>
      MedicationControllerService.uploadMedications({
        patientUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.draft
 * @returns Response OK
 * @throws ApiError
 */
export const useMedicationControllerServiceSaveMedication = <
  TData = Common.MedicationControllerServiceSaveMedicationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        draft?: boolean;
        requestBody: MedicationRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      draft?: boolean;
      requestBody: MedicationRequest;
    },
    TContext
  >({
    mutationFn: ({ draft, requestBody }) =>
      MedicationControllerService.saveMedication({
        draft,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useMacroControllerServiceAddMacro = <
  TData = Common.MacroControllerServiceAddMacroMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: MacroDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: MacroDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      MacroControllerService.addMacro({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.formData
 * @returns Response OK
 * @throws ApiError
 */
export const useLocationControllerServiceAddLocation = <
  TData = Common.LocationControllerServiceAddLocationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        formData?: {
          locationRequest: LocationRequestDto;
          template?: Blob | File;
        };
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      formData?: {
        locationRequest: LocationRequestDto;
        template?: Blob | File;
      };
    },
    TContext
  >({
    mutationFn: ({ formData }) =>
      LocationControllerService.addLocation({
        formData,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useLocationGroupControllerServiceAddLocationGroup = <
  TData = Common.LocationGroupControllerServiceAddLocationGroupMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LocationGroupRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LocationGroupRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      LocationGroupControllerService.addLocationGroup({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useLocationAvailabilityControllerServiceCreate21 = <
  TData = Common.LocationAvailabilityControllerServiceCreate21MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LocationAvailabilityDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LocationAvailabilityDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      LocationAvailabilityControllerService.create21({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientLinkPharmacyControllerServiceLinkPharmacy = <
  TData = Common.PatientLinkPharmacyControllerServiceLinkPharmacyMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PatientLinkedPharmacyDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PatientLinkedPharmacyDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PatientLinkPharmacyControllerService.linkPharmacy({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useLabTestControllerServiceCreateLabTest = <
  TData = Common.LabTestControllerServiceCreateLabTestMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LabTestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LabTestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      LabTestControllerService.createLabTest({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useLabResultControllerServiceProccesResult = <
  TData = Common.LabResultControllerServiceProccesResultMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    "mutationFn"
  >,
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      LabResultControllerService.proccesResult() as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.orderUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useLabResultControllerServiceAddLabResultByOrderUuid = <
  TData =
    Common.LabResultControllerServiceAddLabResultByOrderUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        orderUuid: string;
        requestBody: LabResultDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      orderUuid: string;
      requestBody: LabResultDto;
    },
    TContext
  >({
    mutationFn: ({ orderUuid, requestBody }) =>
      LabResultControllerService.addLabResultByOrderUuid({
        orderUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useLabResultControllerServiceAddLabResult = <
  TData = Common.LabResultControllerServiceAddLabResultMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ExternalLabResultDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ExternalLabResultDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      LabResultControllerService.addLabResult({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.draft
 * @returns Response OK
 * @throws ApiError
 */
export const useLabOrderControllerServiceCreateLabOrder = <
  TData = Common.LabOrderControllerServiceCreateLabOrderMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        draft?: boolean;
        requestBody: LabOrderDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      draft?: boolean;
      requestBody: LabOrderDto;
    },
    TContext
  >({
    mutationFn: ({ draft, requestBody }) =>
      LabOrderControllerService.createLabOrder({
        draft,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useLabOrderControllerServiceCalculatePrice = <
  TData = Common.LabOrderControllerServiceCalculatePriceMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: TestNamesDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: TestNamesDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      LabOrderControllerService.calculatePrice({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useLabOrderSetControllerServiceCreateLabOrderSet = <
  TData = Common.LabOrderSetControllerServiceCreateLabOrderSetMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LabOrderSetDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LabOrderSetDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      LabOrderSetControllerService.createLabOrderSet({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useInvoiceControllerServiceSaveInvoiceStatement = <
  TData = Common.InvoiceControllerServiceSaveInvoiceStatementMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: InvoiceStatementRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: InvoiceStatementRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      InvoiceControllerService.saveInvoiceStatement({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useInvoiceControllerServiceSaveInvoice = <
  TData = Common.InvoiceControllerServiceSaveInvoiceMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: InvoiceRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: InvoiceRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      InvoiceControllerService.saveInvoice({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useInsuranceControllerServiceCreateInsurance = <
  TData = Common.InsuranceControllerServiceCreateInsuranceMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        requestBody: InsuranceDetailsDto[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      requestBody: InsuranceDetailsDto[];
    },
    TContext
  >({
    mutationFn: ({ patientUuid, requestBody }) =>
      InsuranceControllerService.createInsurance({
        patientUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useImagingResultControllerServiceSaveImagingResult = <
  TData = Common.ImagingResultControllerServiceSaveImagingResultMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ImagingResultRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ImagingResultRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ImagingResultControllerService.saveImagingResult({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useImagingOrderControllerServiceSaveImagingOrder = <
  TData = Common.ImagingOrderControllerServiceSaveImagingOrderMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ImagingOrderRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ImagingOrderRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ImagingOrderControllerService.saveImagingOrder({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useIcdCodeControllerServiceCreateIcdCode = <
  TData = Common.IcdCodeControllerServiceCreateIcdCodeMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: IcdCodeDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: IcdCodeDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      IcdCodeControllerService.createIcdCode({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useHAndPNoteControllerServiceAddHandPnote = <
  TData = Common.HAndPNoteControllerServiceAddHandPnoteMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: HAndPNoteRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: HAndPNoteRequestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      HAndPNoteControllerService.addHandPnote({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useHabitsControllerServiceCreate31 = <
  TData = Common.HabitsControllerServiceCreate31MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: HabitsDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: HabitsDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      HabitsControllerService.create31({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useGlobalHolidayControllerServiceAddGlobalHoliday = <
  TData = Common.GlobalHolidayControllerServiceAddGlobalHolidayMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: GlobalHolidayDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: GlobalHolidayDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      GlobalHolidayControllerService.addGlobalHoliday({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useFormTemplateControllerServiceCreateFormTemplate = <
  TData = Common.FormTemplateControllerServiceCreateFormTemplateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: FormTemplateRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: FormTemplateRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      FormTemplateControllerService.createFormTemplate({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.formTemplateUuid
 * @param data.newName
 * @returns Response OK
 * @throws ApiError
 */
export const useFormTemplateControllerServiceDuplicateFormTemplate = <
  TData =
    Common.FormTemplateControllerServiceDuplicateFormTemplateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        formTemplateUuid: string;
        newName?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      formTemplateUuid: string;
      newName?: string;
    },
    TContext
  >({
    mutationFn: ({ formTemplateUuid, newName }) =>
      FormTemplateControllerService.duplicateFormTemplate({
        formTemplateUuid,
        newName,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.formData
 * @returns Response OK
 * @throws ApiError
 */
export const useFormTemplateControllerServiceCreateFormTemplateWithPdf = <
  TData =
    Common.FormTemplateControllerServiceCreateFormTemplateWithPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        formData?: { request: FormTemplateRequest; pdf?: Blob | File };
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      formData?: { request: FormTemplateRequest; pdf?: Blob | File };
    },
    TContext
  >({
    mutationFn: ({ formData }) =>
      FormTemplateControllerService.createFormTemplateWithPdf({
        formData,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useFdbMedicationsControllerServiceCreate4 = <
  TData = Common.FdbMedicationsControllerServiceCreate4MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: FdbMedicationsDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: FdbMedicationsDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      FdbMedicationsControllerService.create4({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.draft
 * @returns Response OK
 * @throws ApiError
 */
export const useFamilyHistoryControllerServiceAddFamilyHistory = <
  TData = Common.FamilyHistoryControllerServiceAddFamilyHistoryMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        draft?: boolean;
        requestBody: FamilyHistoryDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      draft?: boolean;
      requestBody: FamilyHistoryDto;
    },
    TContext
  >({
    mutationFn: ({ draft, requestBody }) =>
      FamilyHistoryControllerService.addFamilyHistory({
        draft,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEducationalMaterialControllerServiceCreateEducationalMaterial =
  <
    TData =
      Common.EducationalMaterialControllerServiceCreateEducationalMaterialMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: EducationalMaterialDto;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: EducationalMaterialDto;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        EducationalMaterialControllerService.createEducationalMaterial({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.educationalMaterialUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEducationalMaterialControllerServiceSetPatientsForMaterial = <
  TData =
    Common.EducationalMaterialControllerServiceSetPatientsForMaterialMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        educationalMaterialUuid: string;
        requestBody?: string[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      educationalMaterialUuid: string;
      requestBody?: string[];
    },
    TContext
  >({
    mutationFn: ({ educationalMaterialUuid, requestBody }) =>
      EducationalMaterialControllerService.setPatientsForMaterial({
        educationalMaterialUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useDrugIntoleranceControllerServiceAddDrugIntolerance = <
  TData =
    Common.DrugIntoleranceControllerServiceAddDrugIntoleranceMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: DrugIntoleranceDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: DrugIntoleranceDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      DrugIntoleranceControllerService.addDrugIntolerance({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useDocumentTypeControllerServiceSaveDocumentType = <
  TData = Common.DocumentTypeControllerServiceSaveDocumentTypeMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: DocumentTypeRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: DocumentTypeRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      DocumentTypeControllerService.saveDocumentType({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useDiagnosisControllerServiceAddDiagnosis = <
  TData = Common.DiagnosisControllerServiceAddDiagnosisMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: DiagnosisDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: DiagnosisDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      DiagnosisControllerService.addDiagnosis({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCptCodeControllerServiceAddCptCode = <
  TData = Common.CptCodeControllerServiceAddCptCodeMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CptCodeDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CptCodeDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      CptCodeControllerService.addCptCode({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCommentControllerServiceAddMessage = <
  TData = Common.CommentControllerServiceAddMessageMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CommentRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CommentRequestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      CommentControllerService.addMessage({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCarePlanControllerServiceSaveCarePlan = <
  TData = Common.CarePlanControllerServiceSaveCarePlanMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CarePlanRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CarePlanRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      CarePlanControllerService.saveCarePlan({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAvailabilityControllerServiceAddAvailability = <
  TData = Common.AvailabilityControllerServiceAddAvailabilityMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AvailabilityDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AvailabilityDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AvailabilityControllerService.addAvailability({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.occurrenceDateTime
 * @returns Response OK
 * @throws ApiError
 */
export const useAvailabilityControllerServiceCreateBlockSlot = <
  TData = Common.AvailabilityControllerServiceCreateBlockSlotMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        occurrenceDateTime?: string;
        requestBody: AppointmentBlockTimeDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      occurrenceDateTime?: string;
      requestBody: AppointmentBlockTimeDto;
    },
    TContext
  >({
    mutationFn: ({ occurrenceDateTime, requestBody }) =>
      AvailabilityControllerService.createBlockSlot({
        occurrenceDateTime,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAppointmentControllerServiceCreateAppointment = <
  TData = Common.AppointmentControllerServiceCreateAppointmentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AppointmentDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AppointmentDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AppointmentControllerService.createAppointment({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.appointmentUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAppointmentControllerServiceSubmitVideoConsent = <
  TData = Common.AppointmentControllerServiceSubmitVideoConsentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        appointmentUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      appointmentUuid: string;
    },
    TContext
  >({
    mutationFn: ({ appointmentUuid }) =>
      AppointmentControllerService.submitVideoConsent({
        appointmentUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.appointmentUuid
 * @param data.appointmentStartDateTime
 * @returns Response OK
 * @throws ApiError
 */
export const useAppointmentControllerServiceConfirmAppointmentFromSms = <
  TData =
    Common.AppointmentControllerServiceConfirmAppointmentFromSmsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        appointmentStartDateTime: string;
        appointmentUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      appointmentStartDateTime: string;
      appointmentUuid: string;
    },
    TContext
  >({
    mutationFn: ({ appointmentStartDateTime, appointmentUuid }) =>
      AppointmentControllerService.confirmAppointmentFromSms({
        appointmentStartDateTime,
        appointmentUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useAppointmentControllerServiceGenerateCalendarSyncUrl = <
  TData =
    Common.AppointmentControllerServiceGenerateCalendarSyncUrlMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    "mutationFn"
  >,
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      AppointmentControllerService.generateCalendarSyncUrl() as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAppointmentTypeControllerServiceCreateAppointmentType = <
  TData =
    Common.AppointmentTypeControllerServiceCreateAppointmentTypeMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AppointmentTypeDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AppointmentTypeDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AppointmentTypeControllerService.createAppointmentType({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAnnotableImageControllerServiceAddAnnotableImage = <
  TData = Common.AnnotableImageControllerServiceAddAnnotableImageMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AnnotableImageDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AnnotableImageDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AnnotableImageControllerService.addAnnotableImage({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAnnotableImageTemplateControllerServiceAddAnnotableImageTemplate =
  <
    TData =
      Common.AnnotableImageTemplateControllerServiceAddAnnotableImageTemplateMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: AnnotableImageTemplateDto;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: AnnotableImageTemplateDto;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        AnnotableImageTemplateControllerService.addAnnotableImageTemplate({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAnnotableImagePinControllerServiceAddAnnotableImagePin = <
  TData =
    Common.AnnotableImagePinControllerServiceAddAnnotableImagePinMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AnnotableImagePinDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AnnotableImagePinDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AnnotableImagePinControllerService.addAnnotableImagePin({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.draft
 * @returns Response OK
 * @throws ApiError
 */
export const useAllergyControllerServiceAddAllergy = <
  TData = Common.AllergyControllerServiceAddAllergyMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        draft?: boolean;
        requestBody: AllergyDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      draft?: boolean;
      requestBody: AllergyDto;
    },
    TContext
  >({
    mutationFn: ({ draft, requestBody }) =>
      AllergyControllerService.addAllergy({
        draft,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.questionnaireUuid
 * @param data.patientUuid
 * @param data.formData
 * @returns Response OK
 * @throws ApiError
 */
export const useQuestionnaireControllerServiceSubmitQuestionnaireMultipart = <
  TData =
    Common.QuestionnaireControllerServiceSubmitQuestionnaireMultipartMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        formData?: { pdfs?: (Blob | File)[] };
        patientUuid: string;
        questionnaireUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      formData?: { pdfs?: (Blob | File)[] };
      patientUuid: string;
      questionnaireUuid: string;
    },
    TContext
  >({
    mutationFn: ({ formData, patientUuid, questionnaireUuid }) =>
      QuestionnaireControllerService.submitQuestionnaireMultipart({
        formData,
        patientUuid,
        questionnaireUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.questionnaireUuid
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useQuestionnaireControllerServiceSendQuestionnaireReminder = <
  TData =
    Common.QuestionnaireControllerServiceSendQuestionnaireReminderMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        questionnaireUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      questionnaireUuid: string;
    },
    TContext
  >({
    mutationFn: ({ patientUuid, questionnaireUuid }) =>
      QuestionnaireControllerService.sendQuestionnaireReminder({
        patientUuid,
        questionnaireUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.questionnaireUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useQuestionnaireControllerServiceSendQuestionnaireFax1 = <
  TData =
    Common.QuestionnaireControllerServiceSendQuestionnaireFax1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        questionnaireUuid: string;
        requestBody: QuestionnaireFaxDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      questionnaireUuid: string;
      requestBody: QuestionnaireFaxDto;
    },
    TContext
  >({
    mutationFn: ({ questionnaireUuid, requestBody }) =>
      QuestionnaireControllerService.sendQuestionnaireFax1({
        questionnaireUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useQuestionnaireControllerServiceUploadPdf = <
  TData = Common.QuestionnaireControllerServiceUploadPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: UploadFormPdfRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: UploadFormPdfRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      QuestionnaireControllerService.uploadPdf({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns string OK
 * @throws ApiError
 */
export const useQuestResultPushControllerServiceReceiveQuestResult = <
  TData =
    Common.QuestResultPushControllerServiceReceiveQuestResultMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      QuestResultPushControllerService.receiveQuestResult({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.orderUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useQuestControllerServiceGetOrderDocument = <
  TData = Common.QuestControllerServiceGetOrderDocumentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        orderUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      orderUuid: string;
    },
    TContext
  >({
    mutationFn: ({ orderUuid }) =>
      QuestControllerService.getOrderDocument({
        orderUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useHl7ControllerServiceUpdateCompadium = <
  TData = Common.Hl7ControllerServiceUpdateCompadiumMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    "mutationFn"
  >,
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      Hl7ControllerService.updateCompadium() as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useHl7ControllerServiceSendOrder = <
  TData = Common.Hl7ControllerServiceSendOrderMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LabOrderDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LabOrderDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      Hl7ControllerService.sendOrder({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useHl7ControllerServiceSubmitToQuest = <
  TData = Common.Hl7ControllerServiceSubmitToQuestMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LabOrderDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LabOrderDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      Hl7ControllerService.submitToQuest({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useHl7ControllerServiceTestOrderQuest = <
  TData = Common.Hl7ControllerServiceTestOrderQuestMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LabOrderDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LabOrderDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      Hl7ControllerService.testOrderQuest({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.orderNumber
 * @param data.startDate
 * @param data.endDate
 * @returns Response OK
 * @throws ApiError
 */
export const useHl7ControllerServiceGetResults = <
  TData = Common.Hl7ControllerServiceGetResultsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        endDate?: string;
        orderNumber?: string;
        startDate?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      endDate?: string;
      orderNumber?: string;
      startDate?: string;
    },
    TContext
  >({
    mutationFn: ({ endDate, orderNumber, startDate }) =>
      Hl7ControllerService.getResults({
        endDate,
        orderNumber,
        startDate,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.formUuid
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientFormControllerServiceSendFormToPatient = <
  TData = Common.PatientFormControllerServiceSendFormToPatientMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        formUuid: string;
        patientUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      formUuid: string;
      patientUuid: string;
    },
    TContext
  >({
    mutationFn: ({ formUuid, patientUuid }) =>
      PatientFormControllerService.sendFormToPatient({
        formUuid,
        patientUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientFormControllerServiceSendMultipleFormsToPatient = <
  TData =
    Common.PatientFormControllerServiceSendMultipleFormsToPatientMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        requestBody: string[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      requestBody: string[];
    },
    TContext
  >({
    mutationFn: ({ patientUuid, requestBody }) =>
      PatientFormControllerService.sendMultipleFormsToPatient({
        patientUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.formUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientFormControllerServiceSendFormToBulkPatients = <
  TData =
    Common.PatientFormControllerServiceSendFormToBulkPatientsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        formUuid: string;
        requestBody: string[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      formUuid: string;
      requestBody: string[];
    },
    TContext
  >({
    mutationFn: ({ formUuid, requestBody }) =>
      PatientFormControllerService.sendFormToBulkPatients({
        formUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.referenceType
 * @param data.documentKey
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useDocumentControllerServiceUploadDocument = <
  TData = Common.DocumentControllerServiceUploadDocumentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        documentKey?: "FRONT_SIDE" | "BACK_SIDE";
        referenceType?:
          | "SOAP_NOTE"
          | "HANDP_NOTE"
          | "IMAGING"
          | "LOCATION_PROFILE"
          | "PROVIDER_PROFILE"
          | "PATIENT_DOCUMENTS"
          | "DOCUMENTS"
          | "INVOICE"
          | "CUSTOM_LOGO"
          | "PATIENT_PROFILE"
          | "LAB_ORDER"
          | "INSURANCE"
          | "REFERRAL"
          | "ANNOTABLE_IMAGE"
          | "EMAIL_STRUCTURE"
          | "EMAIL_TEMPLATE"
          | "TICKET"
          | "QUESTIONNAIRE_PDF"
          | "CHAT_ATTACHMENTS"
          | "AGREEMENT_PDF"
          | "FORM_TEMPLATE_PDF"
          | "NORTHWIND_ORDER"
          | "NORTHWIND_SHIPMENT"
          | "PROVIDER_APPOINTMENTS"
          | "POC_RESULT"
          | "LAB_RESULT"
          | "PATIENT_INFORMATION";
        requestBody?: { file?: Blob | File };
        uuid?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      documentKey?: "FRONT_SIDE" | "BACK_SIDE";
      referenceType?:
        | "SOAP_NOTE"
        | "HANDP_NOTE"
        | "IMAGING"
        | "LOCATION_PROFILE"
        | "PROVIDER_PROFILE"
        | "PATIENT_DOCUMENTS"
        | "DOCUMENTS"
        | "INVOICE"
        | "CUSTOM_LOGO"
        | "PATIENT_PROFILE"
        | "LAB_ORDER"
        | "INSURANCE"
        | "REFERRAL"
        | "ANNOTABLE_IMAGE"
        | "EMAIL_STRUCTURE"
        | "EMAIL_TEMPLATE"
        | "TICKET"
        | "QUESTIONNAIRE_PDF"
        | "CHAT_ATTACHMENTS"
        | "AGREEMENT_PDF"
        | "FORM_TEMPLATE_PDF"
        | "NORTHWIND_ORDER"
        | "NORTHWIND_SHIPMENT"
        | "PROVIDER_APPOINTMENTS"
        | "POC_RESULT"
        | "LAB_RESULT"
        | "PATIENT_INFORMATION";
      requestBody?: { file?: Blob | File };
      uuid?: string;
    },
    TContext
  >({
    mutationFn: ({ documentKey, referenceType, requestBody, uuid }) =>
      DocumentControllerService.uploadDocument({
        documentKey,
        referenceType,
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useDocumentControllerServiceSaveDocument = <
  TData = Common.DocumentControllerServiceSaveDocumentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: DocumentRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: DocumentRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      DocumentControllerService.saveDocument({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useContactDirectoryControllerServiceSaveContactDirectory = <
  TData =
    Common.ContactDirectoryControllerServiceSaveContactDirectoryMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ContactDirectoryRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ContactDirectoryRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ContactDirectoryControllerService.saveContactDirectory({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.referenceType
 * @param data.userUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAwsControllerServiceUploadImageAsMultipart = <
  TData = Common.AwsControllerServiceUploadImageAsMultipartMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        referenceType:
          | "SOAP_NOTE"
          | "HANDP_NOTE"
          | "IMAGING"
          | "LOCATION_PROFILE"
          | "PROVIDER_PROFILE"
          | "PATIENT_DOCUMENTS"
          | "DOCUMENTS"
          | "INVOICE"
          | "CUSTOM_LOGO"
          | "PATIENT_PROFILE"
          | "LAB_ORDER"
          | "INSURANCE"
          | "REFERRAL"
          | "ANNOTABLE_IMAGE"
          | "EMAIL_STRUCTURE"
          | "EMAIL_TEMPLATE"
          | "TICKET"
          | "QUESTIONNAIRE_PDF"
          | "CHAT_ATTACHMENTS"
          | "AGREEMENT_PDF"
          | "FORM_TEMPLATE_PDF"
          | "NORTHWIND_ORDER"
          | "NORTHWIND_SHIPMENT"
          | "PROVIDER_APPOINTMENTS"
          | "POC_RESULT"
          | "LAB_RESULT"
          | "PATIENT_INFORMATION";
        requestBody?: { file: Blob | File };
        userUuid?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      referenceType:
        | "SOAP_NOTE"
        | "HANDP_NOTE"
        | "IMAGING"
        | "LOCATION_PROFILE"
        | "PROVIDER_PROFILE"
        | "PATIENT_DOCUMENTS"
        | "DOCUMENTS"
        | "INVOICE"
        | "CUSTOM_LOGO"
        | "PATIENT_PROFILE"
        | "LAB_ORDER"
        | "INSURANCE"
        | "REFERRAL"
        | "ANNOTABLE_IMAGE"
        | "EMAIL_STRUCTURE"
        | "EMAIL_TEMPLATE"
        | "TICKET"
        | "QUESTIONNAIRE_PDF"
        | "CHAT_ATTACHMENTS"
        | "AGREEMENT_PDF"
        | "FORM_TEMPLATE_PDF"
        | "NORTHWIND_ORDER"
        | "NORTHWIND_SHIPMENT"
        | "PROVIDER_APPOINTMENTS"
        | "POC_RESULT"
        | "LAB_RESULT"
        | "PATIENT_INFORMATION";
      requestBody?: { file: Blob | File };
      userUuid?: string;
    },
    TContext
  >({
    mutationFn: ({ referenceType, requestBody, userUuid }) =>
      AwsControllerService.uploadImageAsMultipart({
        referenceType,
        requestBody,
        userUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.referenceType
 * @param data.base64
 * @param data.userUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAwsControllerServiceUploadImageAsBase64 = <
  TData = Common.AwsControllerServiceUploadImageAsBase64MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        base64: string;
        referenceType:
          | "SOAP_NOTE"
          | "HANDP_NOTE"
          | "IMAGING"
          | "LOCATION_PROFILE"
          | "PROVIDER_PROFILE"
          | "PATIENT_DOCUMENTS"
          | "DOCUMENTS"
          | "INVOICE"
          | "CUSTOM_LOGO"
          | "PATIENT_PROFILE"
          | "LAB_ORDER"
          | "INSURANCE"
          | "REFERRAL"
          | "ANNOTABLE_IMAGE"
          | "EMAIL_STRUCTURE"
          | "EMAIL_TEMPLATE"
          | "TICKET"
          | "QUESTIONNAIRE_PDF"
          | "CHAT_ATTACHMENTS"
          | "AGREEMENT_PDF"
          | "FORM_TEMPLATE_PDF"
          | "NORTHWIND_ORDER"
          | "NORTHWIND_SHIPMENT"
          | "PROVIDER_APPOINTMENTS"
          | "POC_RESULT"
          | "LAB_RESULT"
          | "PATIENT_INFORMATION";
        userUuid?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      base64: string;
      referenceType:
        | "SOAP_NOTE"
        | "HANDP_NOTE"
        | "IMAGING"
        | "LOCATION_PROFILE"
        | "PROVIDER_PROFILE"
        | "PATIENT_DOCUMENTS"
        | "DOCUMENTS"
        | "INVOICE"
        | "CUSTOM_LOGO"
        | "PATIENT_PROFILE"
        | "LAB_ORDER"
        | "INSURANCE"
        | "REFERRAL"
        | "ANNOTABLE_IMAGE"
        | "EMAIL_STRUCTURE"
        | "EMAIL_TEMPLATE"
        | "TICKET"
        | "QUESTIONNAIRE_PDF"
        | "CHAT_ATTACHMENTS"
        | "AGREEMENT_PDF"
        | "FORM_TEMPLATE_PDF"
        | "NORTHWIND_ORDER"
        | "NORTHWIND_SHIPMENT"
        | "PROVIDER_APPOINTMENTS"
        | "POC_RESULT"
        | "LAB_RESULT"
        | "PATIENT_INFORMATION";
      userUuid?: string;
    },
    TContext
  >({
    mutationFn: ({ base64, referenceType, userUuid }) =>
      AwsControllerService.uploadImageAsBase64({
        base64,
        referenceType,
        userUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.referenceType
 * @param data.userUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAwsControllerServiceUploadDocumentAsMultipart = <
  TData = Common.AwsControllerServiceUploadDocumentAsMultipartMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        referenceType:
          | "SOAP_NOTE"
          | "HANDP_NOTE"
          | "IMAGING"
          | "LOCATION_PROFILE"
          | "PROVIDER_PROFILE"
          | "PATIENT_DOCUMENTS"
          | "DOCUMENTS"
          | "INVOICE"
          | "CUSTOM_LOGO"
          | "PATIENT_PROFILE"
          | "LAB_ORDER"
          | "INSURANCE"
          | "REFERRAL"
          | "ANNOTABLE_IMAGE"
          | "EMAIL_STRUCTURE"
          | "EMAIL_TEMPLATE"
          | "TICKET"
          | "QUESTIONNAIRE_PDF"
          | "CHAT_ATTACHMENTS"
          | "AGREEMENT_PDF"
          | "FORM_TEMPLATE_PDF"
          | "NORTHWIND_ORDER"
          | "NORTHWIND_SHIPMENT"
          | "PROVIDER_APPOINTMENTS"
          | "POC_RESULT"
          | "LAB_RESULT"
          | "PATIENT_INFORMATION";
        requestBody?: { file: Blob | File };
        userUuid?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      referenceType:
        | "SOAP_NOTE"
        | "HANDP_NOTE"
        | "IMAGING"
        | "LOCATION_PROFILE"
        | "PROVIDER_PROFILE"
        | "PATIENT_DOCUMENTS"
        | "DOCUMENTS"
        | "INVOICE"
        | "CUSTOM_LOGO"
        | "PATIENT_PROFILE"
        | "LAB_ORDER"
        | "INSURANCE"
        | "REFERRAL"
        | "ANNOTABLE_IMAGE"
        | "EMAIL_STRUCTURE"
        | "EMAIL_TEMPLATE"
        | "TICKET"
        | "QUESTIONNAIRE_PDF"
        | "CHAT_ATTACHMENTS"
        | "AGREEMENT_PDF"
        | "FORM_TEMPLATE_PDF"
        | "NORTHWIND_ORDER"
        | "NORTHWIND_SHIPMENT"
        | "PROVIDER_APPOINTMENTS"
        | "POC_RESULT"
        | "LAB_RESULT"
        | "PATIENT_INFORMATION";
      requestBody?: { file: Blob | File };
      userUuid?: string;
    },
    TContext
  >({
    mutationFn: ({ referenceType, requestBody, userUuid }) =>
      AwsControllerService.uploadDocumentAsMultipart({
        referenceType,
        requestBody,
        userUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.base64
 * @param data.userUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAwsControllerServiceUploadDocumentAsBase64 = <
  TData = Common.AwsControllerServiceUploadDocumentAsBase64MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        base64: string;
        userUuid?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      base64: string;
      userUuid?: string;
    },
    TContext
  >({
    mutationFn: ({ base64, userUuid }) =>
      AwsControllerService.uploadDocumentAsBase64({
        base64,
        userUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.agreementUuid
 * @param data.affiliateGroupUuid
 * @param data.formData
 * @returns Response OK
 * @throws ApiError
 */
export const useAgreementControllerServiceSubmitAgreementMultipart = <
  TData =
    Common.AgreementControllerServiceSubmitAgreementMultipartMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        affiliateGroupUuid: string;
        agreementUuid: string;
        formData?: { pdfs?: (Blob | File)[] };
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      affiliateGroupUuid: string;
      agreementUuid: string;
      formData?: { pdfs?: (Blob | File)[] };
    },
    TContext
  >({
    mutationFn: ({ affiliateGroupUuid, agreementUuid, formData }) =>
      AgreementControllerService.submitAgreementMultipart({
        affiliateGroupUuid,
        agreementUuid,
        formData,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.affiliateGroupUuid
 * @param data.formTemplateUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAgreementControllerServiceCreateAffiliateAgreement = <
  TData =
    Common.AgreementControllerServiceCreateAffiliateAgreementMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        affiliateGroupUuid: string;
        formTemplateUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      affiliateGroupUuid: string;
      formTemplateUuid: string;
    },
    TContext
  >({
    mutationFn: ({ affiliateGroupUuid, formTemplateUuid }) =>
      AgreementControllerService.createAffiliateAgreement({
        affiliateGroupUuid,
        formTemplateUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.affiliateGroupUuid
 * @param data.formTemplateUuids
 * @returns Response OK
 * @throws ApiError
 */
export const useAgreementControllerServiceCreateMultipleAffiliateAgreements = <
  TData =
    Common.AgreementControllerServiceCreateMultipleAffiliateAgreementsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        affiliateGroupUuid: string;
        formTemplateUuids: string[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      affiliateGroupUuid: string;
      formTemplateUuids: string[];
    },
    TContext
  >({
    mutationFn: ({ affiliateGroupUuid, formTemplateUuids }) =>
      AgreementControllerService.createMultipleAffiliateAgreements({
        affiliateGroupUuid,
        formTemplateUuids,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationControllerServiceCreateNotification = <
  TData = Common.NotificationControllerServiceCreateNotificationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: NotificationDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: NotificationDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      NotificationControllerService.createNotification({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationPreferenceControllerServiceAddNotificationPreference =
  <
    TData =
      Common.NotificationPreferenceControllerServiceAddNotificationPreferenceMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: NotificationPreferenceDto;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: NotificationPreferenceDto;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        NotificationPreferenceControllerService.addNotificationPreference({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.active
 * @param data.structure
 * @param data.fileName
 * @param data.objectRequestCategory
 * @param data.employerManagementNotificationSettingUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerManagementNotificationSettingControllerServiceUploadEmailStructureAndTemplateToS32 =
  <
    TData =
      Common.EmployerManagementNotificationSettingControllerServiceUploadEmailStructureAndTemplateToS32MutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          active: boolean;
          employerManagementNotificationSettingUuid: string;
          fileName: string;
          objectRequestCategory:
            | "ADMIN"
            | "PATIENT"
            | "BROKER"
            | "PROVIDER"
            | "SUPER_ADMIN"
            | "CRM"
            | "APPOINTMENT"
            | "BILLER"
            | "STAFF"
            | "EMPLOYER_ADMIN"
            | "EMPLOYER_USER"
            | "NURSE"
            | "AFFILIATE_PROVIDER";
          requestBody?: { template: Blob | File };
          structure: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        active: boolean;
        employerManagementNotificationSettingUuid: string;
        fileName: string;
        objectRequestCategory:
          | "ADMIN"
          | "PATIENT"
          | "BROKER"
          | "PROVIDER"
          | "SUPER_ADMIN"
          | "CRM"
          | "APPOINTMENT"
          | "BILLER"
          | "STAFF"
          | "EMPLOYER_ADMIN"
          | "EMPLOYER_USER"
          | "NURSE"
          | "AFFILIATE_PROVIDER";
        requestBody?: { template: Blob | File };
        structure: string;
      },
      TContext
    >({
      mutationFn: ({
        active,
        employerManagementNotificationSettingUuid,
        fileName,
        objectRequestCategory,
        requestBody,
        structure,
      }) =>
        EmployerManagementNotificationSettingControllerService.uploadEmailStructureAndTemplateToS32(
          {
            active,
            employerManagementNotificationSettingUuid,
            fileName,
            objectRequestCategory,
            requestBody,
            structure,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.employerManagementNotificationSettingUuid
 * @param data.active
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerManagementNotificationSettingControllerServiceUpdateStatus =
  <
    TData =
      Common.EmployerManagementNotificationSettingControllerServiceUpdateStatusMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          active: boolean;
          employerManagementNotificationSettingUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        active: boolean;
        employerManagementNotificationSettingUuid: string;
      },
      TContext
    >({
      mutationFn: ({ active, employerManagementNotificationSettingUuid }) =>
        EmployerManagementNotificationSettingControllerService.updateStatus({
          active,
          employerManagementNotificationSettingUuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePushNotificationControllerServiceSendFcmNotification = <
  TData =
    Common.PushNotificationControllerServiceSendFcmNotificationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: { [key: string]: string };
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: { [key: string]: string };
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PushNotificationControllerService.sendFcmNotification({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePushNotificationControllerServiceSendFcmBulkNotification = <
  TData =
    Common.PushNotificationControllerServiceSendFcmBulkNotificationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: { [key: string]: { [key: string]: unknown } };
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: { [key: string]: { [key: string]: unknown } };
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PushNotificationControllerService.sendFcmBulkNotification({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.notificationSettingUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceUpdateCustomNotification = <
  TData =
    Common.NotificationSettingControllerServiceUpdateCustomNotificationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        notificationSettingUuid: string;
        requestBody: NotificationSettingEnableRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      notificationSettingUuid: string;
      requestBody: NotificationSettingEnableRequest;
    },
    TContext
  >({
    mutationFn: ({ notificationSettingUuid, requestBody }) =>
      NotificationSettingControllerService.updateCustomNotification({
        notificationSettingUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendEmailForSetPassword = <
  TData =
    Common.NotificationSettingControllerServiceSendEmailForSetPasswordMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: UserInvitationDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: UserInvitationDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      NotificationSettingControllerService.sendEmailForSetPassword({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.fileName
 * @param data.objectRequestCategory
 * @param data.referenceType
 * @param data.notificationSettingUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceUploadEmailTemplateToS3 = <
  TData =
    Common.NotificationSettingControllerServiceUploadEmailTemplateToS3MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        fileName: string;
        notificationSettingUuid: string;
        objectRequestCategory:
          | "ADMIN"
          | "PATIENT"
          | "BROKER"
          | "PROVIDER"
          | "SUPER_ADMIN"
          | "CRM"
          | "APPOINTMENT"
          | "BILLER"
          | "STAFF"
          | "EMPLOYER_ADMIN"
          | "EMPLOYER_USER"
          | "NURSE"
          | "AFFILIATE_PROVIDER";
        referenceType:
          | "SOAP_NOTE"
          | "HANDP_NOTE"
          | "IMAGING"
          | "LOCATION_PROFILE"
          | "PROVIDER_PROFILE"
          | "PATIENT_DOCUMENTS"
          | "DOCUMENTS"
          | "INVOICE"
          | "CUSTOM_LOGO"
          | "PATIENT_PROFILE"
          | "LAB_ORDER"
          | "INSURANCE"
          | "REFERRAL"
          | "ANNOTABLE_IMAGE"
          | "EMAIL_STRUCTURE"
          | "EMAIL_TEMPLATE"
          | "TICKET"
          | "QUESTIONNAIRE_PDF"
          | "CHAT_ATTACHMENTS"
          | "AGREEMENT_PDF"
          | "FORM_TEMPLATE_PDF"
          | "NORTHWIND_ORDER"
          | "NORTHWIND_SHIPMENT"
          | "PROVIDER_APPOINTMENTS"
          | "POC_RESULT"
          | "LAB_RESULT"
          | "PATIENT_INFORMATION";
        requestBody?: { template: Blob | File };
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      fileName: string;
      notificationSettingUuid: string;
      objectRequestCategory:
        | "ADMIN"
        | "PATIENT"
        | "BROKER"
        | "PROVIDER"
        | "SUPER_ADMIN"
        | "CRM"
        | "APPOINTMENT"
        | "BILLER"
        | "STAFF"
        | "EMPLOYER_ADMIN"
        | "EMPLOYER_USER"
        | "NURSE"
        | "AFFILIATE_PROVIDER";
      referenceType:
        | "SOAP_NOTE"
        | "HANDP_NOTE"
        | "IMAGING"
        | "LOCATION_PROFILE"
        | "PROVIDER_PROFILE"
        | "PATIENT_DOCUMENTS"
        | "DOCUMENTS"
        | "INVOICE"
        | "CUSTOM_LOGO"
        | "PATIENT_PROFILE"
        | "LAB_ORDER"
        | "INSURANCE"
        | "REFERRAL"
        | "ANNOTABLE_IMAGE"
        | "EMAIL_STRUCTURE"
        | "EMAIL_TEMPLATE"
        | "TICKET"
        | "QUESTIONNAIRE_PDF"
        | "CHAT_ATTACHMENTS"
        | "AGREEMENT_PDF"
        | "FORM_TEMPLATE_PDF"
        | "NORTHWIND_ORDER"
        | "NORTHWIND_SHIPMENT"
        | "PROVIDER_APPOINTMENTS"
        | "POC_RESULT"
        | "LAB_RESULT"
        | "PATIENT_INFORMATION";
      requestBody?: { template: Blob | File };
    },
    TContext
  >({
    mutationFn: ({
      fileName,
      notificationSettingUuid,
      objectRequestCategory,
      referenceType,
      requestBody,
    }) =>
      NotificationSettingControllerService.uploadEmailTemplateToS3({
        fileName,
        notificationSettingUuid,
        objectRequestCategory,
        referenceType,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.active
 * @param data.structure
 * @param data.fileName
 * @param data.objectRequestCategory
 * @param data.notificationSettingUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceUploadEmailStructureAndTemplateToS3 =
  <
    TData =
      Common.NotificationSettingControllerServiceUploadEmailStructureAndTemplateToS3MutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          active: boolean;
          fileName: string;
          notificationSettingUuid: string;
          objectRequestCategory:
            | "ADMIN"
            | "PATIENT"
            | "BROKER"
            | "PROVIDER"
            | "SUPER_ADMIN"
            | "CRM"
            | "APPOINTMENT"
            | "BILLER"
            | "STAFF"
            | "EMPLOYER_ADMIN"
            | "EMPLOYER_USER"
            | "NURSE"
            | "AFFILIATE_PROVIDER";
          requestBody?: { template: Blob | File; headerTemplate?: Blob | File };
          structure: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        active: boolean;
        fileName: string;
        notificationSettingUuid: string;
        objectRequestCategory:
          | "ADMIN"
          | "PATIENT"
          | "BROKER"
          | "PROVIDER"
          | "SUPER_ADMIN"
          | "CRM"
          | "APPOINTMENT"
          | "BILLER"
          | "STAFF"
          | "EMPLOYER_ADMIN"
          | "EMPLOYER_USER"
          | "NURSE"
          | "AFFILIATE_PROVIDER";
        requestBody?: { template: Blob | File; headerTemplate?: Blob | File };
        structure: string;
      },
      TContext
    >({
      mutationFn: ({
        active,
        fileName,
        notificationSettingUuid,
        objectRequestCategory,
        requestBody,
        structure,
      }) =>
        NotificationSettingControllerService.uploadEmailStructureAndTemplateToS3(
          {
            active,
            fileName,
            notificationSettingUuid,
            objectRequestCategory,
            requestBody,
            structure,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendEmailFor = <
  TData = Common.NotificationSettingControllerServiceSendEmailForMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        employerUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      employerUuid: string;
    },
    TContext
  >({
    mutationFn: ({ employerUuid }) =>
      NotificationSettingControllerService.sendEmailFor({
        employerUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendEmailForAddPaymentToPatient =
  <
    TData =
      Common.NotificationSettingControllerServiceSendEmailForAddPaymentToPatientMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: PatientPaymentInfoRequest;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: PatientPaymentInfoRequest;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        NotificationSettingControllerService.sendEmailForAddPaymentToPatient({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendAddressChangeMailToPhp =
  <
    TData =
      Common.NotificationSettingControllerServiceSendAddressChangeMailToPhpMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          invoiceUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        invoiceUuid: string;
      },
      TContext
    >({
      mutationFn: ({ invoiceUuid }) =>
        NotificationSettingControllerService.sendAddressChangeMailToPhp({
          invoiceUuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendEmailForProviderSignup =
  <
    TData =
      Common.NotificationSettingControllerServiceSendEmailForProviderSignupMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: UserInvitationDto;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: UserInvitationDto;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        NotificationSettingControllerService.sendEmailForProviderSignup({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.labOrderUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendAppointmentJoinNotificationToPatient =
  <
    TData =
      Common.NotificationSettingControllerServiceSendAppointmentJoinNotificationToPatientMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          labOrderUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        labOrderUuid: string;
      },
      TContext
    >({
      mutationFn: ({ labOrderUuid }) =>
        NotificationSettingControllerService.sendAppointmentJoinNotificationToPatient(
          {
            labOrderUuid,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.labOrderUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendLabResultToPatient = <
  TData =
    Common.NotificationSettingControllerServiceSendLabResultToPatientMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        labOrderUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      labOrderUuid: string;
    },
    TContext
  >({
    mutationFn: ({ labOrderUuid }) =>
      NotificationSettingControllerService.sendLabResultToPatient({
        labOrderUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendRetailEnrollmentNotification =
  <
    TData =
      Common.NotificationSettingControllerServiceSendRetailEnrollmentNotificationMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        NotificationSettingControllerService.sendRetailEnrollmentNotification() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendRefundEmail = <
  TData =
    Common.NotificationSettingControllerServiceSendRefundEmailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: RefundDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: RefundDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      NotificationSettingControllerService.sendRefundEmail({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendEmailForPatientBirthday =
  <
    TData =
      Common.NotificationSettingControllerServiceSendEmailForPatientBirthdayMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        NotificationSettingControllerService.sendEmailForPatientBirthday() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendUpcomingInvoiceNotification =
  <
    TData =
      Common.NotificationSettingControllerServiceSendUpcomingInvoiceNotificationMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: PatientInvoiceEmailRequest;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: PatientInvoiceEmailRequest;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        NotificationSettingControllerService.sendUpcomingInvoiceNotification({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendPatientNotificationEmail =
  <
    TData =
      Common.NotificationSettingControllerServiceSendPatientNotificationEmailMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: PatientBasicPaymentDetailsDto;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: PatientBasicPaymentDetailsDto;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        NotificationSettingControllerService.sendPatientNotificationEmail({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendPatientEnrollmentRequestNotification =
  <
    TData =
      Common.NotificationSettingControllerServiceSendPatientEnrollmentRequestNotificationMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: ApprovePatientRequest;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: ApprovePatientRequest;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        NotificationSettingControllerService.sendPatientEnrollmentRequestNotification(
          {
            requestBody,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendMultipleFormsEmail = <
  TData =
    Common.NotificationSettingControllerServiceSendMultipleFormsEmailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: MultipleFormsEmailDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: MultipleFormsEmailDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      NotificationSettingControllerService.sendMultipleFormsEmail({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.amount
 * @param data.transactionId
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendMembershipPaidEmail = <
  TData =
    Common.NotificationSettingControllerServiceSendMembershipPaidEmailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        amount: number;
        patientUuid: string;
        transactionId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      amount: number;
      patientUuid: string;
      transactionId: string;
    },
    TContext
  >({
    mutationFn: ({ amount, patientUuid, transactionId }) =>
      NotificationSettingControllerService.sendMembershipPaidEmail({
        amount,
        patientUuid,
        transactionId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendMembershipCreatedEmail =
  <
    TData =
      Common.NotificationSettingControllerServiceSendMembershipCreatedEmailMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: UserInvitationDto;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: UserInvitationDto;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        NotificationSettingControllerService.sendMembershipCreatedEmail({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendLabResultReadyNotification =
  <
    TData =
      Common.NotificationSettingControllerServiceSendLabResultReadyNotificationMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          patientUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        patientUuid: string;
      },
      TContext
    >({
      mutationFn: ({ patientUuid }) =>
        NotificationSettingControllerService.sendLabResultReadyNotification({
          patientUuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendEmailForInvoiceNotificationAutopayDisabled =
  <
    TData =
      Common.NotificationSettingControllerServiceSendEmailForInvoiceNotificationAutopayDisabledMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        NotificationSettingControllerService.sendEmailForInvoiceNotificationAutopayDisabled() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendEmailForInvoiceNotificationAutopay =
  <
    TData =
      Common.NotificationSettingControllerServiceSendEmailForInvoiceNotificationAutopayMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        NotificationSettingControllerService.sendEmailForInvoiceNotificationAutopay() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendEmailForInvoice = <
  TData =
    Common.NotificationSettingControllerServiceSendEmailForInvoiceMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        invoiceUuid: string;
        patientUuid?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      invoiceUuid: string;
      patientUuid?: string;
    },
    TContext
  >({
    mutationFn: ({ invoiceUuid, patientUuid }) =>
      NotificationSettingControllerService.sendEmailForInvoice({
        invoiceUuid,
        patientUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendEmailsForInvoiceNotification =
  <
    TData =
      Common.NotificationSettingControllerServiceSendEmailsForInvoiceNotificationMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        NotificationSettingControllerService.sendEmailsForInvoiceNotification() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendFailedPaymentSummaryToAdmin =
  <
    TData =
      Common.NotificationSettingControllerServiceSendFailedPaymentSummaryToAdminMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        NotificationSettingControllerService.sendFailedPaymentSummaryToAdmin() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendUpcomingInvoiceNotificationToEmployer =
  <
    TData =
      Common.NotificationSettingControllerServiceSendUpcomingInvoiceNotificationToEmployerMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: EmployerInvoiceNotificationRequest;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: EmployerInvoiceNotificationRequest;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        NotificationSettingControllerService.sendUpcomingInvoiceNotificationToEmployer(
          {
            requestBody,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendPatientPaidNotificationToEmployer =
  <
    TData =
      Common.NotificationSettingControllerServiceSendPatientPaidNotificationToEmployerMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: PaymentReceivedDto;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: PaymentReceivedDto;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        NotificationSettingControllerService.sendPatientPaidNotificationToEmployer(
          {
            requestBody,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendInvoiceIssuedNotificationToEmployer =
  <
    TData =
      Common.NotificationSettingControllerServiceSendInvoiceIssuedNotificationToEmployerMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: EmployerInvoiceNotificationRequest;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: EmployerInvoiceNotificationRequest;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        NotificationSettingControllerService.sendInvoiceIssuedNotificationToEmployer(
          {
            requestBody,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendCreatedInvoiceNotificationToEmployer =
  <
    TData =
      Common.NotificationSettingControllerServiceSendCreatedInvoiceNotificationToEmployerMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: EmployerInvoiceNotificationRequest;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: EmployerInvoiceNotificationRequest;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        NotificationSettingControllerService.sendCreatedInvoiceNotificationToEmployer(
          {
            requestBody,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendAutopayProcessedNotificationToEmployer =
  <
    TData =
      Common.NotificationSettingControllerServiceSendAutopayProcessedNotificationToEmployerMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: EmployerAutopayNotificationRequest;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: EmployerAutopayNotificationRequest;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        NotificationSettingControllerService.sendAutopayProcessedNotificationToEmployer(
          {
            requestBody,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendEmployerInvoiceCreationReminderNotification =
  <
    TData =
      Common.NotificationSettingControllerServiceSendEmployerInvoiceCreationReminderNotificationMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        NotificationSettingControllerService.sendEmployerInvoiceCreationReminderNotification() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendEmailForChargePaid = <
  TData =
    Common.NotificationSettingControllerServiceSendEmailForChargePaidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ChargePaidNotificationRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ChargePaidNotificationRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      NotificationSettingControllerService.sendEmailForChargePaid({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendEmailForCardExpiringSoon =
  <
    TData =
      Common.NotificationSettingControllerServiceSendEmailForCardExpiringSoonMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<TData, TError, void, TContext>,
      "mutationFn"
    >,
  ) =>
    useMutation<TData, TError, void, TContext>({
      mutationFn: () =>
        NotificationSettingControllerService.sendEmailForCardExpiringSoon() as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendCardSharedEmail = <
  TData =
    Common.NotificationSettingControllerServiceSendCardSharedEmailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ShareCardNotificationDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ShareCardNotificationDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      NotificationSettingControllerService.sendCardSharedEmail({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendEmailForRemovalOfCard =
  <
    TData =
      Common.NotificationSettingControllerServiceSendEmailForRemovalOfCardMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: UserInvitationDto;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: UserInvitationDto;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        NotificationSettingControllerService.sendEmailForRemovalOfCard({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendCardReceivedEmail = <
  TData =
    Common.NotificationSettingControllerServiceSendCardReceivedEmailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ShareCardNotificationDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ShareCardNotificationDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      NotificationSettingControllerService.sendCardReceivedEmail({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendCallInvitationNotification =
  <
    TData =
      Common.NotificationSettingControllerServiceSendCallInvitationNotificationMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: CallInvitationDto;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: CallInvitationDto;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        NotificationSettingControllerService.sendCallInvitationNotification({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.brokerName
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendSignBroker = <
  TData =
    Common.NotificationSettingControllerServiceSendSignBrokerMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        brokerName: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      brokerName: string;
    },
    TContext
  >({
    mutationFn: ({ brokerName }) =>
      NotificationSettingControllerService.sendSignBroker({
        brokerName,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendEmailForRemovalOfBank =
  <
    TData =
      Common.NotificationSettingControllerServiceSendEmailForRemovalOfBankMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: UserInvitationDto;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: UserInvitationDto;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        NotificationSettingControllerService.sendEmailForRemovalOfBank({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendAppointmentEmail = <
  TData =
    Common.NotificationSettingControllerServiceSendAppointmentEmailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AppointmentInfo;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AppointmentInfo;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      NotificationSettingControllerService.sendAppointmentEmail({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendAgentFirmAgreementCreatedEmail =
  <
    TData =
      Common.NotificationSettingControllerServiceSendAgentFirmAgreementCreatedEmailMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: AffiliateAgreementNotificationDto;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: AffiliateAgreementNotificationDto;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        NotificationSettingControllerService.sendAgentFirmAgreementCreatedEmail(
          {
            requestBody,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationSettingControllerServiceSendAffiliateAgreementCreatedEmail =
  <
    TData =
      Common.NotificationSettingControllerServiceSendAffiliateAgreementCreatedEmailMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: AffiliateAgreementNotificationDto;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: AffiliateAgreementNotificationDto;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        NotificationSettingControllerService.sendAffiliateAgreementCreatedEmail(
          {
            requestBody,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns string OK
 * @throws ApiError
 */
export const useSnsWebHookControllerServiceHandleSnsNotification = <
  TData = Common.SnsWebHookControllerServiceHandleSnsNotificationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      SnsWebHookControllerService.handleSnsNotification({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.active
 * @param data.structure
 * @param data.fileName
 * @param data.objectRequestCategory
 * @param data.notificationSettingUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerNotificationSettingControllerServiceUploadEmailStructureAndTemplateToS31 =
  <
    TData =
      Common.EmployerNotificationSettingControllerServiceUploadEmailStructureAndTemplateToS31MutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          active: boolean;
          fileName: string;
          notificationSettingUuid: string;
          objectRequestCategory:
            | "ADMIN"
            | "PATIENT"
            | "BROKER"
            | "PROVIDER"
            | "SUPER_ADMIN"
            | "CRM"
            | "APPOINTMENT"
            | "BILLER"
            | "STAFF"
            | "EMPLOYER_ADMIN"
            | "EMPLOYER_USER"
            | "NURSE"
            | "AFFILIATE_PROVIDER";
          requestBody?: { template: Blob | File };
          structure: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        active: boolean;
        fileName: string;
        notificationSettingUuid: string;
        objectRequestCategory:
          | "ADMIN"
          | "PATIENT"
          | "BROKER"
          | "PROVIDER"
          | "SUPER_ADMIN"
          | "CRM"
          | "APPOINTMENT"
          | "BILLER"
          | "STAFF"
          | "EMPLOYER_ADMIN"
          | "EMPLOYER_USER"
          | "NURSE"
          | "AFFILIATE_PROVIDER";
        requestBody?: { template: Blob | File };
        structure: string;
      },
      TContext
    >({
      mutationFn: ({
        active,
        fileName,
        notificationSettingUuid,
        objectRequestCategory,
        requestBody,
        structure,
      }) =>
        EmployerNotificationSettingControllerService.uploadEmailStructureAndTemplateToS31(
          {
            active,
            fileName,
            notificationSettingUuid,
            objectRequestCategory,
            requestBody,
            structure,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEmailControllerServiceSendReferralEmail = <
  TData = Common.EmailControllerServiceSendReferralEmailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ReferralEmailDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ReferralEmailDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      EmailControllerService.sendReferralEmail({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEmailControllerServiceSendReferralEmailWithLink = <
  TData = Common.EmailControllerServiceSendReferralEmailWithLinkMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ReferralEmailDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ReferralEmailDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      EmailControllerService.sendReferralEmailWithLink({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns string OK
 * @throws ApiError
 */
export const useEmailControllerServiceSendProviderReassignmentEmails = <
  TData =
    Common.EmailControllerServiceSendProviderReassignmentEmailsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ProviderReassignmentEmailDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ProviderReassignmentEmailDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      EmailControllerService.sendProviderReassignmentEmails({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEmailControllerServiceSendFormTemplate = <
  TData = Common.EmailControllerServiceSendFormTemplateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: SendEmailDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: SendEmailDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      EmailControllerService.sendFormTemplate({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEmailControllerServiceSendBulkEmail = <
  TData = Common.EmailControllerServiceSendBulkEmailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: { [key: string]: BulkUserCredentialDto[] };
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: { [key: string]: BulkUserCredentialDto[] };
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      EmailControllerService.sendBulkEmail({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.toEmail
 * @param data.title
 * @returns Response OK
 * @throws ApiError
 */
export const useEmailControllerServiceSendInvitationEmail = <
  TData = Common.EmailControllerServiceSendInvitationEmailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        title: string;
        toEmail: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      title: string;
      toEmail: string;
    },
    TContext
  >({
    mutationFn: ({ title, toEmail }) =>
      EmailControllerService.sendInvitationEmail({
        title,
        toEmail,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceCreatePromotionalCoupon1 = <
  TData = Common.StripControllerServiceCreatePromotionalCoupon1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PromotionalCodeDto1;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PromotionalCodeDto1;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripControllerService.createPromotionalCoupon1({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns string OK
 * @throws ApiError
 */
export const useStripControllerServiceHandleStripeWebhook1 = <
  TData = Common.StripControllerServiceHandleStripeWebhook1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    "mutationFn"
  >,
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      StripControllerService.handleStripeWebhook1() as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceCreateSubscription1 = <
  TData = Common.StripControllerServiceCreateSubscription1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: StripeSubscriptionRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: StripeSubscriptionRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripControllerService.createSubscription1({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceCreateSubscriptionWithPayment1 = <
  TData =
    Common.StripControllerServiceCreateSubscriptionWithPayment1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: StripeSubscriptionRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: StripeSubscriptionRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripControllerService.createSubscriptionWithPayment1({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.customerId
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceCreateSetupIntent1 = <
  TData = Common.StripControllerServiceCreateSetupIntent1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        customerId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      customerId: string;
    },
    TContext
  >({
    mutationFn: ({ customerId }) =>
      StripControllerService.createSetupIntent1({
        customerId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceCreateSetupIntentWithCustomer1 = <
  TData =
    Common.StripControllerServiceCreateSetupIntentWithCustomer1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: StripeCustomerRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: StripeCustomerRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripControllerService.createSetupIntentWithCustomer1({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.customerId
 * @param data.paymentMethodId
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceSetDefaultPaymentMethod1 = <
  TData = Common.StripControllerServiceSetDefaultPaymentMethod1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        customerId: string;
        paymentMethodId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      customerId: string;
      paymentMethodId: string;
    },
    TContext
  >({
    mutationFn: ({ customerId, paymentMethodId }) =>
      StripControllerService.setDefaultPaymentMethod1({
        customerId,
        paymentMethodId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceSaveCardToCustomerWithCharging1 = <
  TData =
    Common.StripControllerServiceSaveCardToCustomerWithCharging1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: SaveCardRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: SaveCardRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripControllerService.saveCardToCustomerWithCharging1({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceSaveCardToCustomer1 = <
  TData = Common.StripControllerServiceSaveCardToCustomer1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: SaveCardRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: SaveCardRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripControllerService.saveCardToCustomer1({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceCreateProduct1 = <
  TData = Common.StripControllerServiceCreateProduct1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CreateProductRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CreateProductRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripControllerService.createProduct1({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.productId
 * @param data.requestBody
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceCreatePriceForProduct1 = <
  TData = Common.StripControllerServiceCreatePriceForProduct1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        productId: string;
        requestBody: CreateProductPriceRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      productId: string;
      requestBody: CreateProductPriceRequest;
    },
    TContext
  >({
    mutationFn: ({ productId, requestBody }) =>
      StripControllerService.createPriceForProduct1({
        productId,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceCreateProductAndPrice1 = <
  TData = Common.StripControllerServiceCreateProductAndPrice1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CreateProductPriceRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CreateProductPriceRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripControllerService.createProductAndPrice1({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceCreatePaymentIntent1 = <
  TData = Common.StripControllerServiceCreatePaymentIntent1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: StripePaymentRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: StripePaymentRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripControllerService.createPaymentIntent1({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceCreateCustomer1 = <
  TData = Common.StripControllerServiceCreateCustomer1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: StripeCustomerRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: StripeCustomerRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripControllerService.createCustomer1({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceCreateCoupon1 = <
  TData = Common.StripControllerServiceCreateCoupon1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CreateCouponDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CreateCouponDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      StripControllerService.createCoupon1({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketControllerServiceCreateTicket = <
  TData = Common.TicketControllerServiceCreateTicketMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: TicketDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: TicketDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TicketControllerService.createTicket({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketTaskControllerServiceCreateTicketTask = <
  TData = Common.TicketTaskControllerServiceCreateTicketTaskMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: TicketTaskDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: TicketTaskDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TicketTaskControllerService.createTicketTask({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketNotesControllerServiceCreateTicketNotes = <
  TData = Common.TicketNotesControllerServiceCreateTicketNotesMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: TicketNotesDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: TicketNotesDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TicketNotesControllerService.createTicketNotes({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketAttachmentControllerServiceAddAttachment = <
  TData = Common.TicketAttachmentControllerServiceAddAttachmentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: TicketAttachmentDto[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: TicketAttachmentDto[];
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TicketAttachmentControllerService.addAttachment({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmTemplateControllerServiceAddTemplate = <
  TData = Common.CrmTemplateControllerServiceAddTemplateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CrmTemplateDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CrmTemplateDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      CrmTemplateControllerService.addTemplate({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmTaskControllerServiceCreateTask = <
  TData = Common.CrmTaskControllerServiceCreateTaskMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CrmTaskDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CrmTaskDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      CrmTaskControllerService.createTask({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useTaskLogControllerServiceCreateTaskLog = <
  TData = Common.TaskLogControllerServiceCreateTaskLogMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: TaskLogsDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: TaskLogsDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TaskLogControllerService.createTaskLog({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmNewsletterControllerServiceCreateNewsletter = <
  TData = Common.CrmNewsletterControllerServiceCreateNewsletterMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CrmNewsletterDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CrmNewsletterDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      CrmNewsletterControllerService.createNewsletter({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmCampaignControllerServiceCreateCampaign = <
  TData = Common.CrmCampaignControllerServiceCreateCampaignMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CrmCampaignDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CrmCampaignDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      CrmCampaignControllerService.createCampaign({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCallLogsControllerServiceCreateCallLog = <
  TData = Common.CallLogsControllerServiceCreateCallLogMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CallLogsDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CallLogsDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      CallLogsControllerService.createCallLog({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketMergeControllerServiceMergeTicket = <
  TData = Common.TicketMergeControllerServiceMergeTicketMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: TicketMergeDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: TicketMergeDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TicketMergeControllerService.mergeTicket({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketLinkedControllerServiceLinkTicket = <
  TData = Common.TicketLinkedControllerServiceLinkTicketMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: TicketLinkedDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: TicketLinkedDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TicketLinkedControllerService.linkTicket({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketConversationControllerServiceCreateConversation = <
  TData =
    Common.TicketConversationControllerServiceCreateConversationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: TicketConversationDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: TicketConversationDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TicketConversationControllerService.createConversation({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceSendMessage = <
  TData = Common.MessageControllerServiceSendMessageMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: MessageDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: MessageDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      MessageControllerService.sendMessage({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceSendScheduledMessageNow = <
  TData = Common.MessageControllerServiceSendScheduledMessageNowMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      MessageControllerService.sendScheduledMessageNow({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.reminderUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceResendReminderMessage = <
  TData = Common.MessageControllerServiceResendReminderMessageMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        reminderUuid: string;
        requestBody?: MessageReminderDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      reminderUuid: string;
      requestBody?: MessageReminderDto;
    },
    TContext
  >({
    mutationFn: ({ reminderUuid, requestBody }) =>
      MessageControllerService.resendReminderMessage({
        reminderUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceRemoveAttacment = <
  TData = Common.MessageControllerServiceRemoveAttacmentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: string[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: string[];
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      MessageControllerService.removeAttacment({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.callUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useVideoCallControllerServiceEndCall = <
  TData = Common.VideoCallControllerServiceEndCallMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        callUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      callUuid: string;
    },
    TContext
  >({
    mutationFn: ({ callUuid }) =>
      VideoCallControllerService.endCall({
        callUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.callUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useVideoCallControllerServiceDeclineCall = <
  TData = Common.VideoCallControllerServiceDeclineCallMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        callUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      callUuid: string;
    },
    TContext
  >({
    mutationFn: ({ callUuid }) =>
      VideoCallControllerService.declineCall({
        callUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.callUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useVideoCallControllerServiceCancelCall = <
  TData = Common.VideoCallControllerServiceCancelCallMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        callUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      callUuid: string;
    },
    TContext
  >({
    mutationFn: ({ callUuid }) =>
      VideoCallControllerService.cancelCall({
        callUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.callUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useVideoCallControllerServiceAcceptCall = <
  TData = Common.VideoCallControllerServiceAcceptCallMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        callUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      callUuid: string;
    },
    TContext
  >({
    mutationFn: ({ callUuid }) =>
      VideoCallControllerService.acceptCall({
        callUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useVideoCallControllerServiceStartCall = <
  TData = Common.VideoCallControllerServiceStartCallMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: VideoCallStartRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: VideoCallStartRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      VideoCallControllerService.startCall({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.callRef
 * @param data.formData
 * @returns string OK
 * @throws ApiError
 */
export const useTwilioVoiceWebhookControllerServiceOutboundDial = <
  TData = Common.TwilioVoiceWebhookControllerServiceOutboundDialMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        callRef?: string;
        formData?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      callRef?: string;
      formData?: string;
    },
    TContext
  >({
    mutationFn: ({ callRef, formData }) =>
      TwilioVoiceWebhookControllerService.outboundDial({
        callRef,
        formData,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.formData
 * @returns string OK
 * @throws ApiError
 */
export const useTwilioVoiceWebhookControllerServiceInboundCall = <
  TData = Common.TwilioVoiceWebhookControllerServiceInboundCallMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        formData?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      formData?: string;
    },
    TContext
  >({
    mutationFn: ({ formData }) =>
      TwilioVoiceWebhookControllerService.inboundCall({
        formData,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.callRef
 * @param data.menu
 * @param data.attempt
 * @param data.formData
 * @returns string OK
 * @throws ApiError
 */
export const useTwilioVoiceWebhookControllerServiceDialAction = <
  TData = Common.TwilioVoiceWebhookControllerServiceDialActionMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        attempt?: number;
        callRef?: string;
        formData?: string;
        menu?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      attempt?: number;
      callRef?: string;
      formData?: string;
      menu?: string;
    },
    TContext
  >({
    mutationFn: ({ attempt, callRef, formData, menu }) =>
      TwilioVoiceWebhookControllerService.dialAction({
        attempt,
        callRef,
        formData,
        menu,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.formData
 * @returns string OK
 * @throws ApiError
 */
export const useTwilioVoiceWebhookControllerServiceAppDial = <
  TData = Common.TwilioVoiceWebhookControllerServiceAppDialMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        formData?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      formData?: string;
    },
    TContext
  >({
    mutationFn: ({ formData }) =>
      TwilioVoiceWebhookControllerService.appDial({
        formData,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.callRef
 * @param data.voicemail
 * @param data.urgent
 * @param data.silent
 * @param data.formData
 * @returns unknown OK
 * @throws ApiError
 */
export const useTwilioVoiceWebhookControllerServiceRecordings = <
  TData = Common.TwilioVoiceWebhookControllerServiceRecordingsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        callRef?: string;
        formData?: string;
        silent?: boolean;
        urgent?: boolean;
        voicemail?: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      callRef?: string;
      formData?: string;
      silent?: boolean;
      urgent?: boolean;
      voicemail?: boolean;
    },
    TContext
  >({
    mutationFn: ({ callRef, formData, silent, urgent, voicemail }) =>
      TwilioVoiceWebhookControllerService.recordings({
        callRef,
        formData,
        silent,
        urgent,
        voicemail,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.callRef
 * @param data.formData
 * @returns unknown OK
 * @throws ApiError
 */
export const useTwilioVoiceWebhookControllerServiceEvents = <
  TData = Common.TwilioVoiceWebhookControllerServiceEventsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        callRef?: string;
        formData?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      callRef?: string;
      formData?: string;
    },
    TContext
  >({
    mutationFn: ({ callRef, formData }) =>
      TwilioVoiceWebhookControllerService.events({
        callRef,
        formData,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.platform
 * @returns Response OK
 * @throws ApiError
 */
export const useTwilioVoiceControllerServiceIssueToken = <
  TData = Common.TwilioVoiceControllerServiceIssueTokenMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        platform?: "WEB" | "IOS" | "ANDROID";
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      platform?: "WEB" | "IOS" | "ANDROID";
    },
    TContext
  >({
    mutationFn: ({ platform }) =>
      TwilioVoiceControllerService.issueToken({
        platform,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useTwilioVoiceControllerServicePlaceCall = <
  TData = Common.TwilioVoiceControllerServicePlaceCallMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PlaceCallRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PlaceCallRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TwilioVoiceControllerService.placeCall({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useTwilioVoiceControllerServiceHangUp = <
  TData = Common.TwilioVoiceControllerServiceHangUpMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    "mutationFn"
  >,
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      TwilioVoiceControllerService.hangUp() as unknown as Promise<TData>,
    ...options,
  });
/**
 * Twilio inbound SMS webhook
 * Configured in the Twilio console as the 'A MESSAGE COMES IN' webhook. Confirms an appointment when the patient replies with the token from the reminder SMS. Twilio posts form-encoded parameters and expects TwiML back.
 * @param data The data for the request.
 * @param data.from
 * @param data.body
 * @returns string OK
 * @throws ApiError
 */
export const useTwilioControllerServiceInboundSms = <
  TData = Common.TwilioControllerServiceInboundSmsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        body?: string;
        from?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      body?: string;
      from?: string;
    },
    TContext
  >({
    mutationFn: ({ body, from }) =>
      TwilioControllerService.inboundSms({
        body,
        from,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useTwilioControllerServiceSendSms = <
  TData = Common.TwilioControllerServiceSendSmsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: SendSMSRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: SendSMSRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TwilioControllerService.sendSms({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useTwilioControllerServiceSendGenericSms = <
  TData = Common.TwilioControllerServiceSendGenericSmsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: GenericSMSRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: GenericSMSRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TwilioControllerService.sendGenericSms({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Create a new communication thread
 * Creates a new thread with a Twilio conversation for patient communication
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response Thread created successfully
 * @throws ApiError
 */
export const useThreadControllerServiceCreateThread = <
  TData = Common.ThreadControllerServiceCreateThreadMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ThreadDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ThreadDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ThreadControllerService.createThread({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Resume resolved thread
 * Reopens a resolved thread by changing its status back to OPEN
 * @param data The data for the request.
 * @param data.threadUuid Thread UUID
 * @returns Response Thread resumed successfully
 * @throws ApiError
 */
export const useThreadControllerServiceResumeThread = <
  TData = Common.ThreadControllerServiceResumeThreadMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        threadUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      threadUuid: string;
    },
    TContext
  >({
    mutationFn: ({ threadUuid }) =>
      ThreadControllerService.resumeThread({
        threadUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Broadcast thread list update for a thread
 * Pushes the thread_list_updated socket event to all thread participants. Used by other services (e.g. ehr-service task resolution) after changing thread state outside this service.
 * @param data The data for the request.
 * @param data.threadUuid Thread UUID
 * @returns Response Broadcast triggered successfully
 * @throws ApiError
 */
export const useThreadControllerServiceBroadcastThreadListUpdate = <
  TData = Common.ThreadControllerServiceBroadcastThreadListUpdateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        threadUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      threadUuid: string;
    },
    TContext
  >({
    mutationFn: ({ threadUuid }) =>
      ThreadControllerService.broadcastThreadListUpdate({
        threadUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Broadcast message summaries for a thread
 * Pushes the message_summary_updated socket event to all thread participants. Used by other services (e.g. ehr-service task resolution) after changing thread state outside this service.
 * @param data The data for the request.
 * @param data.threadUuid Thread UUID
 * @returns Response Broadcast triggered successfully
 * @throws ApiError
 */
export const useThreadControllerServiceBroadcastThreadSummaries = <
  TData = Common.ThreadControllerServiceBroadcastThreadSummariesMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        threadUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      threadUuid: string;
    },
    TContext
  >({
    mutationFn: ({ threadUuid }) =>
      ThreadControllerService.broadcastThreadSummaries({
        threadUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Route thread to a user
 * Adds the given user as a participant of the thread
 * @param data The data for the request.
 * @param data.threadUuid Thread UUID
 * @param data.userUuid User UUID to add to the thread
 * @returns Response Thread routed successfully
 * @throws ApiError
 */
export const useThreadControllerServiceRouteThread = <
  TData = Common.ThreadControllerServiceRouteThreadMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        threadUuid: string;
        userUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      threadUuid: string;
      userUuid: string;
    },
    TContext
  >({
    mutationFn: ({ threadUuid, userUuid }) =>
      ThreadControllerService.routeThread({
        threadUuid,
        userUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Create open thread
 * Records whether a user currently has the given thread open
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response Open thread created successfully
 * @throws ApiError
 */
export const useThreadControllerServiceCreateOpenThread = <
  TData = Common.ThreadControllerServiceCreateOpenThreadMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: OpenThreadRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: OpenThreadRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ThreadControllerService.createOpenThread({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Broadcast a real-time event
 * Pushes the realtime_event socket event to the rooms derived from the event's routing keys. Called by other services (e.g. ehr-service) after a create/update/delete.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response Broadcast triggered successfully
 * @throws ApiError
 */
export const useRealtimeControllerServiceBroadcast = <
  TData = Common.RealtimeControllerServiceBroadcastMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: RealtimeEventDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: RealtimeEventDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      RealtimeControllerService.broadcast({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Bookmark a thread
 * Adds a thread to user's bookmarks
 * @param data The data for the request.
 * @param data.threadUuid Thread UUID
 * @returns Response Thread bookmarked successfully
 * @throws ApiError
 */
export const useBookmarkControllerServiceBookmarkThread = <
  TData = Common.BookmarkControllerServiceBookmarkThreadMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        threadUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      threadUuid: string;
    },
    TContext
  >({
    mutationFn: ({ threadUuid }) =>
      BookmarkControllerService.bookmarkThread({
        threadUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Bookmark a message
 * Adds a message to user's bookmarks
 * @param data The data for the request.
 * @param data.messageUuid Message UUID
 * @returns Response Message bookmarked successfully
 * @throws ApiError
 */
export const useBookmarkControllerServiceBookmarkMessage = <
  TData = Common.BookmarkControllerServiceBookmarkMessageMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        messageUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      messageUuid: string;
    },
    TContext
  >({
    mutationFn: ({ messageUuid }) =>
      BookmarkControllerService.bookmarkMessage({
        messageUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Archive/Unarchive User
 * Change User archive status to either archived or unarchived.
 * @param data The data for the request.
 * @param data.userId
 * @param data.status
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceUpdateUserArchiveStatus = <
  TData = Common.UserControllerServiceUpdateUserArchiveStatusMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        status: boolean;
        userId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      status: boolean;
      userId: string;
    },
    TContext
  >({
    mutationFn: ({ status, userId }) =>
      UserControllerService.updateUserArchiveStatus({
        status,
        userId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Bulk Update User Status
 * Update status of multiple users in Keycloak
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceBulkUpdateUserStatus = <
  TData = Common.UserControllerServiceBulkUpdateUserStatusMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: { [key: string]: boolean };
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: { [key: string]: boolean };
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      UserControllerService.bulkUpdateUserStatus({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Update Staff Users
 * Edit Staff User with editable fields as firstName, lastName, phone, roleType, role.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceUpdateUser = <
  TData = Common.UserControllerServiceUpdateUserMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: User;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: User;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      UserControllerService.updateUser({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Enable/Disable User
 * Change user status to either active or inactive to restrict user from login
 * @param data The data for the request.
 * @param data.userId
 * @param data.status
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceUpdateUserStatus = <
  TData = Common.UserControllerServiceUpdateUserStatusMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        status: boolean;
        userId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      status: boolean;
      userId: string;
    },
    TContext
  >({
    mutationFn: ({ status, userId }) =>
      UserControllerService.updateUserStatus({
        status,
        userId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.deviceToken
 * @param data.deviceType
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceSyncDeviceToken = <
  TData = Common.UserControllerServiceSyncDeviceTokenMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        deviceToken: string;
        deviceType: "MOBILE" | "WEB";
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      deviceToken: string;
      deviceType: "MOBILE" | "WEB";
    },
    TContext
  >({
    mutationFn: ({ deviceToken, deviceType }) =>
      UserControllerService.syncDeviceToken({
        deviceToken,
        deviceType,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.deviceType
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceRevokeDeviceToken = <
  TData = Common.UserControllerServiceRevokeDeviceTokenMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        deviceType: "MOBILE" | "WEB";
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      deviceType: "MOBILE" | "WEB";
    },
    TContext
  >({
    mutationFn: ({ deviceType }) =>
      UserControllerService.revokeDeviceToken({
        deviceType,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.oldPassword
 * @param data.newPassword
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceResetPassword = <
  TData = Common.UserControllerServiceResetPasswordMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        newPassword: string;
        oldPassword: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      newPassword: string;
      oldPassword: string;
    },
    TContext
  >({
    mutationFn: ({ newPassword, oldPassword }) =>
      UserControllerService.resetPassword({
        newPassword,
        oldPassword,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.locationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceSwitchLastLoggedInLocation = <
  TData = Common.UserControllerServiceSwitchLastLoggedInLocationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        locationUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      locationUuid: string;
    },
    TContext
  >({
    mutationFn: ({ locationUuid }) =>
      UserControllerService.switchLastLoggedInLocation({
        locationUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceUpdateProfileDetailsOfUser = <
  TData = Common.UserControllerServiceUpdateProfileDetailsOfUserMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: User;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: User;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      UserControllerService.updateProfileDetailsOfUser({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.username
 * @returns Response OK
 * @throws ApiError
 */
export const useUserControllerServiceCheckUsername = <
  TData = Common.UserControllerServiceCheckUsernameMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        username: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      username: string;
    },
    TContext
  >({
    mutationFn: ({ username }) =>
      UserControllerService.checkUsername({
        username,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uploadUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployeeUploadControllerServiceProcessUpload = <
  TData = Common.EmployeeUploadControllerServiceProcessUploadMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uploadUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uploadUuid: string;
    },
    TContext
  >({
    mutationFn: ({ uploadUuid }) =>
      EmployeeUploadControllerService.processUpload({
        uploadUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.subscriptionId
 * @param data.priceId
 * @param data.promotionCode
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceUpdateSubscription = <
  TData = Common.StripeControllerServiceUpdateSubscriptionMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        priceId?: string;
        promotionCode?: string;
        subscriptionId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      priceId?: string;
      promotionCode?: string;
      subscriptionId: string;
    },
    TContext
  >({
    mutationFn: ({ priceId, promotionCode, subscriptionId }) =>
      StripeControllerService.updateSubscription({
        priceId,
        promotionCode,
        subscriptionId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.subscriptionId
 * @param data.newPriceId
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceChangePlan = <
  TData = Common.StripeControllerServiceChangePlanMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        newPriceId: string;
        subscriptionId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      newPriceId: string;
      subscriptionId: string;
    },
    TContext
  >({
    mutationFn: ({ newPriceId, subscriptionId }) =>
      StripeControllerService.changePlan({
        newPriceId,
        subscriptionId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.subscriptionId
 * @param data.newPriceId
 * @param data.prorate
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceChangePlanWithProration = <
  TData = Common.StripeControllerServiceChangePlanWithProrationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        newPriceId: string;
        prorate?: boolean;
        subscriptionId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      newPriceId: string;
      prorate?: boolean;
      subscriptionId: string;
    },
    TContext
  >({
    mutationFn: ({ newPriceId, prorate, subscriptionId }) =>
      StripeControllerService.changePlanWithProration({
        newPriceId,
        prorate,
        subscriptionId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.promotionalCodeId
 * @param data.active
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceUpdatePromotionalCoupon = <
  TData = Common.StripeControllerServiceUpdatePromotionalCouponMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        active: boolean;
        promotionalCodeId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      active: boolean;
      promotionalCodeId: string;
    },
    TContext
  >({
    mutationFn: ({ active, promotionalCodeId }) =>
      StripeControllerService.updatePromotionalCoupon({
        active,
        promotionalCodeId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.sessionToken
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceUpdateScriptSurePatient = <
  TData =
    Common.ScriptSureControllerServiceUpdateScriptSurePatientMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ScriptSurePatientDto;
        sessionToken?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ScriptSurePatientDto;
      sessionToken?: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, sessionToken }) =>
      ScriptSureControllerService.updateScriptSurePatient({
        requestBody,
        sessionToken,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceUpdateAllergy = <
  TData = Common.ScriptSureControllerServiceUpdateAllergyMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        requestBody: AllergyDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      requestBody: AllergyDto;
    },
    TContext
  >({
    mutationFn: ({ patientUuid, requestBody }) =>
      ScriptSureControllerService.updateAllergy({
        patientUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceArchiveAllergy = <
  TData = Common.ScriptSureControllerServiceArchiveAllergyMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        requestBody: AllergyDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      requestBody: AllergyDto;
    },
    TContext
  >({
    mutationFn: ({ patientUuid, requestBody }) =>
      ScriptSureControllerService.archiveAllergy({
        patientUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useSavedCardControllerServiceUpdateSavedCardByUuid = <
  TData = Common.SavedCardControllerServiceUpdateSavedCardByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CardUpdateRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CardUpdateRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      SavedCardControllerService.updateSavedCardByUuid({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.savedCardUuid
 * @returns unknown OK
 * @throws ApiError
 */
export const useSavedCardControllerServiceSetAutopaySavedCardByUuid = <
  TData =
    Common.SavedCardControllerServiceSetAutopaySavedCardByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        savedCardUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      savedCardUuid: string;
    },
    TContext
  >({
    mutationFn: ({ savedCardUuid }) =>
      SavedCardControllerService.setAutopaySavedCardByUuid({
        savedCardUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.savedBankAccountUuid
 * @returns unknown OK
 * @throws ApiError
 */
export const useSavedBankControllerServiceSetAutopaySavedBankByUuid = <
  TData =
    Common.SavedBankControllerServiceSetAutopaySavedBankByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        savedBankAccountUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      savedBankAccountUuid: string;
    },
    TContext
  >({
    mutationFn: ({ savedBankAccountUuid }) =>
      SavedBankControllerService.setAutopaySavedBankByUuid({
        savedBankAccountUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.salesTaxProfileUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useSalesTaxProfileControllerServiceUpdateSalesTaxProfileByUuid = <
  TData =
    Common.SalesTaxProfileControllerServiceUpdateSalesTaxProfileByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: SalesTaxProfileRequest;
        salesTaxProfileUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: SalesTaxProfileRequest;
      salesTaxProfileUuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, salesTaxProfileUuid }) =>
      SalesTaxProfileControllerService.updateSalesTaxProfileByUuid({
        requestBody,
        salesTaxProfileUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.salesTaxJurisdictionUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useSalesTaxJurisdictionControllerServiceUpdateSalesTaxJurisdictionByUuid =
  <
    TData =
      Common.SalesTaxJurisdictionControllerServiceUpdateSalesTaxJurisdictionByUuidMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: SalesTaxJurisdictionRequest;
          salesTaxJurisdictionUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: SalesTaxJurisdictionRequest;
        salesTaxJurisdictionUuid: string;
      },
      TContext
    >({
      mutationFn: ({ requestBody, salesTaxJurisdictionUuid }) =>
        SalesTaxJurisdictionControllerService.updateSalesTaxJurisdictionByUuid({
          requestBody,
          salesTaxJurisdictionUuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.roleId
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useRolesAndPermissionControllerServiceUpdatePermissionsOfRole = <
  TData =
    Common.RolesAndPermissionControllerServiceUpdatePermissionsOfRoleMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: RoleRequest;
        roleId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: RoleRequest;
      roleId: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, roleId }) =>
      RolesAndPermissionControllerService.updatePermissionsOfRole({
        requestBody,
        roleId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useRoleTypeManagementControllerServiceUpdateRoleType = <
  TData =
    Common.RoleTypeManagementControllerServiceUpdateRoleTypeMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: RoleTypeRequest;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: RoleTypeRequest;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      RoleTypeManagementControllerService.updateRoleType({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useRoleTypeFeatureManagementControllerServiceUpdateRoleTypeFeature =
  <
    TData =
      Common.RoleTypeFeatureManagementControllerServiceUpdateRoleTypeFeatureMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: RoleTypeFeatureRequest;
          uuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: RoleTypeFeatureRequest;
        uuid: string;
      },
      TContext
    >({
      mutationFn: ({ requestBody, uuid }) =>
        RoleTypeFeatureManagementControllerService.updateRoleTypeFeature({
          requestBody,
          uuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderControllerServiceUpdateProvider = <
  TData = Common.ProviderControllerServiceUpdateProviderMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ProviderRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ProviderRequestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ProviderControllerService.updateProvider({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderControllerServiceAssignedNewProvider = <
  TData = Common.ProviderControllerServiceAssignedNewProviderMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AssignedProviderDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AssignedProviderDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ProviderControllerService.assignedNewProvider({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePlanControllerServiceUpdatePlan = <
  TData = Common.PlanControllerServiceUpdatePlanMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PlanDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PlanDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PlanControllerService.updatePlan({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePlanControllerServiceUpdatePlanDetails = <
  TData = Common.PlanControllerServiceUpdatePlanDetailsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PlanDetailsDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PlanDetailsDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PlanControllerService.updatePlanDetails({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePaymentTransactionControllerServiceUpdatePaymentTransaction = <
  TData =
    Common.PaymentTransactionControllerServiceUpdatePaymentTransactionMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PaymentTransactionRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PaymentTransactionRequestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PaymentTransactionControllerService.updatePaymentTransaction({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceUpdatePatient = <
  TData = Common.PatientControllerServiceUpdatePatientMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PatientRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PatientRequestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PatientControllerService.updatePatient({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceUnEnrollPatient = <
  TData = Common.PatientControllerServiceUnEnrollPatientMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        requestBody: UnEnrollDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      requestBody: UnEnrollDto;
    },
    TContext
  >({
    mutationFn: ({ patientUuid, requestBody }) =>
      PatientControllerService.unEnrollPatient({
        patientUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.primaryPatientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServicePatientCreateUpdate = <
  TData = Common.PatientControllerServicePatientCreateUpdateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        primaryPatientUuid?: string;
        requestBody: PatientRequestDto[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      primaryPatientUuid?: string;
      requestBody: PatientRequestDto[];
    },
    TContext
  >({
    mutationFn: ({ primaryPatientUuid, requestBody }) =>
      PatientControllerService.patientCreateUpdate({
        primaryPatientUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceEndMembershipForPatientAndDependents = <
  TData =
    Common.PatientControllerServiceEndMembershipForPatientAndDependentsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        requestBody: UnEnrollDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      requestBody: UnEnrollDto;
    },
    TContext
  >({
    mutationFn: ({ patientUuid, requestBody }) =>
      PatientControllerService.endMembershipForPatientAndDependents({
        patientUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.enrollmentRequestDate
 * @param data.membershipStartDate
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceEditDependentMembershipDetails = <
  TData =
    Common.PatientControllerServiceEditDependentMembershipDetailsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        enrollmentRequestDate?: string;
        membershipStartDate?: string;
        patientUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      enrollmentRequestDate?: string;
      membershipStartDate?: string;
      patientUuid: string;
    },
    TContext
  >({
    mutationFn: ({ enrollmentRequestDate, membershipStartDate, patientUuid }) =>
      PatientControllerService.editDependentMembershipDetails({
        enrollmentRequestDate,
        membershipStartDate,
        patientUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.primaryPatientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceCreateUpdatePatient = <
  TData = Common.PatientControllerServiceCreateUpdatePatientMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        primaryPatientUuid?: string;
        requestBody: PatientRequestDto[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      primaryPatientUuid?: string;
      requestBody: PatientRequestDto[];
    },
    TContext
  >({
    mutationFn: ({ primaryPatientUuid, requestBody }) =>
      PatientControllerService.createUpdatePatient({
        primaryPatientUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientModuleUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientModuleControllerServiceUpdate = <
  TData = Common.PatientModuleControllerServiceUpdateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientModuleUuid: string;
        requestBody: PatientModuleRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientModuleUuid: string;
      requestBody: PatientModuleRequest;
    },
    TContext
  >({
    mutationFn: ({ patientModuleUuid, requestBody }) =>
      PatientModuleControllerService.update({
        patientModuleUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientModuleAccessUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientModuleAccessControllerServiceUpdate1 = <
  TData = Common.PatientModuleAccessControllerServiceUpdate1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientModuleAccessUuid: string;
        requestBody: PatientModuleAccessRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientModuleAccessUuid: string;
      requestBody: PatientModuleAccessRequest;
    },
    TContext
  >({
    mutationFn: ({ patientModuleAccessUuid, requestBody }) =>
      PatientModuleAccessControllerService.update1({
        patientModuleAccessUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientInformationUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientInformationControllerServiceUpdate2 = <
  TData = Common.PatientInformationControllerServiceUpdate2MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientInformationUuid: string;
        requestBody: PatientInformationRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientInformationUuid: string;
      requestBody: PatientInformationRequest;
    },
    TContext
  >({
    mutationFn: ({ patientInformationUuid, requestBody }) =>
      PatientInformationControllerService.update2({
        patientInformationUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNurseStaffProviderControllerServiceUpdateNurseStaffProvider = <
  TData =
    Common.NurseStaffProviderControllerServiceUpdateNurseStaffProviderMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: NurseStaffProviderRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: NurseStaffProviderRequestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      NurseStaffProviderControllerService.updateNurseStaffProvider({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useLeadControllerServiceUpdateLead = <
  TData = Common.LeadControllerServiceUpdateLeadMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LeadResponseDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LeadResponseDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      LeadControllerService.updateLead({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useLeadControllerServiceCreateUpdateLead = <
  TData = Common.LeadControllerServiceCreateUpdateLeadMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LeadResponseDto[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LeadResponseDto[];
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      LeadControllerService.createUpdateLead({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useInvoiceSettingControllerServiceUpdateInvoiceSetting = <
  TData =
    Common.InvoiceSettingControllerServiceUpdateInvoiceSettingMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: InvoiceSettingDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: InvoiceSettingDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      InvoiceSettingControllerService.updateInvoiceSetting({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.emailNotificationEnabled
 * @returns Response OK
 * @throws ApiError
 */
export const useInvoiceSettingControllerServiceToggleEmailNotification = <
  TData =
    Common.InvoiceSettingControllerServiceToggleEmailNotificationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        emailNotificationEnabled: boolean;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      emailNotificationEnabled: boolean;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ emailNotificationEnabled, uuid }) =>
      InvoiceSettingControllerService.toggleEmailNotification({
        emailNotificationEnabled,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useFeatureManagementControllerServiceUpdateFeature = <
  TData = Common.FeatureManagementControllerServiceUpdateFeatureMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: FeatureRequest;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: FeatureRequest;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      FeatureManagementControllerService.updateFeature({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceUpdateFaxDocument = <
  TData = Common.FaxControllerServiceUpdateFaxDocumentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: FaxDocumentsRequest;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: FaxDocumentsRequest;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      FaxControllerService.updateFaxDocument({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useFaceSheetLayoutControllerServiceSaveLayout = <
  TData = Common.FaceSheetLayoutControllerServiceSaveLayoutMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: FaceSheetLayoutRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: FaceSheetLayoutRequestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      FaceSheetLayoutControllerService.saveLayout({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceUpdateEmployer = <
  TData = Common.EmployerControllerServiceUpdateEmployerMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: EmployerDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: EmployerDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      EmployerControllerService.updateEmployer({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceSavePricingDetails = <
  TData = Common.EmployerControllerServiceSavePricingDetailsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: EmployerPricingDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: EmployerPricingDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      EmployerControllerService.savePricingDetails({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceSaveOnlineSignUp = <
  TData = Common.EmployerControllerServiceSaveOnlineSignUpMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: EmployerOnlineSignUpDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: EmployerOnlineSignUpDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      EmployerControllerService.saveOnlineSignUp({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceSaveAccountDetails = <
  TData = Common.EmployerControllerServiceSaveAccountDetailsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: EmployerAccountDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: EmployerAccountDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      EmployerControllerService.saveAccountDetails({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.employerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerPageControllerServiceUpdateEmployerPage = <
  TData = Common.EmployerPageControllerServiceUpdateEmployerPageMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        employerUuid?: string;
        requestBody: EmployerPageDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      employerUuid?: string;
      requestBody: EmployerPageDto;
    },
    TContext
  >({
    mutationFn: ({ employerUuid, requestBody }) =>
      EmployerPageControllerService.updateEmployerPage({
        employerUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerDivisionControllerServiceUpdateEmployerDivision = <
  TData =
    Common.EmployerDivisionControllerServiceUpdateEmployerDivisionMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: EmployerDivisionDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: EmployerDivisionDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      EmployerDivisionControllerService.updateEmployerDivision({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerAdministratorControllerServiceUpdateEmployerAdministrator =
  <
    TData =
      Common.EmployerAdministratorControllerServiceUpdateEmployerAdministratorMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: EmployerAdministratorDto;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: EmployerAdministratorDto;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        EmployerAdministratorControllerService.updateEmployerAdministrator({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCreditControllerServiceUpdateCredit = <
  TData = Common.CreditControllerServiceUpdateCreditMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CreditDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CreditDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      CreditControllerService.updateCredit({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCoverageRuleControllerServiceUpdateCoverageRule = <
  TData = Common.CoverageRuleControllerServiceUpdateCoverageRuleMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CoverageRuleDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CoverageRuleDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      CoverageRuleControllerService.updateCoverageRule({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCoveragePlanControllerServiceUpdateCoveragePlan = <
  TData = Common.CoveragePlanControllerServiceUpdateCoveragePlanMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CoveragePlanDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CoveragePlanDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      CoveragePlanControllerService.updateCoveragePlan({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCouponControllerServiceUpdateCoupon = <
  TData = Common.CouponControllerServiceUpdateCouponMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CouponRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CouponRequestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      CouponControllerService.updateCoupon({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.chargeItemUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useChargeItemControllerServiceUpdateChargeItemByUuid = <
  TData =
    Common.ChargeItemControllerServiceUpdateChargeItemByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        chargeItemUuid: string;
        requestBody: ChargeItemRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      chargeItemUuid: string;
      requestBody: ChargeItemRequest;
    },
    TContext
  >({
    mutationFn: ({ chargeItemUuid, requestBody }) =>
      ChargeItemControllerService.updateChargeItemByUuid({
        chargeItemUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.chargeCategoryUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useChargeCategoryControllerServiceUpdateChargeCategoryByUuid = <
  TData =
    Common.ChargeCategoryControllerServiceUpdateChargeCategoryByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        chargeCategoryUuid: string;
        requestBody: ChargeCategoryRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      chargeCategoryUuid: string;
      requestBody: ChargeCategoryRequest;
    },
    TContext
  >({
    mutationFn: ({ chargeCategoryUuid, requestBody }) =>
      ChargeCategoryControllerService.updateChargeCategoryByUuid({
        chargeCategoryUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.cancellationsUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCancellationControllerServiceUpdateCancellation = <
  TData = Common.CancellationControllerServiceUpdateCancellationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        cancellationsUuid: string;
        requestBody: CancellationRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      cancellationsUuid: string;
      requestBody: CancellationRequest;
    },
    TContext
  >({
    mutationFn: ({ cancellationsUuid, requestBody }) =>
      CancellationControllerService.updateCancellation({
        cancellationsUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.cancellationsUuid
 * @param data.archive
 * @returns Response OK
 * @throws ApiError
 */
export const useCancellationControllerServiceArchiveAndUnarchiveCancellationByUuid =
  <
    TData =
      Common.CancellationControllerServiceArchiveAndUnarchiveCancellationByUuidMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          archive: boolean;
          cancellationsUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        archive: boolean;
        cancellationsUuid: string;
      },
      TContext
    >({
      mutationFn: ({ archive, cancellationsUuid }) =>
        CancellationControllerService.archiveAndUnarchiveCancellationByUuid({
          archive,
          cancellationsUuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useBrokerControllerServiceUpdateBroker = <
  TData = Common.BrokerControllerServiceUpdateBrokerMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: BrokerDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: BrokerDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      BrokerControllerService.updateBroker({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.breakGlassUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useBreakGlassControllerServiceUpdate3 = <
  TData = Common.BreakGlassControllerServiceUpdate3MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        breakGlassUuid: string;
        requestBody: BreakGlassRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      breakGlassUuid: string;
      requestBody: BreakGlassRequest;
    },
    TContext
  >({
    mutationFn: ({ breakGlassUuid, requestBody }) =>
      BreakGlassControllerService.update3({
        breakGlassUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.invoiceUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceUpdateAncillaryServiceCharges =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceUpdateAncillaryServiceChargesMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          invoiceUuid?: string;
          requestBody: UpdateAncillaryServiceChargesRequest[];
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        invoiceUuid?: string;
        requestBody: UpdateAncillaryServiceChargesRequest[];
      },
      TContext
    >({
      mutationFn: ({ invoiceUuid, requestBody }) =>
        AncillaryServiceChargesControllerService.updateAncillaryServiceCharges({
          invoiceUuid,
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.miscellaneousServiceChargeUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceUpdateMiscellaneousServiceChargeByUuid =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceUpdateMiscellaneousServiceChargeByUuidMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          miscellaneousServiceChargeUuid: string;
          requestBody: MiscellaneousServiceChargeRequest;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        miscellaneousServiceChargeUuid: string;
        requestBody: MiscellaneousServiceChargeRequest;
      },
      TContext
    >({
      mutationFn: ({ miscellaneousServiceChargeUuid, requestBody }) =>
        AncillaryServiceChargesControllerService.updateMiscellaneousServiceChargeByUuid(
          {
            miscellaneousServiceChargeUuid,
            requestBody,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAgentFirmControllerServiceUpdateAgentFirm = <
  TData = Common.AgentFirmControllerServiceUpdateAgentFirmMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AgentFirmDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AgentFirmDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AgentFirmControllerService.updateAgentFirm({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAgentDealControllerServiceUpdateAgentDeal = <
  TData = Common.AgentDealControllerServiceUpdateAgentDealMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AgentDealDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AgentDealDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AgentDealControllerService.updateAgentDeal({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.affiliateGroupUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAffiliateGroupControllerServiceUpdateAffiliate = <
  TData = Common.AffiliateGroupControllerServiceUpdateAffiliateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        affiliateGroupUuid: string;
        requestBody: AffiliateGroupDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      affiliateGroupUuid: string;
      requestBody: AffiliateGroupDto;
    },
    TContext
  >({
    mutationFn: ({ affiliateGroupUuid, requestBody }) =>
      AffiliateGroupControllerService.updateAffiliate({
        affiliateGroupUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.affiliateGroupUuid
 * @param data.userUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAffiliateGroupControllerServiceUpdateAffiliateUser = <
  TData =
    Common.AffiliateGroupControllerServiceUpdateAffiliateUserMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        affiliateGroupUuid: string;
        requestBody: User;
        userUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      affiliateGroupUuid: string;
      requestBody: User;
      userUuid: string;
    },
    TContext
  >({
    mutationFn: ({ affiliateGroupUuid, requestBody, userUuid }) =>
      AffiliateGroupControllerService.updateAffiliateUser({
        affiliateGroupUuid,
        requestBody,
        userUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.affiliateGroupUuid
 * @param data.userUuid
 * @param data.primary
 * @returns Response OK
 * @throws ApiError
 */
export const useAffiliateGroupControllerServiceMarkAffiliateUserAsPrimary = <
  TData =
    Common.AffiliateGroupControllerServiceMarkAffiliateUserAsPrimaryMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        affiliateGroupUuid: string;
        primary?: boolean;
        userUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      affiliateGroupUuid: string;
      primary?: boolean;
      userUuid: string;
    },
    TContext
  >({
    mutationFn: ({ affiliateGroupUuid, primary, userUuid }) =>
      AffiliateGroupControllerService.markAffiliateUserAsPrimary({
        affiliateGroupUuid,
        primary,
        userUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.adminUserUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAdminUserControllerServiceUpdateAdminUserByUuid = <
  TData = Common.AdminUserControllerServiceUpdateAdminUserByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        adminUserUuid: string;
        requestBody: AdminUserRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      adminUserUuid: string;
      requestBody: AdminUserRequest;
    },
    TContext
  >({
    mutationFn: ({ adminUserUuid, requestBody }) =>
      AdminUserControllerService.updateAdminUserByUuid({
        adminUserUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.adminUserUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAdminUserControllerServiceActiveAdminUserByUuid = <
  TData = Common.AdminUserControllerServiceActiveAdminUserByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        adminUserUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      adminUserUuid: string;
    },
    TContext
  >({
    mutationFn: ({ adminUserUuid }) =>
      AdminUserControllerService.activeAdminUserByUuid({
        adminUserUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useWorkNoteControllerServiceUpdateWorkNote = <
  TData = Common.WorkNoteControllerServiceUpdateWorkNoteMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: WorkNoteRequestDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: WorkNoteRequestDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      WorkNoteControllerService.updateWorkNote({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useVitalControllerServiceUpdateVital = <
  TData = Common.VitalControllerServiceUpdateVitalMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: VitalDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: VitalDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      VitalControllerService.updateVital({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useVaccineControllerServiceUpdateVaccine = <
  TData = Common.VaccineControllerServiceUpdateVaccineMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: VaccineDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: VaccineDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      VaccineControllerService.updateVaccine({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useTaskControllerServiceUpdateTask = <
  TData = Common.TaskControllerServiceUpdateTaskMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: TaskRequestDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: TaskRequestDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      TaskControllerService.updateTask({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useStatusConfigurationControllerServiceUpdateStatusConfiguration =
  <
    TData =
      Common.StatusConfigurationControllerServiceUpdateStatusConfigurationMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: StatusConfigurationDto;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: StatusConfigurationDto;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        StatusConfigurationControllerService.updateStatusConfiguration({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useSocialHistoryControllerServiceUpdateSocialHistory = <
  TData =
    Common.SocialHistoryControllerServiceUpdateSocialHistoryMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: SocialHistoryDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: SocialHistoryDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      SocialHistoryControllerService.updateSocialHistory({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteControllerServiceUpdateSoapNote = <
  TData = Common.SoapNoteControllerServiceUpdateSoapNoteMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: SoapNoteRequestDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: SoapNoteRequestDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      SoapNoteControllerService.updateSoapNote({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @param data.isAdmin
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteTemplateControllerServiceUpdateSoapNoteTemplate = <
  TData =
    Common.SoapNoteTemplateControllerServiceUpdateSoapNoteTemplateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        isAdmin?: boolean;
        requestBody: SoapNoteTemplateDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      isAdmin?: boolean;
      requestBody: SoapNoteTemplateDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ isAdmin, requestBody, uuid }) =>
      SoapNoteTemplateControllerService.updateSoapNoteTemplate({
        isAdmin,
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useScreenHistoryControllerServiceUpdateScreenHistory = <
  TData =
    Common.ScreenHistoryControllerServiceUpdateScreenHistoryMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ScreenHistoryDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ScreenHistoryDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      ScreenHistoryControllerService.updateScreenHistory({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @param data.isAdmin
 * @returns Response OK
 * @throws ApiError
 */
export const useReviewOfSystemTemplateControllerServiceUpdateReviewOfSystemTemplate =
  <
    TData =
      Common.ReviewOfSystemTemplateControllerServiceUpdateReviewOfSystemTemplateMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          isAdmin?: boolean;
          requestBody: ReviewOfSystemTemplateDto;
          uuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        isAdmin?: boolean;
        requestBody: ReviewOfSystemTemplateDto;
        uuid: string;
      },
      TContext
    >({
      mutationFn: ({ isAdmin, requestBody, uuid }) =>
        ReviewOfSystemTemplateControllerService.updateReviewOfSystemTemplate({
          isAdmin,
          requestBody,
          uuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useReviewOfSystemControllerServiceUpdateReviewOfSystem = <
  TData =
    Common.ReviewOfSystemControllerServiceUpdateReviewOfSystemMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: ReviewOfSystemDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: ReviewOfSystemDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      ReviewOfSystemControllerService.updateReviewOfSystem({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.referralByUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useReferralControllerServiceUpdateReferralByUuid = <
  TData = Common.ReferralControllerServiceUpdateReferralByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        referralByUuid: string;
        requestBody: ReferralRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      referralByUuid: string;
      requestBody: ReferralRequest;
    },
    TContext
  >({
    mutationFn: ({ referralByUuid, requestBody }) =>
      ReferralControllerService.updateReferralByUuid({
        referralByUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.directoryUuid
 * @param data.source
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderDirectoryControllerServiceUpdateProviderDirectory = <
  TData =
    Common.ProviderDirectoryControllerServiceUpdateProviderDirectoryMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        directoryUuid: string;
        requestBody: ProviderDirectoryRequest;
        source: "MANUAL" | "IMPORTED";
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      directoryUuid: string;
      requestBody: ProviderDirectoryRequest;
      source: "MANUAL" | "IMPORTED";
    },
    TContext
  >({
    mutationFn: ({ directoryUuid, requestBody, source }) =>
      ProviderDirectoryControllerService.updateProviderDirectory({
        directoryUuid,
        requestBody,
        source,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePointsOfCareLabControllerServiceUpdatePointOfCareLab = <
  TData =
    Common.PointsOfCareLabControllerServiceUpdatePointOfCareLabMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PointOfCareLabDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PointOfCareLabDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PointsOfCareLabControllerService.updatePointOfCareLab({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePocLabTestControllerServiceUpdatePocLabTest = <
  TData = Common.PocLabTestControllerServiceUpdatePocLabTestMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PocLabTestRequestDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PocLabTestRequestDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      PocLabTestControllerService.updatePocLabTest({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePocLabResultControllerServiceUpdatePocLabResult = <
  TData = Common.PocLabResultControllerServiceUpdatePocLabResultMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PocLabResultRequestDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PocLabResultRequestDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      PocLabResultControllerService.updatePocLabResult({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @param data.isAdmin
 * @returns Response OK
 * @throws ApiError
 */
export const usePhysicalExamTemplateControllerServiceUpdatePhysicalExamTemplate =
  <
    TData =
      Common.PhysicalExamTemplateControllerServiceUpdatePhysicalExamTemplateMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          isAdmin?: boolean;
          requestBody: PhysicalExamTemplateDto;
          uuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        isAdmin?: boolean;
        requestBody: PhysicalExamTemplateDto;
        uuid: string;
      },
      TContext
    >({
      mutationFn: ({ isAdmin, requestBody, uuid }) =>
        PhysicalExamTemplateControllerService.updatePhysicalExamTemplate({
          isAdmin,
          requestBody,
          uuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePhysicalExamControllerServiceUpdatePhysicalExam = <
  TData = Common.PhysicalExamControllerServiceUpdatePhysicalExamMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PhysicalExamDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PhysicalExamDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      PhysicalExamControllerService.updatePhysicalExam({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePharmacyControllerServiceUpdatePharmacy = <
  TData = Common.PharmacyControllerServiceUpdatePharmacyMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PharmacyDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PharmacyDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      PharmacyControllerService.updatePharmacy({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientVaccinationControllerServiceUpdatePatientVaccination = <
  TData =
    Common.PatientVaccinationControllerServiceUpdatePatientVaccinationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PatientVaccinationDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PatientVaccinationDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      PatientVaccinationControllerService.updatePatientVaccination({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientFlagControllerServiceUpdatePatientFlag = <
  TData = Common.PatientFlagControllerServiceUpdatePatientFlagMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PatientFlagDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PatientFlagDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      PatientFlagControllerService.updatePatientFlag({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePastSurgicalHistoryControllerServiceUpdatePastSurgicalHistory =
  <
    TData =
      Common.PastSurgicalHistoryControllerServiceUpdatePastSurgicalHistoryMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: PastSurgicalHistoryDto;
          uuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: PastSurgicalHistoryDto;
        uuid: string;
      },
      TContext
    >({
      mutationFn: ({ requestBody, uuid }) =>
        PastSurgicalHistoryControllerService.updatePastSurgicalHistory({
          requestBody,
          uuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePastMedicalHistoryControllerServiceUpdatePastMedicalHistory = <
  TData =
    Common.PastMedicalHistoryControllerServiceUpdatePastMedicalHistoryMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PastMedicalHistoryDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PastMedicalHistoryDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      PastMedicalHistoryControllerService.updatePastMedicalHistory({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.noteByUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNoteControllerServiceUpdateNoteByUuid = <
  TData = Common.NoteControllerServiceUpdateNoteByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        noteByUuid: string;
        requestBody: NoteRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      noteByUuid: string;
      requestBody: NoteRequest;
    },
    TContext
  >({
    mutationFn: ({ noteByUuid, requestBody }) =>
      NoteControllerService.updateNoteByUuid({
        noteByUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.medicationUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useMedicationControllerServiceUpdateMedicationByUuid = <
  TData =
    Common.MedicationControllerServiceUpdateMedicationByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        medicationUuid: string;
        requestBody: MedicationRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      medicationUuid: string;
      requestBody: MedicationRequest;
    },
    TContext
  >({
    mutationFn: ({ medicationUuid, requestBody }) =>
      MedicationControllerService.updateMedicationByUuid({
        medicationUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.macroUuid
 * @param data.requestBody
 * @param data.isAdmin
 * @returns Response OK
 * @throws ApiError
 */
export const useMacroControllerServiceUpdateMacro = <
  TData = Common.MacroControllerServiceUpdateMacroMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        isAdmin?: boolean;
        macroUuid: string;
        requestBody: MacroDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      isAdmin?: boolean;
      macroUuid: string;
      requestBody: MacroDto;
    },
    TContext
  >({
    mutationFn: ({ isAdmin, macroUuid, requestBody }) =>
      MacroControllerService.updateMacro({
        isAdmin,
        macroUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.formData
 * @returns Response OK
 * @throws ApiError
 */
export const useLocationControllerServiceUpdateLocation = <
  TData = Common.LocationControllerServiceUpdateLocationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        formData?: {
          locationRequest: LocationRequestDto;
          template?: Blob | File;
        };
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      formData?: {
        locationRequest: LocationRequestDto;
        template?: Blob | File;
      };
    },
    TContext
  >({
    mutationFn: ({ formData }) =>
      LocationControllerService.updateLocation({
        formData,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.locationUuid
 * @param data.sharableUuid
 * @param data.enabled
 * @returns Response OK
 * @throws ApiError
 */
export const useLocationShareableSettingControllerServiceUpdateSingleToggle = <
  TData =
    Common.LocationShareableSettingControllerServiceUpdateSingleToggleMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        enabled: boolean;
        locationUuid: string;
        sharableUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      enabled: boolean;
      locationUuid: string;
      sharableUuid: string;
    },
    TContext
  >({
    mutationFn: ({ enabled, locationUuid, sharableUuid }) =>
      LocationShareableSettingControllerService.updateSingleToggle({
        enabled,
        locationUuid,
        sharableUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useLocationGroupControllerServiceUpdateLocationGroup = <
  TData =
    Common.LocationGroupControllerServiceUpdateLocationGroupMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LocationGroupRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LocationGroupRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      LocationGroupControllerService.updateLocationGroup({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useLocationAvailabilityControllerServiceUpdateLocationAvailability =
  <
    TData =
      Common.LocationAvailabilityControllerServiceUpdateLocationAvailabilityMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody: LocationAvailabilityDto;
          uuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody: LocationAvailabilityDto;
        uuid: string;
      },
      TContext
    >({
      mutationFn: ({ requestBody, uuid }) =>
        LocationAvailabilityControllerService.updateLocationAvailability({
          requestBody,
          uuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.pharmacyUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientLinkPharmacyControllerServiceSetDefaultPharmacy = <
  TData =
    Common.PatientLinkPharmacyControllerServiceSetDefaultPharmacyMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        pharmacyUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      pharmacyUuid: string;
    },
    TContext
  >({
    mutationFn: ({ patientUuid, pharmacyUuid }) =>
      PatientLinkPharmacyControllerService.setDefaultPharmacy({
        patientUuid,
        pharmacyUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useLabTestControllerServiceUpdateLabTest = <
  TData = Common.LabTestControllerServiceUpdateLabTestMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LabTestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LabTestDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      LabTestControllerService.updateLabTest({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.labResultUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLabResultControllerServiceApproveLabResult = <
  TData = Common.LabResultControllerServiceApproveLabResultMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        labResultUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      labResultUuid: string;
    },
    TContext
  >({
    mutationFn: ({ labResultUuid }) =>
      LabResultControllerService.approveLabResult({
        labResultUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useLabOrderControllerServiceUpdateLabOrder = <
  TData = Common.LabOrderControllerServiceUpdateLabOrderMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LabOrderDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LabOrderDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      LabOrderControllerService.updateLabOrder({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useLabOrderSetControllerServiceUpdateLabOrderSet = <
  TData = Common.LabOrderSetControllerServiceUpdateLabOrderSetMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: LabOrderSetDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: LabOrderSetDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      LabOrderSetControllerService.updateLabOrderSet({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useInvoiceControllerServiceUpdateInvoiceByUuid = <
  TData = Common.InvoiceControllerServiceUpdateInvoiceByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        invoiceUuid: string;
        requestBody: InvoiceRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      invoiceUuid: string;
      requestBody: InvoiceRequest;
    },
    TContext
  >({
    mutationFn: ({ invoiceUuid, requestBody }) =>
      InvoiceControllerService.updateInvoiceByUuid({
        invoiceUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useInsuranceControllerServiceUpdateInsurance = <
  TData = Common.InsuranceControllerServiceUpdateInsuranceMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        requestBody: InsuranceDetailsDto[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      requestBody: InsuranceDetailsDto[];
    },
    TContext
  >({
    mutationFn: ({ patientUuid, requestBody }) =>
      InsuranceControllerService.updateInsurance({
        patientUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.imagingResultByUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useImagingResultControllerServiceUpdateImagingResult = <
  TData =
    Common.ImagingResultControllerServiceUpdateImagingResultMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        imagingResultByUuid: string;
        requestBody: ImagingResultRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      imagingResultByUuid: string;
      requestBody: ImagingResultRequest;
    },
    TContext
  >({
    mutationFn: ({ imagingResultByUuid, requestBody }) =>
      ImagingResultControllerService.updateImagingResult({
        imagingResultByUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.imagingOrderByUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useImagingOrderControllerServiceUpdateImagingOrder = <
  TData = Common.ImagingOrderControllerServiceUpdateImagingOrderMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        imagingOrderByUuid: string;
        requestBody: ImagingOrderRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      imagingOrderByUuid: string;
      requestBody: ImagingOrderRequest;
    },
    TContext
  >({
    mutationFn: ({ imagingOrderByUuid, requestBody }) =>
      ImagingOrderControllerService.updateImagingOrder({
        imagingOrderByUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useIcdCodeControllerServiceUpdateIcdCode = <
  TData = Common.IcdCodeControllerServiceUpdateIcdCodeMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: IcdCodeDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: IcdCodeDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      IcdCodeControllerService.updateIcdCode({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useHAndPNoteControllerServiceUpdateHandPnote = <
  TData = Common.HAndPNoteControllerServiceUpdateHandPnoteMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: HAndPNoteRequestDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: HAndPNoteRequestDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      HAndPNoteControllerService.updateHandPnote({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useHabitsControllerServiceUpdateHabits = <
  TData = Common.HabitsControllerServiceUpdateHabitsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: HabitsDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: HabitsDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      HabitsControllerService.updateHabits({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useGlobalHolidayControllerServiceUpdateGlobalHoliday = <
  TData =
    Common.GlobalHolidayControllerServiceUpdateGlobalHolidayMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: GlobalHolidayDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: GlobalHolidayDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      GlobalHolidayControllerService.updateGlobalHoliday({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.formTemplateUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useFormTemplateControllerServiceUpdateFormTemplate = <
  TData = Common.FormTemplateControllerServiceUpdateFormTemplateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        formTemplateUuid: string;
        requestBody: FormTemplateRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      formTemplateUuid: string;
      requestBody: FormTemplateRequest;
    },
    TContext
  >({
    mutationFn: ({ formTemplateUuid, requestBody }) =>
      FormTemplateControllerService.updateFormTemplate({
        formTemplateUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.formTemplateUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useFormTemplateControllerServiceSetFormAsDefault = <
  TData = Common.FormTemplateControllerServiceSetFormAsDefaultMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        formTemplateUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      formTemplateUuid: string;
    },
    TContext
  >({
    mutationFn: ({ formTemplateUuid }) =>
      FormTemplateControllerService.setFormAsDefault({
        formTemplateUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.formTemplateUuid
 * @param data.formData
 * @returns Response OK
 * @throws ApiError
 */
export const useFormTemplateControllerServiceUpdateFormTemplateWithPdf = <
  TData =
    Common.FormTemplateControllerServiceUpdateFormTemplateWithPdfMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        formData?: { request: FormTemplateRequest; pdf?: Blob | File };
        formTemplateUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      formData?: { request: FormTemplateRequest; pdf?: Blob | File };
      formTemplateUuid: string;
    },
    TContext
  >({
    mutationFn: ({ formData, formTemplateUuid }) =>
      FormTemplateControllerService.updateFormTemplateWithPdf({
        formData,
        formTemplateUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useFdbMedicationsControllerServiceUpdateFdbMedication = <
  TData =
    Common.FdbMedicationsControllerServiceUpdateFdbMedicationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: FdbMedicationsDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: FdbMedicationsDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      FdbMedicationsControllerService.updateFdbMedication({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useFamilyHistoryControllerServiceUpdateFamilyHistory = <
  TData =
    Common.FamilyHistoryControllerServiceUpdateFamilyHistoryMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: FamilyHistoryDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: FamilyHistoryDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      FamilyHistoryControllerService.updateFamilyHistory({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.educationalMaterialUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEducationalMaterialControllerServiceUpdateEducationalMaterial =
  <
    TData =
      Common.EducationalMaterialControllerServiceUpdateEducationalMaterialMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          educationalMaterialUuid: string;
          requestBody: EducationalMaterialDto;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        educationalMaterialUuid: string;
        requestBody: EducationalMaterialDto;
      },
      TContext
    >({
      mutationFn: ({ educationalMaterialUuid, requestBody }) =>
        EducationalMaterialControllerService.updateEducationalMaterial({
          educationalMaterialUuid,
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useDrugIntoleranceControllerServiceUpdateDrugIntolerance = <
  TData =
    Common.DrugIntoleranceControllerServiceUpdateDrugIntoleranceMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: DrugIntoleranceDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: DrugIntoleranceDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      DrugIntoleranceControllerService.updateDrugIntolerance({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useDocumentTypeControllerServiceUpdateDocumentType = <
  TData = Common.DocumentTypeControllerServiceUpdateDocumentTypeMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: UpdateDocumentTypeRequest[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: UpdateDocumentTypeRequest[];
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      DocumentTypeControllerService.updateDocumentType({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useDiagnosisControllerServiceUpdateDiagnosis = <
  TData = Common.DiagnosisControllerServiceUpdateDiagnosisMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: DiagnosisDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: DiagnosisDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      DiagnosisControllerService.updateDiagnosis({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCptCodeControllerServiceUpdateIcdCode1 = <
  TData = Common.CptCodeControllerServiceUpdateIcdCode1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CptCodeDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CptCodeDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      CptCodeControllerService.updateIcdCode1({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCommentControllerServiceUpdateMessage = <
  TData = Common.CommentControllerServiceUpdateMessageMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CommentRequestDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CommentRequestDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      CommentControllerService.updateMessage({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.carePlanUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCarePlanControllerServiceUpdateCarePlanByUuid = <
  TData = Common.CarePlanControllerServiceUpdateCarePlanByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        carePlanUuid: string;
        requestBody: UpdateCarePlanRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      carePlanUuid: string;
      requestBody: UpdateCarePlanRequest;
    },
    TContext
  >({
    mutationFn: ({ carePlanUuid, requestBody }) =>
      CarePlanControllerService.updateCarePlanByUuid({
        carePlanUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAvailabilityControllerServiceUpdateAvailability = <
  TData = Common.AvailabilityControllerServiceUpdateAvailabilityMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AvailabilityDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AvailabilityDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AvailabilityControllerService.updateAvailability({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.availabilityDate
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAvailabilityControllerServiceCreateAvailabilityForDate = <
  TData =
    Common.AvailabilityControllerServiceCreateAvailabilityForDateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        availabilityDate?: string;
        requestBody?: AvailabilityDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      availabilityDate?: string;
      requestBody?: AvailabilityDto;
    },
    TContext
  >({
    mutationFn: ({ availabilityDate, requestBody }) =>
      AvailabilityControllerService.createAvailabilityForDate({
        availabilityDate,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAppointmentControllerServiceUpdateAppointment = <
  TData = Common.AppointmentControllerServiceUpdateAppointmentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AppointmentDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AppointmentDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AppointmentControllerService.updateAppointment({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.masterAppointmentUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAppointmentControllerServiceCancelAppointmentByUuid = <
  TData =
    Common.AppointmentControllerServiceCancelAppointmentByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        masterAppointmentUuid: string;
        requestBody?: DeleteAppointmentRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      masterAppointmentUuid: string;
      requestBody?: DeleteAppointmentRequestDto;
    },
    TContext
  >({
    mutationFn: ({ masterAppointmentUuid, requestBody }) =>
      AppointmentControllerService.cancelAppointmentByUuid({
        masterAppointmentUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAppointmentTypeControllerServiceUpdateAppointmentType = <
  TData =
    Common.AppointmentTypeControllerServiceUpdateAppointmentTypeMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AppointmentTypeDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AppointmentTypeDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      AppointmentTypeControllerService.updateAppointmentType({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAnnotableImageControllerServiceUpdateAnnotableImage = <
  TData =
    Common.AnnotableImageControllerServiceUpdateAnnotableImageMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AnnotableImageDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AnnotableImageDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      AnnotableImageControllerService.updateAnnotableImage({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.anotableImageTemplateUuid
 * @param data.requestBody
 * @param data.isAdmin
 * @returns Response OK
 * @throws ApiError
 */
export const useAnnotableImageTemplateControllerServiceUpdateAnnotableImageTemplate =
  <
    TData =
      Common.AnnotableImageTemplateControllerServiceUpdateAnnotableImageTemplateMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          anotableImageTemplateUuid: string;
          isAdmin?: boolean;
          requestBody: AnnotableImageTemplateDto;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        anotableImageTemplateUuid: string;
        isAdmin?: boolean;
        requestBody: AnnotableImageTemplateDto;
      },
      TContext
    >({
      mutationFn: ({ anotableImageTemplateUuid, isAdmin, requestBody }) =>
        AnnotableImageTemplateControllerService.updateAnnotableImageTemplate({
          anotableImageTemplateUuid,
          isAdmin,
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAnnotableImagePinControllerServiceUpdateAnnotableImagePin = <
  TData =
    Common.AnnotableImagePinControllerServiceUpdateAnnotableImagePinMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AnnotableImagePinDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AnnotableImagePinDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      AnnotableImagePinControllerService.updateAnnotableImagePin({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAllergyControllerServiceUpdateAllergy1 = <
  TData = Common.AllergyControllerServiceUpdateAllergy1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: AllergyDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: AllergyDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      AllergyControllerService.updateAllergy1({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.userUuid
 * @param data.notificationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationControllerServiceMarkAsRead = <
  TData = Common.NotificationControllerServiceMarkAsReadMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        notificationUuid?: string;
        userUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      notificationUuid?: string;
      userUuid: string;
    },
    TContext
  >({
    mutationFn: ({ notificationUuid, userUuid }) =>
      NotificationControllerService.markAsRead({
        notificationUuid,
        userUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.notificationPreferenceUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationPreferenceControllerServiceUpdateNotificationPreference =
  <
    TData =
      Common.NotificationPreferenceControllerServiceUpdateNotificationPreferenceMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          notificationPreferenceUuid: string;
          requestBody: NotificationPreferenceUpdateRequest;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        notificationPreferenceUuid: string;
        requestBody: NotificationPreferenceUpdateRequest;
      },
      TContext
    >({
      mutationFn: ({ notificationPreferenceUuid, requestBody }) =>
        NotificationPreferenceControllerService.updateNotificationPreference({
          notificationPreferenceUuid,
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.employerUuid
 * @param data.notificationSettingUuid
 * @param data.enabled
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerManagementNotificationSettingControllerServiceUpdateSingleToggle1 =
  <
    TData =
      Common.EmployerManagementNotificationSettingControllerServiceUpdateSingleToggle1MutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          employerUuid: string;
          enabled: boolean;
          notificationSettingUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        employerUuid: string;
        enabled: boolean;
        notificationSettingUuid: string;
      },
      TContext
    >({
      mutationFn: ({ employerUuid, enabled, notificationSettingUuid }) =>
        EmployerManagementNotificationSettingControllerService.updateSingleToggle1(
          {
            employerUuid,
            enabled,
            notificationSettingUuid,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.subscriptionId
 * @param data.priceId
 * @param data.promotionCode
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceUpdateSubscription1 = <
  TData = Common.StripControllerServiceUpdateSubscription1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        priceId?: string;
        promotionCode?: string;
        subscriptionId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      priceId?: string;
      promotionCode?: string;
      subscriptionId: string;
    },
    TContext
  >({
    mutationFn: ({ priceId, promotionCode, subscriptionId }) =>
      StripControllerService.updateSubscription1({
        priceId,
        promotionCode,
        subscriptionId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.subscriptionId
 * @param data.newPriceId
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceChangePlan1 = <
  TData = Common.StripControllerServiceChangePlan1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        newPriceId: string;
        subscriptionId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      newPriceId: string;
      subscriptionId: string;
    },
    TContext
  >({
    mutationFn: ({ newPriceId, subscriptionId }) =>
      StripControllerService.changePlan1({
        newPriceId,
        subscriptionId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.subscriptionId
 * @param data.newPriceId
 * @param data.prorate
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceChangePlanWithProration1 = <
  TData = Common.StripControllerServiceChangePlanWithProration1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        newPriceId: string;
        prorate?: boolean;
        subscriptionId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      newPriceId: string;
      prorate?: boolean;
      subscriptionId: string;
    },
    TContext
  >({
    mutationFn: ({ newPriceId, prorate, subscriptionId }) =>
      StripControllerService.changePlanWithProration1({
        newPriceId,
        prorate,
        subscriptionId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.promotionalCodeId
 * @param data.active
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceUpdatePromotionalCoupon1 = <
  TData = Common.StripControllerServiceUpdatePromotionalCoupon1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        active: boolean;
        promotionalCodeId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      active: boolean;
      promotionalCodeId: string;
    },
    TContext
  >({
    mutationFn: ({ active, promotionalCodeId }) =>
      StripControllerService.updatePromotionalCoupon1({
        active,
        promotionalCodeId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.ticketUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketControllerServiceUpdateTicket = <
  TData = Common.TicketControllerServiceUpdateTicketMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: TicketDto;
        ticketUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: TicketDto;
      ticketUuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, ticketUuid }) =>
      TicketControllerService.updateTicket({
        requestBody,
        ticketUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.ticketUuid
 * @param data.newPriority
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketControllerServiceUpdateTicketPriority = <
  TData = Common.TicketControllerServiceUpdateTicketPriorityMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        newPriority: "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";
        ticketUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      newPriority: "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";
      ticketUuid: string;
    },
    TContext
  >({
    mutationFn: ({ newPriority, ticketUuid }) =>
      TicketControllerService.updateTicketPriority({
        newPriority,
        ticketUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.ticketUuid
 * @param data.status
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketControllerServiceUpdateTicketStatus = <
  TData = Common.TicketControllerServiceUpdateTicketStatusMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        status:
          | "PENDING"
          | "ONGOING"
          | "RESOLVED"
          | "OPEN"
          | "CLOSED"
          | "ASSIGNED"
          | "UNDER_REVIEW"
          | "IN_PROGRESS";
        ticketUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      status:
        | "PENDING"
        | "ONGOING"
        | "RESOLVED"
        | "OPEN"
        | "CLOSED"
        | "ASSIGNED"
        | "UNDER_REVIEW"
        | "IN_PROGRESS";
      ticketUuid: string;
    },
    TContext
  >({
    mutationFn: ({ status, ticketUuid }) =>
      TicketControllerService.updateTicketStatus({
        status,
        ticketUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.taskUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketTaskControllerServiceUpdateTicketTask = <
  TData = Common.TicketTaskControllerServiceUpdateTicketTaskMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: TicketTaskDto;
        taskUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: TicketTaskDto;
      taskUuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, taskUuid }) =>
      TicketTaskControllerService.updateTicketTask({
        requestBody,
        taskUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.taskUuid
 * @param data.newStatus
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketTaskControllerServiceUpdateTicketTaskStatus = <
  TData =
    Common.TicketTaskControllerServiceUpdateTicketTaskStatusMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        newStatus: "OPEN" | "CLOSED";
        taskUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      newStatus: "OPEN" | "CLOSED";
      taskUuid: string;
    },
    TContext
  >({
    mutationFn: ({ newStatus, taskUuid }) =>
      TicketTaskControllerService.updateTicketTaskStatus({
        newStatus,
        taskUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.taskUuid
 * @param data.newPriority
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketTaskControllerServiceUpdateTicketTaskPriority = <
  TData =
    Common.TicketTaskControllerServiceUpdateTicketTaskPriorityMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        newPriority: "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";
        taskUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      newPriority: "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";
      taskUuid: string;
    },
    TContext
  >({
    mutationFn: ({ newPriority, taskUuid }) =>
      TicketTaskControllerService.updateTicketTaskPriority({
        newPriority,
        taskUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.taskUuid
 * @param data.assigneeUuids
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketTaskControllerServiceUpdateTicketTaskAssignee = <
  TData =
    Common.TicketTaskControllerServiceUpdateTicketTaskAssigneeMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        assigneeUuids: string[];
        taskUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      assigneeUuids: string[];
      taskUuid: string;
    },
    TContext
  >({
    mutationFn: ({ assigneeUuids, taskUuid }) =>
      TicketTaskControllerService.updateTicketTaskAssignee({
        assigneeUuids,
        taskUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.notesUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketNotesControllerServiceUpdateTicketNotes = <
  TData = Common.TicketNotesControllerServiceUpdateTicketNotesMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        notesUuid: string;
        requestBody: TicketNotesDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      notesUuid: string;
      requestBody: TicketNotesDto;
    },
    TContext
  >({
    mutationFn: ({ notesUuid, requestBody }) =>
      TicketNotesControllerService.updateTicketNotes({
        notesUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.attachmentUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketAttachmentControllerServiceUpdateAttachment = <
  TData =
    Common.TicketAttachmentControllerServiceUpdateAttachmentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        attachmentUuid: string;
        requestBody: TicketAttachmentDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      attachmentUuid: string;
      requestBody: TicketAttachmentDto;
    },
    TContext
  >({
    mutationFn: ({ attachmentUuid, requestBody }) =>
      TicketAttachmentControllerService.updateAttachment({
        attachmentUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.templateUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmTemplateControllerServiceUpdateTemplate = <
  TData = Common.CrmTemplateControllerServiceUpdateTemplateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CrmTemplateDto;
        templateUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CrmTemplateDto;
      templateUuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, templateUuid }) =>
      CrmTemplateControllerService.updateTemplate({
        requestBody,
        templateUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.taskUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmTaskControllerServiceUpdateCrmTask = <
  TData = Common.CrmTaskControllerServiceUpdateCrmTaskMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: CrmTaskDto;
        taskUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: CrmTaskDto;
      taskUuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, taskUuid }) =>
      CrmTaskControllerService.updateCrmTask({
        requestBody,
        taskUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.taskPriority
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmTaskControllerServiceUpdateTaskPriority = <
  TData = Common.CrmTaskControllerServiceUpdateTaskPriorityMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        taskPriority: "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      taskPriority: "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";
    },
    TContext
  >({
    mutationFn: ({ taskPriority }) =>
      CrmTaskControllerService.updateTaskPriority({
        taskPriority,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.taskLogUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useTaskLogControllerServiceUpdateTaskLog = <
  TData = Common.TaskLogControllerServiceUpdateTaskLogMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: TaskLogsDto;
        taskLogUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: TaskLogsDto;
      taskLogUuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, taskLogUuid }) =>
      TaskLogControllerService.updateTaskLog({
        requestBody,
        taskLogUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.newsletterUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmNewsletterControllerServiceUpdateNewsletter = <
  TData = Common.CrmNewsletterControllerServiceUpdateNewsletterMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        newsletterUuid: string;
        requestBody: CrmNewsletterDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      newsletterUuid: string;
      requestBody: CrmNewsletterDto;
    },
    TContext
  >({
    mutationFn: ({ newsletterUuid, requestBody }) =>
      CrmNewsletterControllerService.updateNewsletter({
        newsletterUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.campaignUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmCampaignControllerServiceUpdateCampaign = <
  TData = Common.CrmCampaignControllerServiceUpdateCampaignMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        campaignUuid: string;
        requestBody: CrmCampaignDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      campaignUuid: string;
      requestBody: CrmCampaignDto;
    },
    TContext
  >({
    mutationFn: ({ campaignUuid, requestBody }) =>
      CrmCampaignControllerService.updateCampaign({
        campaignUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.callLogUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useCallLogsControllerServiceUpdateCallLog = <
  TData = Common.CallLogsControllerServiceUpdateCallLogMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        callLogUuid: string;
        requestBody: CallLogsDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      callLogUuid: string;
      requestBody: CallLogsDto;
    },
    TContext
  >({
    mutationFn: ({ callLogUuid, requestBody }) =>
      CallLogsControllerService.updateCallLog({
        callLogUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceMarkMessageUrgent = <
  TData = Common.MessageControllerServiceMarkMessageUrgentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      MessageControllerService.markMessageUrgent({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.userUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceMarkMessageReadByUser = <
  TData = Common.MessageControllerServiceMarkMessageReadByUserMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        userUuid: string;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      userUuid: string;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ userUuid, uuid }) =>
      MessageControllerService.markMessageReadByUser({
        userUuid,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceCancelScheduledMessage = <
  TData = Common.MessageControllerServiceCancelScheduledMessageMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      MessageControllerService.cancelScheduledMessage({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.threadUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceMarkAllMessagesReadInThread = <
  TData =
    Common.MessageControllerServiceMarkAllMessagesReadInThreadMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        threadUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      threadUuid: string;
    },
    TContext
  >({
    mutationFn: ({ threadUuid }) =>
      MessageControllerService.markAllMessagesReadInThread({
        threadUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.threadUuid
 * @param data.userUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceMarkAllMessagesReadInThreadForUser = <
  TData =
    Common.MessageControllerServiceMarkAllMessagesReadInThreadForUserMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        threadUuid: string;
        userUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      threadUuid: string;
      userUuid: string;
    },
    TContext
  >({
    mutationFn: ({ threadUuid, userUuid }) =>
      MessageControllerService.markAllMessagesReadInThreadForUser({
        threadUuid,
        userUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceRescheduleMessage = <
  TData = Common.MessageControllerServiceRescheduleMessageMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: MessageDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: MessageDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      MessageControllerService.rescheduleMessage({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceEditScheduledMessage = <
  TData = Common.MessageControllerServiceEditScheduledMessageMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: MessageDto;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: MessageDto;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      MessageControllerService.editScheduledMessage({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceRemoveMessageUrgent = <
  TData = Common.MessageControllerServiceRemoveMessageUrgentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      MessageControllerService.removeMessageUrgent({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.status
 * @param data.uploadUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployeeUploadControllerServiceSetReviewed = <
  TData = Common.EmployeeUploadControllerServiceSetReviewedMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        status: boolean;
        uploadUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      status: boolean;
      uploadUuid: string;
    },
    TContext
  >({
    mutationFn: ({ status, uploadUuid }) =>
      EmployeeUploadControllerService.setReviewed({
        status,
        uploadUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.status
 * @param data.uploadUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployeeUploadControllerServiceUpdateMuteStatus = <
  TData = Common.EmployeeUploadControllerServiceUpdateMuteStatusMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        status: boolean;
        uploadUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      status: boolean;
      uploadUuid: string;
    },
    TContext
  >({
    mutationFn: ({ status, uploadUuid }) =>
      EmployeeUploadControllerService.updateMuteStatus({
        status,
        uploadUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useSavedBankControllerServiceUpdateAutopaySavedBank = <
  TData = Common.SavedBankControllerServiceUpdateAutopaySavedBankMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: UpdateSavedBankRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: UpdateSavedBankRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      SavedBankControllerService.updateAutopaySavedBank({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.roleUuid
 * @param data.name
 * @returns Response OK
 * @throws ApiError
 */
export const useRolesAndPermissionControllerServiceUpdateRoleName = <
  TData =
    Common.RolesAndPermissionControllerServiceUpdateRoleNameMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        name: string;
        roleUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      name: string;
      roleUuid: string;
    },
    TContext
  >({
    mutationFn: ({ name, roleUuid }) =>
      RolesAndPermissionControllerService.updateRoleName({
        name,
        roleUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.providerUuid
 * @param data.status
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderControllerServiceUpdatePatientEntrollmentByProviderUuid =
  <
    TData =
      Common.ProviderControllerServiceUpdatePatientEntrollmentByProviderUuidMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          providerUuid: string;
          status: boolean;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        providerUuid: string;
        status: boolean;
      },
      TContext
    >({
      mutationFn: ({ providerUuid, status }) =>
        ProviderControllerService.updatePatientEntrollmentByProviderUuid({
          providerUuid,
          status,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.status
 * @param data.providerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderControllerServiceUpdateProviderStatus = <
  TData = Common.ProviderControllerServiceUpdateProviderStatusMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        providerUuid: string;
        status: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      providerUuid: string;
      status: boolean;
    },
    TContext
  >({
    mutationFn: ({ providerUuid, status }) =>
      ProviderControllerService.updateProviderStatus({
        providerUuid,
        status,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.status
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceSetPatientPortalAccess = <
  TData = Common.PatientControllerServiceSetPatientPortalAccessMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        status: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      status: boolean;
    },
    TContext
  >({
    mutationFn: ({ patientUuid, status }) =>
      PatientControllerService.setPatientPortalAccess({
        patientUuid,
        status,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.planEndDate
 * @param data.cancellationUuid
 * @param data.status
 * @param data.isCancelMembership
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceUpdatePatientStatus = <
  TData = Common.PatientControllerServiceUpdatePatientStatusMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        cancellationUuid?: string;
        isCancelMembership?: boolean;
        patientUuid: string;
        planEndDate?: string;
        status?: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      cancellationUuid?: string;
      isCancelMembership?: boolean;
      patientUuid: string;
      planEndDate?: string;
      status?: boolean;
    },
    TContext
  >({
    mutationFn: ({
      cancellationUuid,
      isCancelMembership,
      patientUuid,
      planEndDate,
      status,
    }) =>
      PatientControllerService.updatePatientStatus({
        cancellationUuid,
        isCancelMembership,
        patientUuid,
        planEndDate,
        status,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.dependentPatientUuid
 * @param data.oldPrimaryRelationShip
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceMakePrimary = <
  TData = Common.PatientControllerServiceMakePrimaryMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        dependentPatientUuid: string;
        oldPrimaryRelationShip?:
          | "NONE"
          | "ALL"
          | "SELF"
          | "SPOUSE"
          | "SIBLING"
          | "MOTHER"
          | "FATHER"
          | "GUARDIAN"
          | "PARENT"
          | "CHILDREN"
          | "GRANDPARENT"
          | "GRANDCHILDREN"
          | "FRIEND"
          | "PARTNER"
          | "OTHER";
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      dependentPatientUuid: string;
      oldPrimaryRelationShip?:
        | "NONE"
        | "ALL"
        | "SELF"
        | "SPOUSE"
        | "SIBLING"
        | "MOTHER"
        | "FATHER"
        | "GUARDIAN"
        | "PARENT"
        | "CHILDREN"
        | "GRANDPARENT"
        | "GRANDCHILDREN"
        | "FRIEND"
        | "PARTNER"
        | "OTHER";
    },
    TContext
  >({
    mutationFn: ({ dependentPatientUuid, oldPrimaryRelationShip }) =>
      PatientControllerService.makePrimary({
        dependentPatientUuid,
        oldPrimaryRelationShip,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.providerUuid
 * @param data.locationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceSetPatientPrimaryProvider = <
  TData =
    Common.PatientControllerServiceSetPatientPrimaryProviderMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        locationUuid: string;
        patientUuid: string;
        providerUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      locationUuid: string;
      patientUuid: string;
      providerUuid: string;
    },
    TContext
  >({
    mutationFn: ({ locationUuid, patientUuid, providerUuid }) =>
      PatientControllerService.setPatientPrimaryProvider({
        locationUuid,
        patientUuid,
        providerUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.sendSms
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceSetSendSms = <
  TData = Common.PatientControllerServiceSetSendSmsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        sendSms: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      sendSms: boolean;
    },
    TContext
  >({
    mutationFn: ({ patientUuid, sendSms }) =>
      PatientControllerService.setSendSms({
        patientUuid,
        sendSms,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.status
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceRemovePreEngage = <
  TData = Common.PatientControllerServiceRemovePreEngageMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        status: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      status: boolean;
    },
    TContext
  >({
    mutationFn: ({ patientUuid, status }) =>
      PatientControllerService.removePreEngage({
        patientUuid,
        status,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.reEnrollment
 * @param data.reasonForReEnrollment
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceSetReEnrollment = <
  TData = Common.PatientControllerServiceSetReEnrollmentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        reasonForReEnrollment?: string;
        reEnrollment: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      reasonForReEnrollment?: string;
      reEnrollment: boolean;
    },
    TContext
  >({
    mutationFn: ({ patientUuid, reasonForReEnrollment, reEnrollment }) =>
      PatientControllerService.setReEnrollment({
        patientUuid,
        reasonForReEnrollment,
        reEnrollment,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.primaryPatientUuid
 * @param data.relationShip
 * @param data.existingPatientUuid
 * @param data.effectiveDate
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceAddExistingPatientAsDependent = <
  TData =
    Common.PatientControllerServiceAddExistingPatientAsDependentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        effectiveDate?: string;
        existingPatientUuid: string;
        primaryPatientUuid: string;
        relationShip:
          | "NONE"
          | "ALL"
          | "SELF"
          | "SPOUSE"
          | "SIBLING"
          | "MOTHER"
          | "FATHER"
          | "GUARDIAN"
          | "PARENT"
          | "CHILDREN"
          | "GRANDPARENT"
          | "GRANDCHILDREN"
          | "FRIEND"
          | "PARTNER"
          | "OTHER";
        requestBody?: DependentRelationDto[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      effectiveDate?: string;
      existingPatientUuid: string;
      primaryPatientUuid: string;
      relationShip:
        | "NONE"
        | "ALL"
        | "SELF"
        | "SPOUSE"
        | "SIBLING"
        | "MOTHER"
        | "FATHER"
        | "GUARDIAN"
        | "PARENT"
        | "CHILDREN"
        | "GRANDPARENT"
        | "GRANDCHILDREN"
        | "FRIEND"
        | "PARTNER"
        | "OTHER";
      requestBody?: DependentRelationDto[];
    },
    TContext
  >({
    mutationFn: ({
      effectiveDate,
      existingPatientUuid,
      primaryPatientUuid,
      relationShip,
      requestBody,
    }) =>
      PatientControllerService.addExistingPatientAsDependent({
        effectiveDate,
        existingPatientUuid,
        primaryPatientUuid,
        relationShip,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.planStartDate
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceChangeBillingDate = <
  TData = Common.PatientControllerServiceChangeBillingDateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        planStartDate: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      planStartDate: string;
    },
    TContext
  >({
    mutationFn: ({ patientUuid, planStartDate }) =>
      PatientControllerService.changeBillingDate({
        patientUuid,
        planStartDate,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.status
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNurseStaffProviderControllerServiceUpdateNurseStaffProviderStatus =
  <
    TData =
      Common.NurseStaffProviderControllerServiceUpdateNurseStaffProviderStatusMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          status: boolean;
          uuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        status: boolean;
        uuid: string;
      },
      TContext
    >({
      mutationFn: ({ status, uuid }) =>
        NurseStaffProviderControllerService.updateNurseStaffProviderStatus({
          status,
          uuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.status
 * @param data.employerUuid
 * @param data.isCancelEndMembership
 * @param data.planEndDate
 * @param data.planStartDate
 * @param data.cancellationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceUpdateEmployerStatus = <
  TData = Common.EmployerControllerServiceUpdateEmployerStatusMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        cancellationUuid?: string;
        employerUuid: string;
        isCancelEndMembership?: boolean;
        planEndDate?: string;
        planStartDate?: string;
        status: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      cancellationUuid?: string;
      employerUuid: string;
      isCancelEndMembership?: boolean;
      planEndDate?: string;
      planStartDate?: string;
      status: boolean;
    },
    TContext
  >({
    mutationFn: ({
      cancellationUuid,
      employerUuid,
      isCancelEndMembership,
      planEndDate,
      planStartDate,
      status,
    }) =>
      EmployerControllerService.updateEmployerStatus({
        cancellationUuid,
        employerUuid,
        isCancelEndMembership,
        planEndDate,
        planStartDate,
        status,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.brokerUuid
 * @param data.active
 * @returns Response OK
 * @throws ApiError
 */
export const useBrokerControllerServiceUpdateBrokerStatus = <
  TData = Common.BrokerControllerServiceUpdateBrokerStatusMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        active: boolean;
        brokerUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      active: boolean;
      brokerUuid: string;
    },
    TContext
  >({
    mutationFn: ({ active, brokerUuid }) =>
      BrokerControllerService.updateBrokerStatus({
        active,
        brokerUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.agentDealUuid
 * @param data.endDate
 * @returns Response OK
 * @throws ApiError
 */
export const useAgentDealControllerServiceEndAgentDeal = <
  TData = Common.AgentDealControllerServiceEndAgentDealMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        agentDealUuid: string;
        endDate?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      agentDealUuid: string;
      endDate?: string;
    },
    TContext
  >({
    mutationFn: ({ agentDealUuid, endDate }) =>
      AgentDealControllerService.endAgentDeal({
        agentDealUuid,
        endDate,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.agentFirmUuid
 * @param data.effectiveDate
 * @param data.cancelEndDeal
 * @param data.agentDealUuids
 * @returns Response OK
 * @throws ApiError
 */
export const useAgentDealControllerServiceEndAllDealsByAgentFirm = <
  TData = Common.AgentDealControllerServiceEndAllDealsByAgentFirmMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        agentDealUuids?: string[];
        agentFirmUuid: string;
        cancelEndDeal?: boolean;
        effectiveDate: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      agentDealUuids?: string[];
      agentFirmUuid: string;
      cancelEndDeal?: boolean;
      effectiveDate: string;
    },
    TContext
  >({
    mutationFn: ({
      agentDealUuids,
      agentFirmUuid,
      cancelEndDeal,
      effectiveDate,
    }) =>
      AgentDealControllerService.endAllDealsByAgentFirm({
        agentDealUuids,
        agentFirmUuid,
        cancelEndDeal,
        effectiveDate,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestUuid
 * @param data.rejectionReason
 * @returns Response OK
 * @throws ApiError
 */
export const useSupervisingProviderRequestControllerServiceDeny = <
  TData = Common.SupervisingProviderRequestControllerServiceDenyMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        rejectionReason?: string;
        requestUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      rejectionReason?: string;
      requestUuid: string;
    },
    TContext
  >({
    mutationFn: ({ rejectionReason, requestUuid }) =>
      SupervisingProviderRequestControllerService.deny({
        rejectionReason,
        requestUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useSupervisingProviderRequestControllerServiceApprove = <
  TData =
    Common.SupervisingProviderRequestControllerServiceApproveMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestUuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestUuid }) =>
      SupervisingProviderRequestControllerService.approve({
        requestUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.coverageUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderCoverageControllerServiceRevoke = <
  TData = Common.ProviderCoverageControllerServiceRevokeMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        coverageUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      coverageUuid: string;
    },
    TContext
  >({
    mutationFn: ({ coverageUuid }) =>
      ProviderCoverageControllerService.revoke({
        coverageUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.coverageUuid
 * @param data.denialReasonCode
 * @param data.denialReasonNote
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderCoverageControllerServiceDeny1 = <
  TData = Common.ProviderCoverageControllerServiceDeny1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        coverageUuid: string;
        denialReasonCode?:
          | "OTHER"
          | "UNAVAILABLE"
          | "NOT_MY_PANEL"
          | "WRONG_DATES";
        denialReasonNote?: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      coverageUuid: string;
      denialReasonCode?:
        | "OTHER"
        | "UNAVAILABLE"
        | "NOT_MY_PANEL"
        | "WRONG_DATES";
      denialReasonNote?: string;
    },
    TContext
  >({
    mutationFn: ({ coverageUuid, denialReasonCode, denialReasonNote }) =>
      ProviderCoverageControllerService.deny1({
        coverageUuid,
        denialReasonCode,
        denialReasonNote,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.coverageUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderCoverageControllerServiceApprove1 = <
  TData = Common.ProviderCoverageControllerServiceApprove1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        coverageUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      coverageUuid: string;
    },
    TContext
  >({
    mutationFn: ({ coverageUuid }) =>
      ProviderCoverageControllerService.approve1({
        coverageUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderCoverageControllerServiceUpdateUrgentMessageAlert = <
  TData =
    Common.ProviderCoverageControllerServiceUpdateUrgentMessageAlertMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: UrgentMessageAlertDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: UrgentMessageAlertDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ProviderCoverageControllerService.updateUrgentMessageAlert({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderCoverageControllerServiceExpireEndedCoverages = <
  TData =
    Common.ProviderCoverageControllerServiceExpireEndedCoveragesMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    "mutationFn"
  >,
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      ProviderCoverageControllerService.expireEndedCoverages() as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useInventoryOrderControllerServiceUpdateInventory = <
  TData = Common.InventoryOrderControllerServiceUpdateInventoryMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: UpdateLocationInventoryRequest;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: UpdateLocationInventoryRequest;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      InventoryOrderControllerService.updateInventory({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.inventoryDetailUuids
 * @returns Response OK
 * @throws ApiError
 */
export const useInventoryOrderControllerServiceUpdateFormulary = <
  TData = Common.InventoryOrderControllerServiceUpdateFormularyMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        inventoryDetailUuids: string[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      inventoryDetailUuids: string[];
    },
    TContext
  >({
    mutationFn: ({ inventoryDetailUuids }) =>
      InventoryOrderControllerService.updateFormulary({
        inventoryDetailUuids,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.locationInventoryUuid
 * @param data.autoShip
 * @returns Response OK
 * @throws ApiError
 */
export const useInventoryOrderControllerServiceUpdateAutoShip = <
  TData = Common.InventoryOrderControllerServiceUpdateAutoShipMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        autoShip: boolean;
        locationInventoryUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      autoShip: boolean;
      locationInventoryUuid: string;
    },
    TContext
  >({
    mutationFn: ({ autoShip, locationInventoryUuid }) =>
      InventoryOrderControllerService.updateAutoShip({
        autoShip,
        locationInventoryUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useGoogleMapsControllerServiceUpdateShareLink = <
  TData = Common.GoogleMapsControllerServiceUpdateShareLinkMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: UpdateGoogleMapsShareLinkRequest;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: UpdateGoogleMapsShareLinkRequest;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ requestBody, uuid }) =>
      GoogleMapsControllerService.updateShareLink({
        requestBody,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.cartUuid
 * @param data.quantity
 * @returns Response OK
 * @throws ApiError
 */
export const useCartControllerServiceUpdateQuantity = <
  TData = Common.CartControllerServiceUpdateQuantityMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        cartUuid: string;
        quantity: number;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      cartUuid: string;
      quantity: number;
    },
    TContext
  >({
    mutationFn: ({ cartUuid, quantity }) =>
      CartControllerService.updateQuantity({
        cartUuid,
        quantity,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.status
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteControllerServiceUpdatePreEngagedStatus = <
  TData = Common.SoapNoteControllerServiceUpdatePreEngagedStatusMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
        status: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
      status: boolean;
    },
    TContext
  >({
    mutationFn: ({ patientUuid, status }) =>
      SoapNoteControllerService.updatePreEngagedStatus({
        patientUuid,
        status,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.bookMark
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteTemplateControllerServiceUpdateSoapNoteTemplateBookmark =
  <
    TData =
      Common.SoapNoteTemplateControllerServiceUpdateSoapNoteTemplateBookmarkMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          bookMark: boolean;
          uuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        bookMark: boolean;
        uuid: string;
      },
      TContext
    >({
      mutationFn: ({ bookMark, uuid }) =>
        SoapNoteTemplateControllerService.updateSoapNoteTemplateBookmark({
          bookMark,
          uuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.bookMark
 * @returns Response OK
 * @throws ApiError
 */
export const useReviewOfSystemTemplateControllerServiceUpdateRosBookmark = <
  TData =
    Common.ReviewOfSystemTemplateControllerServiceUpdateRosBookmarkMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        bookMark: boolean;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      bookMark: boolean;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ bookMark, uuid }) =>
      ReviewOfSystemTemplateControllerService.updateRosBookmark({
        bookMark,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.bookMark
 * @returns Response OK
 * @throws ApiError
 */
export const usePhysicalExamTemplateControllerServiceUpdatePhysicalExamTemplateBookmark =
  <
    TData =
      Common.PhysicalExamTemplateControllerServiceUpdatePhysicalExamTemplateBookmarkMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          bookMark: boolean;
          uuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        bookMark: boolean;
        uuid: string;
      },
      TContext
    >({
      mutationFn: ({ bookMark, uuid }) =>
        PhysicalExamTemplateControllerService.updatePhysicalExamTemplateBookmark(
          {
            bookMark,
            uuid,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.status
 * @param data.noteUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNoteControllerServiceUpdateNoteFlag = <
  TData = Common.NoteControllerServiceUpdateNoteFlagMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        noteUuid: string;
        status: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      noteUuid: string;
      status: boolean;
    },
    TContext
  >({
    mutationFn: ({ noteUuid, status }) =>
      NoteControllerService.updateNoteFlag({
        noteUuid,
        status,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.macroUuid
 * @param data.bookMark
 * @returns Response OK
 * @throws ApiError
 */
export const useMacroControllerServiceUpdateMacroBookmark = <
  TData = Common.MacroControllerServiceUpdateMacroBookmarkMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        bookMark: boolean;
        macroUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      bookMark: boolean;
      macroUuid: string;
    },
    TContext
  >({
    mutationFn: ({ bookMark, macroUuid }) =>
      MacroControllerService.updateMacroBookmark({
        bookMark,
        macroUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.labOrderUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLabOrderControllerServiceMarkAsComplete = <
  TData = Common.LabOrderControllerServiceMarkAsCompleteMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        labOrderUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      labOrderUuid: string;
    },
    TContext
  >({
    mutationFn: ({ labOrderUuid }) =>
      LabOrderControllerService.markAsComplete({
        labOrderUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.labOrderUuid
 * @param data.status
 * @returns Response OK
 * @throws ApiError
 */
export const useLabOrderControllerServiceArchiveLabOrderByUuid = <
  TData = Common.LabOrderControllerServiceArchiveLabOrderByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        labOrderUuid: string;
        status: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      labOrderUuid: string;
      status: boolean;
    },
    TContext
  >({
    mutationFn: ({ labOrderUuid, status }) =>
      LabOrderControllerService.archiveLabOrderByUuid({
        labOrderUuid,
        status,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.active
 * @returns Response OK
 * @throws ApiError
 */
export const useGlobalHolidayControllerServiceToggleGlobalHoliday = <
  TData =
    Common.GlobalHolidayControllerServiceToggleGlobalHolidayMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        active: boolean;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      active: boolean;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ active, uuid }) =>
      GlobalHolidayControllerService.toggleGlobalHoliday({
        active,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.educationalMaterialUuid
 * @param data.patientUuid
 * @param data.bookMark
 * @returns Response OK
 * @throws ApiError
 */
export const useEducationalMaterialControllerServiceUpdatePatientMaterialBookmark =
  <
    TData =
      Common.EducationalMaterialControllerServiceUpdatePatientMaterialBookmarkMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          bookMark?: boolean;
          educationalMaterialUuid: string;
          patientUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        bookMark?: boolean;
        educationalMaterialUuid: string;
        patientUuid: string;
      },
      TContext
    >({
      mutationFn: ({ bookMark, educationalMaterialUuid, patientUuid }) =>
        EducationalMaterialControllerService.updatePatientMaterialBookmark({
          bookMark,
          educationalMaterialUuid,
          patientUuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.educationalMaterialUuid
 * @param data.bookMark
 * @returns Response OK
 * @throws ApiError
 */
export const useEducationalMaterialControllerServiceUpdateBookmark = <
  TData =
    Common.EducationalMaterialControllerServiceUpdateBookmarkMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        bookMark?: boolean;
        educationalMaterialUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      bookMark?: boolean;
      educationalMaterialUuid: string;
    },
    TContext
  >({
    mutationFn: ({ bookMark, educationalMaterialUuid }) =>
      EducationalMaterialControllerService.updateBookmark({
        bookMark,
        educationalMaterialUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useDiagnosisControllerServiceResolvedDiagnosis = <
  TData = Common.DiagnosisControllerServiceResolvedDiagnosisMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      DiagnosisControllerService.resolvedDiagnosis({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.appointmentUuid
 * @param data.appointmentStartDateTime
 * @param data.statusConfigurationUuid
 * @param data.appointmentRoom
 * @param data.description
 * @returns Response OK
 * @throws ApiError
 */
export const useAppointmentControllerServiceUpdateAppointmentStatus = <
  TData =
    Common.AppointmentControllerServiceUpdateAppointmentStatusMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        appointmentRoom?:
          | "NONE"
          | "ROOM_ONE"
          | "ROOM_TWO"
          | "ROOM_THREE"
          | "ROOM_FOUR"
          | "ROOM_FIVE"
          | "ROOM_SIX"
          | "ROOM_SEVEN"
          | "ROOM_EIGHT"
          | "ROOM_NINE"
          | "ROOM_TEN";
        appointmentStartDateTime: string;
        appointmentUuid: string;
        description?: string;
        statusConfigurationUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      appointmentRoom?:
        | "NONE"
        | "ROOM_ONE"
        | "ROOM_TWO"
        | "ROOM_THREE"
        | "ROOM_FOUR"
        | "ROOM_FIVE"
        | "ROOM_SIX"
        | "ROOM_SEVEN"
        | "ROOM_EIGHT"
        | "ROOM_NINE"
        | "ROOM_TEN";
      appointmentStartDateTime: string;
      appointmentUuid: string;
      description?: string;
      statusConfigurationUuid: string;
    },
    TContext
  >({
    mutationFn: ({
      appointmentRoom,
      appointmentStartDateTime,
      appointmentUuid,
      description,
      statusConfigurationUuid,
    }) =>
      AppointmentControllerService.updateAppointmentStatus({
        appointmentRoom,
        appointmentStartDateTime,
        appointmentUuid,
        description,
        statusConfigurationUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.anotableImageTemplateUuid
 * @param data.bookMark
 * @returns Response OK
 * @throws ApiError
 */
export const useAnnotableImageTemplateControllerServiceUpdateAnnotableImageTemplateBookmark =
  <
    TData =
      Common.AnnotableImageTemplateControllerServiceUpdateAnnotableImageTemplateBookmarkMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          anotableImageTemplateUuid: string;
          bookMark: boolean;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        anotableImageTemplateUuid: string;
        bookMark: boolean;
      },
      TContext
    >({
      mutationFn: ({ anotableImageTemplateUuid, bookMark }) =>
        AnnotableImageTemplateControllerService.updateAnnotableImageTemplateBookmark(
          {
            anotableImageTemplateUuid,
            bookMark,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.questionnaireUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useQuestionnaireControllerServiceMarkAsReviewed = <
  TData = Common.QuestionnaireControllerServiceMarkAsReviewedMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        questionnaireUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      questionnaireUuid: string;
    },
    TContext
  >({
    mutationFn: ({ questionnaireUuid }) =>
      QuestionnaireControllerService.markAsReviewed({
        questionnaireUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.documentUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useDocumentControllerServiceUnshareDocumentWithPatient = <
  TData =
    Common.DocumentControllerServiceUnshareDocumentWithPatientMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        documentUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      documentUuid: string;
    },
    TContext
  >({
    mutationFn: ({ documentUuid }) =>
      DocumentControllerService.unshareDocumentWithPatient({
        documentUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.documentUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useDocumentControllerServiceShareDocumentWithPatient = <
  TData =
    Common.DocumentControllerServiceShareDocumentWithPatientMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        documentUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      documentUuid: string;
    },
    TContext
  >({
    mutationFn: ({ documentUuid }) =>
      DocumentControllerService.shareDocumentWithPatient({
        documentUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.documentUuid
 * @param data.status
 * @returns Response OK
 * @throws ApiError
 */
export const useDocumentControllerServiceUpdateReviewRequired = <
  TData = Common.DocumentControllerServiceUpdateReviewRequiredMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        documentUuid: string;
        status: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      documentUuid: string;
      status: boolean;
    },
    TContext
  >({
    mutationFn: ({ documentUuid, status }) =>
      DocumentControllerService.updateReviewRequired({
        documentUuid,
        status,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.documentUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useDocumentControllerServiceExpireDocument = <
  TData = Common.DocumentControllerServiceExpireDocumentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        documentUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      documentUuid: string;
    },
    TContext
  >({
    mutationFn: ({ documentUuid }) =>
      DocumentControllerService.expireDocument({
        documentUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.reminderUuid
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceUpdateMessageReminderDays = <
  TData =
    Common.MessageControllerServiceUpdateMessageReminderDaysMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        reminderUuid: string;
        requestBody: MessageReminderDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      reminderUuid: string;
      requestBody: MessageReminderDto;
    },
    TContext
  >({
    mutationFn: ({ reminderUuid, requestBody }) =>
      MessageControllerService.updateMessageReminderDays({
        reminderUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceUpdateMessageReminderSetting = <
  TData =
    Common.MessageControllerServiceUpdateMessageReminderSettingMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: MessageReminderDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: MessageReminderDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      MessageControllerService.updateMessageReminderSetting({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Mark thread as urgent
 * Marks a thread as urgent or removes urgent status
 * @param data The data for the request.
 * @param data.threadUuid Thread UUID
 * @param data.urgent Mark as urgent (true) or remove urgent status (false)
 * @returns Response Thread urgency updated successfully
 * @throws ApiError
 */
export const useThreadControllerServiceMarkThreadUrgent = <
  TData = Common.ThreadControllerServiceMarkThreadUrgentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        threadUuid: string;
        urgent: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      threadUuid: string;
      urgent: boolean;
    },
    TContext
  >({
    mutationFn: ({ threadUuid, urgent }) =>
      ThreadControllerService.markThreadUrgent({
        threadUuid,
        urgent,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Update thread status
 * Updates the status of a thread (e.g., OPEN, CLOSED, RESOLVED)
 * @param data The data for the request.
 * @param data.threadUuid Thread UUID
 * @param data.status New thread status
 * @returns Response Thread status updated successfully
 * @throws ApiError
 */
export const useThreadControllerServiceUpdateThreadStatus = <
  TData = Common.ThreadControllerServiceUpdateThreadStatusMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        status: "RESOLVED" | "OPEN" | "CLOSED";
        threadUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      status: "RESOLVED" | "OPEN" | "CLOSED";
      threadUuid: string;
    },
    TContext
  >({
    mutationFn: ({ status, threadUuid }) =>
      ThreadControllerService.updateThreadStatus({
        status,
        threadUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Update open thread
 * Updates the open flag of an open thread record
 * @param data The data for the request.
 * @param data.uuid Open thread UUID
 * @param data.open Open flag
 * @returns Response Open thread updated successfully
 * @throws ApiError
 */
export const useThreadControllerServiceUpdateOpenThread = <
  TData = Common.ThreadControllerServiceUpdateOpenThreadMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        open: boolean;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      open: boolean;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ open, uuid }) =>
      ThreadControllerService.updateOpenThread({
        open,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.subscriptionId
 * @returns Response OK
 * @throws ApiError
 */
export const useStripeControllerServiceCancelSubscription = <
  TData = Common.StripeControllerServiceCancelSubscriptionMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        subscriptionId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      subscriptionId: string;
    },
    TContext
  >({
    mutationFn: ({ subscriptionId }) =>
      StripeControllerService.cancelSubscription({
        subscriptionId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceDeleteScriptSurePatient = <
  TData =
    Common.ScriptSureControllerServiceDeleteScriptSurePatientMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
    },
    TContext
  >({
    mutationFn: ({ patientUuid }) =>
      ScriptSureControllerService.deleteScriptSurePatient({
        patientUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useScriptSureControllerServiceDeletePreferredPharmacy = <
  TData =
    Common.ScriptSureControllerServiceDeletePreferredPharmacyMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid: string;
    },
    TContext
  >({
    mutationFn: ({ patientUuid }) =>
      ScriptSureControllerService.deletePreferredPharmacy({
        patientUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.savedCardUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useSavedCardControllerServiceDeleteSavedCardByUuid = <
  TData = Common.SavedCardControllerServiceDeleteSavedCardByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        savedCardUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      savedCardUuid: string;
    },
    TContext
  >({
    mutationFn: ({ savedCardUuid }) =>
      SavedCardControllerService.deleteSavedCardByUuid({
        savedCardUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.savedBankAccountUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useSavedBankControllerServiceDeleteSavedBankByUuid = <
  TData = Common.SavedBankControllerServiceDeleteSavedBankByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        savedBankAccountUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      savedBankAccountUuid: string;
    },
    TContext
  >({
    mutationFn: ({ savedBankAccountUuid }) =>
      SavedBankControllerService.deleteSavedBankByUuid({
        savedBankAccountUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.salesTaxProfileUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useSalesTaxProfileControllerServiceDeleteSalesTaxProfileByUuid = <
  TData =
    Common.SalesTaxProfileControllerServiceDeleteSalesTaxProfileByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        salesTaxProfileUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      salesTaxProfileUuid: string;
    },
    TContext
  >({
    mutationFn: ({ salesTaxProfileUuid }) =>
      SalesTaxProfileControllerService.deleteSalesTaxProfileByUuid({
        salesTaxProfileUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.salesTaxJurisdictionUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useSalesTaxJurisdictionControllerServiceDeleteSalesTaxJurisdictionByUuid =
  <
    TData =
      Common.SalesTaxJurisdictionControllerServiceDeleteSalesTaxJurisdictionByUuidMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          salesTaxJurisdictionUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        salesTaxJurisdictionUuid: string;
      },
      TContext
    >({
      mutationFn: ({ salesTaxJurisdictionUuid }) =>
        SalesTaxJurisdictionControllerService.deleteSalesTaxJurisdictionByUuid({
          salesTaxJurisdictionUuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useRoleTypeManagementControllerServiceDeleteRoleType = <
  TData =
    Common.RoleTypeManagementControllerServiceDeleteRoleTypeMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      RoleTypeManagementControllerService.deleteRoleType({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useRoleTypeFeatureManagementControllerServiceDeleteRoleTypeFeature =
  <
    TData =
      Common.RoleTypeFeatureManagementControllerServiceDeleteRoleTypeFeatureMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          uuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >({
      mutationFn: ({ uuid }) =>
        RoleTypeFeatureManagementControllerService.deleteRoleTypeFeature({
          uuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.providerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderControllerServiceDeleteProviderByUuid = <
  TData = Common.ProviderControllerServiceDeleteProviderByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        providerUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      providerUuid: string;
    },
    TContext
  >({
    mutationFn: ({ providerUuid }) =>
      ProviderControllerService.deleteProviderByUuid({
        providerUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.planUuid
 * @param data.active
 * @param data.reason
 * @returns Response OK
 * @throws ApiError
 */
export const usePlanControllerServiceDeletePlanByUuid = <
  TData = Common.PlanControllerServiceDeletePlanByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        active: boolean;
        planUuid: string;
        reason: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      active: boolean;
      planUuid: string;
      reason: string;
    },
    TContext
  >({
    mutationFn: ({ active, planUuid, reason }) =>
      PlanControllerService.deletePlanByUuid({
        active,
        planUuid,
        reason,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.paymentTransactionUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePaymentTransactionControllerServiceDeletePaymentTransaction = <
  TData =
    Common.PaymentTransactionControllerServiceDeletePaymentTransactionMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        paymentTransactionUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      paymentTransactionUuid: string;
    },
    TContext
  >({
    mutationFn: ({ paymentTransactionUuid }) =>
      PaymentTransactionControllerService.deletePaymentTransaction({
        paymentTransactionUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientUuid
 * @param data.remove
 * @param data.employer
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientControllerServiceDeletePatientByUuid = <
  TData = Common.PatientControllerServiceDeletePatientByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        employer?: boolean;
        patientUuid: string;
        remove?: boolean;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      employer?: boolean;
      patientUuid: string;
      remove?: boolean;
    },
    TContext
  >({
    mutationFn: ({ employer, patientUuid, remove }) =>
      PatientControllerService.deletePatientByUuid({
        employer,
        patientUuid,
        remove,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientModuleUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientModuleControllerServiceDelete1 = <
  TData = Common.PatientModuleControllerServiceDelete1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientModuleUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientModuleUuid: string;
    },
    TContext
  >({
    mutationFn: ({ patientModuleUuid }) =>
      PatientModuleControllerService.delete1({
        patientModuleUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientModuleAccessControllerServiceDelete2 = <
  TData = Common.PatientModuleAccessControllerServiceDelete2MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: string[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: string[];
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      PatientModuleAccessControllerService.delete2({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.patientInformationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientInformationControllerServiceDelete = <
  TData = Common.PatientInformationControllerServiceDeleteMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientInformationUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientInformationUuid: string;
    },
    TContext
  >({
    mutationFn: ({ patientInformationUuid }) =>
      PatientInformationControllerService.delete({
        patientInformationUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNurseStaffProviderControllerServiceDeleteNurseStaffProvider = <
  TData =
    Common.NurseStaffProviderControllerServiceDeleteNurseStaffProviderMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      NurseStaffProviderControllerService.deleteNurseStaffProvider({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.leadUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLeadControllerServiceDeleteLeadByUuid = <
  TData = Common.LeadControllerServiceDeleteLeadByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        leadUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      leadUuid: string;
    },
    TContext
  >({
    mutationFn: ({ leadUuid }) =>
      LeadControllerService.deleteLeadByUuid({
        leadUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useInvoiceSettingControllerServiceDeleteInvoiceSettingByUuid = <
  TData =
    Common.InvoiceSettingControllerServiceDeleteInvoiceSettingByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      InvoiceSettingControllerService.deleteInvoiceSettingByUuid({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useFeatureManagementControllerServiceDeleteFeature = <
  TData = Common.FeatureManagementControllerServiceDeleteFeatureMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      FeatureManagementControllerService.deleteFeature({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.faxId
 * @param data.locationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceDeleteEfaxFax = <
  TData = Common.FaxControllerServiceDeleteEfaxFaxMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        faxId: string;
        locationUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      faxId: string;
      locationUuid: string;
    },
    TContext
  >({
    mutationFn: ({ faxId, locationUuid }) =>
      FaxControllerService.deleteEfaxFax({
        faxId,
        locationUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useFaxControllerServiceDeleteFax = <
  TData = Common.FaxControllerServiceDeleteFaxMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      FaxControllerService.deleteFax({ uuid }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useFaceSheetLayoutControllerServiceResetLayout = <
  TData = Common.FaceSheetLayoutControllerServiceResetLayoutMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    "mutationFn"
  >,
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      FaceSheetLayoutControllerService.resetLayout() as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceDeleteEmployer = <
  TData = Common.EmployerControllerServiceDeleteEmployerMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      EmployerControllerService.deleteEmployer({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerControllerServiceArchiveEmployerPlan = <
  TData = Common.EmployerControllerServiceArchiveEmployerPlanMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: EmployerPlanChangeDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: EmployerPlanChangeDto;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      EmployerControllerService.archiveEmployerPlan({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerPageUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerPageControllerServiceDeleteEmployerPageByUuid = <
  TData =
    Common.EmployerPageControllerServiceDeleteEmployerPageByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        employerPageUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      employerPageUuid: string;
    },
    TContext
  >({
    mutationFn: ({ employerPageUuid }) =>
      EmployerPageControllerService.deleteEmployerPageByUuid({
        employerPageUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.employerDivisionUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerDivisionControllerServiceDeleteEmployerDivisionByUuid =
  <
    TData =
      Common.EmployerDivisionControllerServiceDeleteEmployerDivisionByUuidMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          employerDivisionUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        employerDivisionUuid: string;
      },
      TContext
    >({
      mutationFn: ({ employerDivisionUuid }) =>
        EmployerDivisionControllerService.deleteEmployerDivisionByUuid({
          employerDivisionUuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.employerAdministratorUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEmployerAdministratorControllerServiceDeleteEmployerAdministratorByUuid =
  <
    TData =
      Common.EmployerAdministratorControllerServiceDeleteEmployerAdministratorByUuidMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          employerAdministratorUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        employerAdministratorUuid: string;
      },
      TContext
    >({
      mutationFn: ({ employerAdministratorUuid }) =>
        EmployerAdministratorControllerService.deleteEmployerAdministratorByUuid(
          {
            employerAdministratorUuid,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCreditControllerServiceDeleteCredit = <
  TData = Common.CreditControllerServiceDeleteCreditMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      CreditControllerService.deleteCredit({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.coverageRuleUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCoverageRuleControllerServiceDeleteCoverageRuleByUuid = <
  TData =
    Common.CoverageRuleControllerServiceDeleteCoverageRuleByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        coverageRuleUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      coverageRuleUuid: string;
    },
    TContext
  >({
    mutationFn: ({ coverageRuleUuid }) =>
      CoverageRuleControllerService.deleteCoverageRuleByUuid({
        coverageRuleUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.coveragePlanUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCoveragePlanControllerServiceDeleteCoveragePlanByUuid = <
  TData =
    Common.CoveragePlanControllerServiceDeleteCoveragePlanByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        coveragePlanUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      coveragePlanUuid: string;
    },
    TContext
  >({
    mutationFn: ({ coveragePlanUuid }) =>
      CoveragePlanControllerService.deleteCoveragePlanByUuid({
        coveragePlanUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.coveragePlanEmployerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCoveragePlanControllerServiceDeleteCoveragePlanEmployerByUuid =
  <
    TData =
      Common.CoveragePlanControllerServiceDeleteCoveragePlanEmployerByUuidMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          coveragePlanEmployerUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        coveragePlanEmployerUuid: string;
      },
      TContext
    >({
      mutationFn: ({ coveragePlanEmployerUuid }) =>
        CoveragePlanControllerService.deleteCoveragePlanEmployerByUuid({
          coveragePlanEmployerUuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.couponUuid
 * @param data.archive
 * @returns Response OK
 * @throws ApiError
 */
export const useCouponControllerServiceDeleteCouponByUuid = <
  TData = Common.CouponControllerServiceDeleteCouponByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        archive: boolean;
        couponUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      archive: boolean;
      couponUuid: string;
    },
    TContext
  >({
    mutationFn: ({ archive, couponUuid }) =>
      CouponControllerService.deleteCouponByUuid({
        archive,
        couponUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.chargeItemUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useChargeItemControllerServiceDeleteChargeItemByUuid = <
  TData =
    Common.ChargeItemControllerServiceDeleteChargeItemByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        chargeItemUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      chargeItemUuid: string;
    },
    TContext
  >({
    mutationFn: ({ chargeItemUuid }) =>
      ChargeItemControllerService.deleteChargeItemByUuid({
        chargeItemUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useChargeItemControllerServiceDeleteChargeItemsByUuids = <
  TData =
    Common.ChargeItemControllerServiceDeleteChargeItemsByUuidsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: string[];
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: string[];
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ChargeItemControllerService.deleteChargeItemsByUuids({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.chargeCategoryUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useChargeCategoryControllerServiceDeleteChargeCategoryByUuid = <
  TData =
    Common.ChargeCategoryControllerServiceDeleteChargeCategoryByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        chargeCategoryUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      chargeCategoryUuid: string;
    },
    TContext
  >({
    mutationFn: ({ chargeCategoryUuid }) =>
      ChargeCategoryControllerService.deleteChargeCategoryByUuid({
        chargeCategoryUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.cancellationsUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCancellationControllerServiceDeleteCancellationByUuid = <
  TData =
    Common.CancellationControllerServiceDeleteCancellationByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        cancellationsUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      cancellationsUuid: string;
    },
    TContext
  >({
    mutationFn: ({ cancellationsUuid }) =>
      CancellationControllerService.deleteCancellationByUuid({
        cancellationsUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.brokerUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useBrokerControllerServiceDeleteBrokerByUuid = <
  TData = Common.BrokerControllerServiceDeleteBrokerByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        brokerUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      brokerUuid: string;
    },
    TContext
  >({
    mutationFn: ({ brokerUuid }) =>
      BrokerControllerService.deleteBrokerByUuid({
        brokerUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.breakGlassUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useBreakGlassControllerServiceDelete3 = <
  TData = Common.BreakGlassControllerServiceDelete3MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        breakGlassUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      breakGlassUuid: string;
    },
    TContext
  >({
    mutationFn: ({ breakGlassUuid }) =>
      BreakGlassControllerService.delete3({
        breakGlassUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.miscellaneousServiceChargeUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceDeleteMiscellaneousServiceChargeByUuid =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceDeleteMiscellaneousServiceChargeByUuidMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          miscellaneousServiceChargeUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        miscellaneousServiceChargeUuid: string;
      },
      TContext
    >({
      mutationFn: ({ miscellaneousServiceChargeUuid }) =>
        AncillaryServiceChargesControllerService.deleteMiscellaneousServiceChargeByUuid(
          {
            miscellaneousServiceChargeUuid,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.ancillaryServiceChargesByUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAncillaryServiceChargesControllerServiceDeleteAncillaryServiceChargesByUuid =
  <
    TData =
      Common.AncillaryServiceChargesControllerServiceDeleteAncillaryServiceChargesByUuidMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          ancillaryServiceChargesByUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        ancillaryServiceChargesByUuid: string;
      },
      TContext
    >({
      mutationFn: ({ ancillaryServiceChargesByUuid }) =>
        AncillaryServiceChargesControllerService.deleteAncillaryServiceChargesByUuid(
          {
            ancillaryServiceChargesByUuid,
          },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.agentFirmUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAgentFirmControllerServiceDeleteAgentFirmByUuid = <
  TData = Common.AgentFirmControllerServiceDeleteAgentFirmByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        agentFirmUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      agentFirmUuid: string;
    },
    TContext
  >({
    mutationFn: ({ agentFirmUuid }) =>
      AgentFirmControllerService.deleteAgentFirmByUuid({
        agentFirmUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.agentDealUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAgentDealControllerServiceDeleteAgentDealByUuid = <
  TData = Common.AgentDealControllerServiceDeleteAgentDealByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        agentDealUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      agentDealUuid: string;
    },
    TContext
  >({
    mutationFn: ({ agentDealUuid }) =>
      AgentDealControllerService.deleteAgentDealByUuid({
        agentDealUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.affiliateGroupUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAffiliateGroupControllerServiceDeleteAffiliate = <
  TData = Common.AffiliateGroupControllerServiceDeleteAffiliateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        affiliateGroupUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      affiliateGroupUuid: string;
    },
    TContext
  >({
    mutationFn: ({ affiliateGroupUuid }) =>
      AffiliateGroupControllerService.deleteAffiliate({
        affiliateGroupUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.adminUserUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAdminUserControllerServiceDeleteAdminUserByUuid = <
  TData = Common.AdminUserControllerServiceDeleteAdminUserByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        adminUserUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      adminUserUuid: string;
    },
    TContext
  >({
    mutationFn: ({ adminUserUuid }) =>
      AdminUserControllerService.deleteAdminUserByUuid({
        adminUserUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.sharedCardUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useShareCardControllerServiceDeleteShareCard = <
  TData = Common.ShareCardControllerServiceDeleteShareCardMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        sharedCardUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      sharedCardUuid: string;
    },
    TContext
  >({
    mutationFn: ({ sharedCardUuid }) =>
      ShareCardControllerService.deleteShareCard({
        sharedCardUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.sharedBankAccountUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useShareBankControllerServiceDeleteSharedBankAccount = <
  TData =
    Common.ShareBankControllerServiceDeleteSharedBankAccountMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        sharedBankAccountUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      sharedBankAccountUuid: string;
    },
    TContext
  >({
    mutationFn: ({ sharedBankAccountUuid }) =>
      ShareBankControllerService.deleteSharedBankAccount({
        sharedBankAccountUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useGoogleMapsControllerServiceDeleteShareLink = <
  TData = Common.GoogleMapsControllerServiceDeleteShareLinkMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      GoogleMapsControllerService.deleteShareLink({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCartControllerServiceDeleteCartByUuid = <
  TData = Common.CartControllerServiceDeleteCartByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      CartControllerService.deleteCartByUuid({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useWorkNoteControllerServiceDeleteWorkNoteByUuid = <
  TData = Common.WorkNoteControllerServiceDeleteWorkNoteByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      WorkNoteControllerService.deleteWorkNoteByUuid({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useVitalControllerServiceDeleteVital = <
  TData = Common.VitalControllerServiceDeleteVitalMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      VitalControllerService.deleteVital({ uuid }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useVaccineControllerServiceDeleteVaccineByUuid = <
  TData = Common.VaccineControllerServiceDeleteVaccineByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      VaccineControllerService.deleteVaccineByUuid({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTaskControllerServiceDeleteTask = <
  TData = Common.TaskControllerServiceDeleteTaskMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      TaskControllerService.deleteTask({ uuid }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.statusConfigurationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useStatusConfigurationControllerServiceDeleteStatusConfigurationByUuid =
  <
    TData =
      Common.StatusConfigurationControllerServiceDeleteStatusConfigurationByUuidMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          statusConfigurationUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        statusConfigurationUuid: string;
      },
      TContext
    >({
      mutationFn: ({ statusConfigurationUuid }) =>
        StatusConfigurationControllerService.deleteStatusConfigurationByUuid({
          statusConfigurationUuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useSocialHistoryControllerServiceDeleteSocialHistoryByUuid = <
  TData =
    Common.SocialHistoryControllerServiceDeleteSocialHistoryByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      SocialHistoryControllerService.deleteSocialHistoryByUuid({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.soapNoteUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteControllerServiceDeleteSoapNote = <
  TData = Common.SoapNoteControllerServiceDeleteSoapNoteMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        soapNoteUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      soapNoteUuid: string;
    },
    TContext
  >({
    mutationFn: ({ soapNoteUuid }) =>
      SoapNoteControllerService.deleteSoapNote({
        soapNoteUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.isAdmin
 * @returns Response OK
 * @throws ApiError
 */
export const useSoapNoteTemplateControllerServiceDeleteSoapNoteTemplateByUuid =
  <
    TData =
      Common.SoapNoteTemplateControllerServiceDeleteSoapNoteTemplateByUuidMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          isAdmin?: boolean;
          uuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        isAdmin?: boolean;
        uuid: string;
      },
      TContext
    >({
      mutationFn: ({ isAdmin, uuid }) =>
        SoapNoteTemplateControllerService.deleteSoapNoteTemplateByUuid({
          isAdmin,
          uuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useScreenHistoryControllerServiceDeleteScreenHistoryByUuid = <
  TData =
    Common.ScreenHistoryControllerServiceDeleteScreenHistoryByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      ScreenHistoryControllerService.deleteScreenHistoryByUuid({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.isAdmin
 * @returns Response OK
 * @throws ApiError
 */
export const useReviewOfSystemTemplateControllerServiceDeleteReviewOfSystemTemplate =
  <
    TData =
      Common.ReviewOfSystemTemplateControllerServiceDeleteReviewOfSystemTemplateMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          isAdmin?: boolean;
          uuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        isAdmin?: boolean;
        uuid: string;
      },
      TContext
    >({
      mutationFn: ({ isAdmin, uuid }) =>
        ReviewOfSystemTemplateControllerService.deleteReviewOfSystemTemplate({
          isAdmin,
          uuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useReviewOfSystemControllerServiceDeleteReviewOfSystem = <
  TData =
    Common.ReviewOfSystemControllerServiceDeleteReviewOfSystemMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      ReviewOfSystemControllerService.deleteReviewOfSystem({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.referralByUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useReferralControllerServiceDeleteReferralByUuid = <
  TData = Common.ReferralControllerServiceDeleteReferralByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        referralByUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      referralByUuid: string;
    },
    TContext
  >({
    mutationFn: ({ referralByUuid }) =>
      ReferralControllerService.deleteReferralByUuid({
        referralByUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.providerDirectoryUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useProviderDirectoryControllerServiceDeleteProviderDirectoryByUuid =
  <
    TData =
      Common.ProviderDirectoryControllerServiceDeleteProviderDirectoryByUuidMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          providerDirectoryUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        providerDirectoryUuid: string;
      },
      TContext
    >({
      mutationFn: ({ providerDirectoryUuid }) =>
        ProviderDirectoryControllerService.deleteProviderDirectoryByUuid({
          providerDirectoryUuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.pointOfCareUuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePointsOfCareLabControllerServiceDeletePointOfCareLabByUuid = <
  TData =
    Common.PointsOfCareLabControllerServiceDeletePointOfCareLabByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        pointOfCareUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      pointOfCareUuid: string;
    },
    TContext
  >({
    mutationFn: ({ pointOfCareUuid }) =>
      PointsOfCareLabControllerService.deletePointOfCareLabByUuid({
        pointOfCareUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePocLabTestControllerServiceDeletePocLabTest = <
  TData = Common.PocLabTestControllerServiceDeletePocLabTestMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      PocLabTestControllerService.deletePocLabTest({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePocLabTestControllerServiceDeletePocTestFields = <
  TData = Common.PocLabTestControllerServiceDeletePocTestFieldsMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      PocLabTestControllerService.deletePocTestFields({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePocLabResultControllerServiceDeletePocLabResult = <
  TData = Common.PocLabResultControllerServiceDeletePocLabResultMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      PocLabResultControllerService.deletePocLabResult({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.isAdmin
 * @returns Response OK
 * @throws ApiError
 */
export const usePhysicalExamTemplateControllerServiceDeletePhysicalExamTemplateByUuid =
  <
    TData =
      Common.PhysicalExamTemplateControllerServiceDeletePhysicalExamTemplateByUuidMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          isAdmin?: boolean;
          uuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        isAdmin?: boolean;
        uuid: string;
      },
      TContext
    >({
      mutationFn: ({ isAdmin, uuid }) =>
        PhysicalExamTemplateControllerService.deletePhysicalExamTemplateByUuid({
          isAdmin,
          uuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePhysicalExamControllerServiceDeletePhysicalExamByUuid = <
  TData =
    Common.PhysicalExamControllerServiceDeletePhysicalExamByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      PhysicalExamControllerService.deletePhysicalExamByUuid({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePharmacyControllerServiceDeletePharmacy = <
  TData = Common.PharmacyControllerServiceDeletePharmacyMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      PharmacyControllerService.deletePharmacy({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientVaccinationControllerServiceDeletePatientVaccination = <
  TData =
    Common.PatientVaccinationControllerServiceDeletePatientVaccinationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      PatientVaccinationControllerService.deletePatientVaccination({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientFlagControllerServiceDeletePatientFlag = <
  TData = Common.PatientFlagControllerServiceDeletePatientFlagMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      PatientFlagControllerService.deletePatientFlag({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePastSurgicalHistoryControllerServiceDeletePastSurgicalHistoryByUuid =
  <
    TData =
      Common.PastSurgicalHistoryControllerServiceDeletePastSurgicalHistoryByUuidMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          uuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >({
      mutationFn: ({ uuid }) =>
        PastSurgicalHistoryControllerService.deletePastSurgicalHistoryByUuid({
          uuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePastMedicalHistoryControllerServiceDeletePastMedicalHistoryByUuid =
  <
    TData =
      Common.PastMedicalHistoryControllerServiceDeletePastMedicalHistoryByUuidMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          uuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >({
      mutationFn: ({ uuid }) =>
        PastMedicalHistoryControllerService.deletePastMedicalHistoryByUuid({
          uuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.noteByUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNoteControllerServiceDeleteNoteByUuid = <
  TData = Common.NoteControllerServiceDeleteNoteByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        noteByUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      noteByUuid: string;
    },
    TContext
  >({
    mutationFn: ({ noteByUuid }) =>
      NoteControllerService.deleteNoteByUuid({
        noteByUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.medicationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useMedicationControllerServiceDeleteMedicationByUuid = <
  TData =
    Common.MedicationControllerServiceDeleteMedicationByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        medicationUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      medicationUuid: string;
    },
    TContext
  >({
    mutationFn: ({ medicationUuid }) =>
      MedicationControllerService.deleteMedicationByUuid({
        medicationUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.macroUuid
 * @param data.isAdmin
 * @returns Response OK
 * @throws ApiError
 */
export const useMacroControllerServiceDeleteMacro = <
  TData = Common.MacroControllerServiceDeleteMacroMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        isAdmin?: boolean;
        macroUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      isAdmin?: boolean;
      macroUuid: string;
    },
    TContext
  >({
    mutationFn: ({ isAdmin, macroUuid }) =>
      MacroControllerService.deleteMacro({
        isAdmin,
        macroUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.locationUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLocationControllerServiceDeleteLocationByUuid = <
  TData = Common.LocationControllerServiceDeleteLocationByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        locationUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      locationUuid: string;
    },
    TContext
  >({
    mutationFn: ({ locationUuid }) =>
      LocationControllerService.deleteLocationByUuid({
        locationUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.locationGroupUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLocationGroupControllerServiceDeleteLocationGroupByUuid = <
  TData =
    Common.LocationGroupControllerServiceDeleteLocationGroupByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        locationGroupUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      locationGroupUuid: string;
    },
    TContext
  >({
    mutationFn: ({ locationGroupUuid }) =>
      LocationGroupControllerService.deleteLocationGroupByUuid({
        locationGroupUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLocationAvailabilityControllerServiceDeleteLocationAvailabilityByUuid =
  <
    TData =
      Common.LocationAvailabilityControllerServiceDeleteLocationAvailabilityByUuidMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          uuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >({
      mutationFn: ({ uuid }) =>
        LocationAvailabilityControllerService.deleteLocationAvailabilityByUuid({
          uuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const usePatientLinkPharmacyControllerServiceDeletePharmacyForPatientByUuid =
  <
    TData =
      Common.PatientLinkPharmacyControllerServiceDeletePharmacyForPatientByUuidMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          uuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >({
      mutationFn: ({ uuid }) =>
        PatientLinkPharmacyControllerService.deletePharmacyForPatientByUuid({
          uuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.labTestUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLabTestControllerServiceDeleteLabTestByUuid = <
  TData = Common.LabTestControllerServiceDeleteLabTestByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        labTestUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      labTestUuid: string;
    },
    TContext
  >({
    mutationFn: ({ labTestUuid }) =>
      LabTestControllerService.deleteLabTestByUuid({
        labTestUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.labResultUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLabResultControllerServiceArchiveLabResult = <
  TData = Common.LabResultControllerServiceArchiveLabResultMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        labResultUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      labResultUuid: string;
    },
    TContext
  >({
    mutationFn: ({ labResultUuid }) =>
      LabResultControllerService.archiveLabResult({
        labResultUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.labOrderUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLabOrderControllerServiceDeleteLabOrderByUuid = <
  TData = Common.LabOrderControllerServiceDeleteLabOrderByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        labOrderUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      labOrderUuid: string;
    },
    TContext
  >({
    mutationFn: ({ labOrderUuid }) =>
      LabOrderControllerService.deleteLabOrderByUuid({
        labOrderUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.labOrderSetUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useLabOrderSetControllerServiceDeleteLabOrderSetByUuid = <
  TData =
    Common.LabOrderSetControllerServiceDeleteLabOrderSetByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        labOrderSetUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      labOrderSetUuid: string;
    },
    TContext
  >({
    mutationFn: ({ labOrderSetUuid }) =>
      LabOrderSetControllerService.deleteLabOrderSetByUuid({
        labOrderSetUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.invoiceUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useInvoiceControllerServiceDeleteInvoiceByUuid = <
  TData = Common.InvoiceControllerServiceDeleteInvoiceByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        invoiceUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      invoiceUuid: string;
    },
    TContext
  >({
    mutationFn: ({ invoiceUuid }) =>
      InvoiceControllerService.deleteInvoiceByUuid({
        invoiceUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.insuranceUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useInsuranceControllerServiceDeleteInsuranceByUuid = <
  TData = Common.InsuranceControllerServiceDeleteInsuranceByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        insuranceUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      insuranceUuid: string;
    },
    TContext
  >({
    mutationFn: ({ insuranceUuid }) =>
      InsuranceControllerService.deleteInsuranceByUuid({
        insuranceUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.imagingResultByUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useImagingResultControllerServiceDeleteImagingResultByUuid = <
  TData =
    Common.ImagingResultControllerServiceDeleteImagingResultByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        imagingResultByUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      imagingResultByUuid: string;
    },
    TContext
  >({
    mutationFn: ({ imagingResultByUuid }) =>
      ImagingResultControllerService.deleteImagingResultByUuid({
        imagingResultByUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.imagingOrderByUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useImagingOrderControllerServiceDeleteImagingOrderByUuid = <
  TData =
    Common.ImagingOrderControllerServiceDeleteImagingOrderByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        imagingOrderByUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      imagingOrderByUuid: string;
    },
    TContext
  >({
    mutationFn: ({ imagingOrderByUuid }) =>
      ImagingOrderControllerService.deleteImagingOrderByUuid({
        imagingOrderByUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useIcdCodeControllerServiceDeleteIcdCodeByUuid = <
  TData = Common.IcdCodeControllerServiceDeleteIcdCodeByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      IcdCodeControllerService.deleteIcdCodeByUuid({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useHAndPNoteControllerServiceDeleteHandPnote = <
  TData = Common.HAndPNoteControllerServiceDeleteHandPnoteMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      HAndPNoteControllerService.deleteHandPnote({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useHabitsControllerServiceDeleteHabitsByUuid = <
  TData = Common.HabitsControllerServiceDeleteHabitsByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      HabitsControllerService.deleteHabitsByUuid({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useGlobalHolidayControllerServiceDeleteGlobalHolidayByUuid = <
  TData =
    Common.GlobalHolidayControllerServiceDeleteGlobalHolidayByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      GlobalHolidayControllerService.deleteGlobalHolidayByUuid({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.formTemplateUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useFormTemplateControllerServiceDeleteFormTemplate = <
  TData = Common.FormTemplateControllerServiceDeleteFormTemplateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        formTemplateUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      formTemplateUuid: string;
    },
    TContext
  >({
    mutationFn: ({ formTemplateUuid }) =>
      FormTemplateControllerService.deleteFormTemplate({
        formTemplateUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useFdbMedicationsControllerServiceDeleteFdbMedicationByUuid = <
  TData =
    Common.FdbMedicationsControllerServiceDeleteFdbMedicationByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      FdbMedicationsControllerService.deleteFdbMedicationByUuid({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useFamilyHistoryControllerServiceDeleteFamilyHistoryByUuid = <
  TData =
    Common.FamilyHistoryControllerServiceDeleteFamilyHistoryByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      FamilyHistoryControllerService.deleteFamilyHistoryByUuid({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.educationalMaterialUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useEducationalMaterialControllerServiceDeleteEducationalMaterial =
  <
    TData =
      Common.EducationalMaterialControllerServiceDeleteEducationalMaterialMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          educationalMaterialUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        educationalMaterialUuid: string;
      },
      TContext
    >({
      mutationFn: ({ educationalMaterialUuid }) =>
        EducationalMaterialControllerService.deleteEducationalMaterial({
          educationalMaterialUuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.drugIntoleranceUuid
 * @param data.archive
 * @returns Response OK
 * @throws ApiError
 */
export const useDrugIntoleranceControllerServiceDeleteDrugIntoleranceByUuid = <
  TData =
    Common.DrugIntoleranceControllerServiceDeleteDrugIntoleranceByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        archive?: boolean;
        drugIntoleranceUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      archive?: boolean;
      drugIntoleranceUuid: string;
    },
    TContext
  >({
    mutationFn: ({ archive, drugIntoleranceUuid }) =>
      DrugIntoleranceControllerService.deleteDrugIntoleranceByUuid({
        archive,
        drugIntoleranceUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.documentTypeUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useDocumentTypeControllerServiceDeleteDocumentTypeByUuid = <
  TData =
    Common.DocumentTypeControllerServiceDeleteDocumentTypeByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        documentTypeUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      documentTypeUuid: string;
    },
    TContext
  >({
    mutationFn: ({ documentTypeUuid }) =>
      DocumentTypeControllerService.deleteDocumentTypeByUuid({
        documentTypeUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useDiagnosisControllerServiceDeleteDiagnosis = <
  TData = Common.DiagnosisControllerServiceDeleteDiagnosisMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      DiagnosisControllerService.deleteDiagnosis({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.cptCodeUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCptCodeControllerServiceDeleteIcdCodeByUuid1 = <
  TData = Common.CptCodeControllerServiceDeleteIcdCodeByUuid1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        cptCodeUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      cptCodeUuid: string;
    },
    TContext
  >({
    mutationFn: ({ cptCodeUuid }) =>
      CptCodeControllerService.deleteIcdCodeByUuid1({
        cptCodeUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCommentControllerServiceDeleteMessage = <
  TData = Common.CommentControllerServiceDeleteMessageMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      CommentControllerService.deleteMessage({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.carePlanUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCarePlanControllerServiceDeleteCarePlan = <
  TData = Common.CarePlanControllerServiceDeleteCarePlanMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        carePlanUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      carePlanUuid: string;
    },
    TContext
  >({
    mutationFn: ({ carePlanUuid }) =>
      CarePlanControllerService.deleteCarePlan({
        carePlanUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.availabilityUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAvailabilityControllerServiceDeleteAvailabilityByUuid = <
  TData =
    Common.AvailabilityControllerServiceDeleteAvailabilityByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        availabilityUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      availabilityUuid: string;
    },
    TContext
  >({
    mutationFn: ({ availabilityUuid }) =>
      AvailabilityControllerService.deleteAvailabilityByUuid({
        availabilityUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.masterAppointmentUuid
 * @param data.cancellation
 * @param data.requestBody
 * @returns Response OK
 * @throws ApiError
 */
export const useAppointmentControllerServiceDeleteAppointmentByUuid = <
  TData =
    Common.AppointmentControllerServiceDeleteAppointmentByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        cancellation?: boolean;
        masterAppointmentUuid: string;
        requestBody?: DeleteAppointmentRequestDto;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      cancellation?: boolean;
      masterAppointmentUuid: string;
      requestBody?: DeleteAppointmentRequestDto;
    },
    TContext
  >({
    mutationFn: ({ cancellation, masterAppointmentUuid, requestBody }) =>
      AppointmentControllerService.deleteAppointmentByUuid({
        cancellation,
        masterAppointmentUuid,
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.appointmentTypeUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAppointmentTypeControllerServiceDeleteAppointmentTypeByUuid = <
  TData =
    Common.AppointmentTypeControllerServiceDeleteAppointmentTypeByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        appointmentTypeUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      appointmentTypeUuid: string;
    },
    TContext
  >({
    mutationFn: ({ appointmentTypeUuid }) =>
      AppointmentTypeControllerService.deleteAppointmentTypeByUuid({
        appointmentTypeUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAnnotableImageControllerServiceDeleteAnnotableImage = <
  TData =
    Common.AnnotableImageControllerServiceDeleteAnnotableImageMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      AnnotableImageControllerService.deleteAnnotableImage({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.anotableImageTemplateUuid
 * @param data.isAdmin
 * @returns Response OK
 * @throws ApiError
 */
export const useAnnotableImageTemplateControllerServiceDeleteAnnotableImageTemplate =
  <
    TData =
      Common.AnnotableImageTemplateControllerServiceDeleteAnnotableImageTemplateMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          anotableImageTemplateUuid: string;
          isAdmin?: boolean;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        anotableImageTemplateUuid: string;
        isAdmin?: boolean;
      },
      TContext
    >({
      mutationFn: ({ anotableImageTemplateUuid, isAdmin }) =>
        AnnotableImageTemplateControllerService.deleteAnnotableImageTemplate({
          anotableImageTemplateUuid,
          isAdmin,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAnnotableImagePinControllerServiceDeleteAnnotableImagePin = <
  TData =
    Common.AnnotableImagePinControllerServiceDeleteAnnotableImagePinMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      AnnotableImagePinControllerService.deleteAnnotableImagePin({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @param data.archive
 * @returns Response OK
 * @throws ApiError
 */
export const useAllergyControllerServiceDeleteAllergyByUuId = <
  TData = Common.AllergyControllerServiceDeleteAllergyByUuIdMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        archive?: boolean;
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      archive?: boolean;
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ archive, uuid }) =>
      AllergyControllerService.deleteAllergyByUuId({
        archive,
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.questionnaireUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useQuestionnaireControllerServiceDeleteQuestionnaire = <
  TData =
    Common.QuestionnaireControllerServiceDeleteQuestionnaireMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        questionnaireUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      questionnaireUuid: string;
    },
    TContext
  >({
    mutationFn: ({ questionnaireUuid }) =>
      QuestionnaireControllerService.deleteQuestionnaire({
        questionnaireUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.documentUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useDocumentControllerServiceDeleteDocumentByUuid = <
  TData = Common.DocumentControllerServiceDeleteDocumentByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        documentUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      documentUuid: string;
    },
    TContext
  >({
    mutationFn: ({ documentUuid }) =>
      DocumentControllerService.deleteDocumentByUuid({
        documentUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.contactDirectoryUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useContactDirectoryControllerServiceDeleteContactDirectoryByUuid =
  <
    TData =
      Common.ContactDirectoryControllerServiceDeleteContactDirectoryByUuidMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          contactDirectoryUuid: string;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        contactDirectoryUuid: string;
      },
      TContext
    >({
      mutationFn: ({ contactDirectoryUuid }) =>
        ContactDirectoryControllerService.deleteContactDirectoryByUuid({
          contactDirectoryUuid,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.agreementUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useAgreementControllerServiceDeleteAgreement = <
  TData = Common.AgreementControllerServiceDeleteAgreementMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        agreementUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      agreementUuid: string;
    },
    TContext
  >({
    mutationFn: ({ agreementUuid }) =>
      AgreementControllerService.deleteAgreement({
        agreementUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useNotificationControllerServiceDeleteNotification = <
  TData = Common.NotificationControllerServiceDeleteNotificationMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      NotificationControllerService.deleteNotification({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.subscriptionId
 * @returns Response1 OK
 * @throws ApiError
 */
export const useStripControllerServiceCancelSubscription1 = <
  TData = Common.StripControllerServiceCancelSubscription1MutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        subscriptionId: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      subscriptionId: string;
    },
    TContext
  >({
    mutationFn: ({ subscriptionId }) =>
      StripControllerService.cancelSubscription1({
        subscriptionId,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.ticketUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketControllerServiceDeleteTicket = <
  TData = Common.TicketControllerServiceDeleteTicketMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        ticketUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      ticketUuid: string;
    },
    TContext
  >({
    mutationFn: ({ ticketUuid }) =>
      TicketControllerService.deleteTicket({
        ticketUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.taskUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketTaskControllerServiceDeleteTicketTask = <
  TData = Common.TicketTaskControllerServiceDeleteTicketTaskMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        taskUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      taskUuid: string;
    },
    TContext
  >({
    mutationFn: ({ taskUuid }) =>
      TicketTaskControllerService.deleteTicketTask({
        taskUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.notesUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketNotesControllerServiceDeleteTicketNotes = <
  TData = Common.TicketNotesControllerServiceDeleteTicketNotesMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        notesUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      notesUuid: string;
    },
    TContext
  >({
    mutationFn: ({ notesUuid }) =>
      TicketNotesControllerService.deleteTicketNotes({
        notesUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.attachmentUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketAttachmentControllerServiceDeleteAttachment = <
  TData =
    Common.TicketAttachmentControllerServiceDeleteAttachmentMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        attachmentUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      attachmentUuid: string;
    },
    TContext
  >({
    mutationFn: ({ attachmentUuid }) =>
      TicketAttachmentControllerService.deleteAttachment({
        attachmentUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.templateUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmTemplateControllerServiceDeleteTemplate = <
  TData = Common.CrmTemplateControllerServiceDeleteTemplateMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        templateUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      templateUuid: string;
    },
    TContext
  >({
    mutationFn: ({ templateUuid }) =>
      CrmTemplateControllerService.deleteTemplate({
        templateUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.taskUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmTaskControllerServiceDeleteCrmTask = <
  TData = Common.CrmTaskControllerServiceDeleteCrmTaskMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        taskUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      taskUuid: string;
    },
    TContext
  >({
    mutationFn: ({ taskUuid }) =>
      CrmTaskControllerService.deleteCrmTask({
        taskUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.taskLogUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTaskLogControllerServiceDeleteTaskLog = <
  TData = Common.TaskLogControllerServiceDeleteTaskLogMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        taskLogUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      taskLogUuid: string;
    },
    TContext
  >({
    mutationFn: ({ taskLogUuid }) =>
      TaskLogControllerService.deleteTaskLog({
        taskLogUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.newsletterUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmNewsletterControllerServiceDeleteNewsletter = <
  TData = Common.CrmNewsletterControllerServiceDeleteNewsletterMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        newsletterUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      newsletterUuid: string;
    },
    TContext
  >({
    mutationFn: ({ newsletterUuid }) =>
      CrmNewsletterControllerService.deleteNewsletter({
        newsletterUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useCrmCampaignControllerServiceDeleteCampaign = <
  TData = Common.CrmCampaignControllerServiceDeleteCampaignMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    "mutationFn"
  >,
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      CrmCampaignControllerService.deleteCampaign() as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.callLogUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useCallLogsControllerServiceDeleteCallLog = <
  TData = Common.CallLogsControllerServiceDeleteCallLogMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        callLogUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      callLogUuid: string;
    },
    TContext
  >({
    mutationFn: ({ callLogUuid }) =>
      CallLogsControllerService.deleteCallLog({
        callLogUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.mainTicketUuid
 * @param data.linkedTicketUuid
 * @returns Response OK
 * @throws ApiError
 */
export const useTicketLinkedControllerServiceUnlinkTicket = <
  TData = Common.TicketLinkedControllerServiceUnlinkTicketMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        linkedTicketUuid: string;
        mainTicketUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      linkedTicketUuid: string;
      mainTicketUuid: string;
    },
    TContext
  >({
    mutationFn: ({ linkedTicketUuid, mainTicketUuid }) =>
      TicketLinkedControllerService.unlinkTicket({
        linkedTicketUuid,
        mainTicketUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceDeleteMessageByUuid = <
  TData = Common.MessageControllerServiceDeleteMessageByUuidMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      MessageControllerService.deleteMessageByUuid({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @param data The data for the request.
 * @param data.uuid
 * @returns Response OK
 * @throws ApiError
 */
export const useMessageControllerServiceDeleteScheduledMessage = <
  TData = Common.MessageControllerServiceDeleteScheduledMessageMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        uuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      uuid: string;
    },
    TContext
  >({
    mutationFn: ({ uuid }) =>
      MessageControllerService.deleteScheduledMessage({
        uuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * @returns Response OK
 * @throws ApiError
 */
export const useTwilioVoiceControllerServiceUnregister = <
  TData = Common.TwilioVoiceControllerServiceUnregisterMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    "mutationFn"
  >,
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      TwilioVoiceControllerService.unregister() as unknown as Promise<TData>,
    ...options,
  });
/**
 * Unbookmark a thread
 * Removes a thread from user's bookmarks
 * @param data The data for the request.
 * @param data.threadUuid Thread UUID
 * @returns Response Thread unbookmarked successfully
 * @throws ApiError
 */
export const useBookmarkControllerServiceUnbookmarkThread = <
  TData = Common.BookmarkControllerServiceUnbookmarkThreadMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        threadUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      threadUuid: string;
    },
    TContext
  >({
    mutationFn: ({ threadUuid }) =>
      BookmarkControllerService.unbookmarkThread({
        threadUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Unbookmark a message
 * Removes a message from user's bookmarks
 * @param data The data for the request.
 * @param data.messageUuid Message UUID
 * @returns Response Message unbookmarked successfully
 * @throws ApiError
 */
export const useBookmarkControllerServiceUnbookmarkMessage = <
  TData = Common.BookmarkControllerServiceUnbookmarkMessageMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        messageUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      messageUuid: string;
    },
    TContext
  >({
    mutationFn: ({ messageUuid }) =>
      BookmarkControllerService.unbookmarkMessage({
        messageUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
/**
 * Unbookmark all messages in a thread
 * Removes all message bookmarks for the specified thread for the current user. For non-patient users, patientUuid is required.
 * @param data The data for the request.
 * @param data.threadUuid Thread UUID
 * @param data.patientUuid Patient UUID (required for non-patient users)
 * @returns Response Messages unbookmarked successfully
 * @throws ApiError
 */
export const useBookmarkControllerServiceUnbookmarkMessagesByThread = <
  TData =
    Common.BookmarkControllerServiceUnbookmarkMessagesByThreadMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        patientUuid?: string;
        threadUuid: string;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      patientUuid?: string;
      threadUuid: string;
    },
    TContext
  >({
    mutationFn: ({ patientUuid, threadUuid }) =>
      BookmarkControllerService.unbookmarkMessagesByThread({
        patientUuid,
        threadUuid,
      }) as unknown as Promise<TData>,
    ...options,
  });
